import type { Dict } from '../types';

export const pl: Dict = {
  'chat.amrCard.switchTitle': 'Wywołanie modelu nieudane — to zadanie jest wstrzymane',
  'chat.amrCard.switchBody': 'Przełącz się na oficjalną usługę modeli Crie3 Cloud — bez konfigurowania klucza API. Po zalogowaniu, autoryzacji i doładowaniu zadanie zostanie automatycznie ponowione.',
  'chat.amrCard.chipOfficial': 'Oficjalny hosting',
  'chat.amrCard.chipNoKey': 'Bez klucza API',
  'chat.amrCard.chipAutoRetry': 'Automatyczne ponowienie po zalogowaniu',
  'chat.amrCard.switchCta': 'Przełącz na Crie3 Cloud i ponów',
  'chat.amrError.authMessage': 'Twoje konto Crie3 Cloud nie zostało jeszcze autoryzowane. Autoryzuj je, a zadanie zostanie automatycznie ponowione.',
  'chat.amrError.balanceMessage': 'Saldo Crie3 Cloud zostało wyczerpane. Doładuj, aby kontynuować zadanie.',
  'chat.amrError.authorizeCta': 'Autoryzuj i ponów',
  'chat.amrError.rechargeCta': 'Doładuj Crie3 Cloud',
  'chat.amrBalanceGate.title': 'Ulepsz plan i twórz dalej',
  'chat.amrBalanceGate.message': 'Za mało kredytów (pozostało {balance}). Ulepsz plan lub doładuj, a zadanie ruszy od razu.',
  'chat.amrBalanceGate.benefitsTitle': 'Co daje Ci Crie3 Cloud',
  'chat.amrBalanceGate.benefit1': 'Bez kluczy API — szeroki wybór modeli',
  'chat.amrBalanceGate.benefit2': 'Wbudowany agent SOTA, bez konfiguracji',
  'chat.amrBalanceGate.benefit3': 'Oficjalna, niezawodna usługa',
  'chat.amrBalanceGate.benefit4': 'Stale się rozwija: wdrożenie 1 kliknięciem, multimodalność, zespoły i więcej',
  'chat.amrBalanceGate.laterCta': 'Nie teraz',
  'chat.amrBalanceGate.plansCta': 'Ulepsz plan',
  'chat.amrBalanceGate.signedOutTitle': 'Zaloguj się, aby zacząć tworzyć',
  'chat.amrBalanceGate.signedOutMessage': 'Używasz agenta Crie3 Cloud — zaloguj się, a to zadanie ruszy od razu.',
  'chat.amrBalanceGate.signInCta': 'Zaloguj się',
  'chat.amrBalanceGate.watchingWallet': 'Będziemy kontynuować automatycznie, gdy saldo się zaktualizuje.',
  'chat.amrLowBalance.title': 'Kredyty na wyczerpaniu',
  'chat.amrLowBalance.message': 'Zostało tylko {balance} — prawdopodobnie za mało, by ukończyć to zadanie. Najpierw doładuj lub ulepsz plan.',
  'chat.amrLowBalance.rechargeCta': 'Doładuj',
  'chat.amrLowBalance.proceedCta': 'Uruchom mimo to',
  'chat.amrLowBalance.dontRemind': 'Nie pytaj ponownie',
  'chat.amrArtifactUpgrade.title': 'Dopracuj projekt z mocniejszymi modelami',
  'chat.amrArtifactUpgrade.message': 'Odblokuj zaawansowane modele, więcej równoległych zadań i więcej kredytów miesięcznie.',
  'chat.amrArtifactUpgrade.benefit1': 'Więcej zaawansowanych modeli, w tym Fable 5 i GPT-5.6',
  'chat.amrArtifactUpgrade.benefit2': 'Nawet 10 razy więcej zadań równolegle',
  'chat.amrArtifactUpgrade.benefit3': 'Nawet 300 razy więcej kredytów miesięcznie',
  'chat.amrArtifactUpgrade.benefit4': 'Priorytet w godzinach szczytu, aby generować szybciej',
  'chat.amrArtifactUpgrade.promoBanner': 'Oferta ograniczona czasowo: do 67% zniżki na subskrypcje',
  'chat.amrArtifactUpgrade.countdownLabel': 'Oferta kończy się za',
  'chat.amrArtifactUpgrade.plansCta': 'Ulepsz plan teraz, nawet 67% taniej',
  'chat.amrArtifactUpgrade.homePlansCta': 'Oszczędź 67%',
  'chat.amrArtifactUpgrade.laterCta': 'Kontynuuj z Free i wyślij',
  'chat.amrArtifactUpgrade.homeTitle': 'Projekt jest gotowy. Rozwiń kolejny pomysł jeszcze bardziej.',
  'chat.amrArtifactUpgrade.homeMessage': 'Ulepsz plan, aby zyskać mocniejsze modele, więcej zadań i więcej kredytów.',
  'chat.amrArtifactUpgrade.homeArtifactCta': 'Zobacz projekt',
  'chat.antigravityError.launchTerminalCta': 'Zaloguj się przez terminal',
  'chat.antigravityError.launchSwitchModelCta': 'Zmień model w terminalu',
  'chat.connectionDropped': 'Połączenie z usługą modelu zostało przerwane przed zakończeniem odpowiedzi — zwykle z powodu niestabilnej sieci lub serwera proxy. Spróbuj ponownie.',
  'chat.runError.title.authRequired': 'Wymagana autoryzacja',
  'chat.runError.title.balance': 'Niewystarczające środki',
  'chat.runError.title.connectionDropped': 'Połączenie przerwane',
  'chat.runError.title.signInRequired': 'Wymagane logowanie',
  'chat.runError.title.rateLimited': 'Osiągnięto limit użycia',
  'chat.runError.title.generic': 'Zadanie nie powiodło się',
  'chat.runError.signInMessage.amr': 'Agent Crie3 Cloud nie jest jeszcze zalogowany — zaloguj się, aby zacząć go używać.',
  'chat.runError.signInMessage.other': '{agent} nie jest zalogowany. Sprawdź jego stan logowania lokalnie. Polecamy agenta Crie3 Cloud — stabilniejszego i korzystniejszego.',
  'chat.runError.agentFallback': 'agent',
  'chat.runError.sourceLabel': 'Źródło błędu',
  'chat.runError.sourceExpandAria': 'Rozwiń źródło błędu',
  'chat.runError.sourceCollapseAria': 'Zwiń źródło błędu',
  'chat.runError.title.cliMissing': 'Agent nie zainstalowany',
  'chat.runError.title.promptTooLarge': 'Zbyt długie dane wejściowe',
  'chat.runError.title.modelUnavailable': 'Model niedostępny',
  'chat.runError.title.upstreamUnavailable': 'Usługa chwilowo niedostępna',
  'chat.runError.title.toolLoop': 'Utknięcie w pętli',
  'chat.runError.title.outputInvalid': 'Nieprawidłowe wyjście modelu',
  'chat.runError.title.runtimeConfig': 'Błąd konfiguracji',
  'chat.runError.cliMissingMessage': 'Nie znaleziono narzędzia wiersza poleceń {agent}. Zainstaluj je i upewnij się, że jest w PATH, a następnie spróbuj ponownie.',
  'chat.runError.promptTooLargeMessage': 'Ta tura przekroczyła limit kontekstu modelu. Skróć zapytanie, usuń załączniki lub rozpocznij nową rozmowę i spróbuj ponownie.',
  'chat.runError.modelUnavailableMessage': 'Wybrany model jest niedostępny lub nie istnieje. Przełącz się na inny model w Ustawieniach i spróbuj ponownie.',
  'chat.runError.rateLimitedMessage': 'Osiągnięto limit użycia usługi modelu. Poczekaj chwilę i spróbuj ponownie lub przełącz się na inny model albo usługę.',
  'chat.runError.upstreamUnavailableMessage': 'Usługa modelu jest chwilowo niedostępna — zwykle z powodu niestabilności po stronie dostawcy lub problemu z siecią/proxy. Spróbuj ponownie za chwilę.',
  'chat.runError.toolLoopMessage': '{agent} powtarzał tę samą czynność bez postępu i został zatrzymany. Sprawdź docelowy plik lub polecenie i spróbuj ponownie.',
  'chat.runError.outputInvalidMessage': 'Model wygenerował nieprawidłowe dane wyjściowe i ta tura została przerwana. Zwykle pomaga ponowna próba.',
  'chat.runError.runtimeConfigMessage': 'Konfiguracja środowiska uruchomieniowego wybranego agenta jest nieprawidłowa, więc nie można było rozpocząć. Zaktualizuj do najnowszej wersji lub skontaktuj się z pomocą techniczną.',
  'chat.runError.title.quotaExhausted': "Wyczerpano limit",
  'chat.runError.title.timedOut': "Przekroczono limit czasu",
  'chat.runError.title.emptyOutput': "Brak wyniku",
  'chat.hostedAgentName': "Agent Crie3",
  'chat.plain.warningTruncated': 'Odpowiedź została przerwana ze względów bezpieczeństwa. Zapytaj ponownie, najlepiej z większą liczbą szczegółów.',
  'chat.plain.warningRepeatedStopped': 'Ten sam krok nie powiódł się kilka razy z rzędu, więc praca została zatrzymana. Spróbuj poprosić ponownie lub opisać to inaczej.',
  'chat.plain.warningRepeatedStuck': 'Ten sam krok wciąż się nie udaje i może zatrzymać pracę.',
  'chat.runError.hostedGenericMessage': 'Zadanie nie zostało ukończone. Spróbuj ponownie za chwilę — jeśli to się powtarza, odezwij się do nas.',
  'chat.plain.details': "Pokaż szczegóły techniczne",
  'chat.plain.detailsHide': "Ukryj szczegóły techniczne",
  'chat.brandAudit.needsFixes': "Wymaga poprawek ({count})",
  'chat.brandAudit.syncFailed': "Nie udało się teraz zaktualizować marki: {error}",
  'chat.brandAudit.checkFailed': "Nie udało się teraz sprawdzić marki.",
  'chat.brandEnrichmentStartFailed': 'Nie udało się teraz rozpocząć dopracowania. Spróbuj ponownie za chwilę.',
  'chat.designNoResult': 'Crie3 finished without producing the piece. Try asking again — if it keeps happening, describe what you asked for and we will look into it.',
  'chat.designDeliveryFailed': 'The piece was created, but Crie3 could not save it to the project. Try again.',
  'chat.runError.title.sessionExpired': "Sesja wygasła",
  'chat.runError.title.gitBashMissing': "Brak Git Bash",
  'chat.runError.quotaExhaustedMessage': "Limit lub próg rozliczeniowy Twojej usługi modelu został wyczerpany, więc ponowna próba nie pomoże. Doładuj u swojego dostawcy lub przełącz się na inny model albo usługę.",
  'chat.runError.workspaceCreditsMessage': "W Twoim obszarze roboczym skończyły się kredyty. Dodaj kredyty (lub poproś właściciela obszaru o doładowanie) albo przełącz się na inny model lub usługę.",
  'chat.runError.timedOutMessage': "To uruchomienie trwało zbyt długo i zostało zatrzymane. Spróbuj ponownie lub zawęź zadanie i powtórz.",
  'chat.runError.inactivityTimeoutMessage': "Agent zbyt długo nie dawał nowego wyniku i został zatrzymany z powodu przekroczenia limitu czasu. Ponowna próba zwykle go wznawia.",
  'chat.runError.emptyOutputMessage': "Agent zakończył działanie bez żadnego wyniku. Zwykle jest to chwilowe, spróbuj ponownie.",
  'chat.runError.sessionExpiredMessage': "Wznowiona sesja wygasła. Została zresetowana, więc spróbuj ponownie, aby rozpocząć nowe uruchomienie.",
  'chat.runError.gitBashMissingMessage': "Do uruchomienia tego agenta w systemie Windows wymagany jest Git Bash, ale go nie znaleziono. Zainstaluj Git dla Windows i spróbuj ponownie.",
  'common.cancel': 'Anuluj',
  'chat.selectFromLibrary': 'Importuj z biblioteki',
  'chat.importFigma': 'Importuj z Figmy',
  'chat.plus.group.files': 'Files',
  'chat.plus.group.code': 'Code',
  'chat.plus.group.designs': 'Designs',
  'chat.plus.group.other': 'Other',
  'chat.plus.attachFiles': 'Attach files',
  'chat.plus.referenceProject': 'Reference another project',
  'chat.plus.linkLocalCode': 'Link local code',
  'chat.plus.uploadFig': 'Upload .fig file',
  'chat.plus.learnHow': 'Learn how',
  'chat.plus.designSystem': 'Design system',
  'chat.plus.skills': 'Skills',
  'chat.plus.noSkills': 'No skills available',
  'chat.plus.connectors': 'Connectors',
  'chat.plus.plugins': 'Plugins',
  'chat.plus.mcp': 'MCP',
  'chat.referenceProject.title': 'Reference another project',
  'chat.referenceProject.search': 'Search projects…',
  'chat.referenceProject.empty': 'No projects match “{query}”',
  'chat.referenceProject.emptyAll': 'No other projects yet',
  'chat.referenceProject.loadFailed': 'Could not load projects. Check that the daemon is running and try again.',
  'chat.referenceProject.confirm': 'Reference project',
  'chat.contextPrompt.referenceProject': 'Use the Crie3 project “{name}” as reference context. Its local path is: {path}. Before designing or modifying anything, search and read this directory when useful.',
  'chat.contextPrompt.localCode': 'Use the local code folder “{name}” as code reference. Its absolute path is: {path}. Read relevant files when useful and stay consistent with the existing implementation.',
  'chat.figmaHelp.title': 'How to download a .fig file',
  'chat.figmaHelp.intro': 'From the Figma web or desktop app:',
  'chat.figmaHelp.step1': 'Open the file in Figma.',
  'chat.figmaHelp.step2': 'Go to File → Save local copy... (web: main menu → File).',
  'chat.figmaHelp.step3': 'Figma downloads a .fig file. Drop it onto the composer or upload it.',
  'chat.figmaHelp.note': 'The .fig file is parsed locally and is not uploaded to Figma.',
  'designFiles.library.label': 'Importuj z biblioteki',
  'designFiles.library.title': 'Importuj z biblioteki',
  'libraryPicker.title': 'Importuj z biblioteki',
  'libraryPicker.searchPlaceholder': 'Szukaj w bibliotece…',
  'libraryPicker.empty': 'Brak zasobów w Twojej bibliotece',
  'libraryPicker.allKinds': 'Wszystkie',
  'libraryPicker.add': 'Importuj',
  'libraryPicker.loading': 'Ładowanie…',
  'common.save': 'Zapisz',
  'common.close': 'Zamknij',
  'common.clear': 'Wyczyść',
  'common.delete': 'Usuń',
  'common.rename': 'Zmień nazwę',
  'common.edit': 'Edytuj',
  'common.preview': 'Podgląd',
  'common.share': 'Udostępnij',
  'common.search': 'Szukaj',
  'common.searchEllipsis': 'Szukaj…',
  'common.loading': 'Ładowanie…',
  'common.all': 'Wszystkie',
  'common.none': 'Brak',
  'common.default': 'Domyślne',
  'common.installed': 'zainstalowano',
  'common.notInstalled': 'nie zainstalowano',
  'common.active': 'aktywny',
  'common.disabled': 'Wyłączone',
  'common.enabled': 'Włączone',
  'common.selected': 'wybrano',
  'common.create': 'Utwórz',
  'common.openPreview': 'Otwórz podgląd',
  'common.exitFullscreen': 'Zamknij pełny ekran',
  'common.fullscreen': 'Pełny ekran',
  'common.openInNewTab': 'Otwórz w nowej karcie',
  'common.exportPdf': 'Eksportuj jako PDF',
  'common.exportZip': 'Pobierz jako .zip',
  'common.exportHtml': 'Eksportuj jako samodzielny HTML',
  'common.exportImage': 'Eksportuj jako obraz',
  'common.exportImageFailed': 'Nie udało się wygenerować obrazu. Spróbuj ponownie.',
  'common.justNow': 'przed chwilą',
  'common.minutesAgo': '{n} min temu',
  'common.hoursAgo': '{n} godz. temu',
  'common.daysAgo': '{n} dni temu',
  'common.weeksAgo': '{n} tyg. temu',
  'common.now': 'teraz',
  'common.minutesShort': '{n}m',
  'common.hoursShort': '{n}h',
  'common.daysShort': '{n}d',
  'common.untitled': 'Bez tytułu',
  'designBrowser.savePageBrief': 'Save page brief',
  'designBrowser.menu': 'Browser menu',
  'designBrowser.copyScreenshot': 'Copy screenshot',
  'designBrowser.hardReload': 'Hard reload',
  'designBrowser.copyUrl': 'Copy URL',
  'designBrowser.openExternal': 'Open externally',
  'designBrowser.downloadPage': 'Download page',
  'designBrowser.downloadPageBusy': 'Downloading page...',
  'designBrowser.clearHistory': 'Clear history',
  'designBrowser.clearCookies': 'Clear cookies',
  'designBrowser.clearAllData': 'Clear all browser data',
  'designBrowser.status.noUrlToCopy': 'No URL to copy.',
  'designBrowser.status.urlCopied': 'URL copied.',
  'designBrowser.status.openHttpFirst': 'Open an http or https page first.',
  'designBrowser.status.openBeforeScreenshot': 'Open a page before taking a screenshot.',
  'designBrowser.status.screenshotSaved': 'Screenshot saved.',
  'designBrowser.status.screenshotFailed': 'Screenshot failed.',
  'designBrowser.status.openBeforeBrief': 'Open a page before saving a brief.',
  'designBrowser.status.briefSaveFailed': 'Page brief save failed.',
  'designBrowser.status.openBeforeDownload': 'Open a page before saving a snapshot.',
  'designBrowser.status.pageSnapshotStarted': 'Saving page snapshot...',
  'designBrowser.status.pageSnapshotUnsupported': 'This page cannot be archived.',
  'designBrowser.status.pageSnapshotFailed': 'Page snapshot save failed.',
  'designBrowser.status.pageSnapshotSaved': 'Saved page snapshot (HTML + CSS).',
  'designBrowser.status.viewDesignFiles': 'View Design Files',
  'designBrowser.status.downloadAssistHint': 'Step 2: click Download Page here, wait for the saved snapshot success, then return to the left Next Step card and click Continue extraction.',
  'designBrowser.status.desktopDataUnavailable': 'Desktop browser data is unavailable here.',
  'designBrowser.status.browserDataCleared': 'Browser data cleared.',
  'designBrowser.status.browserDataClearFailed': 'Browser data clear failed.',
  'designBrowser.status.historyCleared': 'History cleared.',
  'plugins.availableDetails.provenance': 'Pochodzenie',
  'plugins.availableDetails.provenanceLine': 'z {source} · {trust} · {resolved}',
  'plugins.availableDetails.provenanceLineWithIntegrity': 'z {source} · {trust} · {resolved} · {integrity}',
  'plugins.availableDetails.install': 'Zainstaluj',
  'plugins.availableDetails.version': 'Wersja',
  'plugins.availableDetails.pluginVersion': 'Wersja wtyczki',
  'plugins.availableDetails.copyInstallCommand': 'Kopiuj polecenie instalacji',
  'plugins.availableDetails.copied': 'Skopiowano',
  'plugins.availableDetails.deprecatedPrefix': 'Wycofane: {message}',
  'plugins.availableDetails.deprecatedFallback': 'Ta wersja została oznaczona jako wycofana.',
  'plugins.availableDetails.yanked': 'Wstrzymana.',
  'plugins.availableDetails.yankedWithReason': 'Wstrzymana: {reason}',
  'plugins.availableDetails.versionDeprecatedSuffix': ' (wycofane)',
  'plugins.availableDetails.versionYankedSuffix': ' (wstrzymane)',
  'plugins.availableDetails.ref': 'Ref',
  'plugins.availableDetails.integrity': 'Integrity',
  'plugins.availableDetails.permissions': 'Uprawnienia',
  'plugins.availableDetails.capabilitySummary': 'Podsumowanie możliwości',
  'plugins.actions.copyInstallCommand': 'Kopiuj polecenie instalacji',
  'plugins.actions.copyPluginId': 'Kopiuj ID wtyczki',
  'plugins.actions.openSourceGithub': 'Otwórz źródło na GitHubie',
  'plugins.actions.openSource': 'Otwórz źródło',
  'plugins.actions.openHomepage': 'Otwórz stronę domową',
  'plugins.actions.openMarketplace': 'Otwórz w marketplace',
  'app.brand': 'Crie3',
  'app.brandPill': 'Wersja badawcza',
  'app.brandSubtitle': 'od Nexu Labs',
  'app.welcomeLoading': 'Ładowanie obszaru roboczego…',
  'settings.welcomeKicker': '',
  'settings.welcomeTitle': 'Witamy w Crie3',
  'settings.welcomeSubtitle': '',
  'settings.onboardingCreateTitle': 'Zacznij od briefu',
  'settings.onboardingCreateBody': 'Opisz stronę, aplikację, prezentację, obraz lub film, którego potrzebujesz. Crie3 utworzy projekt i zachowa pracę w wersji edytowalnej.',
  'settings.onboardingMemoryTitle': 'Zapisz kontekst pracy',
  'settings.onboardingMemoryBody': 'Dodaj preferencje, fakty o projekcie i powtarzające się reguły, aby przyszłe czaty korzystały z właściwego kontekstu.',
  'settings.onboardingMemoryCalloutTitle': 'Zapisano w Twojej Pamięci',
  'settings.onboardingMemoryCalloutBody': 'Te odpowiedzi tworzą podstawę Twojego profilu Pamięci. Crie3 wykorzystuje go ponownie przy każdym zadaniu — i uczy się w trakcie Twojej pracy.',
  'settings.onboardingMemoryBenefitIntent': 'Rozumie Twoje intencje na podstawie krótkiej prośby',
  'settings.onboardingMemoryBenefitFewerQuestions': 'Pomija powtarzające się pytania konfiguracyjne',
  'settings.onboardingMemoryBenefitPersonalized': 'Dostosowuje wyniki do Twojej roli, odbiorców i gustu',
  'settings.onboardingSystemsTitle': 'Dodaj swój system projektowy',
  'settings.onboardingSystemsBody': 'Wybierz lub utwórz system marki, aby generowana praca uwzględniała rzeczywiste kolory, typografię i język produktu.',
  'settings.onboardingExecutionTitle': 'Wybierz sposób generowania',
  'settings.onboardingExecutionBody': 'Oficjalny CLI z konfiguracją jednym kliknięciem i gotowymi ustawieniami domyślnymi. Użyj jednego klucza, aby wybierać spośród wielu modeli z lepszymi cenami.',
  'settings.onboardingAmrCloudBenefitOfficial': 'Oficjalnie polecane',
  'settings.onboardingAmrCloudBenefitReady': 'Bez wdrażania',
  'settings.onboardingAmrCloudBenefitModels': 'Obsługuje Claude Opus 4.8',
  'settings.onboardingAmrCloudBenefitPricing': 'Harness SOTA',
  'settings.onboardingAmrCloudUpcomingLabel': 'Wkrótce',
  'settings.onboardingAmrCloudUpcomingImageVideo': 'Obraz i wideo',
  'settings.onboardingAmrCloudUpcomingSkills': 'Wiele Skills',
  'settings.onboardingAmrCloudUpcomingRouting': 'Inteligentny routing',
  'settings.onboardingAmrModelSourceLabel': 'Crie3 Cloud',
  'settings.onboardingAmrCloudAuthorizeAction': 'Autoryzuj Crie3 Cloud',
  'settings.onboardingAmrCloudAuthorizedAction': 'Autoryzowano',
  'settings.onboardingStepConnect': 'Connect',
  'settings.onboardingStepDesignSystem': 'Utwórz system projektowy',
  'settings.onboardingStepProfile': 'About you',
  'settings.onboardingStepNewsletter': 'Bądź na bieżąco',
  'settings.onboardingNewsletterTitle': 'Bądź na bieżąco',
  'settings.onboardingNewsletterBody': 'Otrzymuj nowości produktowe, nowe szablony, design systemy i działania ambasadorów na skrzynkę. Opcjonalne — możesz pominąć.',
  'settings.onboardingConnectTitle': 'Choose a runtime',
  'settings.onboardingConnectBody': '',
  'settings.onboardingCloudTitle': 'Zaloguj się do Crie3',
  'settings.onboardingCloudBody': 'Zaloguj się i od razu zacznij projektować z chmurową SI — bez skomplikowanej konfiguracji.',
  'settings.onboardingCloudSignIn': 'Zaloguj się do Crie3',
  'settings.onboardingCloudContinue': 'Kontynuuj (zalogowano)',
  'settings.onboardingCloudAlternative': 'Użyj lokalnego CLI lub własnego klucza API',
  'settings.onboardingCloudRights': 'Wszelkie prawa zastrzeżone.',
  'settings.onboardingCloudOr': 'lub',
  'settings.onboardingGateTooltipNoRuntime': 'Kolejne kroki działają na AI — wybierz środowisko uruchomieniowe, aby kontynuować.',
  'settings.onboardingGateTooltipAmr': 'Kolejne kroki działają na AI — zaloguj się do Crie3 Cloud, aby kontynuować.',
  'settings.onboardingGateTooltipLocal': 'Kolejne kroki działają na AI — wybierz dostępne lokalne CLI, aby kontynuować.',
  'settings.onboardingGateTooltipByok': 'Kolejne kroki działają na AI — dodaj i przetestuj swój klucz modelu, aby kontynuować.',
  'settings.onboardingRecommended': 'Recommended',
  'settings.onboardingAmrCloudOfficialBadge': 'Oficjalne',
  'settings.onboardingLocalTitle': 'Local coding agent',
  'settings.onboardingLocalBody': 'Use an installed CLI such as Claude Code, Codex, Cursor, Gemini, or OpenCode.',
  'settings.onboardingLocalAction': 'Open CLI settings',
  'settings.onboardingCliScanHint': 'This usually takes 5-10 seconds.',
  'settings.onboardingByokTitle': 'Bring your own key',
  'settings.onboardingByokBody': 'Use your own model provider credentials.',
  'settings.onboardingByokAction': 'Open BYOK settings',
  'settings.onboardingDesignTitle': 'Design system',
  'settings.onboardingDesignBody': 'Generate once, reuse everywhere.',
  'settings.onboardingDesignIntroGenerateTitle': 'Generate from existing work',
  'settings.onboardingDesignIntroGenerateBody': 'Upload your design system from GitHub or local code repositories, Figma files, images, and other content assets.',
  'settings.onboardingDesignIntroReuseTitle': 'Reuse in future work',
  'settings.onboardingDesignIntroReuseBody': 'Future prototypes, slides, and other content can reference your existing fonts, spacing, logo style, and color tone.',
  'settings.onboardingDesignIntroSkipTitle': 'Optional for now',
  'settings.onboardingDesignIntroSkipBody': 'Skip this step if you want to start without generating a design system.',
  'settings.onboardingGithubTitle': 'Import from GitHub',
  'settings.onboardingGithubBody': 'Use a frontend repository.',
  'settings.onboardingUploadTitle': 'Upload local files',
  'settings.onboardingUploadBody': 'Add project files, screenshots, CSS, docs, or assets.',
  'settings.onboardingPromptTitle': 'Generate from prompt',
  'settings.onboardingPromptBody': 'Describe the product or brand.',
  'settings.onboardingProfileTitle': 'O Tobie',
  'settings.onboardingProfileBody': 'Opcjonalne dane dla lepszych ustawień domyślnych.',
  'settings.onboardingRoleLabel': 'Twoja rola',
  'settings.onboardingOrgSizeLabel': 'Wielkość organizacji',
  'settings.onboardingWorshipTeamLabel': 'How big is the worship team?',
  'settings.onboardingWorshipSolo': 'Just me',
  'settings.onboardingWorshipSmall': 'Up to 5 people',
  'settings.onboardingWorshipMedium': '6 to 15 people',
  'settings.onboardingWorshipLarge': 'More than 15, on rotation',
  'settings.onboardingMediaTeamLabel': 'Who handles the media work?',
  'settings.onboardingMediaSolo': 'Just me',
  'settings.onboardingMediaPair': '2 or 3 volunteers',
  'settings.onboardingMediaTeam': 'A team of 4 to 10',
  'settings.onboardingMediaDept': 'A full communications department',
  'settings.onboardingAgencyClientsLabel': 'How many churches or ministries do you serve?',
  'settings.onboardingAgencyFew': '1 to 3',
  'settings.onboardingAgencySome': '4 to 10',
  'settings.onboardingAgencyMany': '11 to 25',
  'settings.onboardingAgencyLots': 'More than 25',
  'settings.onboardingUseCaseLabel': 'Zastosowanie',
  'settings.onboardingSourceLabel': 'Skąd o nas wiesz?',
  'settings.onboardingSourceX': '🐦 X / Twitter',
  'settings.onboardingSourceGithub': '🐙 GitHub',
  'settings.onboardingSourceYoutube': '▶️ YouTube',
  'settings.onboardingSourceTiktok': '🎵 TikTok',
  'settings.onboardingSourceReddit': '👽 Reddit',
  'settings.onboardingSourceLinkedin': '💼 LinkedIn',
  'settings.onboardingSourceMetaSocial': '📸 Instagram / Threads / Facebook',
  'settings.onboardingSourceSearch': '🔍 Wyszukiwarka (Google / Bing)',
  'settings.onboardingSourceAiTool': '🤖 Narzędzie AI (ChatGPT / Perplexity)',
  'settings.onboardingSourceFriend': '👥 Znajomy lub współpracownik',
  'settings.onboardingSourceCommunity': '💬 Discord / społeczność',
  'settings.onboardingSourceEmail': '✉️ E-mail / newsletter',
  'settings.onboardingSourceBlog': '📝 Blog / artykuł',
  'settings.onboardingSourceOther': '✨ Inne',
  'settings.onboardingSourceOtherPlaceholder': 'Napisz nam skąd (opcjonalnie)',
  'settings.onboardingSelectPlaceholder': 'Wybierz jedną opcję',
  'settings.onboardingSelectMultiplePlaceholder': 'Wybierz jedną lub więcej opcji',
  'settings.onboardingOrgSolo': 'Solo / osobiste (1)',
  'settings.onboardingOrgTeam': 'Mały zespół (2-10)',
  'settings.onboardingOrgStartup': 'Startup / MŚP (11-50)',
  'settings.onboardingOrgGrowth': 'Firma w fazie wzrostu (51-200)',
  'settings.onboardingOrgMidMarket': 'Średnia firma (201-1000)',
  'settings.onboardingOrgEnterprise': 'Duże przedsiębiorstwo (1000+)',
  'settings.onboardingRolePm': '📋 Product manager',
  'settings.onboardingRoleDesigner': '🎨 Projektant',
  'settings.onboardingRoleEngineer': '💻 Inżynier',
  'settings.onboardingRoleMarketing': '📣 Marketing',
  'settings.onboardingRoleAgency': '📣 Agencja marketingowa',
  'settings.onboardingRoleGrowth': '📈 Wzrost',
  'settings.onboardingRoleOps': '⚙️ Operacje',
  'settings.onboardingRoleFounder': '🚀 Założyciel / kadra kierownicza',
  'settings.onboardingRoleStudent': '🎓 Student / nauczyciel',
  'settings.onboardingRoleOther': '✨ Inne',
  'settings.onboardingUseProduct': '🎨 Projektowanie produktu',
  'settings.onboardingUseDesignSystem': '🧩 System projektowy',
  'settings.onboardingUsePrototype': '📱 Prototyp / UI aplikacji',
  'settings.onboardingUseLanding': '🌐 Strony docelowe',
  'settings.onboardingUseAds': '📣 Reklamy / treści społecznościowe',
  'settings.onboardingUseDashboard': '📊 Pulpity / narzędzia wewnętrzne',
  'settings.onboardingUseDeck': '🖥️ Prezentacja / talia slajdów',
  'settings.onboardingUseMarketing': '📈 Marketing / wzrost',
  'settings.onboardingUseEngineering': '🤝 Przekazanie do inżynierii',
  'settings.onboardingUseAgency': '💼 Praca agencyjna / dla klienta',
  'settings.onboardingBack': 'Back',
  'settings.onboardingContinue': 'Continue',
  'settings.onboardingFinish': 'Finish setup',
  'settings.kicker': 'Ustawienia',
  'settings.title': 'Tryb wykonywania',
  'settings.subtitle': 'Wybierz lokalne CLI albo BYOK.',
  'settings.modeAria': 'Tryb wykonywania',
  'settings.protocolAria': 'Protokół API',
  'settings.modeDaemon': 'Lokalne CLI',
  'settings.modeDaemonHelp': 'Uruchamiaj przez agenta CLI na swoim komputerze',
  'settings.modeDaemonOffline': 'Daemon nie jest uruchomiony',
  'settings.modeDaemonOfflineMeta': 'daemon offline',
  'settings.modeDaemonInstalledMeta': '{count} zainstalowano',
  'settings.modeApi': 'Dostawca API',
  'settings.modeApiMeta': 'BYOK',
  'settings.byokNoFileToolsNotice': 'BYOK nie może odczytywać, zapisywać ani edytować plików projektu. Użyj Local CLI, gdy potrzebujesz zmian w kodzie.',
  'settings.codeAgent': 'Agent kodu',
  'settings.codeAgentHint': 'Wykryto poprzez skanowanie PATH. Wybierz CLI, przez które mają przechodzić generacje.',
  'settings.rescan': '↻ Ponów skanowanie',
  'settings.rescanTitle': 'Ponownie skanuj PATH',
  'settings.rescanRunning': 'Skanowanie...',
  'settings.rescanSuccess': 'Skanowanie zakończone. Dostępne: {count}.',
  'settings.designSystemRenameFailed': 'Zmiana nazwy nie powiodła się. Sprawdź daemon i spróbuj ponownie.',
  'settings.rescanFailed': 'Skanowanie nie powiodło się. Sprawdź daemon i spróbuj ponownie.',
  'settings.test': 'Testuj',
  'settings.testTitle': 'Wyślij maleńki monit testowy, aby zweryfikować połączenie',
  'settings.testRunning': 'Testowanie połączenia…',
  'settings.byokReadyToTest': 'Gotowe do testu',
  'settings.testCancel': 'Anuluj',
  'settings.testRetry': 'Ponów test',
  'settings.required': 'wymagane',
  'settings.testMissingFields': 'Wypełnij {fields}, aby przetestować połączenie.',
  'settings.testSuccessApi': 'Połączono. Odpowiedź w {ms} ms — \'{sample}\'',
  'settings.testSuccessCli': '{agentName} odpowiedział w {ms} ms — \'{sample}\'',
  'settings.testAuthFailed': 'Uwierzytelnianie nie powiodło się. Sprawdź klucz API.',
  'settings.testForbidden': 'Brak dostępu. Sprawdź konto, region lub organizację.',
  'settings.testNotFoundModel': 'Nie znaleziono modelu \'{model}\' w tym punkcie końcowym.',
  'settings.testInvalidModelId': 'Id modelu \'{model}\' jest nieprawidłowy. Własne id musi zaczynać się od litery lub cyfry i nie może zawierać spacji.',
  'settings.testInvalidBaseUrl': 'Base URL jest nieprawidłowy lub nieosiągalny.',
  'settings.testRateLimited': 'Dostawca ograniczył test. Konfiguracja wygląda poprawnie.',
  'settings.testUpstream': 'Dostawca zwrócił {status}. Spróbuj ponownie za chwilę.',
  'settings.testTimeout': 'Test przekroczył limit czasu po {ms} ms.',
  'settings.testAgentMissing': '{agentName} nie jest zainstalowany lub nie jest w PATH.',
  'settings.testAgentSpawn': 'Nie można uruchomić {agentName}: {detail}.',
  'settings.testUnknown': 'Test nieudany: {detail}',
  'settings.agentInstall.install': 'Zainstaluj',
  'settings.agentInstall.docs': 'Dokumentacja',
  'settings.agentInstall.pathHint': 'Jeśli zainstalowano CLI przez npm lub Homebrew, ale nadal widnieje jako niezainstalowana, upewnij się, że katalog bin narzędzia jest w PATH dziedziczonym przez daemon Crie3 (na macOS PATH w Terminalu i aplikacjach GUI może się różnić). Zobacz QUICKSTART.md (sekcja "Local agent CLI and PATH").',
  'settings.agentInstall.stepOpenLinks': 'Otwórz Zainstaluj lub Dokumentacja dla wybranego agenta.',
  'settings.agentInstall.stepAuth': 'Uwierzytelnij się w CLI dostawcy (zaloguj się lub dodaj dane API), zanim wrócisz do Crie3.',
  'settings.agentInstall.stepRescan': 'Kliknij Ponów skanowanie w tej sekcji.',
  'settings.agentInstall.stepSelect': 'Wybierz kartę agenta, gdy pojawi się jako zainstalowany.',
  'settings.noAgentsDetected': 'Nie wykryto jeszcze żadnych agentów. Zainstaluj Claude Code, Codex, Devin for Terminal, OpenCode, Cursor Agent, Qwen lub GitHub Copilot CLI, a następnie kliknij Ponów skanowanie.',
  'settings.agentInstalledGroup': 'Twoje CLI ({count})',
  'settings.agentInstallGroup': 'Dostępne do instalacji ({count})',
  'settings.agentAuthRequired': 'Wymagane uwierzytelnienie',
  'settings.agentAuthUnknown': 'Stan uwierzytelnienia nieznany',
  'settings.amrCloud': 'Crie3 Cloud',
  'settings.amrAuthorize': 'Autoryzuj',
  'settings.amrBenefitOfficial': 'Officially maintained',
  'settings.amrBenefitLowerPrice': 'Lower price',
  'settings.amrBenefitManyModels': 'Wiele modeli',
  'settings.amrPromoBonus': 'Ograniczony bonus: +100%',
  'settings.amrSignInToContinue': 'Zaloguj się, aby kontynuować',
  'settings.amrSignIn': 'Zaloguj się',
  'settings.amrSignedIn': 'Zalogowano',
  'settings.amrWalletBalance': 'Wallet balance',
  'settings.amrWalletUnavailable': 'Balance temporarily unavailable',
  'settings.amrWalletUpdatedAt': 'Updated {time}',
  'settings.amrWalletCached': 'cached',
  'settings.amrWalletRefresh': 'Refresh',
  'settings.amrWalletRefreshTitle': 'Refresh Crie3 Cloud wallet balance',
  'settings.amrNotSignedIn': 'Niezalogowany',
  'settings.amrSigningIn': 'Logowanie…',
  'settings.amrActivationHint': 'Strona logowania się nie otworzyła? Naciśnij przycisk poniżej, aby otworzyć ją ponownie.',
  'settings.amrActivationBrowserFailed': 'Nie udało się automatycznie otworzyć przeglądarki. Otwórz stronę logowania poniżej, aby kontynuować.',
  'settings.amrActivationOpen': 'Otwórz stronę logowania',
  'settings.amrCancelSignIn': 'Anuluj logowanie',
  'settings.amrAccountStatus': 'Status konta Crie3 Cloud',
  'settings.amrConsole': 'Zarządzaj',
  'settings.amrBalance': 'Saldo',
  'settings.amrPlan': 'Plan',
  'settings.amrUpgrade': 'Ulepsz',
  'settings.amrModelUpgradeHint': 'Ulepsz, aby użyć',
  'settings.amrLoginErrorCompact': 'Logowanie Crie3 Cloud nie powiodło się.',
  'settings.advanced': 'Zaawansowane',
  'settings.amrLogin': 'Zaloguj się',
  'settings.amrLogout': 'Wyloguj się',
  'settings.amrLoggingIn': 'Logowanie…',
  'settings.amrLoggingOut': 'Wylogowywanie…',
  'settings.amrLoggedInAs': 'Zalogowano jako {email}',
  'settings.amrLoggedInWithPlan': 'Zalogowano jako {email} · {plan}',
  'settings.amrLoggedInPill': 'Zalogowano',
  'settings.amrNotLoggedIn': 'Niezalogowany',
  'settings.apiSection': 'Anthropic API',
  'settings.quickFillProvider': 'Szybkie wypełnienie dostawcy',
  'settings.providerPreset': 'Preset bramy',
  'settings.protocolGroupProtocols': 'Protokoły',
  'settings.protocolGroupGateways': 'Bramy',
  'settings.customProvider': 'Niestandardowy dostawca',
  'settings.apiKey': 'Klucz API',
  'settings.apiKeyGetLink': 'Pobierz klucz ↗',
  'settings.showKey': 'Pokaż klucz',
  'settings.hideKey': 'Ukryj klucz',
  'settings.show': 'Pokaż',
  'settings.hide': 'Ukryj',
  'settings.model': 'Model',
  'settings.sidebarExpand': 'Rozwiń menu ustawień',
  'settings.sidebarCollapse': 'Zwiń menu ustawień',
  'settings.sectionsNavAria': 'Sekcje ustawień',
  'settings.apiKeyInvalid': 'Nieprawidłowy API key.',
  'settings.apiKeyCleaned': 'Usunięto zbędne białe znaki z API key.',
  'settings.modelsLoadedFromAccount': '✓ Wczytano {count} modeli z Twojego konta.',
  'settings.modelsLoadedCount': '✓ Wczytano {count} modeli.',
  'settings.modelSourceAccount': 'Z Twojego konta',
  'settings.modelSourceSuggested': 'Sugerowane',
  'modelCapability.standard': 'Standard',
  'modelCapability.advanced': 'Advanced',
  'modelCapability.bestQuality': 'Best Quality',
  'modelCapability.standardDescription': 'Solid quality for regular tasks.',
  'modelCapability.advancedDescription': 'Stronger quality for more demanding tasks.',
  'modelCapability.bestQualityDescription': 'Best output quality for the most demanding work.',
  'modelCost.upToHalf': 'Niski koszt',
  'modelCost.halfToOne': 'Średni koszt',
  'modelCost.oneToFour': 'Wysoki koszt',
  'modelCost.overFour': 'Najwyższy koszt',
  'settings.fetchModels': 'Pobierz modele',
  'settings.fetchModelsTitle': 'Pobierz dostępne modele od tego dostawcy',
  'settings.fetchModelsRunning': 'Pobieranie modeli…',
  'settings.fetchModelsMissingFields': 'Wypełnij {fields}, aby pobrać modele.',
  'settings.fetchModelsInvalidBaseUrl': 'Wprowadź prawidłowy Base URL, aby pobrać modele.',
  'settings.fetchModelsUnsupportedAzure': 'Azure OpenAI używa nazw wdrożeń, więc wykrywanie modeli nie jest tutaj dostępne.',
  'settings.fetchModelsUnsupportedOllama': 'Wykrywanie modeli Ollama Cloud nie jest jeszcze dostępne. Wybierz lub wpisz model.',
  'settings.fetchModelsSuccess': 'Pobrano {count} modeli.',
  'settings.fetchModelsEmpty': 'Nie zwrócono żadnych zgodnych modeli tekstowych.',
  'settings.fetchModelsUnsupported': 'Wykrywanie modeli nie jest dostępne dla tego protokołu.',
  'settings.fetchModelsFailed': 'Nie udało się pobrać modeli: {detail}',
  'settings.suggestedModelsHint': 'To sugerowane modele dla tego protokołu. Twój dostawca może obsługiwać inne modele.',
  'settings.baseUrl': 'Bazowy URL',
  'settings.baseUrlInvalid': 'Użyj publicznego URL http:// lub https://.',
  'settings.baseUrlCustomize': 'Dostosuj',
  'settings.baseUrlDefaultHint': 'Domyślny punkt końcowy. Zwykle nie trzeba go zmieniać.',
  'settings.azureBaseUrlPlaceholder': 'https://my-resource.openai.azure.com',
  'settings.azureBaseUrlHint': 'Znajdziesz to w portalu Azure → Twój zasób → Endpoint.',
  'settings.azureDeploymentModel': 'Nazwa wdrożenia',
  'settings.azureCustomDeploymentName': 'Niestandardowa nazwa wdrożenia',
  'settings.azureDeploymentModelHint': 'Dla Azure OpenAI to pole jest używane jako nazwa wdrożenia w /openai/deployments/<model>. Wpisz nazwę wdrożenia utworzonego w Azure.',
  'settings.azureModelFetchHint': 'Wprowadź nazwę wdrożenia z Twojego zasobu Azure. Wdrożeń Azure nie można pobrać automatycznie.',
  'settings.apiVersion': 'Wersja API',
  'settings.byokImageModel': 'Model generowania obrazów',
  'settings.byokVideoModel': 'Model generowania wideo',
  'settings.byokVideoI2vHint': 'Model obraz-na-wideo: wymagany obraz referencyjny (w innym razie użyty zostanie najnowszy obraz w projekcie)',
  'settings.byokSpeechModel': 'Model mowy',
  'settings.byokSpeechVoice': 'Głos',
  'settings.byokModelDefaultOption': 'Domyślny',
  'settings.maxTokens': 'Maks. liczba tokenów (opcjonalnie)',
  'settings.maxTokensHint': 'Limit długości odpowiedzi. Każdy model ma dostrojony domyślny limit (widoczny jako placeholder); pozostaw puste, aby go użyć, lub wpisz liczbę.',
  'settings.apiHint': 'Wywołania są wysyłane przez lokalny proxy daemon do ustawionego Base URL. Klucz jest przechowywany tylko w tej przeglądarce i wysyłany z żądaniami do dostawcy.',
  'settings.skipForNow': 'Pomiń na razie',
  'settings.getStarted': 'Rozpocznij',
  'settings.envConfigure': 'Tryb wykonywania',
  'settings.agentModel': 'Agent i model',
  'settings.agentModelHint': 'Agent, który działa w Crie3',
  'settings.agentModelBody': 'Wybierz model, którego agent Crie3 używa, gdy tworzysz w Crie3. Nie zmienia to niczego w asystencie połączonym przez MCP.',
  'settings.localCli': 'Lokalne CLI',
  'settings.anthropicApi': 'Anthropic API',
  'settings.noAgentSelected': 'nie wybrano agenta',
  'settings.language': 'Język',
  'settings.languageHint': 'Zmień język interfejsu. Zapisano w tej przeglądarce.',
  'settings.appearance': 'Wygląd',
  'settings.appearanceHint': 'Jasny, ciemny lub zgodny z ustawieniami systemu.',
  'settings.themeSystem': 'Systemowy',
  'settings.themeLight': 'Jasny',
  'settings.themeDark': 'Ciemny',
  'settings.agentModelHead': 'Model dla:',
  'settings.modelPicker': 'Model',
  'settings.modelSourceLive': 'Na żywo z CLI',
  'settings.modelSourceFallback': 'Lista wbudowana',
  'settings.reasoningPicker': 'Poziom rozumowania',
  'settings.modelPickerHint': 'Pobierane z CLI, gdy obsługuje ono polecenie `models`. „Domyślne” pozostawia wybór konfiguracji CLI; „Własne…” pozwala wpisać dowolne ID modelu akceptowane przez CLI.',
  'settings.modelPickerLiveHint': 'Modele zostały odświeżone z zainstalowanego CLI. Domyślny wybór nadal używa konfiguracji CLI.',
  'settings.modelPickerLiveCatalogOnlyHint': 'Modele zostały odświeżone z zainstalowanego CLI.',
  'settings.modelPickerFallbackHint': 'Wyświetlane są wbudowane wartości domyślne. Kliknij Ponów skanowanie, aby pobrać modele na żywo z CLI.',
  'settings.cliEnvTitle': 'Zaawansowane: proxy i własne ścieżki',
  'settings.cliEnvHint': 'Użyj tych pól, aby nadpisać środowisko wybranej CLI: API keys, proxy base URL, własne home lub niestandardowe ścieżki binarne. Bez base URL CLI używa własnego domyślnego endpointu. Sekrety pozostają w lokalnej konfiguracji aplikacji i widzi je tylko wybrana CLI.',
  'settings.cliEnvClaudeConfigDir': 'Katalog konfiguracji Claude Code',
  'settings.cliEnvClaudeBaseUrl': 'Base URL serwera proxy Claude',
  'settings.cliEnvClaudeApiKey': 'Claude CLI API key',
  'settings.cliEnvCodexHome': 'Katalog domowy Codex',
  'settings.cliEnvCodexBin': 'Ścieżka pliku wykonywalnego Codex',
  'settings.cliEnvCodexBaseUrl': 'Base URL serwera proxy Codex/OpenAI',
  'settings.cliEnvCodexApiKey': 'Codex/OpenAI CLI API key',
  'settings.modelCustom': 'Własny (wpisz poniżej)…',
  'settings.modelCustomLabel': 'Własne ID modelu',
  'settings.modelCustomPlaceholder': 'np. anthropic/claude-sonnet-4-6',
  'settings.mediaProviders': 'Dostawcy multimediów',
  'settings.mediaProvidersHint': 'Klucze API do generowania obrazów, wideo i dźwięku. Przechowywane lokalnie i synchronizowane z lokalnym daemonem.',
  'settings.mcpServerTitle': 'Serwer MCP',
  'settings.mcpServerHint': 'Udostępnij Crie3 jako serwer MCP dla swojego agenta kodu.',
  'settings.externalMcpTitle': 'Zewnętrzny MCP',
  'settings.externalMcpHint': 'Dodaj narzędzia MCP z usług zewnętrznych (Higgsfield, GitHub, …).',
  'settings.mediaProviderApiKey': 'Klucz API',
  'settings.mediaProviderBaseUrl': 'Bazowy URL',
  'settings.mediaProviderConfigured': 'Skonfigurowano',
  'settings.mediaProviderUnset': 'Nieustawione',
  'settings.mediaProviderClear': 'Wyczyść',
  'settings.mediaProviderClearConfirm': 'Usunąć zapisane ustawienia dla {name}? Aby ponownie używać {name}, musisz wprowadzić je ponownie.',
  'settings.mediaProviderPlaceholder': 'Wklej klucz API',
  'settings.mediaProviderBaseUrlPlaceholder': 'Nadpisz domyślny bazowy URL',
  'settings.mediaProviderReload': 'Przeładuj z lokalnego daemona',
  'settings.mediaProviderReloadError': 'Nie udało się ponownie wczytać ustawień dostawców mediów z lokalnego demona.',
  'settings.mediaProviderReloadSuccess': 'Ustawienia dostawców mediów zostały ponownie wczytane z lokalnego demona.',
  'settings.mediaProviderLoadError': 'Nie udało się wczytać ustawień dostawców mediów z lokalnego demona. Na razie używane będą ustawienia zapisane w przeglądarce.',
  'settings.mediaProviderComingSoonHint': 'Śledzimy je w mapie drogowej; daemon nie dostarcza jeszcze klienta, więc nie ma nic do skonfigurowania.',
  'settings.privacy': 'Prywatność',
  'settings.privacyHint': 'Jakie dane są udostępniane zespołowi Crie3',
  'settings.privacyConsentKicker': 'Pomóż nam ulepszyć Crie3',
  'settings.privacyConsentLead': 'Udostępnianie danych o użytkowaniu pomaga nam zrozumieć, jak Crie3 działa w prawdziwych przepływach pracy, abyśmy mogli ulepszać części najważniejsze dla Twojego doświadczenia.',
  'settings.privacyConsentFooter': 'Te opcje możesz zmienić w dowolnej chwili w Ustawienia → Prywatność.',
  'settings.privacyConsentShare': 'Udostępnij',
  'settings.privacyConsentDecline': 'Nie udostępniaj',
  'settings.privacyConsentAccept': 'Rozumiem',
  'settings.privacyConsentBannerFooter': 'Udostępnianie danych jest domyślnie włączone. Możesz je wyłączyć w dowolnej chwili w Ustawienia → Prywatność.',
  'settings.privacyConsentPolicyLink': "Zobacz ustawienia prywatności",
  'settings.privacyMetrics': 'Anonimowe metryki',
  'settings.privacyMetricsHint': 'Liczba uruchomień, zużycie Token, wskaźnik błędów i czas trwania jako podstawowe metryki użycia.',
  'settings.privacyContent': 'Treść rozmów',
  'settings.privacyContentHint': 'Po usunięciu sekretów i innych informacji wrażliwych używamy promptów, odpowiedzi asystenta, wejść/wyjść narzędzi oraz kontekstu potrzebnego do przeglądu jakości.',
  'settings.privacyConsentContentExcluded': 'Nie jest udostępniane tym wyborem. Treść rozmów pozostaje wyłączona, dopóki nie włączysz jej w Ustawieniach → Prywatność.',
  'settings.privacyInstallationId': 'Anonimowy identyfikator',
  'settings.privacyOptedOut': 'zrezygnowano',
  'settings.privacyDataDeletion': 'Usuń moje dane',
  'settings.privacyDataDeletionHint': 'Zmienia Twój anonimowy identyfikator i zatrzymuje wysyłanie. Istniejące dane śledzenia wygasają zgodnie z naszą polityką przechowywania.',
  'settings.legal': 'Warunki',
  'settings.legalHint': 'Warunki korzystania i polityka prywatności',
  'settings.plans': 'Plany',
  'settings.plansHint': 'Ceny i limity subskrypcji',
  'settings.billing': 'Subskrypcja',
  'settings.billingHint': 'Twój plan i dane płatności',
  'legal.tabTerms': 'Warunki korzystania',
  'legal.tabPrivacy': 'Polityka prywatności',
  'legal.badgeDefault': 'Szablon domyślny',
  'legal.defaultNotice': 'Szablon domyślny — uzupełnij pola w nawiasach kwadratowych i zleć weryfikację przed publikacją.',
  'legal.updatedAt': 'Zaktualizowano {date}',
  'legal.reset': 'Przywróć szablon domyślny',
  'legal.resetConfirm': 'Przywrócić szablon domyślny? Bieżący tekst zostanie utracony.',
  'legal.exportPdf': 'Eksportuj PDF',
  'legal.exportDocx': 'Eksportuj DOCX',
  'legal.exporting': 'Eksportowanie…',
  'legal.readOnly': 'Tylko do odczytu. Te dokumenty może edytować wyłącznie operator tej instalacji.',
  'legal.titleLabel': 'Tytuł',
  'legal.bodyLabel': 'Treść (Markdown)',
  'legal.bodyHint': 'Użyj # dla nagłówków i - dla list. Ten sam tekst trafia na ekran, do PDF i do DOCX.',
  'legal.loadError': 'Nie udało się wczytać dokumentów.',
  'legal.saveError': 'Nie udało się zapisać dokumentu.',
  'legal.exportError': 'Nie udało się wyeksportować dokumentu.',
  'legal.saved': 'Dokument zapisany.',
  'legal.bodyRequired': 'Treść nie może być pusta.',
  'settings.briefing': 'Moja marka',
  'settings.briefingHint': 'Profil marki używany w materiałach i przez AI',
  'briefing.intro': 'Te dane automatycznie wypełniają materiały (adres, media społecznościowe, osoby), więc nie musisz ich wpisywać za każdym razem.',
  'briefing.loadError': 'Nie udało się wczytać profilu.',
  'briefing.saveError': 'Nie udało się zapisać profilu.',
  'briefing.logoUploadError': 'Nie udało się przesłać logo.',
  'briefing.saved': 'Zapisano.',
  'briefing.saving': 'Zapisywanie…',
  'briefing.save': 'Zapisz',
  'briefing.nameLabel': 'Nazwa',
  'briefing.cityLabel': 'Miasto',
  'briefing.addressLabel': 'Adres',
  'briefing.serviceTimesLabel': 'Stałe godziny',
  'briefing.servicesLabel': 'Plan tygodnia',
  'briefing.servicesHint': 'Dzień i godzina każdego stałego wydarzenia (nabożeństwo, próba, transmisja na żywo).',
  'briefing.serviceDay': 'Dzień',
  'briefing.serviceTime': 'Godzina',
  'briefing.serviceNamePlaceholder': 'Nazwa (opcjonalnie), np. Nabożeństwo rodzinne, Próba',
  'briefing.serviceAdd': 'Dodaj godzinę',
  'briefing.serviceRemove': 'Usuń godzinę',
  'briefing.serviceIncomplete': 'Wpisz godzinę w każdym wierszu lub usuń wiersz.',
  'briefing.timezoneLabel': 'Strefa czasowa',
  'briefing.timezone.saoPaulo': 'Czas Brasílii (UTC−3)',
  'briefing.timezone.manaus': 'Manaus, Cuiabá, Campo Grande (UTC−4)',
  'briefing.timezone.rioBranco': 'Acre (UTC−5)',
  'briefing.timezone.noronha': 'Fernando de Noronha (UTC−2)',
  'briefing.socialHandlesLabel': 'Media społecznościowe',
  'briefing.contactsLabel': 'Kontakty',
  'briefing.contactWhatsapp': 'WhatsApp',
  'briefing.contactPhone': 'Telefon',
  'briefing.contactEmail': 'E-mail',
  'briefing.contactSite': 'Strona WWW',
  'briefing.customFieldsLabel': 'Pola własne',
  'briefing.customFieldsHint': 'Na to, co dotyczy tylko tego klienta, np. wyznanie albo gdzie słuchać.',
  'briefing.customFieldLabelPlaceholder': 'Etykieta',
  'briefing.customFieldValuePlaceholder': 'Wartość',
  'briefing.customFieldAdd': 'Dodaj pole',
  'briefing.customFieldRemove': 'Usuń',
  'clients.listHeading': 'Klienci',
  'clients.listHint': 'Każdy klient ma własny profil, system projektowy i Instagram.',
  'clients.limitUsage': '{used} z {limit} klientów w Twoim planie.',
  'clients.limitReached': 'Aby dodać więcej klientów, zmień plan w Subskrypcji.',
  'clients.new': 'Nowy klient',
  'clients.namePlaceholder': 'Nazwa klienta',
  'clients.create': 'Utwórz',
  'clients.default': 'Główny',
  'clients.open': 'Otwórz',
  'clients.back': 'Wszyscy klienci',
  'clients.nameLabel': 'Nazwa klienta',
  'clients.typeLabel': 'Typ',
  'clients.type.igreja': 'Kościół',
  'clients.type.ministerio': 'Służba',
  'clients.type.pregador': 'Kaznodzieja',
  'clients.type.cantor_banda': 'Wokalista lub zespół',
  'clients.type.criador': 'Twórca treści',
  'clients.type.evento': 'Wydarzenie',
  'clients.type.agencia': 'Agencja',
  'clients.type.outro': 'Inny',
  'clients.designSystemLabel': 'System projektowy',
  'clients.designSystemDefault': 'Domyślny dla konta',
  'clients.instagramLabel': 'Instagram',
  'clients.instagramNone': 'Brak',
  'clients.save': 'Zapisz klienta',
  'clients.saved': 'Klient zapisany.',
  'clients.loadError': 'Nie udało się wczytać klientów.',
  'clients.saveError': 'Nie udało się zapisać klienta.',
  'clients.nameTaken': 'Inny klient ma już tę nazwę.',
  'clients.instagramTaken': 'Ten Instagram należy już do innego klienta.',
  'clients.inviteButton': 'Zaproś do połączenia',
  'clients.inviteHint': 'Wyślij ten link klientowi. Działa 7 dni i dla jednego połączenia; nowy link zastępuje ten.',
  'clients.inviteExpires': 'Ważny do {date}',
  'clients.inviteCopy': 'Kopiuj link',
  'clients.inviteCopied': 'Link skopiowany.',
  'clients.inviteNew': 'Nowy link',
  'clients.instagramConnect': 'Połącz Instagram',
  'clients.instagramConnectHint': 'Otwiera Instagram, abyś sam go autoryzował; konto zostaje przy tym kliencie.',
  'clients.instagramConnected': 'Instagram połączony z tym klientem.',
  'clients.instagramConnectError': 'Nie udało się połączyć Instagrama. Spróbuj ponownie.',
  'clients.instagramConnectTaken': 'Ten Instagram jest już przypisany do innego klienta.',
  'clients.instagramReconnect': 'Połącz ponownie Instagram',
  'clients.instagramStatusConnected': 'Połączono: {handle}, od {date}',
  'clients.instagramStatusReconnect': '{handle} wymaga ponownej autoryzacji; do tego czasu posty się nie opublikują.',
  'clients.instagramStatusMissing': 'Instagram tego klienta nie jest już połączony. Połącz go ponownie.',
  'clients.instagramStatusNone': 'Ten klient nie ma jeszcze połączonego Instagrama.',
  'clients.instagramBadgeConnected': 'Instagram połączony',
  'clients.instagramBadgeReconnect': 'Połącz ponownie Instagram',
  'clients.inviteRevoke': 'Unieważnij link',
  'clients.inviteError': 'Nie udało się utworzyć linku z zaproszeniem.',
  'invite.title': 'Połącz Instagram',
  'invite.body': '{inviter} zaprasza {client} do połączenia Instagrama z Crie3, aby planować posty.',
  'invite.bodyNoInviter': '{client} otrzymał zaproszenie do połączenia swojego Instagrama z Crie3, aby planować posty.',
  'invite.whoSent': 'osoby, która wysłała zaproszenie',
  'invite.connect': 'Połącz Instagram',
  'invite.privacy': 'Autoryzujesz bezpośrednio w Instagramie. Crie3 nigdy nie widzi Twojego hasła.',
  'invite.connected': 'Gotowe! Instagram @{username} jest połączony z {client}.',
  'invite.connectedNoName': 'Gotowe! Instagram jest połączony z {client}.',
  'invite.expired': 'Ten link wygasł. Poproś {inviter} o nowy link.',
  'invite.revoked': 'Ten link nie jest już ważny. Poproś {inviter} o nowy link.',
  'invite.notFound': 'Ten link nie istnieje. Sprawdź, czy skopiowano go w całości.',
  'invite.loading': 'Ładowanie…',
  'invite.loadError': 'Nie udało się otworzyć zaproszenia. Spróbuj ponownie.',
  'invite.errorDenied': 'Autoryzację anulowano w Instagramie. Możesz spróbować ponownie.',
  'invite.errorTaken': 'Ten Instagram jest już połączony z innym klientem lub kontem. Użyj innego Instagrama albo porozmawiaj z {inviter}.',
  'invite.errorGeneric': 'Nie udało się połączyć. Spróbuj ponownie.',
  'clients.archive': 'Archiwizuj',
  'clients.archiveConfirm': 'Zarchiwizować {name}? Projekty pozostaną, a Instagram zostanie zwolniony dla innego klienta.',
  'clients.delete': 'Usuń klienta',
  'clients.deleteTitle': 'Usunąć {name}?',
  'clients.deleteBody': 'Tego nie da się cofnąć. Instagram klienta zostanie odłączony od Crie3, a otwarte linki z zaproszeniem przestaną działać. Aby tylko ukryć klienta, użyj Archiwizuj.',
  'clients.deleteProjectsQuestion': 'Co z projektami tego klienta?',
  'clients.deleteMove': 'Przenieś projekty do {main}',
  'clients.deleteDrop': 'Usuń także projekty',
  'clients.deleteConfirm': 'Usuń na stałe',
  'clients.deleteScheduled': '{name} ma zatwierdzone lub zaplanowane posty: {count}. Anuluj je w Kalendarzu przed usunięciem.',
  'clients.deleteError': 'Nie udało się usunąć. Nic nie zostało usunięte; spróbuj ponownie.',
  'clients.profileHeading': 'Profil',
  'clients.layoutsHeading': 'Zapisane szablony',
  'clients.layoutsEmpty': 'Brak szablonów. Gdy zatwierdzisz post w Kalendarzu, Crie3 zapyta, czy zapisać go jako szablon tego klienta.',
  'clients.layoutUse': 'Użyj',
  'clients.layoutDelete': 'Usuń',
  'clients.layoutDeleteConfirm': 'Usunąć szablon „{name}”?',
  'clients.layoutError': 'Nie udało się. Spróbuj ponownie.',
  'briefing.pastorsLabel': 'Osoby występujące w materiałach',
  'briefing.pastorNamePlaceholder': 'Imię',
  'briefing.pastorRolePlaceholder': 'Rola',
  'briefing.pastorRemove': 'Usuń',
  'briefing.pastorAdd': 'Dodaj',
  'briefing.missionLabel': 'Opis',
  'briefing.audienceLabel': 'Odbiorcy',
  'briefing.bibleVersionLabel': 'Przekład Biblii',
  'briefing.voiceAdjectivesLabel': 'Ton — przymiotniki',
  'briefing.voiceUseLabel': 'Ton — używać',
  'briefing.voiceAvoidLabel': 'Ton — unikać',
  'briefing.commaHint': 'oddziel przecinkami',
  'briefing.voiceSheet.heading': 'Karta głosu',
  'briefing.voiceSheet.hint': 'Co marka naprawdę pisze. Materiały trzymają się tych zwrotów i nigdy nie używają zakazanego słowa.',
  'briefing.voiceSheet.realPhrases': 'Prawdziwe zdania (jedno w wierszu)',
  'briefing.voiceSheet.greetings': 'Używane powitania',
  'briefing.voiceSheet.forbidden': 'Zakazane słowa',
  'briefing.voiceSheet.register': 'Rejestr',
  'briefing.voiceSheet.registerUnset': 'Do potwierdzenia',
  'briefing.voiceSheet.registerOption.sobrio': 'Stonowany',
  'briefing.voiceSheet.registerOption.caloroso': 'Ciepły',
  'briefing.voiceSheet.registerOption.fervoroso': 'Żarliwy',
  'briefing.voiceSheet.hashtagsFixed': 'Stałe hashtagi (3–5)',
  'briefing.voiceSheet.hashtagBrand': 'Hashtag marki',
  'briefing.doctrine.heading': 'Kalibracja doktrynalna',
  'briefing.doctrine.hint': 'Punkt zostawiony jako „Do potwierdzenia” nigdy nie jest zakładany w materiale.',
  'briefing.doctrine.family': 'Rodzina wyznaniowa',
  'briefing.doctrine.giftsTongues': 'Dary Ducha / języki',
  'briefing.doctrine.faithHealing': 'Uzdrowienie przez wiarę',
  'briefing.doctrine.prosperity': 'Teologia sukcesu',
  'briefing.doctrine.eternalSecurity': 'Wieczne bezpieczeństwo',
  'briefing.doctrine.predestination': 'Predestynacja',
  'briefing.doctrine.womenInMinistry': 'Kobiety w służbie',
  'briefing.doctrine.stance.afirma': 'Potwierdza',
  'briefing.doctrine.stance.neutro': 'Neutralnie',
  'briefing.doctrine.stance.nega': 'Odrzuca',
  'briefing.doctrine.stance.aConfirmar': 'Do potwierdzenia',
  'briefing.decisions.label': 'Zatwierdzone decyzje',
  'briefing.decisions.hint': 'Co zatwierdzono na żywo. Kolejne materiały wychodzą od tego.',
  'briefing.decisions.empty': 'Jeszcze nic nie zapisano.',
  'briefing.decisions.remove': 'Usuń decyzję',
  'briefing.decisions.kind.voz': 'Głos',
  'briefing.decisions.kind.visual': 'Wizualne',
  'briefing.spacePhotos.label': 'Zdjęcia miejsca',
  'briefing.spacePhotos.hint': 'Prawdziwe zdjęcia świątyni, ołtarza lub fasady. Tylko zdjęcie dobrej jakości może być głównym elementem materiału.',
  'briefing.spacePhotos.add': 'Dodaj zdjęcie',
  'briefing.spacePhotos.descriptionPlaceholder': 'Co przedstawia',
  'briefing.spacePhotos.quality': 'Jakość',
  'briefing.spacePhotos.quality.boa': 'Dobra',
  'briefing.spacePhotos.quality.mediana': 'Średnia',
  'briefing.spacePhotos.remove': 'Usuń zdjęcie',
  'briefing.spacePhotos.uploadError': 'Nie udało się przesłać zdjęcia. Użyj JPEG, PNG lub WebP do 12 MB.',
  'briefing.spacePhotos.saveError': 'Nie udało się zaktualizować zdjęcia.',
  'briefing.colorsLabel': 'Kolory marki',
  'briefing.fontsLabel': 'Czcionki marki',
  'briefing.logoLightLabel': 'Jasne logo',
  'briefing.logoDarkLabel': 'Ciemne logo',
  'briefing.logoLightHint': 'Na jasne tła',
  'briefing.logoDarkHint': 'Na ciemne tła',
  'briefing.logoEmpty': 'Nie przesłano logo',
  'briefing.logoUnavailable': 'Nie udało się pokazać tego logo. Odśwież stronę.',
  'briefing.logoChoose': 'Wybierz obraz',
  'briefing.logoUploading': 'Przesyłanie…',
  'briefing.fillWithAi': 'Wypełnij z agentem Crie3',
  'briefing.fillWithAiHint': 'Odpowiedz na kilka pytań, a AI wypełni pola. Twoje odpowiedzi zastąpią obecne dane; historia zachowa poprzednią wersję.',
  'briefing.fillWithAiCost': 'Ta rozmowa zużywa kredyty AI z Twojego planu: każda odpowiedź liczy się trochę. Tworzenie grafik przez połączonego asystenta (MCP) nic nie zużywa.',
  'briefing.interviewDone': 'Gotowe! Profil został zaktualizowany na podstawie Twoich odpowiedzi.',
  'briefing.interviewClose': 'Zamknij wywiad',
  'briefing.interviewError': 'Nie można teraz kontynuować wywiadu. Zamknij go i uzupełnij pola ręcznie albo spróbuj później.',
  'briefing.interviewErrorQuota': 'Twoje konto wykorzystało limit AI na ten miesiąc. Zamknij wywiad i uzupełnij pola ręcznie; w przyszłym miesiącu znów zadziała.',
  'briefing.interviewErrorNotConfigured': 'Wywiad z AI nie jest dostępny w tej instalacji. Zamknij go i uzupełnij pola ręcznie.',
  'briefing.historyLabel': 'Historia zmian',
  'briefing.historySource.ui': 'w aplikacji',
  'briefing.historySource.cli': 'przez CLI',
  'briefing.historySource.api': 'przez API',
  'briefing.historySource.onboarding': 'przez wywiad z AI',
  'briefing.unsavedChanges': 'Niezapisane zmiany',
  'settings.about': 'O aplikacji',
  'settings.aboutHint': 'Szczegóły wersji i środowiska uruchomieniowego',
  'settings.appVersion': 'Wersja',
  'settings.appChannel': 'Kanał',
  'settings.appRuntime': 'Środowisko',
  'settings.appPlatform': 'Platforma',
  'settings.appArchitecture': 'Architektura',
  'settings.runtimePackaged': 'Aplikacja spakowana',
  'settings.runtimeDevelopment': 'Rozwojowe',
  'settings.versionUnavailable': 'Szczegóły wersji są niedostępne, gdy daemon jest offline.',
  "settings.allowSilentUpdates": "Zezwalaj na ciche aktualizacje",
  "settings.allowSilentUpdatesDesc": "Automatycznie stosuj pobrane aktualizacje payload przy starcie. Aktualizacje z instalatorem nadal pytają najpierw.",
  'settings.installLatest': 'Zainstaluj najnowszą wersję',
  'settings.alreadyLatest': 'Masz już najnowszą wersję',
  'settings.updateCheck': 'Sprawdź aktualizacje',
  'settings.updateNow': 'Zaktualizuj teraz',
  'settings.updateRecheck': 'Sprawdź ponownie',
  'settings.updateRetry': 'Spróbuj ponownie',
  'settings.updateViewReleases': 'Informacje o wydaniu',
  'settings.updateActionFailed': 'Nie udało się wykonać akcji aktualizacji.',
  'settings.updateQuitFailed': 'Instalator został otwarty, ale Crie3 nie mógł zamknąć się automatycznie.',
  'settings.updateStatusNotChecked': 'Jeszcze nie sprawdzono',
  'settings.updateStatusDevelopment': 'Wersje deweloperskie nie obsługują aktualizacji w aplikacji.',
  'settings.updateStatusUnsupported': 'To środowisko nie obsługuje aktualizacji w aplikacji.',
  'settings.updateStatusChecking': 'Sprawdzanie aktualizacji...',
  'settings.updateStatusUpToDate': 'Masz już najnowszą wersję.',
  'settings.updateStatusAvailable': 'Znaleziono wersję {version}. Przygotowanie pobierania.',
  'settings.updateStatusAvailableUnknown': 'Znaleziono nową wersję. Przygotowanie pobierania.',
  'settings.updateStatusDownloading': 'Pobieranie aktualizacji...',
  'settings.updateStatusDownloadingPercent': 'Pobieranie aktualizacji {percent}%.',
  'settings.updateStatusReady': 'Wersja {version} jest gotowa do instalacji.',
  'settings.updateStatusReadyUnknown': 'Aktualizacja jest gotowa do instalacji.',
  'settings.updateStatusInstalling': 'Instalowanie aktualizacji...',
  'settings.updateStatusFailed': 'Sprawdzanie nie powiodło się. Spróbuj ponownie.',
  'settings.mcpTitle': 'Serwer MCP',
  'settings.mcpHint': 'Pozwól agentom do kodowania (Cursor, Claude Code, VS Code…) bezpośrednio odczytywać Twoje projekty Crie3.',
  'settings.mcpDaemonError': 'Nie udało się połączyć z lokalnym demonem, aby ustalić ścieżki instalacji ({error}). Upewnij się, że Crie3 jest uruchomione, a następnie otwórz ten panel ponownie.',
  'settings.mcpBuildDaemon': 'Najpierw zbuduj demona.',
  'settings.mcpNodeMissing': 'Brakuje pliku binarnego Node.',
  'settings.mcpBuildHint': 'Brakuje apps/daemon/dist/cli.js. Uruchom `pnpm --filter @open-design/daemon build` i odśwież.',
  'settings.mcpMethodCli': 'Polecenie CLI',
  'settings.mcpInstructionCli': 'Uruchom to w swoim terminalu.',
  'settings.mcpMethodToml': 'Konfiguracja TOML',
  'settings.mcpInstructionCodex': 'Dołącz tę tabelę do {path}. Ta sama konfiguracja jest współdzielona między Codex CLI a rozszerzeniem Codex do IDE.',
  'settings.mcpMethodOneClick': 'Instalacja jednym kliknięciem',
  'settings.mcpInstructionCursor': 'Kliknij „Install in Cursor”, aby zainstalować z oknem zatwierdzenia, lub scal ten JSON z {path}.',
  'settings.mcpDeeplinkInstallCursor': 'Zainstaluj w Cursor',
  'settings.mcpMethodJson': 'Konfiguracja JSON',
  'settings.mcpInstructionCopilot': 'Otwórz Command Palette ({shortcut}), uruchom „MCP: Open User Configuration” i scal ten JSON. Copilot Chat musi być w trybie Agent, aby narzędzia się pojawiły.',
  'settings.mcpInstructionAntigravity': 'W Antigravity: panel Agent, menu „...” → MCP Servers → Manage MCP Servers → View raw config. Scal ten JSON.',
  'settings.mcpInstructionZed': 'Otwórz Zed Settings ({shortcut}) i scal to z obiektem najwyższego poziomu. Zed używa „context_servers”, a nie „mcpServers”.',
  'settings.mcpInstructionWindsurf': 'Otwórz {path} (lub użyj ikony MCP w Cascade → Configure) i scal:',
  'settings.mcpCopyAria': 'Skopiuj fragment konfiguracji MCP',
  'settings.mcpResolvingFailed': '# rozpoznawanie ścieżek nie powiodło się, zobacz błąd powyżej',
  'settings.mcpLoadingPaths': '# wczytywanie ścieżek instalacji z lokalnego daemona…',
  'settings.mcpCopied': 'Skopiowano',
  'settings.mcpCopy': 'Kopiuj',
  'settings.mcpCursorApproval': 'Cursor wyświetla okno zatwierdzenia przed zapisaniem konfiguracji.',
  'settings.mcpCodexOneClickInstall': 'Zainstaluj w Codex',
  'settings.mcpCodexOneClickUninstall': 'Usuń z Codex',
  'settings.mcpCodexOneClickUnavailable': 'Nie znaleziono Codex CLI w PATH — zainstaluj Codex lub wklej fragment ręcznie.',
  'settings.mcpCodexInstallSuccess': 'Zainstalowano. Uruchom ponownie Codex, aby załadować nowy serwer.',
  'settings.mcpCodexUninstallSuccess': 'Usunięto z Codex.',
  'settings.mcpCodexBusy': 'Pracuję…',
  'settings.mcpCodexInstallError': 'Operacja nie powiodła się: {error}',
  'settings.mcpRestartNote': 'Uruchom ponownie klienta, aby wykryć nowy serwer.',
  'settings.mcpRestartDetail': 'Większość edytorów ładuje serwery MCP tylko przy uruchomieniu. W Cursor / VS Code / Antigravity / Windsurf możesz uruchomić `Developer: Reload Window` z palety poleceń zamiast pełnego restartu. Zed i Claude Code wymagają zamknięcia i ponownego otwarcia.',
  'settings.mcpCapabilitiesTitle': 'Co potrafi Twój Agent',
  'settings.mcpCapabilityRead': 'Odczytuj lub przeszukuj dowolny plik w projekcie (HTML, JSX, CSS, JSON, SVG, Markdown).',
  'settings.mcpCapabilityPull': 'Pobierz pakiet projektu w jednym wywołaniu: plik wejściowy wraz z każdą zmienną CSS, komponentem i czcionką, do których się odwołuje.',
  'settings.mcpCapabilityDefault': 'Domyślnie używaj projektu i pliku otwartego w Crie3, dzięki czemu możesz powiedzieć „zbuduj to w mojej aplikacji” bez ponownego określania, o który projekt chodzi.',
  'settings.mcpRemoteHeading': 'Connect your coding agent',
  'settings.mcpRemoteIntro': 'Connect claude.ai, ChatGPT or a coding agent to this account over the internet.',
  'settings.mcpRemoteAddressLabel': 'Address',
  'settings.mcpRemoteKeyHeading': 'Access key',
  'settings.mcpRemoteKeyNone': 'No key yet. Create one so your agent can sign in.',
  'settings.mcpRemoteKeyCreated': 'Key created on {date}.',
  'settings.mcpRemoteGenerate': 'Create key',
  'settings.mcpRemoteRegenerate': 'Create a new key',
  'settings.mcpRemoteRegenerateNote': 'Creating a new key stops the previous one from working straight away.',
  'settings.mcpRemoteRevoke': 'Revoke key',
  'settings.mcpRemoteRevoked': 'The key was revoked. Anything still using it is now disconnected.',
  'settings.mcpRemoteBusy': 'One moment…',
  'settings.mcpRemoteKeyLabel': 'Your new key',
  'settings.mcpRemoteKeyOnce': 'Copy this key now — it is shown once and cannot be recovered afterwards.',
  'settings.mcpRemoteSnippetHeading': 'Ready to paste',
  'settings.mcpRemoteSnippetNote': 'Paste this into your agent settings. If you have already closed the key, replace the marked part with yours.',
  'settings.mcpRemoteScopeNote': 'The key and the connected apps can read your projects and start new work, including asking the Crie3 agent to change pieces. They cannot delete projects or publish posts without your approval.',
  'settings.mcpRemoteError': 'Something went wrong: {error}',
  'settings.mcpRemoteKeyPlaceholder': 'YOUR-ACCESS-KEY',
  'settings.mcpRemoteOAuthHint': 'In claude.ai, ChatGPT or Claude Code, add this address as a custom connector (remote MCP server). Crie3 asks for your e-mail and password when you connect.',
  'settings.mcpRemoteKeyForOthers': 'For agents without login support, or for scripts, create a key and send it in the Authorization header.',
  'settings.mcpConnectionsHeading': 'Connected apps',
  'settings.mcpConnectionsEmpty': 'No app has connected through login yet.',
  'settings.mcpConnectionsSince': 'Connected on {date}',
  'settings.mcpConnectionsLastUsed': 'last used {date}',
  'settings.mcpConnectionsDisconnect': 'Disconnect',
  'settings.mcpConnectionsDisconnected': '{name} was disconnected. It stops working on its next call.',
  'settings.mcpConnectionsNote': 'Changing your password does not disconnect these apps. Disconnect here any app you no longer use.',
  'settings.mcpRunningNote': 'Crie3 musi być uruchomione, aby wywołania narzędzi MCP zakończyły się powodzeniem. Jeśli uruchomiłeś swojego Agenta do kodowania przed otwarciem Crie3, uruchom Agenta ponownie, aby mógł połączyć się z działającym demonem.',
  'entry.tabDesigns': 'Projekty',
  'entry.tabTemplates': 'Szablony',
  'entry.tabDesignSystems': 'Systemy projektowania',
  'entry.tabConnectors': 'Konektory',
  'entry.openSettingsTitle': 'Ustawienia',
  'entry.openSettingsAria': 'Otwórz ustawienia',
  'entry.discordLabel': 'Dołącz do Discorda',
  'entry.discordOnlineLabel': '{count} online',
  'entry.followThreadsLabel': 'Follow Crie3 on Threads',
  'entry.youtubeLabel': 'Crie3 on YouTube',
  'entry.followLinkedinLabel': 'Obserwuj Crie3 na LinkedIn',
  'entry.followXiaohongshuLabel': 'Obserwuj Crie3 na Xiaohongshu',
  'entry.resizeAria': 'Zmień rozmiar paska bocznego',
  'entry.loadingWorkspace': 'Ładowanie obszaru roboczego…',
  'entry.useEverywhereTitle': 'Używaj wszędzie',
  'entry.useEverywhereAria': 'Otwórz przewodnik „Używaj wszędzie” (CLI, MCP, HTTP, Skills)',
  'entry.workspaceTeamsLabel': 'Teams',
  'entry.workspaceTeamsTitle': 'Workspace dla zespołów — powiedz nam, czego potrzebuje Twój zespół',
  'entry.workspaceTeamsAria': 'Otwórz stronę Workspace dla zespołów',
  'entry.navExpand': 'Rozwiń pasek boczny',
  'entry.navCollapse': 'Zwiń pasek boczny',
  'entry.navNewProject': 'Nowy projekt',
  'entry.navHome': 'Strona główna',
  'entry.navProjects': 'Projekty',
  'entry.navCalendar': 'Kalendarz',
  'entry.navClients': 'Klienci',
  'calendar.title': 'Kalendarz',
  'calendar.intro': 'Wszystkie zaplanowane posty. Zatwierdź, przenieś lub anuluj je przed publikacją.',
  'calendar.week': 'Tydzień',
  'calendar.client': 'Klient',
  'calendar.allClients': 'Wszyscy klienci',
  'calendar.month': 'Miesiąc',
  'calendar.previous': 'Poprzedni',
  'calendar.next': 'Następny',
  'calendar.today': 'Dziś',
  'calendar.loadError': 'Nie udało się wczytać kalendarza.',
  'calendar.empty': 'W tym okresie nic nie zaplanowano.',
  'calendar.more': '+{n} więcej',
  'calendar.state.draft': 'Do zatwierdzenia',
  'calendar.state.approved': 'Zatwierdzony',
  'calendar.state.queued': 'Zaplanowany',
  'calendar.state.publishing': 'Publikowanie',
  'calendar.state.handed_off': 'Gotowy do opublikowania przez Ciebie',
  'calendar.state.published': 'Opublikowany',
  'calendar.state.failed': 'Niepowodzenie',
  'calendar.state.canceled': 'Anulowany',
  'calendar.origin.user': 'Utworzony przez Ciebie',
  'calendar.origin.mcp': 'Szkic zewnętrznego asystenta',
  'calendar.origin.weekly': 'Wygenerowany przez Crie3',
  'calendar.approve': 'Zatwierdź',
  'calendar.approveTiktokHint': 'Posty TikTok zatwierdza się na ekranie publikacji, gdzie TikTok wymaga dodatkowych wyborów.',
  'calendar.reschedule': 'Przenieś',
  'calendar.rescheduleLabel': 'Nowa data i godzina',
  'calendar.unapprove': 'Wróć do szkicu',
  'calendar.cancel': 'Anuluj post',
  'calendar.cancelReason': 'Powód (opcjonalnie)',
  'calendar.close': 'Zamknij',
  'calendar.actionError': 'Nie udało się. Odśwież kalendarz i spróbuj ponownie.',
  'calendar.layoutOffer': 'Zapisać układ tego posta jako szablon klienta, aby użyć go ponownie?',
  'calendar.layoutNameLabel': 'Nazwa szablonu',
  'calendar.layoutSave': 'Zapisz jako szablon',
  'calendar.layoutDismiss': 'Nie teraz',
  'calendar.layoutSaved': 'Zapisano w szablonach klienta. Pojawia się na stronie klienta i dla asystenta w claude.ai.',
  'calendar.layoutError': 'Nie udało się zapisać szablonu tego posta.',
  'calendar.scheduledFor': 'Zaplanowano na {when}',
  'calendar.chipAutomatic': 'automatyczny',
  'calendar.automaticNotice': 'Automatyczny post: zostanie opublikowany {when}. Anuluj go tutaj, jeśli nie powinien wyjść.',
  'calendar.viewOnInstagram': 'Zobacz na Instagramie',
  'calendar.slideOf': 'Slajd {n} z {total}',
  'calendar.previousSlide': 'Poprzedni slajd',
  'calendar.nextSlide': 'Następny slajd',
  'calendar.failure.zernioDisconnected': 'Konto na Instagramie zostało odłączone, więc post nie został opublikowany. Połącz je ponownie i zaplanuj post jeszcze raz.',
  'calendar.failure.zernioPostFailed': 'Instagram nie opublikował tego posta. Sprawdź grafikę (format i rozmiar) i zaplanuj go jeszcze raz.',
  'calendar.reconnectInstagram': 'Połącz ponownie Instagram: @{account} zostało odłączone i zaplanowane posty nie zostaną opublikowane, dopóki nie połączysz go ponownie.',
  'calendar.reconnectAction': 'Połącz ponownie',
  'social.health.needsReconnect': 'wymaga ponownego połączenia',
  'social.automations.title': 'Słowo kluczowe → wiadomość',
  'social.automations.hint': 'Gdy ktoś skomentuje jednym z tych słów dowolny post na Instagramie, dostanie Twoją wiadomość w DM.',
  'social.automations.empty': 'Brak automatycznych odpowiedzi.',
  'social.automations.offline': 'Zernio nie odpowiada; pokazano zapisaną kopię.',
  'social.automations.keywords': 'Słowa kluczowe (oddzielone przecinkami)',
  'social.automations.keywordsPlaceholder': 'nabożeństwo, godziny',
  'social.automations.message': 'Wiadomość wysyłana w DM',
  'social.automations.reply': 'Publiczna odpowiedź na komentarz (opcjonalnie)',
  'social.automations.account': 'Które konto Instagram',
  'social.automations.create': 'Utwórz wstrzymaną',
  'social.automations.on': 'Włączona',
  'social.automations.paused': 'Wstrzymana',
  'social.automations.sent': 'Wysłano wiadomości: {count}',
  'social.automations.turnOn': 'Włącz',
  'social.automations.turnOff': 'Wstrzymaj',
  'social.automations.delete': 'Usuń',
  'social.automations.confirmOn': 'Włączyć odpowiedź dla „{keywords}”? Od teraz każdy, kto skomentuje tymi słowami, dostanie tę wiadomość w DM.',
  'social.automations.failed': 'Nie udało się zapisać automatycznej odpowiedzi. Spróbuj ponownie.',
  'social.automations.needsInstagram': 'Najpierw połącz Instagram kościoła.',
  'calendar.policy.AUTOMATIC_MODE_OFF': 'Powrót do wersji roboczej: tryb automatyczny został wyłączony. Zatwierdź, jeśli nadal ma zostać opublikowany.',
  'calendar.policy.MISSED_SLOT': 'Powrót do wersji roboczej: przekroczono termin. Wybierz nowy termin i zatwierdź ponownie.',
  'calendar.policy.NOT_ENOUGH_NOTICE': 'Powrót do wersji roboczej: automatyczny post musi spędzić 24 godziny w kalendarzu, zanim zostanie opublikowany.',
  'calendar.policy.NOT_ELIGIBLE_FOR_AUTOMATION': 'Wymaga Twojego zatwierdzenia: automatycznie publikowane są tylko cotygodniowe zaproszenia generowane przez Crie3.',
  'publishing.title': 'Tryb publikacji',
  'publishing.manual': 'Ręczny: każdy post czeka na Twoje zatwierdzenie.',
  'publishing.scopeHint': 'Same wychodzą tylko cotygodniowe zaproszenia „Moja marka”. Posty innych klientów czekają na twoją akceptację.',
  'publishing.automatic': 'Automatyczny na {account}: cotygodniowe zaproszenia publikują się same, każde widoczne tutaj najpierw przez 24 godziny.',
  'publishing.optedInBy': 'Włączone przez {who} dnia {when}.',
  'publishing.paused': 'Wstrzymane: nic nie jest publikowane ani generowane, dopóki nie wznowisz.',
  'publishing.turnOn': 'Włącz tryb automatyczny',
  'publishing.turnOff': 'Wróć do trybu ręcznego',
  'publishing.pause': 'Wstrzymaj wszystko',
  'publishing.resume': 'Wznów',
  'publishing.error': 'Nie udało się. Spróbuj ponownie.',
  'publishing.optInTitle': 'Publikacja automatyczna',
  'publishing.optInTerms': 'Gdy publikacja automatyczna jest włączona, Crie3 co tydzień generuje zaproszenie na każde nabożeństwo z sekcji „Moja marka” i publikuje je bez nowego zatwierdzenia, o godzinie pokazanej w kalendarzu. Każde pozostaje tutaj, z możliwością anulowania, przez co najmniej 24 godziny przed publikacją. Możesz w każdej chwili wstrzymać wszystko lub wrócić do trybu ręcznego.\n\nTreści generowane przez AI mogą zawierać błędy. Włączając tę opcję, bierzesz odpowiedzialność za to, co jest publikowane w imieniu Twojego kościoła, i zobowiązujesz się śledzić kalendarz. Wersje robocze od zewnętrznych asystentów nadal wymagają Twojego zatwierdzenia.',
  'publishing.termsLink': 'Przeczytaj Warunki korzystania (sekcja 12)',
  'publishing.optInAccount': 'Konto Instagram',
  'publishing.optInNoAccount': 'Najpierw połącz konto Instagram w Ustawieniach.',
  'publishing.optInAccept': 'Przeczytałem/-am i akceptuję sekcję 12 Warunków korzystania.',
  'publishing.optInConfirm': 'Włącz',
  'publishing.optInTermsChanged': 'Warunki zmieniły się, gdy to okno było otwarte. Przeczytaj je ponownie i potwierdź.',
  'weekly.title': 'Zaproszenia na ten tydzień',
  'weekly.empty': 'Dodaj swoje nabożeństwa w sekcji „Moja marka”, a Crie3 będzie tworzyć jedno zaproszenie na nabożeństwo co tydzień.',
  'weekly.scopeHint': 'Tylko dla „Moja marka”, na podstawie nabożeństw z jej profilu.',
  'weekly.runNow': 'Generuj teraz',
  'weekly.runNowStarted': 'Generowanie. Zaproszenia pojawiają się w kalendarzu w miarę gotowości.',
  'weekly.nextRun': 'Następne generowanie: {when}',
  'weekly.status.pending': 'Oczekuje',
  'weekly.status.generating': 'Generowanie',
  'weekly.status.scheduled': 'Zaplanowany',
  'weekly.status.draft': 'Do zatwierdzenia',
  'weekly.status.not_generated': 'Niewygenerowany',
  'weekly.error': 'Nie udało się wczytać zaproszeń na ten tydzień.',
  'weekly.offHint': 'Wyłączone. Po włączeniu Crie3 co tydzień tworzy jedno zaproszenie na każde nabożeństwo — każde zużywa generacje z Twojego planu.',
  'weekly.turnOn': 'Włącz',
  'weekly.turnOff': 'Wyłącz',
  'entry.navTasks': 'Automatyzacje',
  'entry.navPlugins': 'Wtyczki',
  'entry.navDesignSystems': 'Systemy projektowe',
  'entry.navBrands': 'Zestaw marki',
  'entry.navIntegrations': 'Integracje',
  'workspaceTabs.project': 'Projekt',
  'workspaceTabs.pluginDetails': 'Szczegóły wtyczki',
  'workspaceTabs.marketplace': 'Marketplace',
  'homeHero.title': 'Co dziś zaprojektujesz?',
  'homeHero.startWithTemplate': 'Zacznij od szablonu…',
  'homeHero.startBlankProject': '…lub zacznij pusty projekt',
  'homeHero.templatePicker.label': 'Szablon',
  'homeHero.templatePicker.searchPlaceholder': 'Szukaj szablonów',
  'homeHero.templatePicker.projectTypes': 'Typy projektów',
  'homeHero.templatesScrollHint': 'Przewiń w górę, aby zobaczyć więcej szablonów',
  'homeHero.templatesCollapse': 'Zwiń szablony',
  'homeHero.subtitlePrefix': 'Otwartoźródłowa alternatywa dla Claude Design.',
  'homeHero.placeholder': 'Opisz, co chcesz wygenerować…',
  'homeHero.placeholderActive': 'Edytuj przykładowe zapytanie lub napisz własne…',
  'homeHero.carousel.hint': 'Załącz plik, połącz swój design system lub opisz, co chcesz stworzyć',
  'homeHero.carousel.onePageBrief': 'Put together the church schedule for this week',
  'homeHero.carousel.notesToDeck': 'Turn my sermon notes into projection slides',
  'homeHero.carousel.signupFlow': 'Build a signup page for the retreat',
  'homeHero.carousel.improveBrief': 'Improve the wording of a baptism announcement',
  'homeHero.carousel.loadingAnimation': 'Create a countdown for the start of the service',
  'homeHero.carousel.teamUpdateSlides': 'Make slides with the song lyrics for the screen',
  'homeHero.carousel.ordersDashboard': 'Build a page to follow the giving campaign',
  'homeHero.carousel.productDetail': 'Lay out the artwork for a new sermon series',
  'homeHero.carousel.caseStudy': 'Write the script for the weekly devotional',
  'homeHero.carousel.landingIntro': 'Create an invite for the Friday youth service at 8pm',
  'homeHero.carousel.pitchDeck': 'Make slides to present the missions project',
  'homeHero.carousel.appIdea': 'Describe a daily devotional app for the church',
  'homeHero.carousel.landingLayout': 'Sketch a Bible verse card for the feed',
  'homeHero.skills': 'Umiejętności',
  'homeHero.addMenu': 'Dodaj kontekst',
  'homeHero.addPlugin': 'Dodaj wtyczkę',
  'homeHero.addConnectors': 'Dodaj konektory',
  'homeHero.addMcp': 'Dodaj serwer MCP',
  'homeHero.noPlugins': 'Brak zainstalowanych wtyczek',
  'homeHero.noMcp': 'Brak serwerów MCP',
  'homeHero.noConnectors': 'Brak połączonych konektorów',
  'homeHero.applying': 'Stosowanie…',
  'homeHero.pluginTitle': 'Wtyczka: {title}',
  'homeHero.pluginPrefix': 'Wtyczka: {title}',
  'homeHero.skillPrefix': 'Umiejętność: {title}',
  'homeHero.removePlugin': 'Usuń wtyczkę',
  'homeHero.removePluginAria': 'Usuń wtyczkę {title}',
  'homeHero.clearActivePlugin': 'Wyczyść aktywną wtyczkę',
  'homeHero.clearActiveSkill': 'Wyczyść aktywną umiejętność',
  'homeHero.contextItemsResolved': 'Rozwiązano {n} elementów kontekstu',
  'homeHero.removeFile': 'Usuń plik',
  'homeHero.contextSearchResults': 'Wyniki wyszukiwania kontekstu',
  'homeHero.contextSurfaces': 'Powierzchnie kontekstu',
  'homeHero.loadingContext': 'Wczytywanie kontekstu…',
  'homeHero.noResults': 'Brak wyników dla „{query}”.',
  'homeHero.searchPrompt': 'Przeszukaj pliki, wtyczki, umiejętności, serwery MCP i konektory.',
  'homeHero.parameters': '{n} parametrów',
  'homeHero.details': 'Szczegóły',
  'homeHero.toRun': 'aby uruchomić',
  'homeHero.forNewLine': 'dla nowego wiersza',
  'homeHero.run': 'Uruchom',
  'homeHero.typeSomethingToRun': 'Wpisz coś, aby uruchomić',
  'homeHero.promptExamples': 'Przykłady',
  'homeHero.footer.designSystem': 'Styl',
  'homeHero.footer.autoDesignSystem': 'Auto',
  'homeHero.footer.autoDesignSystemSummary': 'Automatycznie dobiera najlepszy system projektowy i styl wizualny do bieżącego promptu.',
  'homeHero.footer.ratio': 'Proporcje',
  'homeHero.footer.duration': 'Czas',
  'homeHero.footer.resolution': 'Rozdzielczość',
  'homeHero.footer.speakerNotes': 'Notatki',
  'homeHero.footer.noSpeakerNotes': 'Bez notatek',
  'homeHero.footer.availableCount': '{n} dostępnych',
  'homeHero.footer.noMatches': 'Brak dopasowań',
  'homeHero.moreShortcuts': 'Więcej',
  'homeHero.railAria': 'Wybierz kategorię projektu lub skrót startowy',
  'homeHero.subTypeAria': 'Wybierz podtyp',
  'homeHero.subTypeMore': 'Więcej',
  'homeHero.confirmReplaceTitle': 'Zastąpić bieżący prompt?',
  'homeHero.confirmReplaceBody': 'Użycie {title} zastąpi tekst znajdujący się obecnie w polu wprowadzania.',
  'homeHero.confirmReplace': 'Zastąp',
  'homeHero.chip.prototype': 'Prototyp',
  'homeHero.chip.webClone': 'Klon witryny',
  'homeHero.chip.liveArtifact': 'Aktywny artefakt',
  'homeHero.chip.deck': 'Prezentacja',
  'homeHero.chip.image': 'Obraz',
  'homeHero.chip.video': 'Wideo',
  'homeHero.chip.hyperframes': 'HyperFrames',
  'homeHero.chip.webgl': 'Doświadczenie WebGL',
  'homeHero.chip.webglDesc': 'Shadery, 3D i generatywne wizualizacje GPU',
  'homeHero.chip.worker': 'Wizualizator Worker',
  'homeHero.chip.workerDesc': 'Symulacje poza wątkiem, cząstki i wizualizacja danych',
  'homeHero.chip.audio': 'Dźwięk',
  'homeHero.chip.createBrandKit': 'Utwórz zestaw marki',
  'homeHero.chip.createPlugin': 'Utwórz wtyczkę',
  'homeHero.chip.figma': 'Z Figma',
  'homeHero.chip.folder': 'Z folderu',
  'homeHero.chip.template': 'Z szablonu',
  'homeHero.chip.liveArtifactHint': 'Zbuduj interaktywny artefakt HTML/CSS/JS, który możesz podejrzeć na żywo.',
  'homeHero.chip.hyperframesHint': 'Twórz animacje oparte na HTML: napisy, wizualizacje reagujące na dźwięk, przejścia między scenami.',
  'homeHero.chip.createBrandKitHint': 'Wyodrębnij zestaw marki ze strony internetowej, a następnie zastosuj go w dowolnym czacie.',
  'homeHero.chip.createPluginHint': 'Stwórz wielokrotnego użytku wtyczkę Crie3 i dodaj ją do Moich wtyczek.',
  'homeHero.chip.figmaHint': 'Przenieś ramkę Figma do aktywnego systemu projektowego.',
  'homeHero.chip.folderHint': 'Zaimportuj istniejący folder lokalny i kontynuuj edycję.',
  'homeHero.chip.templateHint': 'Zacznij od dołączonego szablonu.',
  'homeHero.chip.wireframe': 'Wireframe',
  'homeHero.chip.mobile': 'Mobile app',
  'homeHero.chip.document': 'Document',
  'homeHero.chip.prototypeDesc': 'Interactive app mockups',
  'homeHero.chip.webCloneDesc': 'Source-first site reproduction',
  'homeHero.chip.wireframeDesc': 'Lo-fi screens & flows',
  'homeHero.chip.mobileDesc': 'iOS & Android screens',
  'homeHero.chip.deckDesc': 'Presentations & pitch decks',
  'homeHero.chip.documentDesc': 'Resumes, reports & PDFs',
  'homeHero.chip.imageDesc': 'Posters, graphics & art',
  'homeHero.chip.videoDesc': 'Clips, reels & promos',
  'homeHero.chip.audioDesc': 'Voiceovers, music & SFX',
  'homeHero.chip.hyperframesDesc': 'Motion graphics & loops',
  'homeHero.chip.liveArtifactDesc': 'Data-backed live dashboards',
  'homeHero.chip.createBrandKitDesc': 'Extract a brand design system',
  'homeHero.chip.prototypeNext': 'Open a chat that builds a high-fidelity, clickable web prototype you refine turn by turn.',
  'homeHero.chip.webCloneNext': 'Open a chat that asks for a target URL, reconstructs the site, and audits the clone.',
  'homeHero.chip.wireframeNext': 'Open a chat that sketches lo-fi screens and flows to validate structure first.',
  'homeHero.chip.mobileNext': 'Open a chat that lays out mobile screens for iOS and Android.',
  'homeHero.chip.deckNext': 'Open a chat that builds a slide deck you can present and export.',
  'homeHero.chip.documentNext': 'Open a chat that drafts a polished document — resume, report, or PDF.',
  'homeHero.chip.imageNext': 'Open a chat that generates on-brand images you can iterate on.',
  'homeHero.chip.videoNext': 'Open a chat that produces a short video you can refine.',
  'homeHero.chip.audioNext': 'Open a chat that creates voiceover, music, or sound effects.',
  'homeHero.chip.webClonePromptSeed': 'Website URL to clone: ',
  'homeWorkingDir.trigger': 'Select working directory',
  'homeWorkingDir.pick': 'Choose folder',
  'homeWorkingDir.replace': 'Change working directory',
  'homeWorkingDir.recent': 'Recent folders',
  'homeWorkingDir.recentEmpty': 'No recent folders',
  'homeWorkingDir.clear': 'Remove working directory',
  'homeWorkingDir.hint': 'Let the agent read this local folder (not imported into Design Files)',
  'homeWorkingDir.missing': 'This working folder no longer exists — pick another',
  'homeWorkingDir.applyFailed': 'Couldn\'t set the working directory — the folder may no longer exist',
  'workingDirPicker.title': 'Folder',
  'workingDirPicker.homeTitle': 'Zapisywane w pamięci lokalnej — kliknij, aby wybrać folder',
  'workingDirPicker.processing': 'Przetwarzanie…',
  'workingDirPicker.select': 'Pamięć lokalna',
  'workingDirPicker.clearAria': 'Wyczyść katalog roboczy',
  'workingDirPicker.replaceFailed': 'Nie udało się zmienić katalogu roboczego',
  'workingDirPicker.unavailable': 'Wybór folderu jest niedostępny w tej kompilacji. Uruchom aplikację desktopową, aby wybrać folder.',
  'workingDirPicker.openUnavailable': 'Otwórz ten projekt w aplikacji desktopowej, aby wyświetlić folder.',
  'workingDirPicker.openFailed': 'Nie udało się wyświetlić tego folderu',
  'workingDirPicker.showInFileManager': 'Pokaż w menedżerze plików',
  'workingDirPicker.replace': 'Wybierz folder…',
  'workingDirPicker.recent': 'Ostatnie katalogi',
  'workingDirPicker.defaultLabel': 'Pamięć lokalna',
  'handoff.toTarget': 'Przekaż do {target}',
  'handoff.openInTarget': 'Otwórz w {target}',
  'handoff.openAction': 'Otwórz',
  'handoff.menuTitle': 'W którym edytorze otworzyć?',
  'handoff.action': 'Przekaż',
  'handoff.fallbackTitle': 'Nie znaleziono edytorów w $PATH - otwiera w {target}',
  'handoff.chooseTargetAria': 'Wybierz cel przekazania',
  'handoff.optionsAria': 'Opcje przekazania',
  'handoff.editorSection': 'Otwórz w edytorze',
  'handoff.cliSection': 'Kopiuj dla CLI',
  'handoff.clickOpen': 'Kliknij, aby otworzyć',
  'handoff.framework': 'Framework kodu',
  'handoff.framework.react': 'React',
  'handoff.framework.vue': 'Vue.js',
  'handoff.framework.svelte': 'Svelte',
  'handoff.framework.solid': 'SolidJS',
  'handoff.framework.next': 'Next.js',
  'handoff.framework.vanilla': 'JS',
  'handoff.frameworkPrompt.react': 'React',
  'handoff.frameworkPrompt.vue': 'Vue.js',
  'handoff.frameworkPrompt.svelte': 'Svelte',
  'handoff.frameworkPrompt.solid': 'SolidJS',
  'handoff.frameworkPrompt.next': 'Next.js / React',
  'handoff.frameworkPrompt.vanilla': 'czysty JavaScript, HTML i CSS',
  'handoff.amrWebsite': 'Otwórz stronę Crie3 Cloud',
  'handoff.copyPrompt': 'Kopiuj prompt',
  'handoff.copyPromptForTarget': 'Kopiuj prompt dla {target}',
  'handoff.copied': 'Skopiowano',
  'handoff.projectPathUnavailable': 'Ścieżka projektu wciąż się ładuje. Spróbuj ponownie za chwilę.',
  'handoff.copyFailed': 'Zapis do schowka został zablokowany. Spróbuj ponownie za chwilę.',
  'handoff.promptIntro': 'Kontynuuj z tego lokalnego folderu projektu Crie3:',
  'handoff.promptTarget': 'Cel',
  'handoff.promptCli': 'CLI',
  'handoff.promptStepsLead': 'Przejmujesz pracę w {cli}. Wykonaj następujące kroki:',
  'handoff.promptReadFiles': 'Najpierw wejdź do tego katalogu lub go odczytaj. Priorytetowo potraktuj DESIGN.md, README, istniejące pliki HTML/CSS/JS, zasoby oraz package.json, jeśli istnieje.',
  'handoff.promptKeepDesign': 'Zachowaj bieżący projekt wizualny, układ, interakcje i zasoby. Nie poprzestawaj na planie.',
  'handoff.promptProduceCode': 'Wygeneruj lub zmodyfikuj prawdziwy, uruchamialny kod {framework}. Jeśli projekt ma już bardziej przejrzysty stack, wskaż konflikt i zachowaj uruchamialność wyniku.',
  'handoff.promptVerify': 'Na koniec podaj mi polecenia uruchomienia, podglądu i weryfikacji.',
  'handoff.promptCommandHint': 'Aby rozpocząć z katalogu projektu, użyj:',
  'handoff.promptProject': 'Projekt',
  'handoff.promptProjectId': 'ID projektu',
  'handoff.notInstalled': 'Nie zainstalowano',
  'handoff.notDetectedTitle': '{target} - nie wykryto w $PATH',
  'designSystemPicker.select': 'Wybierz system projektowy',
  'designSystemPicker.loading': 'Wczytywanie systemów projektowych…',
  'designSystemPicker.searchPlaceholder': 'Szukaj systemów projektowych (tytuł / kategoria / podsumowanie)',
  'designSystemPicker.searchCompactPlaceholder': 'Szukaj systemów projektowych',
  'designSystemPicker.noneTitle': 'Brak systemu projektowego',
  'designSystemPicker.noneSummary': 'Pozwól modelowi wybrać dowolnie',
  'designSystemPicker.empty': 'Brak pasujących systemów projektowych',
  'designSystemPicker.openPreview': 'Otwórz podgląd',
  'designSystemPicker.loadingPreview': 'Wczytywanie podglądu…',
  'designSystemPicker.noPreview': 'Brak strony podglądu. Otwórz Systemy projektowe, aby zobaczyć pełny podgląd.',
  'designSystemPicker.previewHint': 'Najedź na system projektowy, aby go podejrzeć',
  'designSystemPicker.fullscreenAria': 'Podgląd pełnoekranowy: {title}',
  'designSystemPicker.closeFullscreen': 'Zamknij podgląd pełnoekranowy',
  'designSystemPicker.closeEsc': 'Zamknij (Esc)',
  'designSystemPicker.previewFrameTitle': 'Podgląd {title}',
  'designSystemPicker.fullscreenFrameTitle': 'Podgląd pełnoekranowy {title}',
  'recentProjects.title': 'Ostatnie projekty',
  'recentProjects.viewAll': 'Zobacz wszystkie',
  'recentProjects.empty': 'Brak projektów — wpisz prompt, aby rozpocząć.',
  'pluginsHome.title': 'Społeczność',
  'pluginsHome.subtitle': 'Gotowe do użycia przepływy pracy Crie3 dołączone do tego środowiska uruchomieniowego. Wybierz jeden, aby wczytać początkowy prompt, lub przeglądaj rejestr, aby znaleźć więcej.',
  'pluginsHome.browseRegistry': 'Przeglądaj rejestr',
  'pluginsHome.count': '{filtered} z {total}',
  'pluginsHome.loadingCatalog': 'Wczytywanie katalogu…',
  'pluginsHome.emptyCatalog': 'Katalog jest pusty. Wbudowane wtyczki są dostarczane z Crie3 i powinny pojawić się tutaj automatycznie — spróbuj ponownie uruchomić daemona, jeśli problem nie ustępuje.',
  'pluginsHome.emptyFiltered': 'Żadne wtyczki nie pasują do bieżących filtrów.',
  'pluginsHome.clearFilters': 'Wyczyść filtry',
  'pluginsHome.modeAria': 'Tryb wtyczek',
  'pluginsHome.featured': 'Zapisano',
  'pluginsHome.totalInCatalog': '{n} w katalogu',
  'pluginsHome.categoryFilterAria': 'Filtr kategorii',
  'pluginsHome.subcategoryFilterAria': 'Filtr podkategorii {label}',
  'pluginsHome.allCategory': 'Wszystkie: {label}',
  'pluginsHome.searchPlaceholder': 'Szukaj wtyczek…',
  'pluginsHome.searchAria': 'Szukaj wtyczek',
  'pluginsHome.clearSearch': 'Wyczyść wyszukiwanie',
  'pluginsHome.sortAria': 'Kolejność sortowania',
  'pluginsHome.sortHot': 'Popularne',
  'pluginsHome.sortNewest': 'Najnowsze',
  'pluginsHome.facet.import': 'Importuj',
  'pluginsHome.facet.create': 'Utwórz',
  'pluginsHome.facet.export': 'Eksportuj',
  'pluginsHome.facet.share': 'Udostępnij',
  'pluginsHome.facet.deploy': 'Wdróż',
  'pluginsHome.facet.refine': 'Dopracuj',
  'pluginsHome.facet.extend': 'Rozszerz',
  'pluginsHome.facet.figma': 'Figma',
  'pluginsHome.facet.github': 'GitHub',
  'pluginsHome.facet.codeFolder': 'Kod / folder',
  'pluginsHome.facet.url': 'URL',
  'pluginsHome.facet.screenshot': 'Zrzut ekranu',
  'pluginsHome.facet.pdf': 'PDF',
  'pluginsHome.facet.pptx': 'PPTX',
  'pluginsHome.facet.framer': 'Framer',
  'pluginsHome.facet.webflow': 'Webflow',
  'pluginsHome.facet.slides': 'Slajdy',
  'pluginsHome.facet.publicLink': 'Link publiczny',
  'pluginsHome.facet.githubPr': 'GitHub PR',
  'pluginsHome.facet.githubGist': 'GitHub Gist',
  'pluginsHome.subfacet.business-dashboards': 'Dashboardy',
  'pluginsHome.subfacet.app-prototypes': 'Aplikacje',
  'pluginsHome.subfacet.landing-marketing': 'Landing / marketing',
  'pluginsHome.subfacet.developer-tools': 'Narzędzia dev',
  'pluginsHome.subfacet.docs-reports': 'Dokumenty / raporty',
  'pluginsHome.subfacet.brand-design': 'Marka / design',
  'pluginsHome.subfacet.pitch-business': 'Pitch / biznes',
  'pluginsHome.subfacet.course-training': 'Kursy / szkolenia',
  'pluginsHome.subfacet.reports-briefings': 'Raporty / briefy',
  'pluginsHome.subfacet.product-sales': 'Produkt / sprzedaż',
  'pluginsHome.subfacet.engineering-talks': 'Prelekcje techniczne',
  'pluginsHome.subfacet.creative-decks': 'Kreatywne decki',
  'pluginsHome.subfacet.ui-product-mockups': 'UI / makiety',
  'pluginsHome.subfacet.brand-visuals': 'Marka / logo',
  'pluginsHome.subfacet.storyboards-motion-refs': 'Storyboardy',
  'pluginsHome.subfacet.social-content': 'Social / treści',
  'pluginsHome.subfacet.avatar-portrait': 'Awatar / portret',
  'pluginsHome.subfacet.illustration-style': 'Ilustracja / styl',
  'pluginsHome.subfacet.motion-effects': 'Motion / efekty',
  'pluginsHome.subfacet.social-short-form': 'Social / krótkie formy',
  'pluginsHome.subfacet.marketing-product': 'Marketing / produkt',
  'pluginsHome.subfacet.data-explainers': 'Dane / objaśnienia',
  'pluginsHome.subfacet.cinematic-story': 'Kinowe / fabularne',
  'pluginsHome.commercialCategory.student-coursework': 'Student coursework',
  'pluginsHome.commercialCategory.corporate-strategy': 'Corporate strategy',
  'pluginsHome.commercialCategory.professional-training': 'Professional training',
  'pluginsHome.commercialCategory.b2b-sales': 'B2B sales',
  'pluginsHome.commercialCategory.academic-research': 'Academic research',
  'pluginsHome.commercialCategory.marketing-gtm': 'Marketing & GTM',
  'pluginsHome.commercialCategory.data-finance': 'Data & finance',
  'pluginsHome.commercialCategory.fundraising-pitch': 'Fundraising pitch',
  'pluginsHome.commercialCategory.government-policy': 'Government & policy',
  'pluginsHome.commercialCategory.product-management': 'Product management',
  'pluginsHome.commercialCategory.consulting': 'Consulting',
  'pluginsHome.commercialCategory.career': 'Career',
  'pluginsHome.commercialCategory.ai-literacy': 'AI literacy',
  'pluginsHome.commercialCategory.life': 'Life & story',
  'pluginsHome.commercialCategory.design-craft': 'Design craft',
  'pluginsView.lede': 'Przeglądaj zainstalowane przepływy pracy, odkrywaj wpisy w rejestrze, zarządzaj źródłami i przygotowuj wtyczki do dystrybucji w zespole.',
  'pluginsView.importPlugin': 'Importuj wtyczkę',
  'pluginsView.agentContext': 'Kontekst Agenta',
  'pluginsView.summaryAria': 'Podsumowanie wtyczki',
  'pluginsView.areasAria': 'Obszary wtyczek',
  'pluginsView.loading': 'Wczytywanie wtyczek…',
  'pluginsView.tab.installed': 'Zainstalowane',
  'pluginsView.tab.available': 'Dostępne',
  'pluginsView.tab.sources': 'Źródła',
  'pluginsView.tab.team': 'Zespół',
  'pluginsView.tabHint.installed': 'Twoje wtyczki',
  'pluginsView.tabHint.available': 'Ze źródeł',
  'pluginsView.tabHint.sources': 'Katalogi',
  'pluginsView.tabHint.team': 'Przedsiębiorstwo',
  'pluginsView.installedTitle': 'Zainstalowane wtyczki',
  'pluginsView.installedSubtitle': 'Wtyczki zaimportowane lub zainstalowane ze źródeł marketplace.',
  'pluginsView.installedEmpty': 'Brak zainstalowanych wtyczek użytkownika. Użyj opcji Utwórz / Importuj lub zainstaluj dostępny wpis.',
  'pluginsView.availableTitle': 'Dostępne ze źródeł',
  'pluginsView.availableSubtitle': 'Wpisy katalogowe wykryte ze skonfigurowanych marketplace\'ów.',
  'pluginsView.availableFiltersAria': 'Filtry dostępnych wtyczek',
  'pluginsView.searchAvailableAria': 'Szukaj dostępnych wtyczek',
  'pluginsView.searchAvailablePlaceholder': 'Szukaj dostępnych wtyczek',
  'pluginsView.clearAvailableSearch': 'Wyczyść wyszukiwanie dostępnych wtyczek',
  'pluginsView.source': 'Źródło',
  'pluginsView.availableEmptyInstalled': 'Brak dostępnych pozycji. Zainstalowane pozycje katalogu są usuwane z listy Dostępne; odinstaluj jedną, aby ponownie była dostępna.',
  'pluginsView.availableEmptyFiltered': 'Brak dostępnych pozycji pasujących do filtrów.',
  'pluginsView.availableEmptyNoSources': 'Brak dostępnych pozycji. Dodaj źródło na karcie Źródła.',
  'pluginsView.installing': 'Instalowanie…',
  'pluginsView.install': 'Zainstaluj',
  'pluginsView.sourcesTitle': 'Źródła rejestru',
  'pluginsView.sourcesSubtitle': 'Katalogi marketplace zasilające dostępne pozycje wtyczek.',
  'pluginsView.sourceUrl': 'URL źródła',
  'pluginsView.defaultTrust': 'Domyślne zaufanie',
  'pluginsView.trust.restricted': 'Ograniczone',
  'pluginsView.trust.trusted': 'Zaufane',
  'pluginsView.trust.official': 'Oficjalne',
  'pluginsView.adding': 'Dodawanie…',
  'pluginsView.addSource': 'Dodaj źródło',
  'pluginsView.sourcesEmpty': 'Nie skonfigurowano jeszcze żadnych źródeł rejestru.',
  'pluginsView.pluginsCount': '{n} wtyczek',
  'pluginsView.catalogVersion': 'katalog v{version}',
  'pluginsView.trustFor': 'Zaufanie dla {name}',
  'pluginsView.refreshing': 'Odświeżanie…',
  'pluginsView.removing': 'Usuwanie…',
  'pluginsView.teamTitle': 'Prywatne marketplace zespołów',
  'pluginsView.teamBody': 'Ten obszar jest zarezerwowany dla katalogów firmowych i zespołowych, prywatnych zasad zaufania oraz współdzielonej kontroli cyklu życia wtyczek.',
  'pluginCard.details': 'Szczegóły',
  'pluginCard.use': 'Użyj',
  'pluginCard.useWithQuery': 'Użyj z zapytaniem',
  'pluginCard.applying': 'Stosowanie…',
  'pluginCard.duplicate': 'Remix',
  'pluginCard.duplicating': 'Remiksowanie…',
  'pluginCard.duplicateFailed': 'Nie udalo sie zremiksowac tego szablonu.',
  'pluginCard.saved': 'Zapisano',
  'pluginCard.publish': 'Opublikuj',
  'pluginCard.contribute': 'Wnieś wkład',
  'pluginCard.starting': 'Uruchamianie…',
  'pluginCard.detailsAria': 'Wyświetl szczegóły dla {title}',
  'pluginCard.chooseUseAria': 'Wybierz sposób użycia {title}',
  'pluginCard.useOptionsAria': 'Opcje użycia dla {title}',
  'pluginCard.duplicateAria': 'Zremiksuj {title} jako nowy projekt',
  'pluginCard.saveAria': 'Zapisz {title}',
  'pluginCard.savedAria': '{title} zapisano',
  'pluginCard.shareAria': 'Udostępnij {title}',
  'pluginCard.publishAria': 'Opublikuj {title} jako repozytorium GitHub',
  'pluginCard.publishTitle': 'Opublikuj wtyczkę jako repozytorium GitHub',
  'pluginCard.contributeAria': 'Wnieś wkład {title} do Crie3',
  'pluginCard.contributeTitle': 'Wnieś wkład wtyczki do Crie3 za pomocą pull requesta',
  'skillPluginCandidate.createForMe': 'Utwórz wtyczkę/szablon',
  'skillPluginCandidate.contributeToMain': 'Wnieś wkład do open-design',
  'skillPluginCandidate.repoDescription': 'To repozytorium wygląda na takie, które mogłoby działać jako wtyczka.',
  'integrations.kicker': 'Integracja',
  'integrations.lede': 'Łącz zewnętrzne systemy, wprowadzaj narzędzia MCP do pętli swojego Agenta i korzystaj z Crie3 w innych IDE, skryptach i automatyzacjach.',
  'integrations.agentReady': 'Gotowe dla Agenta',
  'integrations.areasAria': 'Obszary integracji',
  'integrations.tabLabel.mcp': 'MCP',
  'integrations.tabLabel.skills': 'Umiejętności',
  'integrations.tabHint.mcp': 'Narzędzia zewnętrzne',
  'integrations.tabHint.connectors': 'Konta i API',
  'integrations.tabHint.useEverywhere': 'CLI, HTTP, MCP',
  'integrations.skillsTitle': 'Integracje umiejętności',
  'integrations.skillsBody': 'Zarządzanie integracjami na poziomie umiejętności jest przenoszone z innej gałęzi. Ta karta jest zarezerwowana, aby konfiguracja MCP, Łączników i przyszłych Umiejętności znajdowała się w tej samej trasie Integracji.',
  'mcpClient.title': 'Zewnętrzne serwery MCP',
  'mcpClient.subtitle': 'Narzędzia innych firm dla Twojego Agenta kodującego.',
  'mcpClient.addServer': 'Dodaj serwer',
  'mcpClient.emptyTitle': 'Nie skonfigurowano żadnych serwerów MCP.',
  'mcpClient.emptyBody': 'Kliknij „Dodaj serwer”, aby rozpocząć — wybierz szablon (Higgsfield OpenClaw, Pollinations, Allyson, Imagician, EdgeOne Pages, GitHub, Filesystem…) lub skonfiguruj własny serwer stdio / HTTP.',
  'mcpClient.saveChanges': 'Zapisz zmiany',
  'mcpClient.storedAt': 'Przechowywane w',
  'mcpClient.daemonError': 'Nie udało się połączyć z lokalnym demonem. Upewnij się, że Crie3 jest uruchomione, a następnie otwórz ponownie ten panel.',
  'mcpClient.saveFailed': 'Zapis nie powiódł się. Sprawdź, czy demon jest uruchomiony, i spróbuj ponownie.',
  'useEverywhere.modalAria': 'Używaj Crie3 wszędzie',
  'useEverywhere.modalTitle': 'Używaj Crie3 wszędzie',
  'useEverywhere.modalSubtitle': 'Zintegruj Crie3 z dowolnym IDE, Agentem lub skryptem — CLI, HTTP, MCP i Skills. Użyj „Kopiuj przewodnik dla Agenta” i wklej do Claude Code, Codex, Cursor, openclaw lub hermes, aby skonfigurować wszystko.',
  'useEverywhere.closeAria': 'Zamknij używanie wszędzie',
  'useEverywhere.closeTitle': 'Zamknij (Esc)',
  'useEverywhere.tabsAria': 'Powierzchnie integracji',
  'useEverywhere.footStrong': 'Przekazanie jednym kliknięciem.',
  'useEverywhere.footBody': 'Kopiuje ustrukturyzowany przewodnik markdown, na podstawie którego Twój Agent może działać od razu — instalacja, weryfikacja i użycie.',
  'useEverywhere.configureMcp': 'Skonfiguruj serwer MCP',
  'useEverywhere.copyGuide': 'Skopiuj przewodnik dla agenta',
  'useEverywhere.copy': 'Kopiuj',
  'useEverywhere.copied': 'Skopiowano',
  'useEverywhere.copyFailed': 'Kopiowanie nie powiodło się',
  'useEverywhere.copySnippetAria': 'Skopiuj fragment: {label}',
  'useEverywhere.section.overview.tab': 'Przegląd',
  'useEverywhere.section.overview.heading': 'Crie3 działa wszędzie tam, gdzie działa Twój agent',
  'useEverywhere.section.overview.intro': 'Crie3 to coś więcej niż okno — to lokalny uprzywilejowany daemon (`od`) wraz z rejestrem Skills + Design-Systems + Atoms. Gdy działa już na Twoim komputerze, dowolny Agent kodu (Claude Code, Codex, Cursor, OpenCode/openclaw, Hermes, Twój własny skrypt) może sterować generacjami, inspekcjonować projekty i tworzyć artefakty projektowe za pośrednictwem czterech wymiennych powierzchni.',
  'useEverywhere.section.overview.bullet1': 'CLI — `od <command>` do skryptów bezgłowych, CI i automatyzacji powłoki.',
  'useEverywhere.section.overview.bullet2': 'Serwer MCP — podłącza Crie3 jako serwer Model Context Protocol, dzięki czemu dowolny Agent obsługujący MCP może wyświetlać listę skills, uruchamiać scenariusze i odczytywać artefakty.',
  'useEverywhere.section.overview.bullet3': 'API HTTP — punkty końcowe REST + SSE pod `http://127.0.0.1:7456/api/*`; ta sama powierzchnia, której używa interfejs webowy.',
  'useEverywhere.section.overview.bullet4': 'Skills — gotowe do użycia pakiety `SKILL.md` (kompatybilne z Claude), które dowolny Agent znajdujący się już w Twojej zmiennej PATH może wywołać całkowicie bez Crie3.',
  'useEverywhere.section.overview.bullet5': 'Standardowe artefakty — twórz prawdziwe projekty HTML na podstawie Skills, wbudowanych domyślnych wtyczek i społecznościowych przykładów wtyczek, zanim daemon wystartuje.',
  'useEverywhere.section.overview.snippet1': 'Uruchom daemona (i interfejs web) lokalnie',
  'useEverywhere.section.overview.snippet2': 'Potwierdź, że jest osiągalny',
  'useEverywhere.section.overview.snippet3': 'Zaczytaj standardowe artefakty przed uruchomieniem',
  'useEverywhere.section.overview.footer': 'Daemon domyślnie zapisuje do `./.od/` (lokalnie w projekcie). Ustaw `OD_DATA_DIR=~/.open-design`, aby współdzielić dane między projektami.',
  'useEverywhere.section.cli.tab': 'CLI · od',
  'useEverywhere.section.cli.heading': 'Steruj Crie3 z dowolnej powłoki',
  'useEverywhere.section.cli.intro': 'Plik binarny `od` jest dostarczany razem z daemonem i jest tym samym plikiem binarnym używanym przez Claude Code / Codex, gdy uruchamiają generowanie. Większość podkomend to lekkie klienty, które wysyłają żądania POST do lokalnego daemona, więc działają tak samo, niezależnie od tego, czy uruchomisz je przez `pnpm tools-dev`, czy jako spakowaną aplikację.',
  'useEverywhere.section.cli.bullet1': '`od` (bez argumentów) — uruchamia daemona i otwiera interfejs webowy.',
  'useEverywhere.section.cli.bullet2': '`od media generate ...` — generuje bajty obrazu / wideo / audio za pośrednictwem ujednoliconego protokołu mediów.',
  'useEverywhere.section.cli.bullet3': '`od run ...` — uruchamia przebieg projektu na podstawie promptu + skill.',
  'useEverywhere.section.cli.bullet4': '`od plugin install <source>` / `od plugin apply <id>` — instaluje i stosuje wtyczki społecznościowe.',
  'useEverywhere.section.cli.bullet5': '`od skills list` / `od design-systems list` — sprawdza, co jest dostępne lokalnie.',
  'useEverywhere.section.cli.bullet6': '`od status` / `od doctor` — weryfikuje kondycję daemona i wykrywa CLI Agentów w Twojej zmiennej PATH.',
  'useEverywhere.section.cli.snippet1': 'Wygeneruj obraz (deleguje do skonfigurowanego dostawcy mediów)',
  'useEverywhere.section.cli.snippet2': 'Uruchom wtyczkę scenariusza bezgłowo i strumieniuj zdarzenia jako linie JSON',
  'useEverywhere.section.cli.snippet3': 'Sporządź inwentarz lokalnie dostępnych umiejętności i systemów projektowych',
  'useEverywhere.section.cli.snippet4': 'Sprawdź zaczytane artefakty przez CLI',
  'useEverywhere.section.cli.snippet5': 'Zweryfikuj środowisko + wykryte Agenty (Claude, Codex, Cursor, …)',
  'useEverywhere.section.cli.footer': 'Wszystkie podkomendy akceptują `--daemon-url http://127.0.0.1:<port>`, aby wskazać konkretnego działającego daemona — przydatne przy uruchamianiu drugiej instancji w piaskownicy na potrzeby testów.',
  'useEverywhere.section.mcp.tab': 'Serwer MCP',
  'useEverywhere.section.mcp.heading': 'Udostępnij Crie3 jako serwer MCP dowolnemu agentowi kodującemu',
  'useEverywhere.section.mcp.intro': 'Crie3 jest dostarczany z serwerem Model Context Protocol (`od mcp`), który pozwala dowolnemu klientowi obsługującemu MCP — Cursor, Claude Code, Antigravity, VS Code Copilot Chat, openclaw, hermes — odkrywać narzędzia Crie3 (lista skills, renderowanie podglądów, generowanie mediów, uruchamianie wtyczek) bez ręcznego uruchamiania powłoki. Daemon publikuje gotowy do wklejenia fragment instalacyjny przez `GET /api/mcp/install-info` dla każdego głównego klienta.',
  'useEverywhere.section.mcp.bullet1': 'Transport stdio — bez dodatkowego portu, klient bezpośrednio uruchamia `od mcp`.',
  'useEverywhere.section.mcp.bullet2': 'Automatycznie wykrywa URL działającego daemona przez lokalne gniazdo statusu IPC, gdy jest uruchamiany jako sidecar.',
  'useEverywhere.section.mcp.bullet3': 'Wraca do `--daemon-url http://127.0.0.1:<port>` w przypadku zwykłych instalacji, dzięki czemu proces MCP zawsze znajdzie działającego daemona.',
  'useEverywhere.section.mcp.bullet4': 'Przypina `OD_DATA_DIR`, aby uruchomiony proces MCP zapisywał w tym samym miejscu, którego daemon już używa (unika EPERM w spakowanych pakietach aplikacji macOS).',
  'useEverywhere.section.mcp.snippet1': 'Ogólna konfiguracja klienta MCP (działa w Cursor, Claude Code, Codex, …)',
  'useEverywhere.section.mcp.snippet2': 'Albo: poproś daemona o fragment dopasowany do Twojej instalacji',
  'useEverywhere.section.mcp.snippet3': 'Wariant MCP z artefaktami na żywo (odczyt i odświeżanie pulpitów)',
  'useEverywhere.section.mcp.footer': 'W aplikacji Crie3 otwórz Ustawienia → Integracje, aby skopiować polecenie instalacyjne dla konkretnego klienta (Cursor, Claude Code, Antigravity, VS Code) zamiast ręcznie edytować JSON.',
  'useEverywhere.section.http.tab': 'API HTTP',
  'useEverywhere.section.http.heading': 'Ta sama powierzchnia REST + SSE, której używa interfejs web',
  'useEverywhere.section.http.intro': 'Lokalny daemon udostępnia API HTTP pod adresem `http://127.0.0.1:7456` (port konfigurowalny). Każdy punkt końcowy wywoływany przez interfejs web jest również dostępny dla Twoich skryptów. Strumieniowe punkty końcowe (tury czatu, uruchomienia projektów) emitują zdarzenia Server-Sent Events z typami kontraktów z `@open-design/contracts`.',
  'useEverywhere.section.http.bullet1': '`GET /api/health` — żywotność daemona.',
  'useEverywhere.section.http.bullet2': '`GET /api/skills` i `GET /api/design-systems` — dostępne rejestry.',
  'useEverywhere.section.http.bullet3': '`GET /api/projects` i `POST /api/projects` — wyświetla i tworzy projekty (POST zwraca projekt + pierwszą konwersację).',
  'useEverywhere.section.http.bullet4': '`GET /api/projects/:id/chat` — strumień SSE zdarzeń Agenta dla konwersacji.',
  'useEverywhere.section.http.bullet5': '`POST /api/plugins/:id/apply` — wiąże zainstalowaną wtyczkę i zwraca jej wyrenderowane przykładowe zapytanie + dane wejściowe.',
  'useEverywhere.section.http.bullet6': '`GET /api/agents` — wykryte CLI Agentów kodu w Twojej zmiennej PATH.',
  'useEverywhere.section.http.snippet1': 'Wyświetl listę zainstalowanych umiejętności (agent użyje ich jako szablonów)',
  'useEverywhere.section.http.snippet2': 'Utwórz projekt na podstawie promptu (pełny przepływ po stronie serwera)',
  'useEverywhere.section.http.snippet3': 'Strumieniowanie tury czatu (SSE — każdy wiersz jest kompatybilny z JSON-Lines)',
  'useEverywhere.section.http.footer': 'Czyste typy TypeScript dla każdego żądania/odpowiedzi znajdują się w `@open-design/contracts` — zaimportuj je w swoim skrypcie, aby uzyskać pełne autouzupełnianie bez konfigurowania generatora.',
  'useEverywhere.section.skills.tab': 'Umiejętności i tryb bezgłowy',
  'useEverywhere.section.skills.heading': 'Gotowe do użycia Skills dla dowolnego Agenta — nawet bez uruchomionego Crie3',
  'useEverywhere.section.skills.intro': 'Skill to katalog z kompatybilnym z Claude plikiem `SKILL.md` (front-matter YAML + treść). Crie3 rozszerza ten format o przestrzeń nazw `od:` (`mode`, `preview`, `design_system`, `inputs`, …), dzięki czemu ten sam artefakt może być używany zarówno wewnątrz Crie3, jak i przez zwykłego Agenta, takiego jak Claude Code, Codex, openclaw lub hermes. Wykrywanie przebiega według łańcucha pierwszeństwa, więc projekty mogą nadpisywać własne skills.',
  'useEverywhere.section.skills.bullet1': 'Wykrywanie: `./.claude/skills/` → `./skills/` → `~/.claude/skills/` (projekt ma pierwszeństwo).',
  'useEverywhere.section.skills.bullet2': 'Utwórz dowiązanie symboliczne jednej umiejętności w wielu projektach, aby ją współdzielić bez kopiowania.',
  'useEverywhere.section.skills.bullet3': 'Każda umiejętność może deklarować konektory, atomy, wymagania systemu projektowego oraz przykładowy wynik `preview` do galerii.',
  'useEverywhere.section.skills.bullet4': 'Tryb bezgłowy: agent z `od` w swojej zmiennej PATH może wywołać `od skills list`, a następnie uruchomić dowolną umiejętność; daemon jest opcjonalny dla przepływów tylko do odczytu.',
  'useEverywhere.section.skills.bullet5': '`pnpm seed:test-projects` ćwiczy ten sam kształt artefaktu z domyślnymi przykładami wtyczek oraz przykładami wtyczek społeczności, a następnie zapisuje powstałe projekty `index.html` jako wielokrotnego użytku dane testowe.',
  'useEverywhere.section.skills.snippet1': 'Minimalny SKILL.md (front matter zgodny z Claude + dodatki Crie3)',
  'useEverywhere.section.skills.snippet2': 'Utwórz dowiązanie symboliczne współdzielonej umiejętności w projekcie (styl cc-switch)',
  'useEverywhere.section.skills.snippet3': 'Tryb bezgłowy: wyświetl umiejętności, które daemon widzi teraz',
  'useEverywhere.section.skills.snippet4': 'Pakiet testowych artefaktów (fixture)',
  'useEverywhere.section.skills.footer': 'Specyfikacja: `docs/skills-protocol.md` i `docs/agent-adapters.md` obejmują pełną powierzchnię adapterów (Claude Code, Codex, Cursor, agenty obsługujące MCP, awaryjne API BYOK) oraz strategie wstrzykiwania umiejętności dla poszczególnych adapterów.',
  'tasks.kicker': 'Przestrzeń automatyzacji',
  'tasks.comingSoon': 'Wkrótce',
  'tasks.lede': 'Automatyzacje zamieniają prompty w trwałą pracę: Orbit je uruchamia, rutyny utrzymują je w czasie, harmonogramy decydują, kiedy się uruchamiają, a artefakty na żywo pokazują, co się zmieniło.',
  'tasks.newAutomation': 'Nowa automatyzacja',
  'tasks.previewNote': 'Tylko powierzchnia podglądu. Ustawienia Orbit są dostępne już dziś; rutyny, harmonogramy i podłączenie artefaktów na żywo pojawią się wraz ze scalaniem gałęzi backendu.',
  'tasks.primitivesAria': 'Prymitywy automatyzacji',
  'tasks.primitive.orbit.title': 'Orbit',
  'tasks.primitive.orbit.body': 'Trwałe środowisko uruchomieniowe dla długotrwałej lub cyklicznej pracy agenta.',
  'tasks.primitive.orbit.enabled': 'Dzienne podsumowanie włączone',
  'tasks.primitive.orbit.manualOnly': 'Tylko ręcznie',
  'tasks.primitive.routines.title': 'Rutyny',
  'tasks.primitive.routines.body': 'Trwałe definicje zadań, które przetrwają po zakończeniu pojedynczego czatu.',
  'tasks.primitive.routines.meta': 'Powłoka produktu gotowa',
  'tasks.primitive.schedules.title': 'Harmonogramy',
  'tasks.primitive.schedules.body': 'Wyzwalacze czasowe lub zdarzeniowe, które decydują, kiedy rutyna powinna się uruchomić.',
  'tasks.primitive.schedules.meta': 'Gałąź w toku',
  'tasks.primitive.liveArtifacts.title': 'Artefakty na żywo',
  'tasks.primitive.liveArtifacts.body': 'Raporty i notatki, które aktualizują się na bieżąco podczas pracy agenta.',
  'tasks.primitive.liveArtifacts.meta': 'Model podglądu',
  'tasks.listAria': 'Lista automatyzacji',
  'tasks.routinesAndRuns': '{n} procedur i uruchomień',
  'tasks.filtersAria': 'Filtry automatyzacji',
  'tasks.filter.scheduled': 'Zaplanowane',
  'tasks.filter.running': 'W trakcie',
  'tasks.filter.done': 'Gotowe',
  'tasks.configurationAria': 'Konfiguracja automatyzacji',
  'tasks.slot.trigger': 'Wyzwalacz',
  'tasks.slot.pattern': 'Wzorzec',
  'tasks.slot.runtime': 'Środowisko uruchomieniowe',
  'tasks.slot.output': 'Wynik',
  'tasks.liveArtifact': 'Artefakt na żywo',
  'tasks.viewProgress': 'Zobacz postęp',
  'tasks.pause': 'Wstrzymaj',
  'tasks.runNow': 'Uruchom teraz',
  'tasks.openArtifact': 'Otwórz artefakt',
  'tasks.status.dailyAt': 'Codziennie · {time}',
  'tasks.status.pausedManual': 'Wstrzymane · tylko ręcznie',
  'tasks.sample.orbit.title': 'Podsumowanie konektora Orbit Daily',
  'tasks.sample.orbit.metaEnabled': 'Zaplanowano przegląd konektora',
  'tasks.sample.orbit.metaDisabled': 'Otwórz ustawienia Orbit, aby włączyć',
  'tasks.sample.orbit.previewEnabled': 'orbit_daily.html · artefakt na żywo',
  'tasks.sample.orbit.previewDisabled': 'Brak zaplanowanego uruchomienia',
  'tasks.sample.orbit.triggerEnabled': 'Harmonogram · codziennie o {time}',
  'tasks.sample.orbit.triggerDisabled': 'Ręcznie · uruchom na żądanie',
  'tasks.sample.orbit.pattern': 'Rutyna · podsumowanie konektorów',
  'tasks.sample.orbit.runtime': 'Orbit · zaplanowane przez daemona',
  'tasks.sample.orbit.output': 'Artefakt na żywo · raport z możliwością odświeżenia',
  'tasks.sample.orbit.artifactMetaEnabled': 'Odświeża się po każdym uruchomieniu',
  'tasks.sample.orbit.artifactMetaDisabled': 'Oczekiwanie na harmonogram',
  'tasks.sample.orbit.body1': '# Podsumowanie aktywności Orbit Daily',
  'tasks.sample.orbit.body2': 'Sprawdzone konektory · sukcesy, pominięcia i niepowodzenia',
  'tasks.sample.orbit.body3': 'Najważniejsze informacje stają się odświeżalnym artefaktem na żywo.',
  'tasks.sample.mcp.title': 'Badanie alternatyw dla MCP',
  'tasks.sample.mcp.status': 'Działa na orbicie · 2h 14m',
  'tasks.sample.mcp.meta': 'Przetworzono 14 / 30 źródeł',
  'tasks.sample.mcp.preview': 'research_notes.md · na żywo',
  'tasks.sample.mcp.trigger': 'Ręcznie · jednorazowo',
  'tasks.sample.mcp.pattern': 'Polecenie pogłębionego badania',
  'tasks.sample.mcp.runtime': 'Zdalnie · trwałe',
  'tasks.sample.mcp.output': 'Raport na żywo · automatyczna aktualizacja',
  'tasks.sample.mcp.artifactMeta': 'Zaktualizowano 12 s temu',
  'tasks.sample.mcp.body1': '# Alternatywy dla MCP - wstępne ustalenia',
  'tasks.sample.mcp.body2': 'Przejrzano 14 źródeł · 3 kandydatów na krótkiej liście',
  'tasks.sample.mcp.body3': '## Lista skrócona',
  'tasks.sample.mcp.body4': '- Schematy wywołań narzędzi przez JSON-RPC...',
  'tasks.sample.mcp.body5': '- Protokoły agentów oparte na gRPC...',
  'tasks.sample.weekly.title': 'Cotygodniowy przegląd zespołu',
  'tasks.sample.weekly.status': 'Następne: pon. 9:00',
  'tasks.sample.weekly.meta': 'Aktualizuje cotygodniowy dokument zespołu',
  'tasks.sample.weekly.preview': 'team_weekly.md · następny artefakt',
  'tasks.sample.weekly.trigger': 'Harmonogram · co tydzień',
  'tasks.sample.weekly.pattern': 'Rutyna · podsumowanie zespołu',
  'tasks.sample.weekly.runtime': 'Zdalnie · cykliczne',
  'tasks.sample.weekly.output': 'Artefakt na żywo · markdown',
  'tasks.sample.weekly.artifactMeta': 'Ostatnia aktualizacja 4 dni temu',
  'tasks.sample.weekly.body1': '# Tydzień zespołu',
  'tasks.sample.weekly.body2': '## W toku',
  'tasks.sample.weekly.body3': '- Przegląd integracji systemu projektowego',
  'tasks.sample.weekly.body4': '- Audyt jakości konektorów',
  'tasks.sample.weekly.body5': '## Ryzyka',
  'tasks.sample.pr.title': 'Przypomnienie o przeglądzie PR',
  'tasks.sample.pr.status': 'Przy nowym PR · uruchomiono 23 min temu',
  'tasks.sample.pr.meta': 'Wysyła wiadomość prywatną na Slacku',
  'tasks.sample.pr.preview': 'Ostatnia dostawa zakończona sukcesem',
  'tasks.sample.pr.trigger': 'Zdarzenie · nowy PR',
  'tasks.sample.pr.pattern': 'Rutyna · powiadomienie',
  'tasks.sample.pr.runtime': 'Lokalnie · szybkie uruchomienie',
  'tasks.sample.pr.output': 'Wiadomość · DM na Slacku',
  'tasks.sample.pr.artifactMeta': 'Ostatnie uruchomienie 23 min temu',
  'tasks.sample.pr.body1': 'Otwarto PR #184 do przeglądu',
  'tasks.sample.pr.body2': 'Dopasowani recenzenci: design-platform, web-runtime',
  'tasks.sample.pr.body3': 'Dostawa: wysłano wiadomość prywatną na Slacku',
  'tasks.sample.meeting.title': 'Przygotowanie przed spotkaniem',
  'tasks.sample.meeting.status': 'Jutro · 10:00',
  'tasks.sample.meeting.meta': 'Jednorazowo · wysyła podsumowanie',
  'tasks.sample.meeting.preview': 'meeting_brief.md · w kolejce',
  'tasks.sample.meeting.trigger': 'Harmonogram · jednorazowo',
  'tasks.sample.meeting.pattern': 'Polecenie briefingu',
  'tasks.sample.meeting.runtime': 'Zdalnie · ograniczone',
  'tasks.sample.meeting.output': 'Artefakt + wiadomość',
  'tasks.sample.meeting.artifactMeta': 'W kolejce do wygenerowania',
  'tasks.sample.meeting.body1': '# Brief spotkania',
  'tasks.sample.meeting.body2': 'Źródło agendy: wydarzenie w kalendarzu + powiązane dokumenty',
  'tasks.sample.meeting.body3': 'Wynik będzie zawierał decyzje, przeszkody i pytania.',
  'tasks.sample.candidate.title': 'Śledzenie kandydatów',
  'tasks.sample.candidate.status': 'Niepowodzenie · wymaga uwagi',
  'tasks.sample.candidate.meta': 'Autoryzacja wygasła',
  'tasks.sample.candidate.preview': 'Połącz ponownie Greenhouse, aby wznowić',
  'tasks.sample.candidate.trigger': 'Harmonogram · codziennie',
  'tasks.sample.candidate.pattern': 'Rutyna · synchronizacja kandydatów',
  'tasks.sample.candidate.runtime': 'Zdalnie · cykliczne',
  'tasks.sample.candidate.output': 'Artefakt na żywo · tabela',
  'tasks.sample.candidate.artifactMeta': 'Wstrzymano do czasu przywrócenia autoryzacji',
  'tasks.sample.candidate.body1': '# Lejek kandydatów',
  'tasks.sample.candidate.body2': 'Ostatnia udana synchronizacja: 2 dni temu',
  'tasks.sample.candidate.body3': 'Wymagane działanie: połącz ponownie konto źródłowe.',
  'routines.title': 'Automatyzacje',
  'routines.subtitle': 'Zaplanowane automatyzacje działające bez nadzoru.',
  'routines.newAutomation': 'Nowa automatyzacja',
  'routines.loading': 'Ładowanie…',
  'routines.empty': 'Brak automatyzacji.',
  'routines.emptyHint': 'Kliknij Nowa automatyzacja, aby zaplanować uruchomienie agenta bez nadzoru.',
  'routines.runHistoryLoading': 'Ładowanie uruchomień…',
  'routines.runHistoryEmpty': 'Brak uruchomień.',
  'routines.fieldName': 'Nazwa',
  'routines.fieldNamePlaceholder': 'Poranny briefing',
  'routines.fieldPrompt': 'Prompt',
  'routines.fieldPromptPlaceholder': 'Pobierz wczorajszą aktywność z GitHub i Linear oraz podsumuj zmiany.',
  'routines.fieldSchedule': 'Harmonogram',
  'routines.fieldMinute': 'Minuta każdej godziny',
  'routines.fieldTime': 'Godzina',
  'routines.fieldTimezone': 'Strefa czasowa',
  'routines.fieldsetProject': 'Projekt',
  'routines.kind.hourly': 'Co godzinę',
  'routines.kind.daily': 'Codziennie',
  'routines.kind.weekdays': 'Dni robocze',
  'routines.kind.weekly': 'Co tydzień',
  'routines.weekday.short.0': 'Nd',
  'routines.weekday.short.1': 'Pn',
  'routines.weekday.short.2': 'Wt',
  'routines.weekday.short.3': 'Śr',
  'routines.weekday.short.4': 'Czw',
  'routines.weekday.short.5': 'Pt',
  'routines.weekday.short.6': 'Sob',
  'routines.weekday.long.0': 'Niedziela',
  'routines.weekday.long.1': 'Poniedziałek',
  'routines.weekday.long.2': 'Wtorek',
  'routines.weekday.long.3': 'Środa',
  'routines.weekday.long.4': 'Czwartek',
  'routines.weekday.long.5': 'Piątek',
  'routines.weekday.long.6': 'Sobota',
  'routines.timeAm': 'AM',
  'routines.timePm': 'PM',
  'routines.describe.hourly': 'Uruchamia się co godzinę o :{minute}',
  'routines.describe.daily': 'Uruchamia się codziennie o {time} {tz}',
  'routines.describe.weekdays': 'Uruchamia się od pon. do pt. o {time} {tz}',
  'routines.describe.weekly': 'Uruchamia się w każdy {day} o {time} {tz}',
  'routines.modeCreate': 'Twórz nowy projekt przy każdym uruchomieniu',
  'routines.modeCreateHint': 'Świeże, odizolowane środowisko robocze przy każdym uruchomieniu.',
  'routines.modeReuse': 'Użyj ponownie istniejącego projektu',
  'routines.modeReuseHint': 'Każde uruchomienie istnieje jako nowa rozmowa w projekcie.',
  'routines.pickProject': '— Wybierz projekt —',
  'routines.targetReuse': '→ {project}',
  'routines.targetCreate': '→ nowy projekt przy każdym uruchomieniu',
  'routines.tagPaused': 'wstrzymana',
  'routines.metaNext': 'następne: {when}',
  'routines.metaLast': 'ostatnie:',
  'routines.triggerManual': 'ręczne',
  'routines.triggerScheduled': 'zaplanowane',
  'routines.openProject': 'Otwórz projekt',
  'routines.openProjectTitle': 'Otwórz projekt, do którego zapisało to uruchomienie',
  'routines.runNow': 'Uruchom teraz',
  'routines.edit': 'Edytuj',
  'routines.pause': 'Wstrzymaj',
  'routines.resume': 'Wznów',
  'routines.history': 'Historia',
  'routines.hideHistory': 'Ukryj historię',
  'routines.delete': 'Usuń',
  'routines.deleteTitle': 'Usuń tę automatyzację',
  'routines.cancel': 'Anuluj',
  'routines.save': 'Zapisz',
  'routines.saving': 'Zapisywanie…',
  'routines.create': 'Utwórz',
  'routines.creating': 'Tworzenie…',
  'routines.status.queued': 'w kolejce',
  'routines.status.running': 'w toku',
  'routines.status.succeeded': 'powiodło się',
  'routines.status.failed': 'nie powiodło się',
  'routines.status.canceled': 'anulowano',
  'routines.confirmDelete': 'Usunąć tę automatyzację? Poprzednie uruchomienia i ich projekty zostaną zachowane.',
  'routines.errorPickProject': 'Wybierz projekt do ponownego użycia lub przełącz na „Twórz nowy przy każdym uruchomieniu”',
  'routines.errorAgentEmptyOutput': 'Agent zakończył działanie bez wygenerowania żadnych danych wyjściowych. Model lub dostawca mógł zwrócić pustą odpowiedź — sprawdź dzienniki agenta pod kątem błędów po stronie źródła.',
  'entry.helpAria': 'Pomoc',
  'entry.helpMenuAria': 'Menu pomocy',
  'entry.helpGetHelp': 'Uzyskaj pomoc na GitHubie',
  'entry.helpSubmitFeature': 'Zaproponuj funkcję',
  'entry.helpWhatsNew': 'Co nowego',
  'entry.helpDownloadDesktop': 'Pobierz aplikację na komputer',
  'entry.githubStarLabel': 'Gwiazdka',
  'entry.githubStarTitle': 'Daj nam gwiazdkę na GitHubie',
  'entry.githubStarAria': 'Daj Crie3 gwiazdkę na GitHubie',
  'entry.tabImageTemplates': 'Szablony obrazów',
  'entry.tabVideoTemplates': 'Szablony wideo',
  'promptTemplates.searchPlaceholder': 'Szukaj szablonów…',
  'promptTemplates.countLabel': '{n} wyników',
  'promptTemplates.emptyImage': 'Nie zainstalowano jeszcze szablonów promptów obrazów.',
  'promptTemplates.emptyVideo': 'Nie zainstalowano jeszcze szablonów promptów wideo.',
  'promptTemplates.emptyNoMatch': 'Brak szablonów pasujących do wyszukiwania.',
  'promptTemplates.attributionFooter': 'Zaadaptowano z publicznych bibliotek promptów. Każda karta linkuje do oryginalnego autora.',
  'promptTemplates.openPreviewTitle': 'Otwórz prompt i podgląd',
  'promptTemplates.sourcePrefix': 'Źródło:',
  'promptTemplates.fetchError': 'Nie udało się załadować treści szablonu.',
  'promptTemplates.promptLabel': 'Treść promptu',
  'promptTemplates.copyPrompt': 'Kopiuj prompt',
  'promptTemplates.copyDone': 'Skopiowano!',
  'promptTemplates.modelHint': 'Sugerowany model: {model}',
  'promptTemplates.openSource': 'Zobacz oryginał',
  'promptTemplates.openFullscreen': 'Podgląd pełnoekranowy',
  'promptTemplates.closeFullscreen': 'Zamknij podgląd pełnoekranowy',
  'promptTemplates.allSources': 'Wszystkie źródła',
  'promptTemplates.sourceFilterAria': 'Filtruj według źródła',
  'promptTemplates.retry': 'Ponów',
  'connectors.title': 'Konektory',
  'connectors.subtitle': 'Lokalne i przyszłe źródła danych, które mogą zasilać artefakty live.',
  'connectors.account': 'Konto',
  'connectors.noAccount': 'Niepołączone',
  'connectors.tools': 'Narzędzia',
  'connectors.connect': 'Połącz',
  'connectors.disconnect': 'Rozłącz',
  'connectors.authorizationPending': 'Oczekiwanie na autoryzację...',
  'connectors.authorizationPendingHint': 'Dokończ autoryzację w otwartym oknie.',
  'connectors.cancelAuthorization': 'Anuluj',
  'connectors.configure': 'Skonfiguruj',
  'connectors.unavailable': 'Niedostępne',
  'connectors.phaseStubTitle': 'Interfejsy konektorów pojawią się w fazie 3; to tylko podgląd.',
  'connectors.statusAvailable': 'Dostępne',
  'connectors.statusConnected': 'Połączone',
  'connectors.statusError': 'Błąd',
  'connectors.statusDisabled': 'Wyłączone',
  'connectors.gateTitle': 'Dodaj klucz API Composio, aby kontynuować',
  'connectors.gateBody': 'Wklej klucz powyżej i kliknij Zapisz klucz, aby wczytać dostępne integracje.',
  'connectors.aboutLabel': 'Informacje',
  'connectors.detailsLabel': 'Szczegóły',
  'connectors.statusLabel': 'Status',
  'connectors.category.aiAgents': 'Agenci AI',
  'connectors.category.aiInfrastructure': 'Infrastruktura AI',
  'connectors.category.accounting': 'Księgowość',
  'connectors.category.admin': 'Administracja',
  'connectors.category.advertising': 'Reklama',
  'connectors.category.analytics': 'Analityka',
  'connectors.category.automation': 'Automatyzacja',
  'connectors.category.cms': 'CMS',
  'connectors.category.crm': 'CRM',
  'connectors.category.calendar': 'Kalendarz',
  'connectors.category.commerce': 'Handel',
  'connectors.category.communication': 'Komunikacja',
  'connectors.category.contacts': 'Kontakty',
  'connectors.category.dataPlatform': 'Platforma danych',
  'connectors.category.database': 'Baza danych',
  'connectors.category.design': 'Projektowanie',
  'connectors.category.developer': 'Narzędzia deweloperskie',
  'connectors.category.documentation': 'Dokumentacja',
  'connectors.category.erp': 'ERP',
  'connectors.category.education': 'Edukacja',
  'connectors.category.email': 'E-mail',
  'connectors.category.events': 'Wydarzenia',
  'connectors.category.fieldService': 'Serwis terenowy',
  'connectors.category.finance': 'Finanse',
  'connectors.category.fitness': 'Fitness',
  'connectors.category.forms': 'Formularze',
  'connectors.category.gaming': 'Gry',
  'connectors.category.hr': 'HR',
  'connectors.category.hospitality': 'Hotelarstwo',
  'connectors.category.itsm': 'ITSM',
  'connectors.category.integration': 'Integracja',
  'connectors.category.localization': 'Lokalizacja',
  'connectors.category.logistics': 'Logistyka',
  'connectors.category.maps': 'Mapy',
  'connectors.category.marketing': 'Marketing',
  'connectors.category.media': 'Media',
  'connectors.category.meetings': 'Spotkania',
  'connectors.category.nonprofit': 'Organizacje non-profit',
  'connectors.category.observability': 'Obserwowalność',
  'connectors.category.payments': 'Płatności',
  'connectors.category.personal': 'Osobiste',
  'connectors.category.presentations': 'Prezentacje',
  'connectors.category.procurement': 'Zakupy',
  'connectors.category.product': 'Produkt',
  'connectors.category.productivity': 'Produktywność',
  'connectors.category.projectManagement': 'Zarządzanie projektami',
  'connectors.category.recruiting': 'Rekrutacja',
  'connectors.category.research': 'Badania',
  'connectors.category.salesIntelligence': 'Analiza sprzedaży',
  'connectors.category.scheduling': 'Planowanie',
  'connectors.category.search': 'Wyszukiwanie',
  'connectors.category.security': 'Bezpieczeństwo',
  'connectors.category.signing': 'Podpisywanie',
  'connectors.category.social': 'Społecznościowe',
  'connectors.category.spreadsheets': 'Arkusze kalkulacyjne',
  'connectors.category.storage': 'Pamięć',
  'connectors.category.support': 'Wsparcie',
  'connectors.category.surveys': 'Ankiety',
  'connectors.category.tasks': 'Zadania',
  'connectors.category.timeTracking': 'Śledzenie czasu',
  'connectors.category.video': 'Wideo',
  'connectors.category.whiteboard': 'Tablica',
  'connectors.categoryLabel': 'Kategoria',
  'connectors.providerLabel': 'Dostawca',
  'connectors.toolsSection': 'Narzędzia',
  'connectors.toolsLoading': 'Ładowanie narzędzi…',
  'connectors.noToolsAvailable': 'Brak dostępnych narzędzi. Po połączeniu odkryjesz możliwości tej integracji.',
  'connectors.toolDetailsUnavailable': 'Szczegóły narzędzi są niedostępne, ale ten konektor zgłasza {n} narzędzi.',
  'connectors.loadMoreTools': 'Wczytaj więcej narzędzi',
  'connectors.openDetailsAria': 'Otwórz szczegóły {name}',
  'connectors.toolsBadgeNone': 'Brak narzędzi',
  'connectors.toolsBadgeOne': '{n} narzędzie',
  'connectors.toolsBadgeMany': '{n} narzędzi',
  'connectors.searchPlaceholder': 'Szukaj konektorów…',
  'connectors.searchAriaLabel': 'Szukaj konektorów po nazwie, dostawcy lub narzędziu',
  'connectors.searchClear': 'Wyczyść wyszukiwanie',
  'connectors.emptyNoMatchTitle': 'Brak konektorów pasujących do „{query}”',
  'connectors.emptyNoMatchBody': 'Spróbuj innego słowa kluczowego lub wyczyść wyszukiwanie, aby zobaczyć pełny katalog.',
  'connectors.emptyNoMatchAction': 'Wyczyść wyszukiwanie',
  'newproj.tabPrototype': 'Prototyp',
  'newproj.tabLiveArtifact': 'Aktywny artefakt',
  'newproj.tabDeck': 'Prezentacja',
  'newproj.tabTemplate': 'Z szablonu',
  'newproj.tabMedia': 'Multimedia',
  'newproj.tabOther': 'Inne',
  'newproj.tabPost': 'Post',
  'newproj.titlePrototype': 'Nowy prototyp',
  'newproj.clientLabel': 'Klient',
  'newproj.titleLiveArtifact': 'Nowy aktywny artefakt',
  'newproj.titleDeck': 'Nowa prezentacja',
  'newproj.titleTemplate': 'Zacznij od szablonu',
  'newproj.titleImage': 'Nowy obraz',
  'newproj.titleVideo': 'Nowe wideo',
  'newproj.titleAudio': 'Nowy dźwięk',
  'newproj.titleMedia': 'Nowe multimedia',
  'newproj.titleOther': 'Nowy projekt',
  'newproj.titlePost': 'Nowy post',
  'newproj.namePlaceholder': 'Nazwa projektu',
  'newproj.fidelityLabel': 'Wierność (Fidelity)',
  'newproj.fidelityWireframe': 'Szkic (Wireframe)',
  'newproj.fidelityHigh': 'Wysoka wierność (Hi-Fi)',
  'newproj.toggleSpeakerNotes': 'Użyj notatek prelegenta',
  'newproj.toggleSpeakerNotesHint': 'Mniej tekstu na slajdach — główne punkty w notatkach.',
  'newproj.toggleAnimations': 'Dołącz animacje',
  'newproj.toggleAnimationsHint': 'Dodaj ruch (wejście, najechanie, przejścia) do szablonu.',
  'newproj.targetPlatformsLabel': 'Platformy docelowe',
  'newproj.targetPlatformsHint': 'Wybierz jedną lub więcej. Responsywna strona internetowa obejmuje wyłącznie punkty graniczne przeglądarki; dodaj iOS, Android, aplikację na tablet lub aplikację na komputer, aby uzyskać natywne warianty wieloplatformowe.',
  'newproj.platform.responsive.label': 'Responsywna strona internetowa',
  'newproj.platform.responsive.hint': 'Jedno środowisko internetowe dostosowane do przeglądarek na komputerach, tabletach i urządzeniach mobilnych',
  'newproj.platform.webDesktop.label': 'Strona internetowa na komputery',
  'newproj.platform.webDesktop.hint': 'Produkt lub strona docelowa zaprojektowane przede wszystkim dla przeglądarki',
  'newproj.platform.mobileIos.label': 'Aplikacja iOS',
  'newproj.platform.mobileIos.hint': 'Ramki iPhone\'a i reguły interakcji iOS',
  'newproj.platform.mobileAndroid.label': 'Aplikacja Android',
  'newproj.platform.mobileAndroid.hint': 'Ramki Pixel i reguły interakcji Material',
  'newproj.platform.tablet.label': 'Aplikacja na tablet',
  'newproj.platform.tablet.hint': 'Środowisko na tablet w stylu natywnym z widokami dzielonymi',
  'newproj.platform.desktopApp.label': 'Aplikacja na komputer',
  'newproj.platform.desktopApp.hint': 'Interfejs aplikacji macOS/Windows',
  'newproj.surfaceOptionsLabel': 'Powierzchnie towarzyszące',
  'newproj.includeLandingPage': 'Dołącz stronę docelową',
  'newproj.includeLandingPageHint': 'Dodaj responsywną stronę marketingową dla reklam, list oczekujących, kampanii premierowych, pobrań aplikacji lub objaśnienia produktu.',
  'newproj.includeOsWidgets': 'Dołącz widżety systemowe',
  'newproj.includeOsWidgetsHint': 'Dodaj natywne dla platformy widżety ekranu głównego, ekranu blokady lub szybkiego dostępu dla aplikacji mobilnych/tabletowych.',
  'newproj.includeOsWidgetsDisabledHint': 'Dostępne, gdy jako platforma docelowa wybrano aplikację iOS, Android lub na tablet.',
  'newproj.templateLabel': 'Szablon',
  'newproj.noTemplatesTitle': 'Brak szablonów',
  'newproj.noTemplatesBody': 'Otwórz dowolny projekt, a następnie użyj menu Udostępnij w przeglądarce plików, aby przekonwertować go na szablon. Szablony pojawią się tutaj.',
  'newproj.savedTemplate': 'Zapisany szablon',
  'newproj.fileSingular': 'plik',
  'newproj.filePlural': 'pliki',
  'newproj.create': 'Utwórz',
  'newproj.locationLabel': 'Zapisz w',
  'newproj.locationDefault': 'Projekty Crie3',
  'newproj.locationExternalBase': 'Zewnętrzna baza',
  'newproj.createLiveArtifact': 'Utwórz aktywny artefakt',
  'newproj.createFromTemplate': 'Utwórz z szablonu',
  'newproj.createDisabledTitle': 'Najpierw zapisz projekt jako szablon (menu Udostępnij wewnątrz projektu).',
  'newproj.importClaudeZip': 'Importuj Claude Design ZIP',
  'newproj.importClaudeZipTitle': 'Importuj eksport .zip z Claude Design',
  'newproj.importingClaudeZip': 'Importowanie…',
  'newproj.openFolder': 'Otwórz folder',
  'newproj.openingFolder': 'Otwieranie…',
  'newproj.importFailed': 'Import nie powiódł się',
  'newproj.importFailedWithReason': 'Import nie powiódł się: {reason}',
  'newproj.folderPickerUnavailable': 'Nie udało się otworzyć wyboru folderu. Zaktualizuj Crie3 i spróbuj ponownie.',
  'newproj.privacyFooter': 'Domyślnie tylko Ty widzisz swój projekt.',
  'newproj.designSystem': 'System projektowania',
  'newproj.dsNoneFreeform': 'Brak — styl dowolny',
  'newproj.dsNoneSubtitleEmpty': 'Brak tokenów systemowych, wybierz własną paletę',
  'newproj.dsNoneSubtitleSelected': 'Pomiń tokeny systemowe. Agent dobierze własną paletę.',
  'newproj.dsCategoryFallback': 'System projektowania',
  'newproj.dsSearch': 'Szukaj systemów projektowania…',
  'newproj.dsModeAria': 'Tryb wyboru',
  'newproj.dsModeSingle': 'Pojedynczy',
  'newproj.dsModeMulti': 'Wiele',
  'newproj.dsNoneTitle': 'Brak — styl dowolny',
  'newproj.dsNoneSub': 'Pomiń tokeny systemowe. Agent dobierze własną paletę.',
  'newproj.dsEmpty': 'Brak systemów projektowania pasujących do „{query}”.',
  'newproj.dsFootSingular': 'służy tylko jako inspiracja.',
  'newproj.dsFootPlural': 'służą tylko jako inspiracja.',
  'newproj.dsFootClear': 'Wyczyść',
  'newproj.dsBadgeDefault': 'DOMYŚLNY',
  'newproj.dsPrimaryFallback': 'Główny',
  'newproj.surfaceImage': 'Obraz',
  'newproj.surfaceVideo': 'Wideo',
  'newproj.surfaceAudio': 'Dźwięk',
  'newproj.modelLabel': 'Model',
  'newproj.modelSearch': 'Szukaj modeli…',
  'newproj.modelEmpty': 'Brak pasujących modeli.',
  'newproj.modelRecommended': 'Zalecany',
  'newproj.modelMissingTitle': 'Wybierz model',
  'newproj.modelMissingSub': 'Wybierz model dla tej powierzchni.',
  'newproj.aspectLabel': 'Proporcje',
  'newproj.videoLengthLabel': 'Długość',
  'newproj.videoLengthSeconds': '{n}s',
  'newproj.audioKindLabel': 'Rodzaj dźwięku',
  'newproj.audioKindMusic': 'Muzyka',
  'newproj.audioKindSpeech': 'Mowa / TTS',
  'newproj.audioKindSfx': 'Efekty (SFX)',
  'newproj.audioDurationLabel': 'Czas trwania',
  'newproj.audioDurationSeconds': '{n}s',
  'newproj.voiceLabel': 'Głos',
  'newproj.voicePlaceholder': 'ID głosu dostawcy, opcjonalnie',
  'newproj.connectorsLabel': 'Konektory',
  'newproj.connectorsHint': 'Źródła danych, z których może korzystać ten artefakt.',
  'newproj.connectorsEmptyTitle': 'Brak skonfigurowanych konektorów',
  'newproj.connectorsEmptyBody': 'Połącz źródło danych, aby artefakt live używał prawdziwych danych zamiast placeholderów.',
  'newproj.connectorsEmptyCta': 'Skonfiguruj konektory →',
  'newproj.connectorsLoading': 'Ładowanie konektorów…',
  'newproj.connectorsCountOne': '{n} połączony',
  'newproj.connectorsCountMany': '{n} połączonych',
  'newproj.connectorsManage': 'Zarządzaj',
  'newproj.promptTemplateLabel': 'Szablon referencyjny',
  'newproj.promptTemplateNoneTitle': 'Brak — napisz własny',
  'newproj.promptTemplateNoneSub': 'Pomiń galerię, opisz własne zadanie',
  'newproj.promptTemplateRefSub': 'Szablon referencyjny',
  'newproj.promptTemplateSearch': 'Szukaj szablonów…',
  'newproj.promptTemplateEmpty': 'Nie zainstalowano jeszcze szablonów dla tego typu powierzchni.',
  'newproj.promptTemplateBodyLabel': 'Polecenie (możesz go dostosować)',
  'newproj.promptTemplateOptimizeHint': 'Możesz edytować wszystko — Twoje zmiany zostaną uwzględnione w instrukcjach dla agenta.',
  'newproj.promptTemplateBodyEmpty': 'Pusta treść — agent nie otrzyma referencji do szablonu.',
  'newproj.deleteTemplateTitle': 'Usuń szablon',
  'newproj.deleteTemplateConfirm': 'Usunąć „{name}"? Tej operacji nie można cofnąć.',
  'newproj.deleteTemplateConfirmCta': 'Usuń szablon',
  'newproj.deleteTemplateError': 'Nie udało się usunąć tego szablonu. Spróbuj ponownie.',
  'designs.subRecent': 'Ostatnie',
  'designs.subYours': 'Twoje projekty',
  'designs.filterAria': 'Filtruj projekty',
  'designs.searchPlaceholder': 'Szukaj…',
  'designs.emptyNoProjects': 'Brak projektów.',
  'designs.emptyNoMatch': 'Brak projektów pasujących do wyszukiwania.',
  'designs.deleteTitle': 'Usuń projekt',
  'designs.deleteConfirm': 'Usunąć „{name}”?',
  'designs.cardFreeform': 'styl dowolny',
  'designs.badgeLive': 'Aktywny',
  'designs.liveArtifactBadgesAria': 'Plakietki aktywnych artefaktów',
  'designs.liveCount': '{n} aktywnych',
  'designs.statusLive': 'Aktywny artefakt',
  'designs.statusArchived': 'Zarchiwizowano',
  'designs.statusError': 'Błąd',
  'designs.statusRefreshing': 'Odświeżanie…',
  'designs.statusRefreshFailed': 'Odświeżanie nie powiodło się',
  'designs.statusRefreshed': 'Odświeżono',
  'designs.status.notStarted': 'Nie rozpoczęto',
  'designs.status.queued': 'W kolejce',
  'designs.status.running': 'Uruchomiony',
  'designs.status.awaitingInput': 'Wymaga danych',
  'designs.status.incomplete': 'Niekompletne',
  'designs.status.succeeded': 'Zakończono',
  'designs.status.published': 'Opublikowano',
  'designs.status.failed': 'Błąd',
  'designs.status.canceled': 'Anulowano',
  'designs.viewToggleAria': 'Tryb widoku',
  'designs.viewGrid': 'Widok siatki',
  'designs.viewKanban': 'Widok tablicy',
  'designs.kanbanEmptyColumn': 'Brak projektów',
  'designs.deleteAria': 'Usuń projekt {name}',
  'designs.menuMore': 'Więcej akcji',
  'designs.menuRename': 'Zmień nazwę',
  'designs.menuDuplicate': 'Duplicate project',
  'designs.menuDelete': 'Usuń',
  'designs.renamePrompt': 'Nowa nazwa dla „{name}”',
  'designs.selectMode': 'Wybierz',
  'designs.cancelSelect': 'Anuluj',
  'designs.deleteSelected': 'Usuń wybrane',
  'designs.selectedCount': 'Wybrano {n}',
  'designs.deleteSelectedConfirm': 'Usunąć {n} projekt(ów)?',
  'designs.deleteSelectedSuccess': 'Pomyślnie usunięto {n} projekt(ów).',
  'designs.deleteSelectedPartial': 'Usunięto {deleted} projekt(ów); {failed} nie powiodło się.',
  'designs.tagPrototype': 'Prototyp',
  'designs.tagLiveArtifact': 'Żywy artefakt',
  'designs.tagSlide': 'Slajd',
  'designs.tagMedia': 'Multimedia',
  'designs.renameTitle': 'Zmień nazwę projektu',
  'designs.renameSave': 'OK',
  'designs.renameCancel': 'Anuluj',
  'examples.typeLabel': 'Typ',
  'examples.surfaceLabel': 'Powierzchnia',
  'examples.surfaceWeb': 'Sieć',
  'examples.surfaceImage': 'Obraz',
  'examples.surfaceVideo': 'Wideo',
  'examples.surfaceAudio': 'Dźwięk',
  'examples.scenarioLabel': 'Scenariusz',
  'examples.modeAll': 'Wszystkie',
  'examples.modePrototypeDesktop': 'Prototypy · Desktop',
  'examples.modePrototypeMobile': 'Prototypy · Mobile',
  'examples.modeDeck': 'Slajdy',
  'examples.modeDocument': 'Dokumenty i szablony',
  'examples.modeOrbit': 'Orbit',
  'examples.modeLive': 'Na żywo',
  'examples.scenarioGeneral': 'Ogólne',
  'examples.scenarioEngineering': 'Inżynieria',
  'examples.scenarioProduct': 'Produkt',
  'examples.scenarioDesign': 'Projektowanie',
  'examples.scenarioMarketing': 'Marketing',
  'examples.scenarioSales': 'Sprzedaż',
  'examples.scenarioFinance': 'Finanse',
  'examples.scenarioHr': 'HR',
  'examples.scenarioOperations': 'Operacje',
  'examples.scenarioSupport': 'Wsparcie',
  'examples.scenarioLegal': 'Prawo',
  'examples.scenarioEducation': 'Edukacja',
  'examples.scenarioPersonal': 'Osobiste',
  'examples.searchPlaceholder': 'Szukaj przykładów…',
  'examples.searchAria': 'Szukaj przykładów po nazwie',
  'examples.emptyNoSkills': 'Brak dostępnych umiejętności. Czy daemon jest uruchomiony?',
  'examples.emptyNoMatch': 'Brak przykładów pasujących do filtrów.',
  'examples.openPreview': '⤢ Otwórz podgląd',
  'examples.loadingPreview': 'Ładowanie podglądu…',
  'examples.hoverPreview': 'Najedź, aby zobaczyć podgląd',
  'examples.usePrompt': 'Użyj tego promptu',
  'examples.previewModalTitle': 'Pełny podgląd (okno)',
  'examples.shareTitle': 'Udostępnij ten przykład',
  'examples.shareLoadFirst': 'Najedź, aby najpierw załadować podgląd',
  'examples.unavailablePlaceholder': 'Brak dołączonego podglądu {kind} — otwórz, aby dowiedzieć się więcej',
  'examples.shareUnavailable': 'Brak dołączonego podglądu {kind} do udostępnienia',
  'examples.shareMenu': 'Udostępnij ▾',
  'examples.exportPdfAllSlides': 'Eksportuj jako PDF (wszystkie slajdy)',
  'examples.exportPptxLocked': 'Eksportuj jako PPTX… (najpierw otwórz szablon)',
  'examples.tagSlideDeck': 'Prezentacja',
  'examples.tagTemplate': 'Szablon',
  'examples.tagDesignSystem': 'System projektowania',
  'examples.tagMobilePrototype': 'Prototyp mobilny',
  'examples.tagDesktopPrototype': 'Prototyp desktopowy',
  'examples.tagImage': 'Obraz',
  'examples.tagVideo': 'Wideo',
  'examples.tagAudio': 'Dźwięk',
  'examples.previewLabel': 'Podgląd',
  'ds.surfaceLabel': 'Powierzchnia',
  'ds.surfaceWeb': 'Sieć',
  'ds.surfaceImage': 'Obraz',
  'ds.surfaceVideo': 'Wideo',
  'ds.surfaceAudio': 'Dźwięk',
  'ds.searchPlaceholder': 'Szukaj systemów projektowania…',
  'ds.emptyNoMatch': 'Brak systemów projektowania pasujących do wyszukiwania.',
  'ds.badgeDefault': 'DOMYŚLNY',
  'ds.preview': 'Podgląd',
  'ds.previewTitle': 'Podgląd systemu projektowania',
  'ds.categoryAll': 'Wszystkie',
  'ds.categoryUncategorized': 'Niekategoryzowane',
  'ds.showcase': 'Galeria',
  'ds.tokens': 'Tokeny',
  'ds.specToggle': 'DESIGN.md',
  'ds.specLoading': 'Ładowanie DESIGN.md…',
  'avatar.title': 'Konto i ustawienia',
  'avatar.localCli': 'Lokalne CLI',
  'avatar.anthropicApi': 'Anthropic API',
  'avatar.useLocal': 'Użyj lokalnego CLI',
  'avatar.useApi': 'Użyj API · BYOK',
  'avatar.codeAgent': 'Agent kodu',
  'avatar.rescan': 'Skanuj PATH ponownie',
  'avatar.amrConsole': 'Konto Crie3 Cloud',
  'avatar.amrConsoleMeta': 'Saldo i doładowanie',
  'avatar.settings': 'Ustawienia',
  'avatar.backToProjects': 'Wróć do projektów',
  'avatar.metaActive': 'aktywny',
  'avatar.metaOffline': 'offline',
  'avatar.metaSelected': 'wybrano',
  'avatar.noAgentSelected': 'nie wybrano agenta',
  'avatar.modelSection': 'Model',
  'avatar.modelLabel': 'Model',
  'avatar.reasoningLabel': 'Rozumowanie',
  'avatar.customSuffix': '(własny)',
  'socialShare.openDesignSection': 'Udostępnij Crie3',
  'socialShare.openDesignTitle': 'Crie3 na GitHub',
  'socialShare.openDesignText': 'Crie3 to otwartoźródłowe środowisko pracy do tworzenia, edytowania, wdrażania i przekazywania artefaktów projektowych.',
  'socialShare.openDesignCopyText': '{text}\n{url}',
  'socialShare.projectSection': 'UDOSTĘPNIANIE W MEDIACH SPOŁECZNOŚCIOWYCH',
  'socialShare.publishPageTitle': 'Opublikuj stronę udostępniania',
  'socialShare.publishPageSubtitle': 'Opublikuj ten podgląd, aby można było udostępniać go w mediach społecznościowych.',
  'socialShare.projectTitle': '{title} · Crie3',
  'socialShare.projectText': 'Stworzone w Crie3: {title}. Zobacz wdrożony artefakt i daj gwiazdkę repozytorium: {repo}',
  'socialShare.projectCopyText': 'Stworzone w Crie3: {title}\n{url}\nRepozytorium Crie3: {repo}',
  'socialShare.deployFirst': 'Wdróż, a następnie udostępnij…',
  'socialShare.copied': 'Skopiowano',
  'socialShare.platform.x': 'X',
  'socialShare.platform.linkedin': 'LinkedIn',
  'socialShare.platform.facebook': 'Facebook',
  'socialShare.platform.reddit': 'Reddit',
  'socialShare.platform.telegram': 'Telegram',
  'socialShare.platform.whatsapp': 'WhatsApp',
  'socialShare.platform.weibo': 'Weibo',
  'socialShare.platform.line': 'LINE',
  'socialShare.platform.instagram': 'Instagram',
  'socialShare.platform.xiaohongshu': 'Xiaohongshu',
  'inlineSwitcher.chipTitle': 'Przełącz CLI / model',
  'inlineSwitcher.chipCli': 'Lokalne CLI',
  'inlineSwitcher.chipByok': 'BYOK',
  'inlineSwitcher.modelDefault': 'domyślny',
  'inlineSwitcher.noAgent': 'brak agenta',
  'inlineSwitcher.modeLabel': 'Tryb',
  'inlineSwitcher.agentLabel': 'Agent',
  'inlineSwitcher.providerLabel': 'Dostawca',
  'inlineSwitcher.modelLabel': 'Model',
  'inlineSwitcher.useCli': 'Użyj lokalnego CLI',
  'inlineSwitcher.useByok': 'Użyj własnego klucza API',
  'inlineSwitcher.daemonOffline': 'Daemon offline — otwórz ustawienia',
  'inlineSwitcher.noAgentsDetected': 'Nie wykryto CLI w PATH',
  'inlineSwitcher.openSettingsForModel': 'Skonfiguruj dostawcę w Ustawieniach',
  'inlineSwitcher.missingApiKey': 'Brak klucza API — dodaj go w Ustawieniach.',
  'inlineSwitcher.openFullSettings': 'Otwórz ustawienia wykonania',
  'inlineSwitcher.customSuffix': '(własny)',
  'project.backToProjects': 'Wróć do projektów',
  'project.brandReadyTitle': 'System projektowy {name} jest gotowy',
  'project.brandReadyTitleGeneric': 'Twój system projektowy jest gotowy',
  'project.brandReadyCta': 'Podgląd w Systemach projektowych',
  'project.brandReadyDismiss': 'Odrzuć',
  'project.brandReadyRefineHint': 'Automatic extraction can miss details. Refine it before using this system broadly.',
  'project.brandReadyAiOptimize': 'AI Optimize',
  'project.brandReadyEditManually': 'Edit manually',
  'project.brandReadyPreviewOpened': 'Podgląd systemu designu otwarty.',
  'project.metaFreeform': 'styl dowolny',
  'project.typePrototype': 'Prototyp',
  'project.typeDeck': 'Slajdy',
  'project.typeTemplate': 'Szablon',
  'project.typeImage': 'Obraz',
  'project.typeVideo': 'Wideo',
  'project.typeAudio': 'Dźwięk',
  'project.customInstructions': 'Instrukcje projektu',
  'project.customInstructionsPlaceholder': 'Instrukcje dla tego projektu (wstrzykiwane do każdej wiadomości)…',
  'project.resizeChatPanel': 'Zmień rozmiar panelu czatu',
  'project.instructionsActive': 'Aktywne — dołączane do każdej wiadomości',
  'project.missing': 'This project has been deleted or no longer exists.',
  'chat.tabChat': 'Czat',
  'chat.tabComments': 'Komentarze',
  'chat.commentsSoon': 'Komentarze — wkrótce',
  'chat.comments.attached': 'Dołączone do czatu',
  'chat.comments.emptyAttached': 'Brak dołączonych komentarzy.',
  'chat.comments.saved': 'Zapisane komentarze',
  'chat.comments.emptySaved': 'Brak zapisanych komentarzy.',
  'chat.comments.add': 'Dodaj',
  'chat.comments.addAll': 'Dodaj wszystkie',
  'chat.comments.remove': 'Usuń',
  'chat.comments.placeholder': 'Skomentuj ten element…',
  'chat.comments.addSend': 'Dodaj i wyślij',
  'chat.comments.updateSend': 'Zaktualizuj i wyślij',
  'chat.comments.removeAttachment': 'Usuń załącznik komentarza',
  'chat.comments.removeAttachmentAria': 'Usuń załącznik komentarza dla {name}',
  'chat.comments.comment': 'Komentarz',
  'chat.comments.sendToChat': 'Wyślij na czat',
  'chat.comments.sending': 'Wysyłanie…',
  'chat.comments.edit': 'Edytuj',
  'chat.comments.select': 'Zaznacz',
  'chat.comments.selectAll': 'Zaznacz wszystko',
  'chat.comments.deselect': 'Odznacz',
  'chat.comments.nSelected': 'Zaznaczono: {n}',
  'chat.comments.pin': 'Przypnij',
  'chat.comments.addNote': 'Dodaj notatkę',
  'chat.comments.savedToast': 'Zapisano komentarz',
  'chat.comments.pinSavedToast': 'Zapisano przypięcie',
  'chat.comments.pinAtCoords': 'at {x}, {y}',
  'chat.comments.capturedItems': 'Przechwycone elementy: {n}',
  'chat.comments.clear': 'Wyczyść',
  'chat.comments.targetImage': 'Obraz',
  'chat.comments.targetControl': 'Element sterujący',
  'chat.comments.targetLink': 'Łącze',
  'chat.comments.targetText': 'Tekst',
  'chat.comments.targetSection': 'Sekcja',
  'chat.comments.targetPage': 'Strona',
  'chat.comments.targetArea': 'Obszar',
  'chat.annotationNotePlaceholder': 'Dodaj notatkę do tego znacznika',
  'chat.annotationAttachImage': 'Dołącz obraz',
  'chat.annotationAttachedImages': 'Dołączone obrazy',
  'chat.annotationAttachedRemove': 'Usuń ostatni obraz',
  'chat.annotationAddToInput': 'Dodaj do pola wprowadzania',
  'chat.annotationAddingToInput': 'Dodawanie...',
  'chat.annotationQueue': 'Kolejka',
  'chat.annotationQueueing': 'Dodawanie do kolejki...',
  'chat.annotationSubmitOptions': 'Opcje wysyłania',
  'chat.annotationSending': 'Wysyłanie...',
  'chat.annotationSendDisabledReason': 'Zadanie jest obecnie w toku',
  'chat.annotationPreviewMissing': 'Nie udało się przechwycić podglądu. Spróbuj ponownie.',
  'chat.annotationPreviewMissingInk': 'Nie udało się przechwycić podglądu. Spróbuj ponownie, aby nie wysłać samego rysunku.',
  'chat.annotationSentWithoutScreenshot': 'Nie udało się przechwycić podglądu. Adnotacja została wysłana bez zrzutu ekranu.',
  'chat.annotationTimeout': 'Przekroczono limit czasu wysyłania adnotacji. Spróbuj ponownie.',
  'chat.annotationFailed': 'Nie udało się wysłać adnotacji. Spróbuj ponownie.',
  'chat.annotationProjectCreateFailed': 'Nie udało się utworzyć projektu, więc adnotacja nie została wysłana.',
  'chat.annotationUploadFailed': 'Nie udało się przesłać załącznika. Spróbuj ponownie.',
  'chat.conversationsTitle': 'Rozmowy',
  'chat.conversationsAria': 'Historia rozmów',
  'chat.newConversation': 'Nowa rozmowa',
  'chat.newConversationsTitle': 'Nowa rozmowa',
  'chat.conversationsHeading': 'Rozmowy',
  'chat.new': 'Nowa',
  'chat.emptyConversations': 'Brak rozmów.',
  'chat.deleteConversation': 'Usuń rozmowę',
  'chat.renameConversationLabel': 'Zmień nazwę „{title}”',
  'chat.deleteConversationConfirm': 'Usunąć „{title}”? Spowoduje to usunięcie wszystkich wiadomości.',
  'chat.untitledConversation': 'Rozmowa bez tytułu',
  'chat.forkedConversationTitle': 'Fork {title}',
  'chat.forkConversationFailed': 'Nie udało się sforkować tej rozmowy.',
  'chat.startTitle': 'Zacznij rozmowę',
  'chat.startHint': 'Opisz, co chcesz wygenerować, albo zacznij od jednego z tych przykładów:',
  'chat.brandBrowserAssistDesktopOnly': 'Browser assist needs the desktop app so Crie3 can read the live browser page.',
  'chat.brandBrowserAssistReadFailed': 'Could not read the browser page. Make sure the brand site is open and fully loaded.',
  'chat.brandBrowserAssistMessage': 'Crie3 needs browser assist to finish this brand extraction. Use the card below to open Browser, then click More, choose Download Page, wait for the success message, and use the left Next Step card to continue extraction.',
  'chat.brandBrowserLocalSnapshotMissing': 'No saved page snapshot is available for this URL.',
  'chat.brandBrowserLocalSnapshotReadFailed': 'Could not read the saved page snapshot.',
  'chat.brandBrowserSnapshotSaveFailed': 'Could not save a page snapshot from the browser.',
  'chat.brandBrowserAssistDownloadGuideTitle': 'Browser opened',
  'chat.brandBrowserAssistDownloadGuideDetails': 'Step 1: Browser is open. Step 2: click More, then Download Page. Step 3: wait for the saved snapshot success message. Step 4: return to the left Next Step card and click Continue extraction to continue the programmatic extraction.',
  'brandEnrichment.title': "Optymalizacja AI",
  'brandEnrichment.body': "Crie3 uruchomi w tle głębszą ekstrakcję, automatycznie zastosuje właściwe skills systemu projektowego i zaktualizuje ten system w miejscu. Może to potrwać 10-20 minut; możesz pracować dalej.",
  'brandEnrichment.cta': "Optymalizuj AI",
  'brandEnrichment.busy': "Uruchamianie optymalizacji AI...",
  'brandExtractionTranscript.sourceDesignMd': 'wklejony DESIGN.md',
  'brandExtractionTranscript.user': 'Wyodrębnij system designu z {source}.',
  'brandExtractionTranscript.doneTitle': 'Programowa ekstrakcja dla {name} zakończona.',
  'brandExtractionTranscript.doneBody': 'Utworzyłem i zarejestrowałem system designu {designSystemId} z {source}. Jest gotowy do podglądu i można go używać w nowych projektach.',
  'brandExtractionTranscript.next': 'Następnie możesz uruchomić AI Optimize, aby wykonać głębszą ekstrakcję, albo utworzyć nowy projekt z tym systemem.',
  'chat.fillInputTitle': 'Kliknij, aby wypełnić pole tekstowe',
  'chat.jumpToLatest': 'Skocz do najnowszych',
  'chat.scrollToLatest': 'Przewiń do najnowszych',
  'chat.you': 'Ty',
  'chat.openFile': 'Otwórz {name}',
  'chat.copyPrompt': 'Kopiuj prompt',
  'chat.copyErrorDiagnostic': 'Kopiuj diagnostykę błędu',
  'chat.copyDone': 'Skopiowano!',
  'chat.formAnswersTitle': 'Twoje odpowiedzi',
  'chat.formAnswerSkipped': 'pominięto',
  'chat.readingToggle': 'Zmierzone dane obrazu',
  'chat.readingDark': 'ciemny',
  'chat.readingMedium': 'średni',
  'chat.readingLight': 'jasny',
  'chat.readingPortrait': 'pionowy',
  'chat.readingLandscape': 'poziomy',
  'chat.readingSquare': 'kwadratowy',
  'chat.readingCopyColor': 'Kopiuj kolor',
  'chat.readingText': 'Odczytany tekst',
  'chat.readingPaletteUnavailable': 'Paleta niedostępna',
  'chat.readingFailed': 'Nie udało się odczytać tego obrazu.',
  'chat.inspect.noEditableTargets': 'This page has no editable elements yet.',
  'chat.inspect.noCommentTargets': 'This page has no commentable elements yet.',
  'chat.inspect.editHint': 'Click an element in the canvas to edit its styles.',
  'chat.inspect.commentHint': 'Click an element in the canvas to add a comment.',
  'chat.composerPlaceholder': 'Opisz, co chcesz wygenerować…',
  'chat.activeFileEditingLabel': 'Edycja',
  'chat.activeFilePlaceholder': 'Poproś Crie3 o zmianę {file}...',
  'chat.designArtifactsShowMore': 'Pokaż jeszcze {count} plików projektu',
  'chat.mode.chat.label': 'Zapytaj',
  'chat.mode.chat.title': 'Tryb zapytań',
  'chat.mode.chat.summary': 'Do szybkich odpowiedzi, poprawek, planowania i rozmowy bez zakładania, że trzeba tworzyć artefakt designu.',
  'chat.mode.chat.solves': 'Użyj go do doprecyzowania pomysłów, poprawy promptów, porównania opcji lub pytań o istniejącą pracę.',
  'chat.mode.chat.query1': 'Podsumuj ten szkic i wskaż braki.',
  'chat.mode.chat.query2': 'Pomóż mi wybrać najlepszą strukturę dla tej landing page.',
  'chat.mode.chat.query3': 'Przejrzyj ten design i zaproponuj konkretne ulepszenia.',
  'chat.mode.plan.label': "Plan",
  'chat.mode.plan.title': "Plan mode",
  'chat.mode.plan.summary': "Creates an editable plan document first, then hands off to Design after you review it.",
  'chat.mode.plan.solves': "Use it for PRDs, slide outlines, prototype briefs, wireframes, storyboards, and any broad request that needs confirmation before generation.",
  'chat.mode.plan.query1': "Create a slide-by-slide PPT outline first.",
  'chat.mode.plan.query2': "Draft a PRD before generating the prototype.",
  'chat.mode.plan.query3': "Turn this idea into an editable design plan.",
  'chat.mode.design.label': 'Projektowanie',
  'chat.mode.design.title': 'Tryb Design',
  'chat.mode.design.summary': 'Do tworzenia lub zmiany konkretnych wyników: stron, prototypów, live artifactów, slajdów, obrazów, wideo, HyperFrames, audio, dashboardów i plików projektu.',
  'chat.mode.design.solves': 'Użyj go, gdy Crie3 ma wygenerować pliki, zaktualizować workspace albo zamienić brief w multimodalne deliverable.',
  'chat.mode.design.query1': 'Stwórz landing page launchu produktu i prototyp HyperFrames na podstawie tego briefu.',
  'chat.mode.design.query2': 'Przygotuj 10-slajdowy deck inwestorski z notatkami prelegenta.',
  'chat.mode.design.query3': 'Wygeneruj koncepcje obrazów, wideo i audio dla tej kampanii.',
  'chat.mode.cardBestFor': 'Najlepsze do',
  'chat.mode.cardTry': 'Przykładowe pytania',
  'chat.mode.cardCost': 'Typowe zużycie',
  'chat.mode.chat.cost': 'Niskie',
  'chat.mode.chat.costNote': 'Tylko rozmowa — nic nie jest generowane, więc zużycie jest najmniejsze.',
  'chat.mode.plan.cost': 'Standardowe',
  'chat.mode.plan.costNote': 'Najpierw tworzy edytowalny dokument planu, zanim cokolwiek wygeneruje.',
  'chat.mode.design.cost': 'Wysokie',
  'chat.mode.design.costNote': 'Generuje pliki i treści multimodalne, więc jedno uruchomienie może zużyć najwięcej.',
  'chat.composerHint': '⌘/Ctrl + Enter, aby wysłać · podaj cel, treść, styl i format',
  'chat.cliSettingsTitle': 'Ustawienia CLI i modelu',
  'chat.cliSettingsAria': 'Otwórz ustawienia CLI i modelu',
  'chat.attachTitle': 'Załącz pliki (lub wklej / przeciągnij)',
  'chat.addContextTitle': 'Add context',
  'chat.attachAria': 'Załącz pliki',
  'chat.importTitle': 'Importuj źródła (wkrótce)',
  'chat.importLabel': 'Importuj',
  'chat.importComingSoon': 'Wkrótce',
  'chat.importSoon': 'Wkrótce',
  'chat.importFig': 'Prześlij plik .fig',
  'chat.importGitHub': 'Połącz z GitHub',
  'chat.importWeb': 'Pobierz element webowy',
  'chat.importFolder': 'Połącz folder z kodem',
  'chat.importSkills': 'Umiejętności i systemy projektowania',
  'chat.importProject': 'Odwołaj się do innego projektu',
  'chat.importDesignSystemHeader': 'Wybierz design system',
  'chat.importDesignSystemBack': 'Wstecz',
  'chat.importDesignSystemSearch': 'Szukaj design systemów…',
  'chat.importDesignSystemEmpty': 'Brak design systemów pasujących do "{query}"',
  'chat.importDesignSystemNone': 'Brak — dowolnie',
  'chat.importDesignSystemNoneSub': 'Nie wiąż się z systemem w tej turze',
  'chat.importDesignSystemActive': 'Aktywny',
  'chat.importDesignSystemSwitched': 'Design system zmieniony na {title}',
  'chat.importDesignSystemFailed': 'Nie udało się zmienić design systemu. Spróbuj ponownie.',
  'chat.importDesignSystemLoadFailed': 'Nie udało się załadować systemów projektowania.',
  'browserUse.title': 'Inspiracja',
  'browserUse.summary': '{count} akcji w sieci, z priorytetem dla ekstrakcji zasobów, języka projektowego, ruchu, kontroli wizualnych i struktury komponentów.',
  'browserUse.searchAria': 'Szukaj inspiracji',
  'browserUse.searchPlaceholder': 'Szukaj zrzutów ekranu, czcionek, kolorów, a11y...',
  'browserUse.empty': 'Brak pasujących inspiracji',
  'browserUse.unavailable': 'Inspiracja jest tutaj niedostępna',
  'browserUse.added': 'Dodano do edytora',
  // Design Browser
  'designBrowser.aria': 'Design Browser',
  'designBrowser.goBack': 'Go Back',
  'designBrowser.goForward': 'Go Forward',
  'designBrowser.reload': 'Reload',

  'designBrowser.stopLoading': 'Zatrzymaj ładowanie',
  'designBrowser.viewportAria': 'Browser viewport',
  'designBrowser.addressPlaceholder': 'Enter URL or search...',
  'designBrowser.addressAria': 'Browser address',
  'designBrowser.suggestion.reference': 'Reference',
  'designBrowser.suggestion.history': 'History',
  'designBrowser.menu.copyScreenshot': 'Copy Screenshot',
  'designBrowser.menu.hardReload': 'Hard Reload',
  'designBrowser.menu.copyUrl': 'Copy URL',
  'designBrowser.menu.openInBrowser': 'Open in Browser',
  'designBrowser.menu.savePageBrief': 'Save Page Brief',
  'designBrowser.menu.clearBrowsingHistory': 'Clear Browsing History',
  'designBrowser.menu.clearCookies': 'Clear Cookies',
  'designBrowser.menu.clearAllData': 'Clear All Data',
  'designBrowser.status.openHttpUrlFirst': 'Open an http URL first',
  'designBrowser.status.openPageBeforeScreenshot': 'Open a page before taking a screenshot',
  'designBrowser.status.screenshotCopied': 'Screenshot copied to clipboard',
  'designBrowser.status.openPageBeforeBrief': 'Open a page before saving a brief',
  'designBrowser.status.openPageBeforeTools': 'Open a page before using browser tools',
  'designBrowser.status.clickElementToComment': 'Click an element to comment',
  'designBrowser.status.clickElementToTune': 'Click an element to tune',
  'designBrowser.status.noElementSelected': 'No browser element selected',
  'designBrowser.status.addBrowserComment': 'Add a browser comment',
  'designBrowser.status.tuneElementThenSaveHtml': 'Tune the element, then save HTML',
  'designBrowser.status.tuneLiveOnly': 'Tune is live only for non-project pages',
  'designBrowser.status.pickerFailed': 'Browser element picker failed',
  'designBrowser.status.applyStyleFailed': 'Could not apply style in browser page',
  'designBrowser.status.editTextFailed': 'Could not edit text in browser page',
  'designBrowser.status.onlyProjectHtmlCanSave': 'Only project-local HTML pages can be saved',
  'designBrowser.status.htmlSaved': 'HTML changes saved',
  'designBrowser.status.htmlSaveFailed': 'HTML save failed',
  'designBrowser.status.commentSavingUnavailable': 'Comment saving is unavailable',
  'designBrowser.status.commentSaved': 'Browser comment saved',
  'designBrowser.status.commentSendingUnavailable': 'Comment sending is unavailable',
  'designBrowser.comments.aria': 'Browser comments',
  'designBrowser.comments.openFor': 'Open browser comment for {label}',
  'designBrowser.comment.dialog': 'Browser comment',
  'designBrowser.comment.elementFallback': 'Browser element',
  'designBrowser.comment.close': 'Close browser comment',
  'designBrowser.comment.noteAria': 'Browser comment note',
  'designBrowser.comment.placeholder': 'Describe the change or issue...',
  'designBrowser.comment.addNote': 'Add note',
  'designBrowser.comment.saveComment': 'Save comment',
  'designBrowser.comment.sending': 'Sending...',
  'designBrowser.comment.sendToChat': 'Send to chat',
  'designBrowser.inspect.editTitle': 'Edit HTML element',
  'designBrowser.inspect.tuneTitle': 'Tune browser element',
  'designBrowser.inspect.closeTune': 'Close browser tune',
  'designBrowser.inspect.colors': 'Colors',
  'designBrowser.inspect.text': 'Text',
  'designBrowser.inspect.fill': 'Fill',
  'designBrowser.inspect.type': 'Type',
  'designBrowser.inspect.size': 'Size',
  'designBrowser.inspect.weight': 'Weight',
  'designBrowser.inspect.spacing': 'Spacing',
  'designBrowser.inspect.pad': 'Pad',
  'designBrowser.inspect.radius': 'Radius',
  'designBrowser.inspect.content': 'Content',
  'designBrowser.inspect.elementText': 'Element text',
  'designBrowser.inspect.saving': 'Saving...',
  'designBrowser.inspect.saveHtml': 'Save HTML',
  'designBrowser.inspect.liveOnly': 'Live only',
  'designBrowser.reference.kicker': 'Crie3 browser',
  'designBrowser.reference.title': 'Reference Board',
  'designBrowser.reference.subtitle': 'A curated set of references across inspiration, real product UI, motion, color, type, assets, and design systems. Open one to browse it live while gathering design language for the next artifact.',
  'designBrowser.reference.categoryAria': 'Reference category',
  'designBrowser.reference.searchPlaceholder': 'Search references...',
  'designBrowser.reference.searchAria': 'Search references',
  'designBrowser.reference.clearSearch': 'Clear search',
  'designBrowser.reference.noMatches': 'No references match “{query}”.',
  'designBrowser.reference.clearFilters': 'Clear filters',
  'designBrowser.reference.open': 'Open',
  'designBrowser.reference.group.inspiration': 'Inspiration',
  'designBrowser.reference.group.interfaces': 'Real Interfaces',
  'designBrowser.reference.group.motion': 'Motion',
  'designBrowser.reference.group.color': 'Color',
  'designBrowser.reference.group.type': 'Typography',
  'designBrowser.reference.group.icons': 'Icons',
  'designBrowser.reference.group.illustration': 'Illustration',
  'designBrowser.reference.group.photography': 'Photography',
  'designBrowser.reference.group.3d': '3D & Graphics',
  'designBrowser.reference.group.mockups': 'Mockups',
  'designBrowser.reference.group.systems': 'Design Systems',
  'designBrowser.reference.group.components': 'Components',
  'designBrowser.reference.group.guidelines': 'Guidelines & A11y',
  'designBrowser.reference.group.tools': 'Tools & Resources',
  'designBrowser.reference.site.dribbble.detail': 'Design shots and UI inspiration.',
  'designBrowser.reference.site.behance.detail': 'Creative portfolios and case studies.',
  'designBrowser.reference.site.awwwards.detail': 'Award-winning website design.',
  'designBrowser.reference.site.godly.detail': 'Curated modern web design.',
  'designBrowser.reference.site.land_book.detail': 'Landing page gallery and patterns.',
  'designBrowser.reference.site.mobbin.detail': 'Real app screens and UI patterns.',
  'designBrowser.reference.site.screenlane.detail': 'Latest UI design patterns from apps.',
  'designBrowser.reference.site.pageflows.detail': 'Real product user flows and onboarding.',
  'designBrowser.reference.site.uisources.detail': 'Interaction patterns from top apps.',
  'designBrowser.reference.site.collectui.detail': 'Daily UI collection by category.',
  'designBrowser.reference.site.gsap.detail': 'Production animation engine and examples.',
  'designBrowser.reference.site.animations.detail': 'Animation patterns and interaction examples.',
  'designBrowser.reference.site.transitions.detail': 'Transition patterns for modern interfaces.',
  'designBrowser.reference.site.motionsites.detail': 'High-end motion and interaction references.',
  'designBrowser.reference.site.motion.detail': 'Scroll and timeline animation inspiration.',
  'designBrowser.reference.site.animography.detail': 'Animated type and kinetic lettering.',
  'designBrowser.reference.site.reactbits.detail': 'React text animation reference for shiny kinetic type.',
  'designBrowser.reference.site.coolors.detail': 'Fast color palette generator.',
  'designBrowser.reference.site.colorhunt.detail': 'Curated color palettes.',
  'designBrowser.reference.site.realtimecolors.detail': 'Preview palettes on a real UI.',
  'designBrowser.reference.site.color_adobe.detail': 'Color wheel and harmony rules.',
  'designBrowser.reference.site.happyhues.detail': 'Palettes shown in real context.',
  'designBrowser.reference.site.fonts_google.detail': 'Open-source font library.',
  'designBrowser.reference.site.fontshare.detail': 'Quality fonts free for commercial use.',
  'designBrowser.reference.site.typewolf.detail': 'Fonts in use and pairing guidance.',
  'designBrowser.reference.site.fontpair.detail': 'Font pairing suggestions.',
  'designBrowser.reference.site.fontsinuse.detail': 'Typography in real-world design.',
  'designBrowser.reference.site.thesvg.detail': 'SVG assets and vector references.',
  'designBrowser.reference.site.svglogos.detail': 'Clean SVG logos for product and brand mocks.',
  'designBrowser.reference.site.icons_lobehub.detail': 'Product and AI-brand icons for interfaces.',
  'designBrowser.reference.site.icon_sets_iconify.detail': '200k+ open-source icons in one place.',
  'designBrowser.reference.site.lucide.detail': 'Clean, consistent open icon set.',
  'designBrowser.reference.site.heroicons.detail': 'Tailwind-made SVG icons.',
  'designBrowser.reference.site.svgrepo.detail': 'Free SVG vectors and icons.',
  'designBrowser.reference.site.storyset.detail': 'Customizable vector illustrations.',
  'designBrowser.reference.site.undraw.detail': 'Open-source MIT illustrations.',
  'designBrowser.reference.site.blush.detail': 'Mix-and-match illustrations.',
  'designBrowser.reference.site.lummi.detail': 'Free AI-generated visuals.',
  'designBrowser.reference.site.whirrls.detail': 'Hand-drawn image references.',
  'designBrowser.reference.site.worldindots.detail': 'Dot-map and data-viz references.',
  'designBrowser.reference.site.unsplash.detail': 'Free high-resolution photos.',
  'designBrowser.reference.site.pexels.detail': 'Free stock photos and video.',
  'designBrowser.reference.site.pixabay.detail': 'Royalty-free images and media.',
  'designBrowser.reference.site.cosmos.detail': 'Visual discovery and mood boards.',
  'designBrowser.reference.site.spline.detail': 'Browser-based 3D design.',
  'designBrowser.reference.site.threejs.detail': 'WebGL 3D references and demos.',
  'designBrowser.reference.site.womp.detail': 'Easy in-browser 3D creation.',
  'designBrowser.reference.site.pixcap.detail': '3D icons, mockups, and scenes.',
  'designBrowser.reference.site.shots.detail': 'Device and browser mockups.',
  'designBrowser.reference.site.mockuuups.detail': 'Drag-and-drop device mockups.',
  'designBrowser.reference.site.angle.detail': '3D device mockup library.',
  'designBrowser.reference.site.rotato.detail': 'Animated 3D product mockups.',
  'designBrowser.reference.site.impeccable.detail': 'High-quality style and interface references.',
  'designBrowser.reference.site.styles_refero.detail': 'Design style references and visual systems.',
  'designBrowser.reference.site.brandfetch.detail': 'Brand assets, logos, and identity.',
  'designBrowser.reference.site.designsystemsrepo.detail': 'Gallery of public design systems.',
  'designBrowser.reference.site.startups.detail': 'Top startup product and brand references.',
  'designBrowser.reference.site.base_ui.detail': 'Unstyled accessible primitives for custom systems.',
  'designBrowser.reference.site.ui_shadcn.detail': 'Composable React components built on Radix and Tailwind.',
  'designBrowser.reference.site.heroui.detail': 'Modern React component library and design system.',
  'designBrowser.reference.site.radix_ui.detail': 'Accessible low-level UI primitives.',
  'designBrowser.reference.site.react_spectrum_adobe.detail': 'Accessible behavior primitives from Adobe.',
  'designBrowser.reference.site.headlessui.detail': 'Unstyled accessible components for Tailwind projects.',
  'designBrowser.reference.site.mui.detail': 'Material-based React component ecosystem.',
  'designBrowser.reference.site.mantine.detail': 'Full-featured React components and hooks.',
  'designBrowser.reference.site.chakra_ui.detail': 'Accessible React components with theme tokens.',
  'designBrowser.reference.site.ant.detail': 'Enterprise component system and patterns.',
  'designBrowser.reference.site.ark_ui.detail': 'Headless components across modern frameworks.',
  'designBrowser.reference.site.daisyui.detail': 'Tailwind CSS component classes and themes.',
  'designBrowser.reference.site.developer_apple.detail': 'Apple platform design guidelines.',
  'designBrowser.reference.site.m3_material.detail': 'Google\'s Material Design 3.',
  'designBrowser.reference.site.lawsofux.detail': 'UX principles and heuristics.',
  'designBrowser.reference.site.webaim.detail': 'Color contrast checker.',
  'designBrowser.reference.site.a11yproject.detail': 'Accessibility checklist and patterns.',
  'designBrowser.reference.site.toolfolio.detail': 'Design tools, resources, and collections.',
  'designBrowser.reference.site.getdesign.detail': 'Curated design resources.',
  'designBrowser.reference.site.tasteskill.detail': 'Design taste training and critique references.',
  'designBrowser.reference.site.uigoodies.detail': 'Hand-picked design resources.',
  'designBrowser.reference.site.sidebar.detail': 'Five design links, every day.',
  'designBrowser.reference.site.github.detail': 'Reference implementation for embedded browser workflows.',
  'browserUse.category.assets': 'Ekstrakcja zasobów',
  'browserUse.category.tokens': 'Język projektowy',
  'browserUse.category.motion': 'Ruch',
  'browserUse.category.visual': 'Kontrole wizualne',
  'browserUse.category.structure': 'Komponenty',
  'browserUse.category.project': 'Uruchomienie projektu',
  'browserUse.category.general': 'Ogólne',
  'browserUse.input.none': 'Brak danych wejściowych',
  'browserUse.input.assetKind': 'kind: images | svgs | media | fonts, limit=200',
  'browserUse.input.optionalSelector': 'Opcjonalny selektor',
  'browserUse.input.requirementSelector': 'Wymaganie, opcjonalny selektor',
  'browserUse.input.selectorOptional': 'Opcjonalny selektor',
  'browserUse.input.scaleOne': 'scale=1',
  'browserUse.input.selectorScaleTwo': 'Selektor, scale=2',
  'browserUse.input.gridOverlay': '12 kolumn, maks. 1200, odstęp 24',
  'browserUse.input.bodySelector': 'selector=\'body\'',
  'browserUse.input.navigate': 'URL, domena lub wyszukiwane terminy',
  'browserUse.input.selector': 'Selektor',
  'browserUse.input.selectorText': 'Selektor i tekst',
  'browserUse.input.scroll': 'Piksele, góra, dół lub strona',
  'browserUse.input.terminalRun': 'Polecenie, limit czasu 120 s',
  'browserUse.input.command': 'Polecenie',
  'browserUse.input.maxChars': 'maxChars=8000',
  'browserUse.input.custom': '{input}',
  'browserUse.action.extract_logo.output': 'Najlepsi kandydaci na logo z nagłówka, nawigacji, nazw klas, pozycji, obrazu OG oraz favikona jako rozwiązanie zapasowe.',
  'browserUse.action.list_images.output': 'Wszystkie obrazy img, srcset, source oraz tła CSS z wymiarami i tekstem alternatywnym.',
  'browserUse.action.download_assets.output': 'Pobrany folder zasobów oraz _manifest.json z obsługą referera i plików cookie.',
  'browserUse.action.extract_svgs.output': 'Wbudowane pliki SVG oraz linkowane pliki .svg zapisane jako osobne pliki SVG.',
  'browserUse.action.optimize_svgs.output': 'Zoptymalizowane pliki SVG oraz współczynnik kompresji.',
  'browserUse.action.extract_colors.output': 'Paleta z wagami oraz zmienne kolorów CSS :root jako palette.json i palette.html.',
  'browserUse.action.extract_fonts.output': 'Najczęstsze rodziny czcionek, rozmiary, grubości oraz reguły @font-face jako typography.json.',
  'browserUse.action.extract_design_tokens.output': 'Promień, cień, odstępy oraz zmienne CSS jako tokens.json.',
  'browserUse.action.extract_type_scale.output': 'Skala typografii nagłówka, tekstu i przycisku z rozmiarem, grubością, wysokością wiersza i proporcjami.',
  'browserUse.action.extract_buttons.output': 'Biblioteka stylów przycisków bez duplikatów jako buttons.html i buttons.json.',
  'browserUse.action.extract_grid_system.output': 'Kontenery grid i flex, kierunek, odstępy, kolumny i maksymalne szerokości jako layout.json.',
  'browserUse.action.extract_breakpoints.output': 'Punkty graniczne media query jako breakpoints.json.',
  'browserUse.action.extract_gradients.output': 'Gradienty CSS jako gradients.css, gradients.json i podgląd HTML.',
  'browserUse.action.extract_shadows.output': 'Cienie ramek, cienie tekstu i cienie rzucane jako shadows.json oraz podgląd.',
  'browserUse.action.extract_easings.output': 'Funkcje wygładzania przejść i animacji jako easings.json.',
  'browserUse.action.export_tokens.output': 'tokens.css, tokens.scss, tailwind.theme.js i style-dictionary.tokens.json.',
  'browserUse.action.extract_animations.output': 'Reguły @keyframes, przejść i transformacji, wykryte biblioteki animacji, motion.css i motion.json.',
  'browserUse.action.validate_view.output': 'Ścieżki zrzutów ekranu oraz ustrukturyzowane problemy wizualne i z układem.',
  'browserUse.action.audit_layout.output': 'Defekty układu, w tym przepełnienie, wykraczanie poza granice, nakładanie i przycięty tekst jako audit.json.',
  'browserUse.action.audit_accessibility.output': 'Problemy z dostępnością wraz z selektorami, etykietami, rolami, fokusem, kontrastem i zrzutami ekranu tam, gdzie to przydatne.',
  'browserUse.action.responsive_screenshots.output': 'Zrzuty ekranu dla telefonu 390, tabletu 834 i desktopu 1440.',
  'browserUse.action.screenshot_full.output': 'Zrzut ekranu całej strony poza obszarem widoku.',
  'browserUse.action.screenshot_element.output': 'Zrzut ekranu pojedynczego elementu domyślnie w skali 2x.',
  'browserUse.action.screenshot_with_grid.output': 'Zrzut ekranu z nałożoną siatką układu.',
  'browserUse.action.screenshot_dark_mode.output': 'Zrzut ekranu z prefers-color-scheme: dark.',
  'browserUse.action.generate_styleguide.output': 'Jednostronicowy przewodnik po stylu z kolorami, skalą typografii, zaokrągleniami i cieniami.',
  'browserUse.action.extract_html.output': 'Czysty, samodzielny HTML bez script, noscript ani wbudowanych atrybutów zdarzeń.',
  'browserUse.action.extract_component_inventory.output': 'Powtarzające się wzorce komponentów, selektory, liczby i zrzuty ekranu.',
  'browserUse.action.extract_copy.output': 'Nagłówki, CTA, treść główna i opisy jako copy.md i copy.json.',
  'browserUse.action.extract_nav.output': 'Główna nawigacja i linki w stopce jako sitemap.md i nav.json.',
  'browserUse.action.extract_forms.output': 'Pola formularzy, etykiety, wskazówki walidacji i akcje wysyłania jako forms.json.',
  'browserUse.action.run_project.output': 'Wykryty URL serwera deweloperskiego otwarty w karcie przeglądarki.',
  'browserUse.action.detect_project.output': 'Framework, menedżer pakietów, polecenie instalacji, polecenie deweloperskie i port.',
  'browserUse.action.page_info.output': 'URL, tytuł, opis, obraz OG, kolor motywu, favicon i viewport.',
  'browserUse.action.snapshot.output': 'Do 120 widocznych elementów interaktywnych i tekstowych wraz ze znacznikiem, etykietą, href i współrzędnymi.',
  'browserUse.action.navigate.output': 'Otwórz stronę i zwróć page_info.',
  'browserUse.action.click.output': 'Kliknij pierwszy pasujący element po przewinięciu go do widoku.',
  'browserUse.action.type_text.output': 'Wypełnij pole i wyślij zdarzenia input oraz change.',
  'browserUse.action.scroll.output': 'Bieżąca i maksymalna pozycja przewijania.',
  'browserUse.action.extract_og_metadata.output': 'Meta tytuł, opis, kanoniczny URL, karty OG/Twitter, obraz społecznościowy i kolor motywu.',
  'browserUse.action.terminal_run.output': 'stdout, stderr i kod wyjścia.',
  'browserUse.action.terminal_run_background.output': 'Identyfikator zadania w tle i ostatnie dane wyjściowe.',
  'browserUse.action.terminal_read.output': 'Ostatnie współdzielone dane wyjściowe terminala.',
  'chat.designToolbox.title': 'Przybornik projektowy',
  'chat.designToolbox.tooltip': 'Przybornik projektowy',
  'chat.designToolbox.aria': 'Otwórz przybornik projektowy',
  'chat.designToolbox.searchPlaceholder': 'Szukaj skilli / MCP / wtyczek / konektorów / plików projektowych...',
  'chat.designToolbox.searchAria': 'Szukaj zasobów przybornika projektowego',
  'chat.designToolbox.followupSection': 'Kontynuacja',
  'chat.designToolbox.resourcesSection': 'Zasoby globalne',
  'chat.designToolbox.selected': 'Wybrane',
  'chat.designToolbox.noResources': 'Nie znaleziono zasobów dla „{query}”.',
  'chat.designToolbox.badge.video': 'Wideo',
  'chat.designToolbox.badge.image': 'Obraz',
  'chat.designToolbox.badge.motion': 'Animacja',
  'chat.designToolbox.badge.polish': 'Dopracowanie',
  'chat.designToolbox.action.auto-match.title': 'Dopasuj następny krok',
  'chat.designToolbox.action.auto-match.badge': 'Dopasuj',
  'chat.designToolbox.action.auto-match.description': 'Najpierw zdefiniuj poprzeczkę jakości, a potem dopasuj skille, MCP, wtyczki, konektory i pliki.',
  'chat.designToolbox.action.asset-search.title': 'Find images / references',
  'chat.designToolbox.action.asset-search.badge': 'Assets',
  'chat.designToolbox.action.asset-search.description': 'Search for usable images, reference screenshots, moodboards, and source candidates for the current design.',
  'chat.designToolbox.action.icon-workflow.title': 'Find / replace icons',
  'chat.designToolbox.action.icon-workflow.badge': 'Icons',
  'chat.designToolbox.action.icon-workflow.description': 'Find, generate, or swap iconography, SVGs, Lucide icons, and visual symbols with a consistent style.',
  'chat.designToolbox.action.image-replace.title': 'Replace page images',
  'chat.designToolbox.action.image-replace.badge': 'Swap',
  'chat.designToolbox.action.image-replace.description': 'Audit current imagery and replace weak hero, section, background, or card images with better assets.',
  'chat.designToolbox.action.reference-extract.title': 'Extract visual references',
  'chat.designToolbox.action.reference-extract.badge': 'Refs',
  'chat.designToolbox.action.reference-extract.description': 'Analyze a reference screenshot or site for palette, typography, layout posture, motion, and asset direction.',
  'chat.designToolbox.action.motion.title': 'Dodaj animację / ruch',
  'chat.designToolbox.action.motion.badge': 'Animacja',
  'chat.designToolbox.action.motion.description': 'Dodaj animacje wejścia, przewijania, przejść stanów i mikrointerakcji do bieżącego HTML lub elementu strony.',
  'chat.designToolbox.action.motion-polish.title': 'Dopracuj animację',
  'chat.designToolbox.action.motion-polish.badge': 'Czas',
  'chat.designToolbox.action.motion-polish.description': 'Przejrzyj czas, wygładzanie, wydajność i alternatywy dla reduced-motion w istniejących animacjach.',
  'chat.designToolbox.action.transition-motion.title': 'Design transitions',
  'chat.designToolbox.action.transition-motion.badge': 'Transition',
  'chat.designToolbox.action.transition-motion.description': 'Design page, scene, loading, and state transitions with restrained timing and reduced-motion fallbacks.',
  'chat.designToolbox.action.threejs-scene.title': '3D / Three.js scene',
  'chat.designToolbox.action.threejs-scene.badge': '3D',
  'chat.designToolbox.action.threejs-scene.description': 'Add or plan Three.js, Spline, Vanta, particle, WebGL, map, or deck.gl-style interactive visuals.',
  'chat.designToolbox.action.anti-ai-polish.title': 'Usuń wrażenie AI',
  'chat.designToolbox.action.anti-ai-polish.badge': 'Smak',
  'chat.designToolbox.action.anti-ai-polish.description': 'Usuń wrażenie szablonowości, gradienty AI, tanie stosy kart i niejasną treść.',
  'chat.designToolbox.action.visual-polish.title': 'Dopracowanie projektu / gotowe do wdrożenia',
  'chat.designToolbox.action.visual-polish.badge': 'Polski',
  'chat.designToolbox.action.visual-polish.description': 'Przeprowadź audyt hierarchii wizualnej, typografii, odstępów, zachowania responsywnego, dostępności i jakości dostarczenia.',
  'chat.designToolbox.action.image-gen.title': 'Generuj obrazy / referencje wizualne',
  'chat.designToolbox.action.image-gen.badge': 'Obraz',
  'chat.designToolbox.action.image-gen.description': 'Generuj referencje sekcji, zasoby, ikony, obrazy do mediów społecznościowych lub moodboard dla bieżącej strony.',
  'chat.designToolbox.action.chart-gen.title': 'Generate charts / diagrams',
  'chat.designToolbox.action.chart-gen.badge': 'Charts',
  'chat.designToolbox.action.chart-gen.description': 'Generate ECharts, React Flow, diagrams, dashboards, relationship maps, or data-visualization assets.',
  'chat.designToolbox.action.logo-gen.title': 'Generate logo / identity',
  'chat.designToolbox.action.logo-gen.badge': 'Logo',
  'chat.designToolbox.action.logo-gen.description': 'Create logo routes, wordmarks, lockups, marks, and identity-system prompts for the current brand.',
  'chat.designToolbox.action.plan-outline.title': "Generate PPT outline from idea",
  'chat.designToolbox.action.plan-outline.badge': "Plan",
  'chat.designToolbox.action.plan-outline.description': "Turn a rough idea into an editable Markdown deck outline before creating slides.",
  'chat.designToolbox.action.video-gen.title': 'Generuj wideo / skrypt animacji',
  'chat.designToolbox.action.video-gen.badge': 'Wideo',
  'chat.designToolbox.action.video-gen.description': 'Zamień projekt w krótkie wideo, scenopis Remotion / Hyperframes lub prompt gotowy do generowania.',
  'chat.designToolbox.kind.skill': 'Umiejętność',
  'chat.designToolbox.kind.plugin': 'Wtyczka',
  'chat.designToolbox.kind.mcp': 'MCP',
  'chat.designToolbox.kind.mcpTemplate': 'Szablon MCP',
  'chat.designToolbox.kind.connector': 'Konektor',
  'chat.designToolbox.kind.designFile': 'Plik projektowy',
  'chat.designToolbox.context.browser': 'Przeglądarka',
  'chat.designToolbox.context.designFiles': 'Pliki projektowe',
  'chat.designToolbox.context.designSystem': 'System projektowy',
  'chat.designToolbox.context.folder': 'Folder',
  'chat.designToolbox.context.terminal': 'Terminal',
  'chat.designToolbox.context.sideChat': 'Czat boczny',
  'chat.designToolbox.context.liveArtifact': 'Artefakt na żywo',
  'chat.designToolbox.context.file': 'Plik',
  'chat.designToolbox.prompt.contextGeneric': 'Bieżący cel: aktualnie otwarty plik HTML / plik projektowy / element strony.',
  'chat.designToolbox.prompt.contextSpecific': 'Bieżący cel: {kind} · {label}.',
  'chat.designToolbox.prompt.preserveDraft': 'Zachowaj intencję już zawartą w edytorze: {draft}',
  'chat.designToolbox.prompt.selectedSkill': 'Wybrany skill: {skill}. Użyj go jako głównego przepływu pracy w tej turze.',
  'chat.designToolbox.prompt.noSkill': 'Jeśli żaden konkretny skill nie pasował, najpierw wybierz najlepszą kombinację spośród dostępnych skilli, MCP, wtyczek, konektorów i plików projektowych.',
  'chat.designToolbox.prompt.autoMatchIntro': 'Działaj jako orkiestrator Creative Director i zrealizuj przepływ pracy projektowej:',
  'chat.designToolbox.prompt.autoMatchStep1': '1. Najpierw zdefiniuj, co oznacza „dobrze wyglądający projekt”: odbiorcy, cel biznesowy, charakter marki, odniesienia stylistyczne, gęstość informacji, standardy kolorów/typografii/animacji/zasobów oraz wzorce AI/szablonów, których należy unikać.',
  'chat.designToolbox.prompt.autoMatchStep2': '2. Przeszukaj i dopasuj pełny indeks zasobów powyżej. Nie korzystaj wyłącznie z rekomendacji przybornika projektowego; łącz skille, MCP, wtyczki, konektory i pliki projektowe, gdy jest to przydatne.',
  'chat.designToolbox.prompt.autoMatchStep3': '3. If the target or aesthetic bar is still unclear, guide me with a structured question-form, include recommended defaults, and make each finite-choice question editable with a custom answer field. If it is clear enough, execute the next step directly.',
  'chat.designToolbox.prompt.autoMatchStep4': '4. Zrealizuj przepływ w tej kolejności: diagnoza -> kierunek stylu -> dobór zasobów -> konkretna edycja/generowanie -> weryfikacja. Na każdym kroku wyjaśnij, dlaczego wybrano te zasoby i co należy potwierdzić w następnej kolejności.',
  'chat.designToolbox.prompt.assetSearch': 'Find the best image/reference assets for the current design. Search available files, connectors, MCPs, browser captures, and generation tools. Return concrete candidates with usage notes, licensing/source caveats when relevant, and a fallback generation prompt if no usable asset exists.',
  'chat.designToolbox.prompt.iconWorkflow': 'Improve the icon system for the current design: find missing icons, replace weak icons, keep stroke/fill/radius/weight consistent, prefer existing icon libraries when available, and generate SVG/icon prompts only when a library icon is insufficient.',
  'chat.designToolbox.prompt.imageReplace': 'Audit every visible image slot in the current design, identify weak or placeholder imagery, then replace or specify better hero, section, background, card, and social images. Preserve layout and provide exact file/prompt/source choices.',
  'chat.designToolbox.prompt.referenceExtract': 'Use the current reference image/site/design file as visual input. Extract palette, type scale, layout rhythm, component posture, motion cues, and asset style, then apply those findings to the current design without copying protected brand assets verbatim.',
  'chat.designToolbox.prompt.motion': 'Add high-quality motion to the current HTML / page element: choose the most useful 1-2 entrance, scroll, state-transition, transition, Rive/Lottie-style icon motion, or GSAP/Motion micro-interaction moments. Keep it restrained, prefer transform / opacity, and include prefers-reduced-motion fallbacks.',
  'chat.designToolbox.prompt.planOutline': "Create or update a Markdown planning document for a PPT/deck outline from this idea. Do not generate the final deck yet. Include slide-by-slide titles, goals, content bullets, visual direction, required data/assets, and open questions. Save it as a `.md` file in Design Files and tell me which file to review.",
  'chat.designToolbox.prompt.motionPolish': 'Przejrzyj i dopracuj istniejące parametry animacji: tempo, easing, wydajność i dostępność. Usuń gwałtowne, tanie lub pogarszające czytelność animacje; w razie potrzeby zastosuj bardziej dopracowaną oś czasu.',
  'chat.designToolbox.prompt.transitionMotion': 'Design high-quality transitions for the current design: page/scene changes, loading bridges, state changes, and section handoffs. Use GSAP/Motion/CSS where appropriate, keep it performant, and include reduced-motion behavior.',
  'chat.designToolbox.prompt.threejsScene': 'Plan or implement a focused Three.js/WebGL visual for the current design. Consider Three.js, Spline-style scenes, Vanta backgrounds, particle systems, Mapbox/deck.gl data layers, or browser portal effects, but keep the scene useful and verify it renders.',
  'chat.designToolbox.prompt.antiAiPolish': 'Wykonaj jeden przebieg dopracowania anty-AI: usuń szablonowe układy, tanie gradienty/poświaty, bezsensowne stosy kart i mgliste teksty. Zachowaj informacje i spraw, by wyglądało to tak, jakby dostarczył to prawdziwy projektant.',
  'chat.designToolbox.prompt.visualPolish': 'Dopracuj ten projekt do stanu gotowego do wdrożenia: sprawdź hierarchię, typografię, odstępy, zachowanie responsywne, stany przycisków, stany pusty/ładowania/błędu oraz dostępność; bezpośrednio napraw najważniejsze problemy.',
  'chat.designToolbox.prompt.imageGen': 'Stwórz plan kolejnych zasobów wizualnych dla tego projektu: referencje sekcji, zasoby hero, ilustracje, ikony, obrazy do mediów społecznościowych lub moodboard. Najpierw zdecyduj, jakiego rodzaju obrazu brakuje, a następnie podaj wykonalne prompty generujące / plan plików.',
  'chat.designToolbox.prompt.chartGen': 'Generate the right chart, diagram, or data-visualization for the current design. Choose between ECharts, React Flow, SVG/CSS diagrams, radar charts, relationship maps, dashboards, or deck.gl/map visualizations based on the data and user goal.',
  'chat.designToolbox.prompt.logoGen': 'Create logo and identity directions for the current brand. Produce multiple routes for wordmark, symbol, lockup, palette, usage rules, and generation prompts; make sure the result is original and usable in the current artifact.',
  'chat.designToolbox.prompt.videoGen': 'Skieruj ten projekt ku wideo: stwórz scenopis krótkiego wideo, strukturę klatek Hyperframes / Remotion lub prompt gotowy dla Sora/fal. Preferuj sprawienie, by istniejąca zawartość HTML / strony naturalnie stała się ujęciami.',
  'chat.designToolbox.prompt.useSkill': 'Użyj {skill} w bieżącym projekcie.',
  'chat.designToolbox.prompt.skillInstruction': 'Najpierw zdecyduj o najlepszym celu dalszych działań, a następnie wykonaj jeden konkretny przebieg. Jeśli zależy to od zewnętrznych zasobów lub API, zapewnij działające rozwiązanie awaryjne lub określ, co muszę dostarczyć.',
  'chat.designToolbox.prompt.selectedResource': 'Wybrany zasób: {kind} · {title} ({id}).',
  'chat.designToolbox.prompt.resourceDescription': 'Opis zasobu: {description}',
  'chat.designToolbox.prompt.pluginResource': 'Użyj tej wtyczki jako głównego kontekstu bieżącego przepływu projektowego. Jeśli udostępnia ona pola wejściowe lub GenUI, poprowadź mnie do wyboru, gdy będzie to potrzebne; jeśli nie pasuje do celu, wybierz lepszy zasób globalny i wyjaśnij dlaczego.',
  'chat.designToolbox.prompt.mcpResource': 'Preferuj tę funkcję MCP na następny krok projektowy. Gdy potrzebne są zewnętrzne zasoby, przechwytywanie sieci, generowanie obrazów/wideo lub dane, najpierw zdecyduj, czy może to wykonać zadanie, a następnie przedstaw wykonalny plan.',
  'chat.designToolbox.prompt.mcpTemplateResource': 'Ten MCP to konfigurowalny szablon. Jeśli jest najbardziej przydatnym narzędziem na tym kroku projektowym, najpierw poprowadź konfigurację; jeśli istnieje skonfigurowana alternatywa, kontynuuj z nią.',
  'chat.designToolbox.prompt.connectorResource': 'Użyj tego konektora, gdy potrzebne są rzeczywiste dane, zasoby, zawartość konta lub dostęp do zewnętrznego przepływu pracy. Przed użyciem wyjaśnij, co zostanie odczytane lub zapisane, i poproś o potwierdzenie, gdy jest to właściwe.',
  'chat.designToolbox.prompt.fileResource': 'Użyj tego pliku projektowego jako bieżącego celu projektowego lub zasobu referencyjnego i wykonaj na jego podstawie następny krok. Jeśli inne pliki wymagają porównania, kontynuuj przeszukiwanie wszystkich plików projektowych.',
  'chat.designToolbox.prompt.resourceIndex': 'Globalny indeks zasobów: skille({skills}), wtyczki({plugins}), MCP({mcpEnabled} włączonych / {mcpTemplates} szablonów), konektory({connectors} połączonych), pliki projektowe({files}).',
  'chat.designToolbox.prompt.searchableSkills': 'Przeszukiwalne skille',
  'chat.designToolbox.prompt.searchablePlugins': 'Przeszukiwalne wtyczki',
  'chat.designToolbox.prompt.availableMcp': 'Dostępne MCP',
  'chat.designToolbox.prompt.connectedConnectors': 'Połączone konektory',
  'chat.designToolbox.prompt.referenceDesignFiles': 'Referencyjne pliki projektowe',
  'chat.designToolbox.prompt.mcpTemplateName': 'Szablon {name}',
  'chat.designToolbox.prompt.processRule': 'Workflow rule: define the aesthetic goal and constraints first, then search and match resources; when user choice is needed, generate a structured question-form with editable custom answers and continue after confirmation.',
  'chat.designToolbox.prompt.moreSuffix': ', +{count} więcej',
  'chat.designToolbox.prompt.compactLine': '{label}: {values}{suffix}.',
  'chat.mentionTabsAria': 'Powierzchnie wzmianek',
  'chat.mentionTabAll': 'Wszystkie',
  'chat.mentionTabTabs': 'Karty',
  'chat.mentionTabPlugins': 'Wtyczki',
  'chat.mentionTabSkills': 'Skille',
  'chat.mentionTabMcp': 'MCP',
  'chat.mentionTabConnectors': 'Konektory',
  'chat.mentionTabFiles': 'Pliki projektów',
  'chat.mentionNoResults': 'Brak wyników dla „{query}”.',
  'chat.mentionSearchPrompt': 'Przeszukaj pliki projektów, karty, wtyczki, umiejętności, serwery MCP i konektory.',
  'chat.mentionSectionTabs': 'Karty',
  'chat.mentionSectionPlugins': 'Wtyczki',
  'chat.mentionSectionSkills': 'Umiejętności',
  'chat.mentionSectionMcp': 'MCP',
  'chat.mentionSectionConnectors': 'Konektory',
  'chat.mentionSectionFiles': 'Pliki projektów',
  'chat.mentionActiveSkill': 'Aktywne',
  'chat.mentionUseMcpTitle': 'Użyj {name}',
  'chat.mentionUseConnectorTitle': 'Użyj {name}',
  'chat.mentionPluginOfficial': 'Oficjalne',
  'chat.mentionPluginMine': 'Moja wtyczka',
  'chat.linkedFolderRemoveAria': 'Usuń połączony folder {path}',
  'chat.linkedFolderNotFound': 'Folder nie istnieje',
  'chat.linkedFolderAlready': 'Ten folder jest już połączony',
  'chat.linkedFolderPickError': 'Nie można otworzyć wyboru folderu',
  'chat.queuedHeader': 'W kolejce',
  'chat.queuedToSend': 'do wysłania',
  'chat.queuedEditQueuedTaskAria': 'Edytuj zadanie w kolejce',
  'chat.queuedSave': 'Zapisz',
  'chat.queuedCancel': 'Anuluj',
  'chat.queuedReorder': 'Przeciągnij, aby zmienić kolejność',
  'chat.queuedEdit': 'Edytuj',
  'chat.queuedMore': 'więcej w kolejce',
  'chat.queuedFollowUpFallback': 'Działanie następcze w kolejce',
  'chat.send': 'Wyślij',
  'chat.stop': 'Zatrzymaj',
  'chat.removeAria': 'Usuń {name}',
  'chat.contextKind.current': 'Bieżący',
  'chat.contextKind.browser': 'Przeglądarka',
  'chat.contextKind.designFiles': 'Pliki projektu',
  'chat.contextKind.designSystem': 'Design system',
  'chat.contextKind.folder': 'Folder',
  'chat.contextKind.project': 'Projekt',
  'chat.contextKind.localCode': 'Kod lokalny',
  'chat.contextKind.terminal': 'Terminal',
  'chat.contextKind.sideChat': 'Czat boczny',
  'chat.contextKind.liveArtifact': 'Element na żywo',
  'chat.contextKind.file': 'Plik',
  'chat.starterPreacher1Title': "Okładka serii",
  'chat.starterPreacher1Tag': "Seria",
  'chat.starterPreacher1Prompt': "Okładka czterotygodniowej serii kazań — tytuł serii dużą, zapadającą w pamięć czcionką, podtytuł niosący obietnicę serii i dyskretny pasek z datami. 1080×1350, plus wersja 1920×1080 do projekcji. Zachowaj czytelność tytułu w rozmiarze miniatury i zostaw miejsce na logo kościoła.",
  'chat.starterPreacher2Title': "Karta z cytatem",
  'chat.starterPreacher2Tag': "Cytat",
  'chat.starterPreacher2Prompt': "Karta do feedu z najmocniejszym zdaniem z kazania — cytat zajmujący większość grafiki, dyskretny podpis autora pod nim i odnośnik biblijny tam, gdzie jest. 1080×1350, wysoki kontrast, jedna myśl na kartę, nic nie konkuruje z tekstem.",
  'chat.starterPreacher3Title': "Karuzela głównej myśli",
  'chat.starterPreacher3Tag': "Social",
  'chat.starterPreacher3Prompt': "5-slajdowa karuzela rozwijająca główną myśl kazania — okładka nazywająca napięcie, które kazanie rozwiązuje, trzy slajdy z jedną myślą każdy i slajd zamykający z zastosowaniem na nadchodzący tydzień. 1080×1350, krótki tekst na slajd, tempo dopasowane do czytania na telefonie.",
  'chat.starterPreacher4Title': "Pionowy fragment kazania",
  'chat.starterPreacher4Tag': "Reels",
  'chat.starterPreacher4Prompt': "Scenariusz 45-sekundowego pionowego fragmentu jednego wątku kazania — hak w pierwszych 3 sekundach, sam fragment i zaproszenie na koniec. Uwzględnij propozycje napisów ekranowych, miejsca cięć i końcowe wezwanie. 1080×1920, z bezpiecznym środkiem kadru.",
  'chat.starterWorship1Title': "Slajdy z tekstami",
  'chat.starterWorship1Tag': "Teksty",
  'chat.starterWorship1Prompt': "Slajdy z tekstem pieśni do projekcji — jedna zwrotka na ekran, duża czcionka o wysokim kontraście, bez dzielenia wyrazów i bez fraz rozbitych między ekranami. 1920×1080, jasny tekst na ciemnym tle, wielkość czytelna z końca sali.",
  'chat.starterWorship2Title': "Karta setlisty",
  'chat.starterWorship2Tag': "Setlista",
  'chat.starterWorship2Prompt': "Karta z niedzielną setlistą — pieśni w kolejności, z tonacją każdej i informacją, kto prowadzi. 1080×1350, wyraźna hierarchia między pieśnią a tonacją, czytelna na telefonie jednym rzutem oka.",
  'chat.starterWorship3Title': "Story o próbie",
  'chat.starterWorship3Tag': "Próba",
  'chat.starterWorship3Prompt': "Seria 2 pionowych stories z wezwaniem na próbę — pierwsze z dniem, godziną i miejscem na pierwszym planie, drugie z tym, co każdy ma przynieść. 1080×1920, duża czcionka, bezpieczny środek kadru, żeby nic się nie ucinało na żadnym telefonie.",
  'chat.starterWorship4Title': "Okładka playlisty",
  'chat.starterWorship4Tag': "Playlista",
  'chat.starterWorship4Prompt': "Kwadratowa okładka playlisty uwielbienia na ten miesiąc — nazwa playlisty mocną czcionką, oprawa wizualna, która przetrwa pomniejszenie do ikony, i miejsce na nazwę służby. 1080×1080, czytelna przy 100×100 pikselach.",
  'chat.starterMedia1Title': "Miniatura YouTube",
  'chat.starterMedia1Tag': "Miniatura",
  'chat.starterMedia1Prompt': "Miniatura filmu na YouTube — najwyżej cztery słowa bardzo dużą czcionką, wysoki kontrast i miejsce po prawej na wyciętą postać. 1280×720, z tekstem czytelnym nawet na szerokości telefonu na liście polecanych.",
  'chat.starterMedia2Title': "Karuzela treści",
  'chat.starterMedia2Tag': "Karuzela",
  'chat.starterMedia2Prompt': "7-slajdowa karuzela na jeden temat — okładka z jasną obietnicą, pięć slajdów z jedną myślą każdy i slajd zamykający z prośbą o obserwowanie lub zapisanie. 1080×1350, spójna hierarchia na wszystkich slajdach, tekst czytelny bez przybliżania.",
  'chat.starterMedia3Title': "Okładka podcastu",
  'chat.starterMedia3Tag': "Podcast",
  'chat.starterMedia3Prompt': "Okładka podcastu — nazwa programu na pierwszym planie, krótki podtytuł mówiący, o czym jest, i oprawa wizualna rozpoznawalna po pomniejszeniu. 3000×3000, sprawdzona pod kątem czytelności przy 55×55 pikselach, czyli realnym rozmiarze w aplikacjach.",
  'chat.starterMedia4Title': "Pionowy skrót",
  'chat.starterMedia4Tag': "Reels",
  'chat.starterMedia4Prompt': "Scenariusz 30-sekundowego pionowego skrótu z dłuższego materiału — 3-sekundowy hak, środek niosący jedną myśl i zakończenie z wezwaniem. Uwzględnij napisy ekranowe i miejsca cięć. 1080×1920, z bezpiecznym środkiem kadru.",
  'chat.starterImage1Title': 'Tło wersetu',
  'chat.starterImage1Tag': 'Grafika biblijna',
  'chat.starterImage1Prompt': 'Obraz tła do karty z wersetem: ciepłe niebo o wschodzie słońca w odcieniach bursztynu, delikatnego różu i głębokiego błękitu u góry, nieliczne miękkie chmury, światło wznoszące się z lewego dolnego rogu. Czysta kompozycja z wolnymi górnymi dwiema trzecimi na późniejsze naniesienie tekstu wersetu. Bez tekstu na obrazie, bez ludzi, subtelne ziarno filmowe, pionowy charakter 1080×1350.',
  'chat.starterImage2Title': 'Okładka serii kazań',
  'chat.starterImage2Tag': 'Seria',
  'chat.starterImage2Prompt': 'Minimalistyczne tło okładki serii kazań: teksturowane, głęboko zielone tło, jeden symboliczny obiekt — lampa oliwna z małym płomieniem — umieszczony pośrodku po prawej, dramatyczne miękkie światło boczne, długi łagodny cień, dużo pustej przestrzeni po lewej na późniejszy tytuł serii. Bez tekstu, bez ludzi, kadr kwadratowy.',
  'chat.starterImage3Title': 'Ilustracja małej grupy',
  'chat.starterImage3Tag': 'Ilustracja',
  'chat.starterImage3Prompt': 'Płaska ilustracja wektorowa spotkania małej grupy w przytulnym salonie — pięć osób w różnym wieku w luźnym kręgu, ciepłe światło lampy, otwarta Biblia na stoliku pośrodku. Powściągliwa 5-kolorowa paleta (krem, terakota, głęboka zieleń, bursztyn, prawie czerń), bez gradientów, cienkie akcenty liniowe, miękkie cienie tylko pod meblami.',
  'chat.starterVideoShot1Title': 'Poranek nabożeństwa',
  'chat.starterVideoShot1Tag': 'Filmowe',
  'chat.starterVideoShot1Prompt': '5-sekundowe kinowe ujęcie: poranne światło wpadające przez witraże pustego kościoła, drobinki kurzu unoszące się w smugach, powolny najazd kamery środkową nawą w stronę ołtarza. Bez ludzi, bez nakładek tekstowych, ciepło i spokojnie.',
  'chat.starterVideoShot2Title': 'Dłonie w modlitwie',
  'chat.starterVideoShot2Tag': 'Nastrój',
  'chat.starterVideoShot2Prompt': '6-sekundowe zbliżenie spracowanych dłoni złożonych w modlitwie w złotej godzinie, płytka głębia ostrości, delikatny najazd, ciepłe światło boczne z miękkimi drobinkami kurzu w powietrzu. Bez dialogów, cicha atmosfera, powściągliwy ruch.',
  'chat.starterVideoShot3Title': 'Światło uwielbienia',
  'chat.starterVideoShot3Tag': 'Pętla',
  'chat.starterVideoShot3Prompt': '5-sekundowe zapętlone ujęcie na ekran uwielbienia: sylwetki uniesionych rąk na tle miękkiego bursztynowo-niebieskiego kontrświatła z lekką mgiełką, powolny, subtelny ruch, twarze poza ostrością, bez tekstu na ekranie. Spokojna, pełna czci energia.',
  'chat.starterVideoFrames1Title': 'Odsłona tytułu serii',
  'chat.starterVideoFrames1Tag': 'HTML-in-canvas',
  'chat.starterVideoFrames1Prompt': 'Stwórz 5-sekundową kompozycję z wyrazistym tytułem serii kazań na czystym, ciemnym tle. Zanimuj okrągłą soczewkę przesuwającą się od lewej do prawej przez tytuł, z subtelnym szklanym załamaniem zniekształcającym litery pod spodem. Użyj html-in-canvas z HyperFrames — przechwyć DOM tekstu i nałóż na wierzch shader soczewki w stylu vfx-liquid-glass. Tytuł w czystym CSS; szkło jako warstwa WebGL.',
  'chat.starterVideoFrames2Title': 'Pisany werset',
  'chat.starterVideoFrames2Tag': 'Nakładka',
  'chat.starterVideoFrames2Prompt': 'Stwórz kompozycję, w której wers z Pisma wypisuje się litera po literze na ciemnym tle — czcionka szeryfowa, miękka poświata narastająca wraz z pojawianiem się słów, delikatne linie skanowania i łagodna winieta nałożone na żywy DOM przez html-in-canvas. Tekst wersetu pozostaje prawdziwym CSS, więc jest idealnie ostry pod przebiegiem shadera. Zakończ, trzymając pełny wers przez dwa takty.',
  'chat.starterVideoFrames3Title': 'Odliczanie przed nabożeństwem',
  'chat.starterVideoFrames3Tag': 'Odliczanie',
  'chat.starterVideoFrames3Prompt': 'Zbuduj 6-sekundowe odliczanie przed nabożeństwem: duże cyfry od 5 do 1 na ciemnym tle, każde przejście to krótki, czysty glitch — rozdzielenie kanałów RGB, chwilowe zacięcie klatki, potem wyraźny reset. Przechwyć cyfry przez html-in-canvas, aby typografia pozostała ostra jak CSS pod warstwą glitcha, i zakończ spokojnym, pełnoekranowym „witajcie”.',
  'chat.starterAudio1Title': 'Powitanie na nabożeństwie',
  'chat.starterAudio1Tag': 'Mowa',
  'chat.starterAudio1Prompt': '30-sekundowy ciepły lektor powitalny na rozpoczęcie nabożeństwa — spokojny, uśmiechnięty ton, chwila pauzy między zdaniami. Tekst: „Cieszymy się, że tu jesteś. Ta godzina jest wyjątkowa — weź oddech, wycisz serce. Witaj w domu.”',
  'chat.starterAudio2Title': 'Czytane rozważanie',
  'chat.starterAudio2Tag': 'Mowa',
  'chat.starterAudio2Prompt': '45-sekundowe spokojne czytanie rozważania, niskim i miarowym głosem, z oddechem między zdaniami i intymnym, bliskim brzmieniem mikrofonu. Tekst: „Pan jest moim pasterzem, niczego mi nie braknie. Na zielonych pastwiskach pozwala mi leżeć. Prowadzi mnie nad wody spokojne. Odnawia moją duszę.”',
  'chat.starterAudio3Title': 'Zaproszenie na wydarzenie',
  'chat.starterAudio3Tag': 'Mowa',
  'chat.starterAudio3Prompt': '20-sekundowe energiczne zaproszenie na wydarzenie do mediów społecznościowych — jasne, pełne energii, ale nie nachalne. Tekst: „To ten weekend. Jeden wieczór uwielbienia, Słowa i społeczności — a Twoje miejsce czeka. Zapisy są otwarte. Przyprowadź kogoś, kto tego potrzebuje.”',
  'ds.loadingSystem': 'Wczytywanie systemu projektowego...',
  'ds.openingWorkspace': 'Otwieranie przestrzeni roboczej...',
  'dsCreate.figmaUrlInvalid': 'Podaj adres URL pliku Figma (https://figma.com/file/… lub /design/…).',
  'dsCreate.extractionAlreadyStarting': 'Ekstrakcja już się rozpoczyna. Poczekaj na zakończenie bieżącego żądania.',
  'dsCreate.prepareProjectFailed': 'Nie udało się przygotować projektu systemu projektowego.',
  'dsCreate.confirmTitle': 'Crie3 wyodrębni Twój system projektowy.',
  'dsCreate.confirmBody': 'Trafisz do projektu, który wypełnia się na żywo — logo, paleta, typografia, obrazy — w miarę analizowania Twojej marki. Nie zamykaj karty.',
  'dsCreate.startingExtraction': 'Rozpoczynanie ekstrakcji...',
  'dsCreate.extractDesignSystem': 'Wyodrębnij system projektowy',
  'dsCreate.addingSourceMaterial': 'Dodawanie materiałów źródłowych...',
  'common.fileSystemReadError': 'Nie udało się odczytać co najmniej jednego z upuszczonych plików lub folderów. Upewnij się, że nadal istnieją, i spróbuj ponownie.',
  'dsCreate.browseFolder': 'Przeglądaj folder',
  'dsCreate.dropZoneSelections': 'Wybrane: {label}',
  'dsCreate.assetEmptyFile': '(pusty plik)',
  'dsCreate.assetNoPreview': 'Brak podglądu dla tego typu pliku.',
  'dsCreate.assetDropAria': 'Dodaj pliki — przeciągnij i upuść, wklej lub kliknij, aby przeglądać',
  'dsCreate.assetDropTitle': 'Przeciągnij i upuść, wklej lub ',
  'dsCreate.assetDropBrowse': 'przeglądaj',
  'dsCreate.assetDropHint': 'Obrazy, fonty, logotypy, PDF, slajdy, HTML — do 12 MB każdy',
  'dsCreate.assetStagedAria': 'Przygotowane zasoby',
  'dsCreate.assetRemoveAria': 'Usuń {name}',
  'dsCreate.assetClosePreview': 'Zamknij podgląd',
  'dsCreate.heroShowcasePalette': 'Paleta',
  'dsCreate.heroShowcaseTypeScale': 'Skala typograficzna',
  'dsCreate.heroShowcaseComponents': 'Komponenty',
  'dsCreate.heroShowcaseBtnPrimary': 'Główny',
  'dsCreate.heroShowcaseBtnGhost': 'Ghost',
  'dsFonts.missingAddFiles': 'Dodaj pliki fontów marki',
  'dsFonts.missingKeepSubstitutes': 'Zachowaj zamienniki',
  'workspace.uploadErrorDismiss': 'Zamknij',
  'chat.searchConversations': 'Szukaj rozmów',
  'chat.noConversationsMatch': 'Brak pasujących rozmów.',
  'chat.chipKindDesignSystem': 'Design System',
  'workspace.searchTabsPlaceholder': 'Szukaj kart',
  'workspace.noTabsFound': 'Nie znaleziono kart',
  'newproj.modalTitle': 'Nowy projekt',
  'newproj.closeEsc': 'Zamknij (Esc)',
  'newproj.creating': 'Tworzenie projektu…',
  'newproj.scrollTabsLeft': 'Przewiń typy projektów w lewo',
  'newproj.scrollTabsRight': 'Przewiń typy projektów w prawo',
  'newproj.targetPlatforms': 'Platformy docelowe',
  'newproj.pickPlatform': 'Wybierz platformę',
  'home.blankProjectFailed': 'Nie udało się utworzyć pustego projektu. Upewnij się, że daemon jest osiągalny.',
  'home.templatePickerUnavailable': 'Wybór szablonów nie jest dostępny w tej powłoce.',
  'home.referenceFolderMissing': 'Wybrany folder referencyjny nie jest już dostępny. Usuń go lub wybierz ponownie przed rozpoczęciem zadania.',
  'home.startRunFailed': 'Nie udało się rozpocząć zadania. Upewnij się, że daemon jest osiągalny, i spróbuj ponownie.',
  'figmaImport.notFigFile': 'To nie jest plik .fig. Wyeksportuj plik Figma jako .fig (File → Save local copy) i upuść go tutaj.',
  'figmaImport.noProject': 'Nie udało się otworzyć projektu, do którego można zaimportować.',
  'figmaImport.invalidUrl': 'Podaj adres URL pliku Figma (https://figma.com/file/… lub /design/…).',
  'figmaImport.tabUploadFig': 'Prześlij .fig',
  'figmaImport.tabUrl': 'Adres URL Figma',
  'workspace.sideChatNeedsAgent': 'Side Chat wymaga lokalnego agenta. Wybierz go na górnym pasku.',
  'workspace.sideChatPickAgent': 'Najpierw wybierz lokalnego agenta (górny pasek).',
  'automations.validationTitle': 'Dodaj tytuł tej automatyzacji.',
  'automations.validationPrompt': 'Dodaj prompt dla zaplanowanej rozmowy.',
  'settings.noMatchingModels': 'Brak pasujących modeli',
  'manualEdit.resetElement': 'Zresetuj element',
  'assistant.designSystemLocked': 'Wybrano aktywny system projektowy. Kierunek wizualny jest już ustalony.',
  'designFiles.pluginFolders': 'Foldery wtyczek',
  'preview.printFailed': 'Drukowanie nie powiodło się. Spróbuj ponownie użyć eksportu PDF lub skorzystaj z wersji przeglądarkowej.',
  'preview.popupBlocked': 'Wyskakujące okno zostało zablokowane! Kliknij ikonę blokady wyskakujących okien w pasku adresu przeglądarki (lub w jej menu), wybierz „Zawsze zezwalaj na wyskakujące okna” dla tej witryny i ponów eksport PDF.',
  'pluginsHome.filtersAria': 'Filtry wtyczek',
  'pluginsHome.savedToast': 'Zapisano {title}.',
  'pluginsHome.saveFailedToast': 'Nie udało się zapisać tej wtyczki w tej przeglądarce.',
  'settings.skillUserImported': 'Umiejętność zaimportowana przez użytkownika',
  'settings.skillDescriptionPlaceholder': 'Co robi ta umiejętność? Kiedy agent powinien po nią sięgać?',
  'settings.skillDetailUnavailable': 'Daemon nie zwrócił pełnych szczegółów umiejętności. Spróbuj ponownie przed jej użyciem.',
  'settings.skillExamplePrompt': 'Przykładowy prompt',
  'entry.navPrimaryAria': 'Główna',
  'chat.pluginsMyPlugins': 'Moje wtyczki',
  'chat.pluginsSearchPlaceholder': 'Szukaj wtyczek…',
  'chat.skillsSearchPlaceholder': 'Szukaj umiejętności…',
  'chat.example1Title': 'Prezentacja redakcyjna (Pitch deck)',
  'chat.example1Tag': 'Magazyn',
  'chat.example1Prompt': '10-slajdowa prezentacja (pitch deck) dla studia projektowego zbierającego rundę seed — układ typu Swiss-grid, duże nagłówki szeryfowe z pogrubionymi inicjałami, numery sekcji o stałej szerokości znaków, dużo wolnej przestrzeni i slajdy ze zdjęciami na cały ekran przeplatane tymi z dużą ilością tekstu. Okładka, wizja, rynek, produkt, trakcja, zespół, zapytanie, kontakt.',
  'chat.example2Title': 'Dashboard analityczny SaaS',
  'chat.example2Tag': 'Dane',
  'chat.example2Prompt': 'Gęsty dashboard analityczny dla SaaS-a z narzędziami dla programistów — pasek KPI ze zmianami tydzień do tygodnia, dwa wykresy liniowe (MRR i aktywne obszary robocze), mapa cieplna użycia na świecie, siatka retencji kohortowej, tabela liderów wśród klientów i kanał zdarzeń w czasie rzeczywistym. Ciemny motyw, cyfry o stałej szerokości, akcenty typu sparkline.',
  'chat.example3Title': 'Raport roczny (long-scroll)',
  'chat.example3Tag': 'Edytorskie',
  'chat.example3Prompt': 'Interaktywny raport roczny dla organizacji klimatycznej — układ typu long-scroll mieszający bloki z dużymi cytatami, wizualizacje danych (wykresy słupkowe, animowane liczniki, mapa choropletowa lokalizacji projektów), przerywniki fotograficzne, lista darczyńców i końcowe wezwanie do działania. Nowoczesny tekst szeryfowy, etykiety wykresów bezszeryfowe, ziemista paleta kolorów.',
  'home.recommendation.eyebrow': 'Polecane dla Ciebie',
  'home.recommendation.primaryCta': 'Zacznij tworzyć',
  'home.recommendation.change': 'Wypróbuj inny',
  'home.recommendation.browseAll': 'Wszystkie typy',
  'home.recommendation.defaultProjectName': 'Nowy projekt',
  'home.recommendation.startFailed': 'Nie udało się rozpocząć tworzenia. Spróbuj ponownie.',
  'studio.firstArtifactHint.title': 'Twój pierwszy projekt jest gotowy',
  'studio.firstArtifactHint.body': 'Spróbuj edytować i dodawać adnotacje — wyeksportuj lub udostępnij, gdy będziesz zadowolony.',
  'studio.firstArtifactHint.dismiss': 'Rozumiem',
  'home.starter.product_ui_prototype.title': 'Zacznij od edytowalnego prototypu produktu',
  'home.starter.product_ui_prototype.desc': 'Na podstawie Twojego celu zacznij od klikalnego interfejsu, który możesz dopracować.',
  'home.starter.product_ui_prototype.firstPrompt': 'Zaprojektuj edytowalny prototyp produktu dla [Twój produkt] z kluczowymi ekranami i wyraźnym głównym przepływem.',
  'home.starter.product_ui_component.title': 'Zacznij od komponentu wielokrotnego użytku',
  'home.starter.product_ui_component.desc': 'Najpierw zbuduj jeden komponent, a potem złóż go w pełne ekrany.',
  'home.starter.product_ui_component.firstPrompt': 'Zaprojektuj komponent [nazwa komponentu] wielokrotnego użytku z jego głównymi stanami i wariantami.',
  'home.starter.product_ui_lowfi.title': 'Zacznij od prototypu o niskiej wierności',
  'home.starter.product_ui_lowfi.desc': 'Najpierw naszkicuj strukturę, a potem podnieś wierność.',
  'home.starter.product_ui_lowfi.firstPrompt': 'Utwórz makietę o niskiej wierności głównych ekranów dla [Twój produkt].',
  'home.starter.marketing_landing.title': 'Zacznij od strony docelowej',
  'home.starter.marketing_landing.desc': 'Zamień swoją kampanię w gotową do wdrożenia stronę docelową.',
  'home.starter.marketing_landing.firstPrompt': 'Zaprojektuj stronę docelową dla [Twój produkt] z sekcją hero, kluczowymi korzyściami i wyraźnym wezwaniem do działania.',
  'home.starter.marketing_multivariant.title': 'Zacznij od kilku wariantów strony docelowej',
  'home.starter.marketing_multivariant.desc': 'Wygeneruj kilka wersji do porównania, zanim podejmiesz decyzję.',
  'home.starter.marketing_multivariant.firstPrompt': 'Utwórz 3 warianty strony docelowej dla [Twój produkt] z różnymi komunikatami hero do porównania.',
  'home.starter.internal_dashboard.title': 'Zacznij od wewnętrznego pulpitu',
  'home.starter.internal_dashboard.desc': 'Zacznij od układu pulpitu dla swojego przepływu pracy.',
  'home.starter.internal_dashboard.firstPrompt': 'Zaprojektuj wewnętrzny pulpit pokazujący [kluczowe metryki] z filtrami i tabelą danych.',
  'home.starter.internal_report.title': 'Zacznij od raportu',
  'home.starter.internal_report.desc': 'Opisz dane i pola, które chcesz zobaczyć.',
  'home.starter.internal_report.firstPrompt': 'Utwórz stronę raportu podsumowującą [opisz dane, pola i metryki, które Cię interesują].',
  'home.starter.ministry_versiculo.title': 'Start with a verse card',
  'home.starter.ministry_versiculo.desc': 'A card with the text large and legible, in your own brand colours.',
  'home.starter.ministry_versiculo.firstPrompt': 'Create a verse card for the feed with [verse reference], large legible type, at 1080×1080.',
  'home.starter.ministry_evento.title': 'Start with an event announcement',
  'home.starter.ministry_evento.desc': 'The invitation artwork with date, time and place up front.',
  'home.starter.ministry_evento.firstPrompt': 'Create the announcement artwork for [event name] with date, time, address and the logo, at 1080×1080.',
  'home.starter.ministry_carrossel.title': 'Start with a carousel',
  'home.starter.ministry_carrossel.desc': 'A sequence of screens that opens on the hook and closes on the invitation.',
  'home.starter.ministry_carrossel.firstPrompt': 'Create a 5-screen carousel about [topic], opening with a hook and closing with a clear invitation.',
  'home.starter.ministry_reels.title': 'Start with a sermon cut',
  'home.starter.ministry_reels.desc': 'A short vertical clip with captions burned in.',
  'home.starter.ministry_reels.firstPrompt': 'Create a 30-second vertical cut from [the sermon excerpt], with on-screen captions and the preacher name.',
  'home.starter.ministry_louvor.title': 'Start with worship artwork',
  'home.starter.ministry_louvor.desc': 'The lyric the church is singing, sized for the feed.',
  'home.starter.ministry_louvor.firstPrompt': 'Create artwork with a lyric excerpt from [song], high contrast and readable on a phone.',
  'home.starter.ministry_serie.title': 'Start with a series cover',
  'home.starter.ministry_serie.desc': 'The campaign identity, ready to carry the pieces that follow.',
  'home.starter.ministry_serie.firstPrompt': 'Create the cover for the [series name] series with room for the title, the subtitle and the dates it runs.',
  'home.starter.ministry_avisos.title': 'Start with the weekly announcements',
  'home.starter.ministry_avisos.desc': 'The whole schedule in one piece, legible from a distance.',
  'home.starter.ministry_avisos.firstPrompt': 'Create the weekly announcements artwork with [the announcements], each with day, time and place.',
  'home.starter.ministry_site.title': 'Start with the ministry site',
  'home.starter.ministry_site.desc': 'A page with the essentials: who you are, where you meet and how to join.',
  'home.starter.ministry_site.firstPrompt': 'Create a page for [ministry name] with an introduction, meeting times, address and a way to get in touch.',
  'home.starter.ministry_projecao.title': 'Start with the service slides',
  'home.starter.ministry_projecao.desc': 'High-contrast screens built for the projector.',
  'home.starter.ministry_projecao.firstPrompt': 'Create the projection slides for the [day] service with [the verse or the lyric], one idea per screen and high contrast.',
  'home.starter.ministry_identidade.title': 'Start with the visual identity',
  'home.starter.ministry_identidade.desc': 'Colours, type and logo gathered for every piece that follows.',
  'home.starter.ministry_identidade.firstPrompt': 'Build the visual identity for [ministry name] with a colour palette, typography and logo usage.',
  'home.starter.general_menu.title': 'Zacznij od pierwszego projektu',
  'home.starter.general_menu.desc': 'Opisz, czego chcesz, a my wygenerujemy edytowalną pierwszą wersję.',
  'home.starter.general_menu.firstPrompt': 'Utwórz edytowalną pierwszą wersję [opisz, co chcesz stworzyć].',
  'chat.example4Title': 'Wideo motion produktu',
  'chat.example4Tag': 'Motion',
  'chat.example4Prompt': 'Stwórz storyboard 15-sekundowego wideo motion dla premiery aplikacji produktywnościowej: mocne otwarcie, zbliżenia UI, typografia kinetyczna, przejścia funkcji, końcowe logo i CTA. Uwzględnij timing, opisy scen, ruch kamery i teksty ekranowe.',
  'preview.usePlugin': 'Użyj wtyczki',
  'preview.usePluginOnly': 'Uzyj bez promptu',
  'preview.usePluginOnlyDesc': 'Uzyj struktury wtyczki bez ladowania przykladowego promptu',
  'preview.replicateContent': 'Uzyj',
  'preview.replicateContentDesc': 'Uzyj przykladowego promptu, aby odtworzyc podglad',
  'preview.duplicateTemplate': 'Remix',
  'preview.duplicateTemplateDesc': 'Zremiksuj ten przyklad w nowym edytowalnym projekcie',
  'preview.shareMenu': 'Udostępnij',
  'preview.exportMenu': 'Eksportuj',
  'preview.shareTemplateBadge': 'Szablon',
  'preview.shareToX': 'X / Twitter',
  'preview.shareToReddit': 'Reddit',
  'preview.shareToFacebook': 'Facebook',
  'preview.shareToLinkedIn': 'LinkedIn',
  'preview.shareToInstagram': 'Instagram',
  'preview.shareToXiaohongshu': '小红书',
  'preview.copyTemplateLink': 'Kopiuj link do szablonu',
  'preview.copyShareText': 'Kopiuj tekst do udostępnienia',
  'preview.shareSocialGroup': 'Udostępnij w mediach społecznościowych',
  'preview.shareCopyGroup': 'Kopiuj',
  'preview.shareExportGroup': 'Eksportuj pliki',
  'preview.shareCopied': 'Skopiowano',
  'preview.shareCopyFailed': 'Kopiowanie nie powiodło się',
  'preview.shareTextDefault': 'Szablon Crie3: {title}',
  'preview.openInNewTab': 'Otwórz w nowej karcie',
  'preview.exit': '⤓ Wyjdź',
  'preview.fullscreen': '⤢ Pełny ekran',
  'preview.closeTitle': 'Zamknij (Esc)',
  'preview.loading': 'Ładowanie {label}…',
  'preview.errorTitle': 'Nie udało się załadować tego przykładu.',
  'preview.errorBody': 'Nie udało się pobrać kodu HTML przykładu. Upewnij się, że Crie3 jest uruchomiony, i spróbuj ponownie.',
  'preview.retry': 'Spróbuj ponownie',
  'preview.unavailableTitle': 'Brak dołączonego podglądu dla {noun}.',
  'preview.unavailableBody': 'Uruchom prompt w czacie, aby wygenerować {kind} wynik.',
  'preview.nounSkill': 'tej umiejętności',
  'preview.nounPlugin': 'tego pluginu',
  'preview.nounTemplate': 'tego szablonu',
  'preview.showSidebar': 'Pokaż {label}',
  'preview.hideSidebar': 'Ukryj {label}',
  'misc.savedTemplate': 'Zapisany szablon',
  'misc.primary': 'Główny',
  'misc.designSystem': 'System projektowania',
  'workspace.designFiles': 'Pliki projektu',
  'workspace.focusMode': 'Skup się na obszarze roboczym',
  'workspace.showChat': 'Pokaż czat',
  'workspace.hideChat': "Ukryj czat",
  'workspace.closeTab': 'Zamknij kartę',
  'workspace.deleteFileConfirm': 'Usunąć „{name}” z folderu projektu?',
  'workspace.deleteSelectedFilesConfirm': 'Usunąć {n} wybranych plików z folderu projektu?',
  'workspace.deleteSelectedFilesPartial': 'Nie udało się usunąć {n} plików.',
  'workspace.openFromDesignFiles': 'Otwórz plik z',
  'workspace.designFilesLink': 'Pliki projektu',
  'workspace.loadingSketch': 'Ładowanie szkicu…',
  'workspace.newTab': 'Nowa karta',
  'workspace.tabsBarAria': 'Karty Crie3',
  'workspace.openTabsAria': 'Otwarte karty',
  'workspace.searchFilesPlaceholder': 'Search files…',
  'workspace.openTabs': 'Otwarte karty',
  'workspace.openFile': 'Open a file',
  'workspace.noFilesMatch': 'No files match',
  'workspace.allFiles': 'All',
  'workspace.createNew': 'Create new',
  'workspace.tabOpen': 'Open',
  'workspace.sideChatContextBanner': 'Integrated context from the current conversation',
  'workspace.sideChatDefaultTitle': 'Side chat',
  'workspace.newTerminal': 'New Terminal',
  'workspace.newTerminalDescription': 'Open a shell in the project directory in a new tab',
  'workspace.newBrowser': 'Nowa przeglądarka',
  'workspace.newBrowserDescription': 'Otwórz wbudowaną kartę przeglądarki dla witryn referencyjnych i zadań',
  'workspace.newSketchDescription': 'Naszkicuj szybkie układy i notatki jako kontekst projektowy dla agenta',
  'workspace.terminalStarting': 'Uruchamianie terminala…',
  'workspace.terminalStartingDescription': 'Przygotowywanie powłoki projektu. Zwykle zajmuje to kilka sekund.',
  'workspace.terminalSessionEnded': 'Sesja zakończona',
  'workspace.terminalReconnecting': 'Ponowne łączenie…',
  'workspace.terminalStartFailed': 'Nie udało się uruchomić sesji terminala',
  'workspace.terminalRestart': 'Uruchom ponownie',
  'workspace.browserTab': 'Browser',
  'workspace.browserTabNumbered': 'Browser {n}',
  'workspace.uploadFailed': 'Upload failed for {count} file(s){detail}.',
  'workspace.uploadFailedDetail': 'Upload failed for {count} file(s) ({detail}).',
  'workspace.uploadPartialFailed': 'Uploaded {uploaded} file(s), but {failed} failed{detail}.',
  'workspace.renamePendingSketchConflict': 'A pending sketch named "{name}" is already open. Save or close it before renaming.',
  'memory.storagePathCopy': 'Memory storage path — click to copy',
  'memory.advanced': 'Advanced',
  'memory.advancedHint': 'Inspect or edit the underlying memory index.',
  'memory.flowOnboarding': 'Onboarding',
  'memory.flowBrandContext': 'Brand context',
  'memory.flowChatSignals': 'Chat signals',
  'memory.howCopy': 'Memory is gathered automatically from profile setup, project and brand extraction, connected apps, and useful facts learned during chats. The saved list below is the review surface; everything else stays quiet unless you open Add or Advanced.',
  'memory.areasAria': 'Memory areas',
  'memory.addManually': 'Add manually',
  'memory.addManuallyCaption': 'Write a fact or preference',
  'memory.addManuallyHint': 'Add facts, preferences, or project context yourself. Fixed assistant behavior lives in Instructions / Rules.',
  'memory.importFromApps': 'Import from apps',
  'memory.importFromAppsCaption': 'Scan connected tools',
  'memory.importFromAppsHint': 'Choose apps to scan for design preferences, project context, and visual references. Nothing is scanned until you select an app.',
  'memory.loading': 'Loading',
  'memory.connectedCount': '{count} connected',
  'memory.manage': 'Manage',
  'memory.chooseSources': 'Choose sources',
  'memory.chooseSourcesHint': 'Select connected apps first. Crie3 only scans the apps you choose.',
  'memory.selectedCount': '{count} selected',
  'memory.connectorListAria': 'Connected memory apps',
  'memory.connectorReadTools': '{count} read tools',
  'memory.connectorCheckingStatus': 'Checking connection status…',
  'memory.connectorAuthPending': 'Finish authorization in your browser, then return here',
  'memory.connectorNotConnected': 'Connect this app before extraction',
  'memory.connectorUseForExtraction': 'Use {name} for memory extraction',
  'memory.selected': 'Selected',
  'memory.select': 'Select',
  'memory.connectAria': 'Connect {name}',
  'memory.reconnectAria': 'Reconnect {name}',
  'memory.checking': 'Checking',
  'memory.waiting': 'Waiting',
  'memory.connecting': 'Connecting',
  'memory.reconnect': 'Reconnect',
  'memory.connect': 'Connect',
  'memory.selectedOfConnectedOne': 'Selected {selected} of {total} connected app.',
  'memory.selectedOfConnectedOther': 'Selected {selected} of {total} connected apps.',
  'memory.scanningApps': 'Scanning apps',
  'memory.selectAppsToScan': 'Select apps to scan',
  'memory.scanSelectedApps': 'Scan selected apps',
  'memory.suggestedMemories': 'Suggested memories',
  'memory.suggestedMemoriesHint': 'Review design-related memories before saving them.',
  'memory.suggestionSourceFallback': 'Connected apps',
  'memory.saving': 'Saving',
  'memory.saveSelected': 'Save selected',
  'memory.discard': 'Discard',
  'memory.diagnosticsAria': 'Connected app read status',
  'memory.lastScan': 'Last scan',
  'memory.bytesRead': '{size} read',
  'memory.noData': 'No data',
  'memory.recentScans': 'Recent scans',
  'memory.runHistoryAria': 'Connected app memory run status',
  'memory.attemptRead': 'Read {name}',
  'memory.attemptFailed': 'Could not read {name}',
  'memory.attemptSkipped': 'Skipped {name}',
  'memory.savedMemory': 'Saved memory',
  'memory.savedMemoryHint': 'Saved facts, preferences, and project context available to future chats.',
  'memory.savedCount': '{count} saved',
  'memory.extractionCountOne': '{count} extraction',
  'memory.extractionCountOther': '{count} extractions',
  'memory.emptyHintBefore': 'Tell the assistant a fact in chat — e.g.',
  'memory.emptyHintExample': 'I prefer dark mode',
  'memory.emptyHintAfter': '— and it will be saved here automatically.',
  'memory.memoryTree': 'Memory tree',
  'memory.memoryTreeHint': 'Technical view of the same saved memories. Most users only need the saved-memory list above.',
  'memory.nodeCountOne': '{count} node',
  'memory.nodeCountOther': '{count} nodes',
  'designFiles.title': 'Pliki projektu',
  'designFiles.upload': 'Prześlij pliki',
  'designFiles.pasteText': 'Wklej jako plik tekstowy',
  'designFiles.newSketch': 'Nowy szkic',
  'designFiles.empty': 'Twoje kreacje pojawią się tutaj',
  'designFiles.refresh': 'Odśwież',
  'designFiles.delete': 'Usuń',
  'designFiles.searchPlaceholder': 'Szukaj plików…',
  'designFiles.up': 'W górę',
  'designFiles.back': 'Wstecz',
  'designFiles.crumbs': 'projekt',
  'designFiles.rowMenu': 'Menu wiersza',
  'designFiles.openInTab': 'Otwórz w karcie',
  'designFiles.download': 'Pobierz',
  'designFiles.downloadSelected': 'Pobierz {n} jako ZIP',
  'designFiles.deleteSelected': 'Usuń {n}',
  'designFiles.clearSelection': 'Wyczyść zaznaczenie',
  'designFiles.selectPage': 'Zaznacz wszystko na stronie',
  'designFiles.selectAll': 'Zaznacz wszystko',
  'designFiles.dropTitle': '⤓ Upuść pliki tutaj',
  'designFiles.dropDesc': 'Obrazy, dokumenty, referencje lub foldery — agent użyje ich jako kontekstu.',
  'designFiles.dropLabel': 'Upuść pliki tutaj',
  'designFiles.upload.title': 'Prześlij pliki',
  'designFiles.paste.title': "Create document",
  'designFiles.upload.label': 'Prześlij',
  'designFiles.paste.label': "Create document",
  'designFiles.documentTemplate.titleFallback': 'Document',
  'designFiles.documentTemplate.goalHeading': 'Goal',
  'designFiles.documentTemplate.goalBody': 'Describe what Crie3 should generate, edit, or decide from this document.',
  'designFiles.documentTemplate.capabilitiesHeading': 'How to use this document',
  'designFiles.documentTemplate.capabilityMarkdown': 'Use any Markdown format: headings, tables, checklists, links, quotes, code blocks, and images.',
  'designFiles.documentTemplate.capabilityAgent': 'The Crie3 agent can read, edit, and use this file as project context.',
  'designFiles.documentTemplate.capabilityImages': 'Paste images, or drag image files onto the editor; uploaded images are inserted at the cursor.',
  'designFiles.documentTemplate.scenarioHeading': 'Scenario guide',
  'designFiles.documentTemplate.scenario.prototype': 'For prototypes, outline the product goal, target users, flows, screens, modules, interaction states, responsive breakpoints, and design tokens such as color, type, spacing, radius, and motion.',
  'designFiles.documentTemplate.scenario.wireframe': 'For wireframes, describe the user flow, screen list, layout hierarchy, content blocks, low-fidelity constraints, and the questions the structure should answer before visual design.',
  'designFiles.documentTemplate.scenario.mobile': 'For mobile apps, list target platforms, screens, navigation model, gestures, native patterns, device sizes, states, and mobile design tokens.',
  'designFiles.documentTemplate.scenario.slideDeck': 'For slides, write a paginated PPT outline: one section per slide with title, purpose, key message, evidence, visual direction, speaker notes, and export needs.',
  'designFiles.documentTemplate.scenario.document': 'For documents, define audience, tone, section structure, source material, citations or data, layout expectations, and PDF/export requirements.',
  'designFiles.documentTemplate.scenario.image': 'For images, specify subject, aspect ratio, composition, visual style, brand tokens, reference files, and negative constraints.',
  'designFiles.documentTemplate.scenario.video': 'For video, draft a storyboard with scenes, timing, captions, motion, assets, audio notes, and output format.',
  'designFiles.documentTemplate.scenario.hyperframes': 'For HyperFrames, describe the HTML motion piece: scenes, timeline, captions, audio-reactive moments, transitions, and capture/export requirements.',
  'designFiles.documentTemplate.scenario.audio': 'For audio, define voice or music direction, duration, mood, script or copy, pacing, pronunciation notes, and final use.',
  'designFiles.documentTemplate.scenario.liveArtifact': 'For live artifacts, describe data sources, refresh cadence, widgets, filters, interactions, empty/loading/error states, and any alerts or automations.',
  'designFiles.documentTemplate.scenario.designSystem': 'For design systems, list brand goals, tokens, typography, color, spacing, components, assets, references, and rules to follow or avoid.',
  'designFiles.documentTemplate.scenario.default': 'Describe the audience, deliverable, required content, references, constraints, and what done should look like.',
  'designFiles.documentTemplate.nextHeading': 'Next step',
  'designFiles.documentTemplate.nextBody': 'Review and edit this document, then ask Crie3 to generate, revise, or operate from it.',

  'designFiles.projectMenu': 'Project actions',
  'designFiles.createDesignSystemFromProject': 'Create design system from this project',
  'designFiles.duplicateProject': 'Duplicate project',

  'designFiles.previewOpen': 'Otwórz',
  'designFiles.previewClose': 'Zamknij podgląd',
  'designFiles.modified': 'Zmodyfikowano {time} · {size}',
  'designFiles.weeksAgo': '{n} tyg. temu',
  'designFiles.groupBy': 'Grupuj według',
  'designFiles.groupByKind': 'Typ',
  'designFiles.groupByModified': 'Modyfikacja',
  'designFiles.filterBy': 'Filtruj według rodzaju',
  'designFiles.filterClear': 'Wyczyść',
  'designFiles.filterCount': '{n} rodzajów',
  'designFiles.expandGroup': 'Rozwiń',
  'designFiles.collapseGroup': 'Zwiń',
  'designFiles.sectionPages': 'Strony',
  'designFiles.sectionScripts': 'Skrypty',
  'designFiles.sectionImages': 'Obrazy',
  'designFiles.sectionSketches': 'Szkice',
  'designFiles.sectionLiveArtifacts': 'Artefakty na żywo',
  'designFiles.sectionOther': 'Inne',
  'designFiles.modifiedToday': 'Dzisiaj',
  'designFiles.modifiedYesterday': 'Wczoraj',
  'designFiles.modifiedPrevious7Days': 'Ostatnie 7 dni',
  'designFiles.modifiedPrevious30Days': 'Ostatnie 30 dni',
  'designFiles.modifiedOlder': 'Starsze',
  'designFiles.showMore': 'Pokaż +{n} więcej',
  'designFiles.kindHtml': 'Strona HTML',
  'designFiles.kindImage': 'Obraz',
  'designFiles.kindSketch': 'Szkic',
  'designFiles.kindText': 'Tekst',
  'designFiles.kindCode': 'Skrypt',
  'designFiles.kindPdf': 'PDF',
  'designFiles.kindDocument': 'Dokument',
  'designFiles.kindPresentation': 'Prezentacja',
  'designFiles.kindSpreadsheet': 'Arkusz kalkulacyjny',
  'designFiles.kindLiveArtifact': 'Żywy artefakt',
  'designFiles.kindBinary': 'Plik binarny',
  'designFiles.kindFolder': 'Folder',
  'designFiles.folderCount': '{n} plików',
  'designFiles.newFolderTitle': 'Nowy folder',
  'designFiles.newFolderLabel': 'Nazwa folderu',
  'designFiles.moveTitle': 'Przenieś do folderu',
  'designFiles.moveLabel': 'Folder docelowy',
  'designFiles.moveRoot': 'Katalog główny projektu',
  'designFiles.moveNewFolder': 'Nowy folder…',
  'designFiles.move': 'Przenieś',
  'designFiles.copyPath': 'Kopiuj ścieżkę',
  'designFiles.copiedPath': 'Skopiowano ścieżkę',
  'designFiles.copyLocalPath': 'Kopiuj lokalną ścieżkę pliku',
  'designFiles.copiedLocalPath': 'Skopiowano lokalną ścieżkę pliku',
  'designFiles.deleteFolderConfirm': 'Usunąć folder „{name}“ i całą jego zawartość?',
  'designFiles.folderCreated': 'Utworzono folder „{name}“',
  'designFiles.folderDeleted': 'Usunięto folder „{name}“',
  'designFiles.filesMoved': 'Przeniesiono {n} do {dest}',
  'designFiles.colName': 'Nazwa',
  'designFiles.colKind': 'Rodzaj',
  'designFiles.colModified': 'Zmodyfikowano',
  'designFiles.perPage': 'Pokaż',
  'designFiles.all': 'Wszystkie',
  'designFiles.prev': 'Poprzednia',
  'designFiles.next': 'Następna',
  'designFiles.jumpToPage': 'Przejdź do strony',
  'designFiles.pageInfo': '{start}–{end} z {total}',
  'designFiles.sectionFolders': 'Foldery',
  'designFiles.sectionStylesheets': 'Arkusze stylów',
  'designFiles.sectionDocuments': 'Dokumenty',
  'designFiles.kindStylesheet': 'Arkusz stylów',
  'designFiles.modifiedExt': 'Zmodyfikowano {time} · {size} · {ext}',
  'designFiles.usefulInfoLabel': 'Przydatne informacje',
  'designFiles.usefulInfoTip': 'Kliknij dwukrotnie dowolny plik, aby otworzyć go w pełnej karcie.',
  'designFiles.usefulInfoTip2': 'Wpisz @ na czacie, aby dodać plik jako kontekst.',
  'designFiles.usefulInfoTip4': 'Wybierz design system, a wyniki będą zgodne z marką.',
  'designFiles.usefulInfoTip5': 'Brak pomysłów? Wypróbuj szablon wtyczki w sekcji Społeczność na stronie głównej.',
  'designFiles.usefulInfoTip9': 'Przeciągnij obrazy, dokumenty lub całe foldery do tego panelu — agent użyje ich jako kontekstu.',
  'designFiles.usefulInfoTip10': 'Kliknij „Nowy szkic”, narysuj układ, a agent wygeneruje go za Ciebie.',
  'designFiles.usefulInfoTip11': 'Zaznacz dowolny element w podglądzie i dodaj komentarz — agent wprowadzi punktowe zmiany.',
  'designFiles.usefulInfoTip12': 'Wynik nie pasuje? Zaznaczenie elementu jest szybsze niż opisywanie od nowa.',
  'designFiles.usefulInfoTip13': 'Każdy projekt wyeksportujesz jednym kliknięciem do PDF, obrazu lub samodzielnego HTML.',
  'designFiles.usefulInfoTip14': 'Zadowolony z projektu? Zapisz go jako szablon w menu Udostępnij.',
  'designFiles.usefulInfoTip15': 'Po wdrożeniu od razu wygenerujesz karty do mediów społecznościowych.',
  'quickSwitcher.placeholder': 'Otwórz plik…',
  'quickSwitcher.empty': 'Brak plików w tym projekcie',
  'quickSwitcher.noMatches': 'Brak wyników',
  'quickSwitcher.navigate': 'nawiguj',
  'quickSwitcher.open': 'otwórz',
  'quickSwitcher.close': 'zamknij',
  'pasteDialog.title': 'Wklej tekst',
  'pasteDialog.hint': 'Zapisano w folderze projektu. Wybierz dowolną nazwę.',
  'pasteDialog.fileNameLabel': 'Nazwa pliku',
  'pasteDialog.namePlaceholder': 'notatki.txt',
  'pasteDialog.contentLabel': 'Treść',
  'pasteDialog.contentPlaceholder': 'Wklej cokolwiek…',
  'pasteDialog.save': 'Zapisz',
  'pasteDialog.cancel': 'Anuluj',
  'sketch.save': 'Zapisz szkic',
  'sketch.cancel': 'Anuluj',
  'sketch.saving': 'Zapisywanie…',
  'sketch.saved': 'Zapisano',
  'sketch.tooltipMainMenu': 'Menu główne: zapis, eksport, pomoc i ustawienia płótna',
  'sketch.tooltipLock': "Keep the current drawing tool active for repeated use",
  'sketch.tooltipHand': "Pan the canvas without selecting objects",
  'sketch.tooltipSelection': "Select, move, resize, or edit objects on the canvas",
  'sketch.tooltipRectangle': "Draw a rectangle or card area",
  'sketch.tooltipDiamond': "Draw a diamond for decisions or branching structure",
  'sketch.tooltipEllipse': "Draw a circle or ellipse",
  'sketch.tooltipArrow': "Draw a directional connector or flow arrow",
  'sketch.tooltipLine': "Draw a straight divider or connector line",
  'sketch.tooltipFreedraw': "Draw freehand lines on the canvas",
  'sketch.tooltipText': "Add editable text to the canvas",
  'sketch.tooltipImage': "Insert an image into the canvas",
  'sketch.tooltipEraser': "Erase objects from the canvas",
  'sketch.tooltipFrame': "Create a frame to group a region of the canvas",
  'sketch.tooltipEmbeddable': "Web Embed only supports valid https:// or http:// links",
  'sketch.tooltipLaser': "Point at canvas content temporarily without changing it",
  'sketch.tooltipMoreTools': "Open additional tools such as frame, web embed, and laser pointer",
  'sketch.tooltipDirty': 'Niezapisane zmiany',
  'sketch.tooltipClean': 'Zapisano',
  'fileViewer.empty': 'Wybierz plik, aby go wyświetlić.',
  'fileViewer.loading': 'Ładowanie…',
  'fileViewer.exportPptx': 'Eksportuj jako PPTX',
  'fileViewer.openInNewTab': 'Otwórz w nowej karcie',
  'fileViewer.copyPath': 'Kopiuj ścieżkę',
  'fileViewer.copied': 'Skopiowano!',
  'fileViewer.share': 'Udostępnij',
  'fileViewer.binaryMeta': 'Binarny · {size}',
  'fileViewer.binaryNote': 'Plik binarny ({size} bajtów). Pobierz go lub otwórz z dysku, aby sprawdzić zawartość.',
  'fileViewer.pdfMeta': 'PDF · {size}',
  'fileViewer.documentMeta': 'Dokument',
  'fileViewer.presentationMeta': 'Prezentacja',
  'fileViewer.spreadsheetMeta': 'Arkusz kalkulacyjny',
  'fileViewer.previewUnavailable': 'Podgląd niedostępny. Pobierz lub otwórz plik, aby go sprawdzić.',
  'fileViewer.download': 'Pobierz',
  'fileViewer.open': 'Otwórz',
  'fileViewer.imageMeta': 'Obraz · {size}',
  'fileViewer.reactMeta': 'Komponent React · {size}',
  'fileViewer.sketchMeta': 'Szkic · {size}',
  'fileViewer.markdownStreamingMeta': 'Podgląd na żywo…',
  'fileViewer.markdownErrorMeta': 'Podgląd może być niepełny (błąd generowania).',
  'fileViewer.markdownStreamingStatus': 'Strumieniowanie… wyświetlanie częściowego markdownu.',
  'fileViewer.markdownErrorStatus': 'Błąd generowania. Wyświetlanie ostatniej dostępnej treści.',
  'fileViewer.markdownSaving': "Saving...",
  'fileViewer.markdownSaveFailed': "Save failed",
  'fileViewer.markdownSaved': "Saved",
  'fileViewer.markdownAutoSaved': "Auto-saved · {time}",
  'fileViewer.markdownAutoSaveHint': "Auto-save on",
  'fileViewer.markdownViewMode': "Markdown view mode",
  'fileViewer.split': "Split",
  'fileViewer.markdownEditor': "Markdown editor",
  'fileViewer.markdownEditorPlaceholder': "Type notes, requirements, or instructions for this document...",
  'fileViewer.markdownPreview': "Markdown preview",
  'fileViewer.videoMeta': 'Wideo · {size}',
  'fileViewer.audioMeta': 'Dźwięk · {size}',
  'fileViewer.reload': 'Odśwież',
  'fileViewer.reloadDisk': 'Odśwież z dysku',
  'fileViewer.copy': 'Kopiuj',
  'fileViewer.copyTitle': 'Kopiuj zawartość pliku',
  'fileViewer.saveDisabled': 'Zapisz (widok tylko do odczytu)',
  'fileViewer.save': 'Zapisz',
  'fileViewer.preview': 'Podgląd',
  'fileViewer.source': 'Źródło',
  'fileViewer.tweaks': 'Poprawki',
  'fileViewer.tweaksUnavailable': 'Brak panelu poprawek w tym artefakcie',
  'fileViewer.jsxModuleTitle': 'Brak samodzielnego podglądu',
  'fileViewer.jsxModuleBody': 'Ten plik to moduł komponentu ładowany przez inną stronę.',
  'fileViewer.jsxModuleCta': 'Otwórz stronę, która go renderuje:',
  'fileViewer.comment': 'Komentarz',
  'fileViewer.edit': 'Edytuj',
  'fileViewer.draw': 'Rysuj',
  'fileViewer.mark': 'Zaznacz',
  'fileViewer.markTool': 'Narzędzie zaznaczania',
  'fileViewer.boxSelect': 'Zaznaczenie prostokątne',
  'fileViewer.textTool': 'Tekst',
  'fileViewer.textAnnotationRemove': 'Usuń tekst',
  'fileViewer.screenshot': 'Zrzut ekranu',
  'fileViewer.versions.entry': 'Wersje',
  'fileViewer.versions.title': 'Wersje',
  'fileViewer.versions.countOne': '1 wersja',
  'fileViewer.versions.countMany': '{count} wersji',
  'fileViewer.versions.current': 'Bieżąca',
  'fileViewer.versions.sourceAi': 'AI edit',
  'fileViewer.versions.sourceManual': 'Manual edit',
  'fileViewer.versions.sourceRestore': 'Restored',
  'fileViewer.versions.restoredFrom': 'Restored from v{version}',
  'fileViewer.versions.versionLabel': 'Wersja {version}',
  'fileViewer.versions.listAria': 'Wersje pliku',
  'fileViewer.versions.loading': 'Ładowanie wersji...',
  'fileViewer.versions.empty': 'Brak wersji.',
  'fileViewer.versions.loadFailed': 'Nie udało się załadować wersji.',
  'fileViewer.versions.previewFailed': 'Nie udało się załadować podglądu tej wersji.',
  'fileViewer.versions.previewLoading': 'Ładowanie podglądu wersji...',
  'fileViewer.versions.noPrompt': 'Brak zapisanego promptu',
  'fileViewer.versions.noPromptBody': 'Dla tej wersji nie zapisano promptu.',
  'fileViewer.versions.promptTitle': 'Prompt',
  'fileViewer.versions.copyPrompt': 'Kopiuj prompt',
  'fileViewer.versions.fullscreen': 'Podgląd pełnoekranowy',
  'fileViewer.versions.open': 'Otwórz podgląd',
  'fileViewer.versions.currentHelp': 'To już jest bieżąca wersja.',
  'fileViewer.versions.restoreHelp': 'Przełączenie przywróci ten HTML jako nową bieżącą wersję.',
  'fileViewer.versions.restore': 'Przełącz na tę wersję',
  'fileViewer.versions.restoreConfirmTitle': 'Przełączyć na tę wersję?',
  'fileViewer.versions.restoreConfirmCta': 'Przełącz',
  'fileViewer.versions.restoring': 'Przełączanie...',
  'fileViewer.versions.restoreFailed': 'Nie udało się przełączyć na tę wersję.',
  'fileViewer.versions.restoreSuccess': 'Przełączono na tę wersję.',
  'manualEdit.layers': 'Warstwy',
  'manualEdit.editableCount': '{count} edytowalnych',
  'manualEdit.hiddenBadge': 'Ukryte',
  'manualEdit.title': 'Edytor ręczny',
  'manualEdit.fallbackTitle': 'Edytuj',
  'manualEdit.movePanel': 'Przenieś panel edycji',
  'manualEdit.editParams': 'Edytuj parametry',
  'manualEdit.closePanel': 'Zamknij panel edycji',
  'manualEdit.selectLayer': 'Wybierz warstwę',
  'manualEdit.empty': 'Kliknij element w podglądzie lub wybierz warstwę.',
  'manualEdit.noEditableLayers': 'Nie znaleziono edytowalnych warstw.',
  'manualEdit.noClass': 'brak klasy',
  'manualEdit.tabsAria': 'Karty edycji ręcznej',
  'manualEdit.tabContent': 'Treść',
  'manualEdit.tabStyle': 'Styl',
  'manualEdit.tabAttributes': 'Atrybuty',
  'manualEdit.tabHtml': 'Html',
  'manualEdit.tabSource': 'Źródło',
  'manualEdit.attributesJson': 'Atrybuty JSON',
  'manualEdit.selectedHtml': 'HTML wybranego elementu',
  'manualEdit.fullSource': 'Pełne źródło artefaktu',
  'manualEdit.applyContent': 'Zastosuj treść',
  'manualEdit.applyStyle': 'Zastosuj styl',
  'manualEdit.applyAttributes': 'Zastosuj atrybuty',
  'manualEdit.applyHtml': 'Zastosuj HTML',
  'manualEdit.applySource': 'Zastosuj źródło',
  'manualEdit.invalidAttributes': 'Nieprawidłowe atrybuty JSON.',
  'manualEdit.changes': 'Zmiany',
  'manualEdit.undo': 'Cofnij',
  'manualEdit.redo': 'Ponów',
  'manualEdit.noChanges': 'Brak ręcznych zmian.',
  'manualEdit.imageUrl': 'URL obrazu',
  'manualEdit.altText': 'Tekst alternatywny',
  'manualEdit.label': 'Etykieta',
  'manualEdit.text': 'Tekst',
  'manualEdit.href': 'Href',
  'manualEdit.textColor': 'Kolor tekstu',
  'manualEdit.background': 'Tło',
  'manualEdit.fontSize': 'Rozmiar czcionki',
  'manualEdit.weight': 'Grubość',
  'manualEdit.align': 'Wyrównanie',
  'manualEdit.padding': 'Dopełnienie',
  'manualEdit.margin': 'Margines',
  'manualEdit.radius': 'Zaokrąglenie',
  'manualEdit.border': 'Obramowanie',
  'manualEdit.width': 'Szerokość',
  'manualEdit.minHeight': 'Minimalna wysokość',
  'manualEdit.deleteElement': 'Usuń element',
  'manualEdit.deleteElementConfirm': 'Usunąć zaznaczony element? Tę operację można cofnąć poleceniem Cofnij.',
  'manualEdit.uploadImage': 'Prześlij obraz',
  'manualEdit.uploadingImage': 'Przesyłanie obrazu…',
  'manualEdit.uploadImageFailed': 'Nie udało się przesłać obrazu.',
  'manualEdit.focusSlides': 'Skup się na slajdach',
  'manualEdit.showPanels': 'Pokaż panele',
  'manualEdit.sectionContent': 'CONTENT',
  'manualEdit.sectionImage': 'IMAGE',
  'manualEdit.sectionPage': 'PAGE',
  'manualEdit.sectionTypography': 'TYPOGRAPHY',
  'manualEdit.sectionSize': 'SIZE',
  'manualEdit.sectionLayout': 'LAYOUT',
  'manualEdit.sectionBox': 'BOX',
  'manualEdit.font': 'Font',
  'manualEdit.size': 'Size',
  'manualEdit.color': 'Color',
  'manualEdit.line': 'Line',
  'manualEdit.tracking': 'Tracking',
  'manualEdit.height': 'Height',
  'manualEdit.gap': 'Gap',
  'manualEdit.direction': 'Direction',
  'manualEdit.justify': 'Justify',
  'manualEdit.fill': 'Fill',
  'manualEdit.opacity': 'Opacity',
  'manualEdit.borderStyle': 'Style',
  'manualEdit.baseSize': 'Base size',
  'manualEdit.pageStylesUnavailable': 'Page styles are available only for full HTML documents.',
  'manualEdit.targetContainer': 'Container',
  'manualEdit.targetImage': 'Image',
  'manualEdit.targetLink': 'Link',
  'manualEdit.targetText': 'Text',
  'manualEdit.pickColor': 'Pick {label}',
  'manualEdit.decrease': '{label} decrease',
  'manualEdit.increase': '{label} increase',
  'fileViewer.zoomOut': 'Pomniejsz',
  'fileViewer.zoomIn': 'Powiększ',
  'fileViewer.resetZoom': 'Resetuj powiększenie',
  'fileViewer.viewportAria': 'Podgląd okna',
  'fileViewer.viewportDesktop': 'Komputer',
  'fileViewer.viewportDesktopTitle': 'Podgląd na komputerze w pełnej szerokości',
  'fileViewer.viewportTablet': 'Tablet',
  'fileViewer.viewportTabletTitle': 'Podgląd na tablecie w rozdzielczości 820 × 1180 (nowoczesna baza pionowa)',
  'fileViewer.viewportMobile': 'Telefon',
  'fileViewer.viewportMobileTitle': 'Podgląd na urządzeniu mobilnym w rozdzielczości 390 × 844',
  'fileViewer.reloadAria': 'Odśwież',
  'fileViewer.previousSlide': 'Poprzedni slajd',
  'fileViewer.nextSlide': 'Następny slajd',
  'fileViewer.slideNavAria': 'Nawigacja slajdów',
  'fileViewer.speakerNotes': 'Notatki prelegenta',
  'fileViewer.speakerNotesSlide': 'Slajd {current} / {total}',
  'fileViewer.speakerNotesEmpty': 'Brak notatek prelegenta dla tego slajdu.',
  'fileViewer.speakerNotesEdit': 'Edytuj',
  'fileViewer.speakerNotesSave': 'Zapisz notatki',
  'fileViewer.speakerNotesSaving': 'Zapisywanie…',
  'fileViewer.speakerNotesSaved': 'Zapisano',
  'fileViewer.speakerNotesSaveFailed': 'Nie udało się zapisać notatek prelegenta.',
  'fileViewer.speakerNotesPlaceholder': 'Dodaj notatki prelegenta do tego slajdu…',
  'fileViewer.presenterReset': 'Resetuj',
  'fileViewer.present': 'Prezentuj',
  'fileViewer.presentInTab': 'W tej karcie',
  'fileViewer.presentFullscreen': 'Pełny ekran',
  'fileViewer.presentNewTab': 'Nowa karta',
  'fileViewer.exitPresentation': 'Wyjdź z prezentacji',
  'fileViewer.shareLabel': 'Udostępnij',
  'fileViewer.shareMenuShareLink': 'UDOSTĘPNIJ',
  'fileViewer.shareMenuPublishOnline': 'OPUBLIKUJ ONLINE',
  'fileViewer.shareMenuDownload': 'POBIERZ',
  'fileViewer.shareMenuPresentation': 'Prezentacja',
  'fileViewer.shareMenuSourceFiles': 'Pliki źródłowe',
  'fileViewer.shareMenuSave': 'ZAPISZ',
  'fileViewer.copyShareLink': 'Kopiuj link udostępniania',
  'fileViewer.openSharePage': 'Otwórz stronę udostępniania',
  'fileViewer.shareLinkRequiresDeploy': 'Najpierw opublikuj online, aby uzyskać link',
  'fileViewer.shareLinkPublishGuide': 'Opublikuj online powyżej, aby włączyć udostępnianie ↑',
  'fileViewer.shareAfterGenerationComplete': 'Udostępnianie będzie dostępne po zakończeniu generowania',
  'fileViewer.copyProviderLink': 'Skopiuj link {provider}',
  'fileViewer.copyCloudflareLink': 'Skopiuj link Cloudflare',
  'fileViewer.screenshotCopying': 'Kopiowanie zrzutu ekranu...',
  'fileViewer.screenshotCopied': 'Zrzut ekranu skopiowany do schowka',
  'fileViewer.screenshotClipboardDenied': 'Przeglądarka zablokowała dostęp do schowka',
  'fileViewer.screenshotPreviewLoading': 'Podgląd nadal się ładuje. Spróbuj ponownie za chwilę.',
  'fileViewer.screenshotCaptureFailed': 'Nie udało się przechwycić podglądu. Spróbuj ponownie.',
  'fileViewer.exportPdf': 'Eksportuj jako PDF',
  'fileViewer.exportPdfAllSlides': 'Eksportuj jako PDF (wszystkie slajdy)',
  'fileViewer.exportPptxBusy': 'Poczekaj, aż bieżąca tura zostanie zakończona.',
  'fileViewer.exportPptxHint': 'Wyślij prośbę do agenta o przekonwertowanie tego projektu na PPTX.',
  'fileViewer.exportPptxNa': 'Eksport do PPTX nie jest tutaj dostępny.',
  'fileViewer.exportZip': 'Pobierz jako .zip',
  'fileViewer.exportHtml': 'Eksportuj jako samodzielny HTML',
  'fileViewer.exportMd': 'Eksportuj jako Markdown',
  'fileViewer.exportImage': 'Eksportuj jako obraz',
  'fileViewer.exportVideo': 'Wideo (MP4)',
  'fileViewer.exportVideoOneCard': 'Wideo nagrywa się z jednej karty. Ta karuzela ma ich kilka, a Instagram przyjmuje jedno wideo na post.',
  'fileViewer.exportVideoNotAnimated': 'Nic się tu nie porusza, więc nie ma czego nagrać. Pobierz jako obraz.',
  'fileViewer.exportVideoFailed': 'Nie udało się utworzyć wideo. Spróbuj ponownie.',
  'fileViewer.exportVideoBusy': 'Trwa tworzenie innych materiałów. Poczekaj chwilę i spróbuj ponownie.',
  'fileViewer.exportPptxImages': 'Eksportuj jako PPTX (obrazy)',
  'fileViewer.exportPptxEditable': 'Eksportuj jako PPTX (edytowalny)',
  'fileViewer.exportPptxEditableHint': 'Native editable shapes & text (not pixel-perfect)',
  'fileViewer.exportPptxModalSubtitle': "Choose how to export, then download.",
  'fileViewer.exportPptxScreenshot': "Screenshot PPTX",
  'fileViewer.exportPptxScreenshotHint': "One image per slide — pixel-perfect, but not editable.",
  'fileViewer.exportPptxConfirm': "Export",
  'fileViewer.exportPptxRecommended': "Recommended",
  'fileViewer.exportingProgress': 'Eksportowanie…',
  'fileViewer.exportSlideProgress': 'Eksportowanie slajdu {current}/{total}…',
  'fileViewer.exportingElapsed': 'Eksportowanie… {seconds}s',
  'fileViewer.exportSlideEta': 'Slajd {current}/{total} · pozostało ~{seconds}s',
  'fileViewer.exportFailed': 'Eksport nie powiódł się. Spróbuj ponownie.',
  'fileViewer.exportDone': 'Eksport zakończony',
  'fileViewer.exportImageFailed': 'Nie udało się wygenerować obrazu tego materiału. Spróbuj ponownie lub pobierz go w formacie PDF.',
  'fileViewer.exportImageDegraded': 'Downloaded a reduced version: without the photo you attached, and at screen size rather than at the size the piece declares. Try again — if it repeats, tell us and we will look into it.',
  'fileViewer.exportImageModalSubtitle': 'Wybierz format, a następnie pobierz bieżący podgląd jako obraz.',
  'fileViewer.exportImageFormatLabel': 'Format',
  'fileViewer.exportImageSaving': 'Zapisywanie obrazu…',
  'fileViewer.exportImageSaved': 'Obraz zapisany',
  'fileViewer.exportImageDownloadStarted': 'Pobieranie rozpoczęte',
  'fileViewer.exportImageDownloadDetails': '{filename} znajduje się w pobranych plikach przeglądarki, jeśli nie pojawiło się okno Zapisz jako.',
  'fileViewer.exportJsx': 'Eksportuj jako JSX',
  'fileViewer.exportReactHtml': 'Eksportuj podgląd jako HTML',
  'fileViewer.exportStarted': 'Rozpoczęto eksport',
  'fileViewer.saveAsTemplate': 'Zapisz jako szablon…',
  'fileViewer.savingTemplate': 'Zapisywanie szablonu…',
  'fileViewer.savedTemplate': 'Zapisano jako „{name}”',
  'fileViewer.savedTemplateFail': 'Nie udało się zapisać szablonu — spróbuj ponownie.',
  'fileViewer.templateNamePrompt': 'Nazwa szablonu',
  'fileViewer.templateNameDefault': 'Szablon bez tytułu',
  'fileViewer.templateDescPrompt': 'Krótki opis (opcjonalnie — co czyni ten szablon użytecznym?)',
  'liveArtifact.refresh.button': 'Odśwież',
  'liveArtifact.refresh.buttonTitle': 'Odśwież ten dynamiczny artefakt',
  'liveArtifact.refresh.loadingTitle': 'Ładowanie artefaktu na żywo…',
  'liveArtifact.refresh.noSourceTitle': 'Nie jest jeszcze dostępne żadne źródło odświeżania.',
  'liveArtifact.refresh.running': 'Odświeżanie…',
  'liveArtifact.refresh.runningMessage': 'Odświeżanie danych i podglądu. Może to chwilę potrwać.',
  'liveArtifact.refresh.runningAction': 'Poprzedni podgląd pozostaje widoczny do czasu pomyślnego odświeżenia.',
  'liveArtifact.refresh.successOne': 'Odświeżanie zakończone. Dane zaktualizowane.',
  'liveArtifact.refresh.successMany': 'Odświeżanie zakończone. Dane zaktualizowane.',
  'liveArtifact.refresh.successAction': 'Podgląd został ponownie wczytany z najnowszymi zatwierdzonymi danymi.',
  'liveArtifact.refresh.previousFailure': 'Poprzednie odświeżanie nie powiodło się: {message}',
  'liveArtifact.refresh.failureAction': 'Przejrzyj historię odświeżania, napraw problem ze źródłem lub uprawnieniami, a następnie spróbuj ponownie.',
  'liveArtifact.refresh.networkFailure': 'Żądanie odświeżenia nie powiodło się. Sprawdź połączenie i spróbuj ponownie.',
  'liveArtifact.refresh.genericFailure': 'Odświeżanie nie powiodło się.',
  'liveArtifact.refresh.statusNever': 'Nie można odświeżyć',
  'liveArtifact.refresh.statusReady': 'Gotowe do odświeżenia',
  'liveArtifact.refresh.statusSucceeded': 'Aktualne',
  'liveArtifact.refresh.statusFailed': 'Odświeżanie nie powiodło się',
  'liveArtifact.refresh.statusRunning': 'Odświeżanie',
  'liveArtifact.refresh.statusRunningDescription': 'Trwa obecnie odświeżanie.',
  'liveArtifact.refresh.statusSucceededDescription': 'Ostatnie odświeżanie zakończyło się pomyślnie.',
  'liveArtifact.refresh.statusFailedDescription': 'Ostatnia próba odświeżenia nie zakończyła się pomyślnie.',
  'liveArtifact.refresh.statusReadyDescription': 'Źródła do odświeżenia są skonfigurowane, ale żadne odświeżanie nie jest w toku.',
  'liveArtifact.refresh.statusNeverDescription': 'Ten dynamiczny artefakt nie ma jeszcze źródła odświeżania.',
  'liveArtifact.refresh.eventStarted': 'Rozpoczęto',
  'liveArtifact.refresh.eventSucceeded': 'Powodzenie',
  'liveArtifact.refresh.eventFailed': 'Niepowodzenie',
  'liveArtifact.refresh.eventStartedDetail': 'Rozpoczęto odświeżanie…',
  'liveArtifact.refresh.sourcesUpdatedOne': 'Zaktualizowano {n} źródło',
  'liveArtifact.refresh.sourcesUpdatedMany': 'Zaktualizowano {n} źródeł',
  'liveArtifact.refresh.timelineEmpty': 'W tej sesji nie odnotowano jeszcze żadnej aktywności odświeżania. Uruchom Odśwież, aby zarejestrować oś czasu, lub poczekaj na automatyczne uruchomienia.',
  'liveArtifact.refresh.heroLastRefreshedLabel': 'Ostatnio odświeżono',
  'liveArtifact.refresh.heroLastRefreshedNever': 'Nigdy',
  'liveArtifact.refresh.justNow': 'przed chwilą',
  'liveArtifact.refresh.factCreated': 'Utworzono',
  'liveArtifact.refresh.factLastUpdated': 'Ostatnia aktualizacja',
  'liveArtifact.refresh.factUnknown': 'Nieznane',
  'liveArtifact.refresh.persistedTitle': 'Zachowana historia odświeżania',
  'liveArtifact.refresh.persistedHint': 'Wpisy wczytane z refreshes.jsonl',
  'liveArtifact.refresh.persistedEmpty': 'Brak zachowanej historii odświeżania.',
  'liveArtifact.refresh.persistedStatusSucceeded': 'powodzenie',
  'liveArtifact.refresh.persistedStatusRunning': 'w toku',
  'liveArtifact.refresh.persistedStatusFailed': 'niepowodzenie',
  'liveArtifact.refresh.persistedStatusCancelled': 'anulowano',
  'liveArtifact.refresh.persistedStatusSkipped': 'pominięto',
  'liveArtifact.refresh.sessionTitle': 'Aktywność sesji',
  'liveArtifact.refresh.sessionHint': 'Zdarzenia zarejestrowane, gdy ta karta jest otwarta',
  'liveArtifact.refresh.docSourceTitle': 'Źródło dokumentu',
  'liveArtifact.refresh.docSourceHint': 'Skonfigurowano źródło',
  'liveArtifact.refresh.docSourceType': 'Typ',
  'liveArtifact.refresh.docSourceTool': 'Narzędzie',
  'liveArtifact.refresh.docSourceConnector': 'Konektor',
  'liveArtifact.refresh.debugSummary': 'Zaawansowane metadane debugowania',
  'liveArtifact.refresh.debugNote': 'Może zawierać identyfikatory konektorów, nazwy plików, metadane źródła oraz wewnętrzne ścieżki artefaktów.',
  'liveArtifact.viewer.tabPreview': 'Podgląd',
  'liveArtifact.viewer.tabCode': 'Kod',
  'liveArtifact.viewer.tabData': 'Dane',
  'liveArtifact.viewer.tabRefreshHistory': 'Historia odświeżeń',
  'liveArtifact.viewer.dataEmpty': 'Brak dostępnego cache data.json.',
  'liveArtifact.viewer.code.templateHeading': 'HTML szablonu',
  'liveArtifact.viewer.code.renderedHeading': 'Wyrenderowany HTML',
  'liveArtifact.viewer.code.templateHelp': 'Edytowalny szablon używany z data.json do wygenerowania podglądu.',
  'liveArtifact.viewer.code.renderedHelp': 'Wygenerowany index.html aktualnie ładowany przez podgląd.',
  'liveArtifact.viewer.code.variantAria': 'Wariant kodu',
  'liveArtifact.viewer.code.variantTemplate': 'Szablon',
  'liveArtifact.viewer.code.variantRendered': 'Wyrenderowany',
  'liveArtifact.viewer.code.loading': 'Ładowanie kodu…',
  'liveArtifact.viewer.code.unavailable': 'Kod nie jest jeszcze dostępny.',
  'liveArtifact.viewer.code.empty': 'Ten plik kodu jest pusty.',
  'fileViewer.deployToVercel': 'Wdróż na Vercel',
  'fileViewer.redeployToVercel': 'Wdróż ponownie',
  'fileViewer.deployingToVercel': 'Wdrażanie na Vercel…',
  'fileViewer.deployProviderLabel': 'Dostawca',
  'fileViewer.vercelProvider': 'Vercel',
  'fileViewer.cloudflarePagesProvider': 'Cloudflare Pages',
  'fileViewer.deployToProvider': 'Wdróż na {provider}',
  'fileViewer.redeployToProvider': 'Wdróż ponownie na {provider}',
  'fileViewer.deployingToProvider': 'Wdrażanie na {provider}…',
  'fileViewer.preparingPublicLink': 'Przygotowywanie publicznego linku…',
  'fileViewer.copyDeployLink': 'Kopiuj link',
  'fileViewer.deployModalTitle': 'Wdróż',
  'fileViewer.deployModalSubtitle': 'Użyj konta wybranego dostawcy, aby wdrożyć ten podgląd HTML.',
  'fileViewer.vercelToken': 'Token Vercel',
  'fileViewer.vercelTokenGetLink': 'Pobierz token Vercel',
  'fileViewer.vercelTokenPlaceholder': 'Wklej swój token Vercel',
  'fileViewer.vercelTokenReuseHint': 'Zapisany token zostanie użyty. Wprowadź nowy, aby go zastąpić.',
  'fileViewer.vercelTokenRequired': 'Najpierw wprowadź i zapisz token Vercel.',
  'fileViewer.cloudflareApiToken': 'Token API Cloudflare',
  'fileViewer.cloudflareApiTokenGetLink': 'Pobierz token API',
  'fileViewer.cloudflareApiTokenPlaceholder': 'Wklej swój token API Cloudflare',
  'fileViewer.cloudflareApiTokenReuseHint': 'Zapisany token API Cloudflare zostanie użyty. Wprowadź nowy, aby go zastąpić.',
  'fileViewer.cloudflareApiTokenRequired': 'Najpierw wprowadź i zapisz token API Cloudflare.',
  'fileViewer.cloudflareApiTokenScopeHint': 'Podczas tworzenia tokenu API wybierz Pages Edit; domeny niestandardowe wymagają Zone Read / DNS Edit.',
  'fileViewer.vercelTeamId': 'ID zespołu',
  'fileViewer.vercelTeamSlug': 'Slug zespołu',
  'fileViewer.cloudflareAccountId': 'ID konta',
  'fileViewer.cloudflareAccountIdHint': 'ID konta znajdziesz w panelu Cloudflare.',
  'fileViewer.cloudflareAccountIdRequired': 'Najpierw wprowadź i zapisz Cloudflare Account ID.',
  'fileViewer.cloudflareZoneLabel': 'Domena',
  'fileViewer.cloudflareZonePlaceholder': 'Zapisz ustawienia Cloudflare, aby wczytać domeny',
  'fileViewer.cloudflareZoneRequired': 'Najpierw wybierz domenę Cloudflare.',
  'fileViewer.cloudflareZonesLoading': 'Ładowanie domen Cloudflare…',
  'fileViewer.cloudflareZonesRefresh': 'Odśwież domeny',
  'fileViewer.cloudflareZonesLoadFailed': 'Nie udało się wczytać domen Cloudflare.',
  'fileViewer.cloudflareZonesEmpty': 'Nie znaleziono aktywnych pełnych domen Cloudflare dla tego konta.',
  'fileViewer.cloudflareDomainPrefixLabel': 'Prefiks subdomeny',
  'fileViewer.cloudflareDomainPrefixPlaceholder': 'demo',
  'fileViewer.cloudflareDomainPrefixInvalid': 'Użyj tylko jednej etykiety DNS: małe litery, cyfry i myślniki.',
  'fileViewer.cloudflareHostnamePreview': 'Podgląd domeny niestandardowej: {hostname}',
  'fileViewer.cloudflareCustomDomainHint': 'Opcjonalnie: podłącz domenę niestandardową. Pozostawienie tego pola pustego nadal utworzy link pages.dev.',
  'fileViewer.cloudflarePagesDevLinkLabel': 'URL pages.dev',
  'fileViewer.cloudflareCustomDomainLinkLabel': 'Domena niestandardowa',
  'fileViewer.optional': 'Opcjonalnie',
  'fileViewer.vercelPreviewOnly': 'Wdrożenia są obecnie dostępne tylko jako Podgląd (Preview).',
  'fileViewer.cloudflarePagesPreviewHint': 'Cloudflare Pages używa Direct Upload.',
  'fileViewer.savingConfig': 'Zapisywanie…',
  'fileViewer.deployConfigSaveFailed': 'Nie udało się zapisać ustawień Vercel.',
  'fileViewer.deployFailed': 'Wdrożenie nie powiodło się. Sprawdź ustawienia Vercel i spróbuj ponownie.',
  'fileViewer.deployProviderConfigSaveFailed': 'Nie udało się zapisać ustawień {provider}.',
  'fileViewer.deployProviderFailed': 'Wdrożenie na {provider} nie powiodło się. Sprawdź ustawienia i spróbuj ponownie.',
  'fileViewer.deployResultLabel': 'Wdrożony URL',
  'fileViewer.deployLinkReady': 'Gotowe',
  'fileViewer.deploySuccessToast': 'Wdrożenie przesłane pomyślnie',
  'fileViewer.deploySuccessToastDetails': '{provider} · {url}',
  'fileViewer.deployLinkPreparingLabel': 'Oczekiwanie na link publiczny',
  'fileViewer.deployLinkDelayed': 'Strona została wdrożona. Dostawca wciąż przygotowuje publiczny link.',
  'fileViewer.deployLinkFailed': 'Domena niestandardowa nie powiodła się',
  'fileViewer.deployLinkProtectedLabel': 'Ochrona wdrożenia włączona',
  'fileViewer.deployLinkProtected': 'Strona została wdrożona, ale ten link podglądu wymaga uwierzytelnienia. Wyłącz Deployment Protection albo użyj własnej domeny.',
  'fileViewer.retryLink': 'Ponów teraz',
  'questionForm.submit': 'Wyślij',
  'questionForm.skip': 'Pomiń',
  'questionForm.locked': 'Odpowiedziano',
  'conv.switch': 'Przełącz rozmowę',
  'conv.label': 'Rozmowa',
  'conv.heading': 'Rozmowy',
  'conv.new': '+ Nowa',
  'conv.empty': 'Brak rozmów.',
  'conv.untitled': 'Rozmowa bez tytułu',
  'conv.renameTooltip': 'Kliknij dwukrotnie, aby zmienić nazwę',
  'conv.delete': 'Usuń rozmowę',
  'conv.deleteConfirm': 'Usunąć „{title}”? Spowoduje to usunięcie wszystkich wiadomości.',
  'agentPicker.label': 'Agent',
  'agentPicker.modeChoose': 'Wybierz tryb wykonywania',
  'agentPicker.localCli': 'Lokalne CLI',
  'agentPicker.daemonOff': 'daemon wyłączony',
  'agentPicker.byok': 'API · BYOK',
  'agentPicker.selectAgent': 'Wybierz wykrytego agenta CLI',
  'agentPicker.noAgents': 'brak agentów w PATH',
  'agentPicker.notInstalled': 'nie zainstalowano',
  'agentPicker.rescan': 'Ponownie skanuj lokalny PATH w poszukiwaniu agentów',
  'tool.openInTab': 'Otwórz {name} w karcie',
  'tool.open': 'otwórz',
  'tool.todos': 'Zadania',
  'tool.todosExpand': 'Pokaż zadania',
  'tool.todosCollapse': 'Ukryj zadania',
  'tool.todosDone': 'Gotowe',
  'tool.todosDismiss': 'Zamknij listę zadań',
  'tool.write': 'Zapisz',
  'tool.edit': 'Edytuj',
  'tool.read': 'Czytaj',
  'tool.delete': 'Usuń',
  'tool.bash': 'Bash',
  'tool.glob': 'Glob',
  'tool.grep': 'Grep',
  'tool.fetch': 'Pobierz (Fetch)',
  'tool.search': 'Szukaj',
  'tool.lines': '{n} linii',
  'tool.changeSingular': 'zmiana',
  'tool.changePlural': 'zmiany',
  'tool.in': 'w {path}',
  'tool.hide': 'ukryj',
  'tool.output': 'wyjście',
  'tool.running': 'uruchomiony…',
  'tool.error': 'błąd',
  'tool.done': 'gotowe',
  'assistant.role': 'Asystent',
  'assistant.workingLabel': 'Pracuję',
  'assistant.doneLabel': 'Gotowe',
  'assistant.copyMarkdown': 'Kopiuj Markdown odpowiedzi',
  'assistant.forkConversation': 'Fork od tego miejsca',
  'assistant.forkingConversation': 'Tworzenie forka…',
  'assistant.shareToOpenDesign': 'Upstream PR',
  'assistant.shareToOpenDesignBusy': 'Przygotowywanie pakietu…',
  'assistant.feedbackPrompt': 'Opinia',
  'assistant.feedbackPositive': 'Pomocne',
  'assistant.feedbackNegative': 'Niepomocne',
  'assistant.feedbackReasonTitle': 'Powiedz nam dlaczego',
  'assistant.feedbackReasonPositiveMatched': 'Zrozumiał moją prośbę',
  'assistant.feedbackReasonPositiveVisual': 'Wygląda dobrze',
  'assistant.feedbackReasonPositiveUseful': 'Przydatna struktura',
  'assistant.feedbackReasonPositiveEasy': 'Łatwo kontynuować edycję',
  'assistant.feedbackReasonPositiveDesignSystem': 'Zgodny z systemem projektowym',
  'assistant.feedbackReasonNegativeMissed': 'Nie spełnił mojej prośby',
  'assistant.feedbackReasonNegativeVisual': 'Jakość wizualna wymaga poprawy',
  'assistant.feedbackReasonNegativeIncomplete': 'Niekompletny wynik',
  'assistant.feedbackReasonNegativeHard': 'Trudny w użyciu',
  'assistant.feedbackReasonNegativeDesignSystem': 'Niezgodny z systemem projektowym',
  'assistant.feedbackReasonOther': 'Inne',
  'assistant.feedbackReasonPlaceholder': 'Dodaj krótką notatkę...',
  'assistant.feedbackReasonSubmit': 'Wyślij',
  'assistant.emptyResponseLabel': 'Brak wyniku',
  'assistant.emptyResponseMessage': 'Dostawca zakończył żądanie bez zwrócenia tekstu ani artefaktu. Wypróbuj inny model lub dostawcę, sprawdź limit albo spróbuj ponownie.',
  'assistant.unfinishedLabel': 'Zatrzymano z niedokończonymi zadaniami',
  'assistant.unfinishedSummary': 'pozostało {n} zadań',
  'assistant.unfinishedMore': '+{n} więcej',
  'assistant.continueRemaining': 'Kontynuuj pozostałe zadania',
  'chat.resumeRunCta': 'Wznów działanie',
  'assistant.outTokens': '{n} wysłano',
  'assistant.producedFiles': 'Pliki z tej tury',
  'assistant.openFile': 'Otwórz',
  'assistant.downloadFile': 'Pobierz',
  'nextStep.title': 'Następny krok',
  'nextStep.more': 'Więcej',
  'nextStep.share': 'Udostępnij',
  'nextStep.download': 'Pobierz',
  'nextStep.createDesignSystemTitle': 'Create design system',
  'nextStep.createDesignSystemBody': 'Duplicate this project into a design-system workspace and start an agent pass from all current files and references.',
  'nextStep.createDesignSystemBusy': 'Creating design system...',
  'nextStep.contribute': 'Wkład',
  'nextStep.planGenerateTitle': "Generate from document",
  'nextStep.planGenerateBody': "Use the approved Markdown plan as the source of truth for the next design run.",
  'nextStep.planImproveTitle': "Improve document",
  'nextStep.planImproveBody': "Tighten the current plan document before generating the final artifact.",
  'nextStep.planGeneratePrompt': "Use `{file}` as the source of truth. Read the document first, preserve its decisions, then generate the final design artifact that matches it. If it is a slide outline, generate the deck; if it is a PRD/prototype plan, generate the prototype or wireframes; if it is a storyboard/creative brief, generate the matching visual/media artifact. Before generating, call out any blocking TODOs or contradictions you cannot resolve.",
  'nextStep.planImprovePrompt': "Read `{file}` and improve it in place as an editable plan document. Tighten scope, fill weak sections, add missing acceptance checks, and keep TODO/open questions where user input is still needed. Do not generate the final design artifact yet.",
  'nextStep.planImproveArtifactTitle': "Improve artifact",
  'nextStep.planImproveArtifactBody': "Keep iterating the generated artifact instead of going back to planning.",
  'nextStep.planImproveArtifactPrompt': "Improve `{artifact}` in place. Keep the existing working artifact and make the highest-impact product, visual, interaction, and content improvements. Preserve behavior that already works, then summarize changed files and any remaining risks.",
  'nextStep.planMergeTitle': "Align document and artifact",
  'nextStep.planMergeBody': "Reconcile the plan and generated artifact so they advance together.",
  'nextStep.planMergePrompt': "Read `{document}` and `{artifact}` together. Treat the document as the intent and the artifact as the current implementation. Reconcile them: update the artifact to match confirmed decisions, update the document only where it is stale, and keep explicit TODO/open questions for anything still unresolved. Preserve existing working behavior and summarize what changed in both files.",

  'nextStep.projectContinueTitle': 'Continue working',
  'nextStep.projectGenerateArtifactTitle': 'Generate artifact',
  'nextStep.designSystemAiRefineTitle': 'AI refine design system',
  'nextStep.designSystemAuditKitTitle': 'Audit tokens & kit',

  'nextStep.brandAiOptimizeTitle': 'Refine extracted design system',
  'nextStep.brandAiOptimizeBody': 'Starts an agent pass that consumes model tokens, re-extracts the source, and updates this design system in place.',
  'nextStep.brandCreateDesignTitle': 'Create with this design system',
  'nextStep.brandCreateDesignBody': 'Start a new design using the extracted colors, type, assets, and system guidance.',
  'nextStep.brandCreateDesignPrompt': 'Create a new design with the {designSystem} design system.',

  'nextStep.brandContinueExtractionTitle': 'Continue extraction',
  'nextStep.brandContinueExtractionBody': 'After the Browser tab is past any verification, read it and keep filling the saved kit.',
  'nextStep.brandContinueExtractionBusy': 'Continuing extraction...',
  'nextStep.brandContinueAiExtractionTitle': 'Continue with agent',
  'nextStep.brandContinueAiExtractionProgrammaticBody': 'Use the selected agent to extract from the saved draft if the programmatic pass still cannot finish.',
  'nextStep.brandContinueAiExtractionAiBody': 'Resume the selected agent from the current brand scaffold and finish the same design system.',
  'nextStep.brandContinueAiExtractionBusy': 'Continuing with agent...',
  'nextStep.createDesignBusy': 'Tworzenie projektu...',
  'assistant.thinking': 'Myślę',
  'assistant.thought': 'Pomyślał',
  'assistant.thoughtFor': 'Myślał {s}s',
  'assistant.systemReminder': 'Przypomnienie systemowe',
  'assistant.possiblePromptInjection': 'Możliwa iniekcja promptu',
  'assistant.waitingFirstOutput': 'Oczekiwanie na pierwszą odpowiedź',
  'assistant.statusBootingAgent': 'Uruchamianie agenta',
  'assistant.statusPreparing': 'Przygotowywanie...',
  'assistant.statusStarting': 'Startowanie',
  'assistant.statusRequesting': 'Wysyłanie prośby',
  'assistant.statusThinking': 'Myślenie',
  'assistant.statusStreaming': 'Strumieniowanie',
  'assistant.slowHint': 'Trwa to dłużej niż zwykle. Formularz zazwyczaj pojawia się w 5–10s — możesz zatrzymać i sformułować zapytanie inaczej.',
  'assistant.verbEditing': 'Edytowanie',
  'assistant.verbWriting': 'Zapisywanie',
  'assistant.verbReading': 'Czytanie',
  'assistant.verbSearching': 'Wyszukiwanie',
  'assistant.verbRunning': 'Uruchamianie',
  'assistant.verbTodos': 'Zadania',
  'assistant.verbFetching': 'Pobieranie',
  'assistant.verbCalling': 'Wywoływanie',
  'qf.answered': 'odpowiedziano',
  'qf.choose': 'Wybierz…',
  'qf.customLabel': 'Custom answer',
  'qf.customPlaceholder': 'Type your own answer...',
  'qf.otherOption': 'Inne',
  'qf.required': 'wymagane',
  'qf.lockedSubmitted': 'Odpowiedzi wysłane — agent używa ich do końca sesji.',
  'qf.lockedPrev': 'Ten formularz pochodzi z poprzedniej tury.',
  'qf.hint': 'Wybierz to, co pasuje. Pomiń opcjonalne pola, które Cię nie interesują — agent użyje rozsądnych domyślnych ustawień.',
  'qf.submitDefault': 'Wyślij odpowiedzi',
  'qf.submitDisabledTitle': 'Najpierw wypełnij wymagane pola',
  'qf.submitTitle': 'Wyślij odpowiedzi',
  'qf.cardSelected': 'wybrano',
  'qf.cardRefs': 'Ref:',
  'qf.cardSampleText': 'Zażółć gęślą jaźń · 0123',
  'questions.tabLabel': 'Pytania',
  'questions.banner': 'Czy mogę zadać kilka krótkich pytań?',
  'questions.bannerAnswered': 'Pytania uzupełnione',
  'questions.continue': 'Kontynuuj',
  'questions.generating': 'Generowanie pytań…',
  'questions.skipAll': 'Pomiń wszystkie',
  'questions.autoSkipHint': 'Automatycznie kontynuuje po upływie czasu',
  'questions.submitting': 'Wysyłanie…',
  'sketch.toolSelect': 'Wybierz (brak akcji)',
  'sketch.toolPen': 'Pióro',
  'sketch.toolText': 'Tekst',
  'sketch.toolRect': 'Prostokąt',
  'sketch.toolArrow': 'Strzałka',
  'sketch.toolEraser': 'Gumka',
  'sketch.color': 'Kolor',
  'sketch.strokeSize': 'Grubość linii',
  'sketch.undo': 'Cofnij',
  'sketch.clear': 'Wyczyść',
  'sketch.close': 'Zamknij',
  'sketch.closeConfirm': 'Zamknąć szkic i odrzucić niezapisane zmiany?',
  'sketch.textPrompt': 'Tekst:',
  'sketch.textModalTitle': 'Dodaj tekst',
  'critiqueTheater.userFacingName': 'Jury projektowe',
  'critiqueTheater.roleDesigner': 'Projektant',
  'critiqueTheater.roleCritic': 'Krytyk',
  'critiqueTheater.roleBrand': 'Marka',
  'critiqueTheater.roleA11y': 'Dostępność',
  'critiqueTheater.roleCopy': 'Treść',
  'critiqueTheater.roundLabel': 'Runda {n} z {m}',
  'critiqueTheater.mustFix': '{n} do koniecznej poprawy',
  'critiqueTheater.composite': 'Łączny',
  'critiqueTheater.threshold': 'Próg',
  'critiqueTheater.consensus': 'Konsensus',
  'critiqueTheater.interrupt': 'Przerwij',
  'critiqueTheater.interrupting': 'Przerywanie…',
  'critiqueTheater.interrupted': 'Przerwano',
  'critiqueTheater.degradedHeading': 'Panel offline w tym przebiegu',
  'critiqueTheater.degradedReasonMalformed': 'Nieprawidłowy format danych wyjściowych panelu (parser odrzucił blok).',
  'critiqueTheater.degradedReasonOversize': 'Dane wyjściowe panelu przekroczyły bezpieczny limit bajtów.',
  'critiqueTheater.degradedReasonAdapter': 'Adapter {adapter} nie obsługiwał protokołu Critique.',
  'critiqueTheater.degradedReasonProtocol': 'Adapter {adapter} wysłał nieobsługiwaną wersję protokołu.',
  'critiqueTheater.degradedReasonMissingArtifact': 'Przebieg zakończył się bez końcowego artefaktu.',
  'critiqueTheater.replay': 'Odtwórz ponownie',
  'critiqueTheater.replaySpeed': 'Prędkość odtwarzania',
  'critiqueTheater.readOnly': 'Tylko do odczytu',
  'critiqueTheater.shippedSummary': 'Wysłano w rundzie {round} · łączny wynik {composite}',
  'critiqueTheater.interruptedSummary': 'Przerwano w rundzie {round} · najlepszy łączny wynik {composite}',
  'critiqueTheater.shippedBadge': 'Wdrożono',
  'critiqueTheater.belowThresholdBadge': 'Poniżej progu',
  'critiqueTheater.timedOutBadge': 'Upłynął limit czasu',
  'critiqueTheater.failedHeading': 'Przebieg nie powiódł się',
  'critiqueTheater.failedReasonCliExit': 'Agent CLI zakończył działanie z kodem niezerowym, zanim panel zdążył się zakończyć.',
  'critiqueTheater.failedReasonPerRoundTimeout': 'Runda przekroczyła swój limit czasu.',
  'critiqueTheater.failedReasonTotalTimeout': 'Cały przebieg przekroczył łączny limit czasu.',
  'critiqueTheater.failedReasonOrchestrator': 'Wewnętrzny błąd orkiestratora.',
  'critiqueTheater.transcriptEmpty': 'Brak zapisu do ponownego odtworzenia. Uruchom krytykę, aby ją nagrać.',
  'critiqueTheater.transcriptLoading': 'Ładowanie transkrypcji…',
  'critiqueTheater.transcriptError': 'Nie udało się wczytać zapisu: {error}',
  'critiqueTheater.replaySpeedPaused': 'Wstrzymano',
  'critiqueTheater.replaySpeedInstant': 'Natychmiast',
  'critiqueTheater.replaySpeedLive': 'Na żywo',
  'critiqueTheater.replaySpeedFast': 'Szybko',
  'critiqueTheater.settingsNav': 'Jury projektowe',
  'critiqueTheater.settingsNavHint': 'Pięciopanelowa recenzja projektu dla Twoich przebiegów',
  'critiqueTheater.settingsEnabledLabel': 'Pokazuj Jury projektowe podczas przebiegów Agenta',
  'critiqueTheater.settingsEnabledDescription': 'Po włączeniu obok generacji Agenta pojawia się pięciopanelowa recenzja, która ocenia wynik przed wdrożeniem. W każdej chwili możesz przerwać.',
  'critiqueTheater.settingsEnabledProjectHint': 'Zapisano dla tego projektu. Nowe przebiegi w tym projekcie będą kierowane przez Jury projektowe po stronie serwera.',
  'critiqueTheater.settingsEnabledNoProjectHint': 'Otwórz projekt, aby utrwalić to po stronie serwera. Do tego czasu zmienia to tylko preferencję w przeglądarce.',
  'pet.title': 'Pupile',
  'pet.subtitle': 'Adoptuj małego towarzysza, który unosi się nad Twoim workspace.',
  'pet.navTitle': 'Pupile',
  'pet.navHint': 'Adoptuj lub dostosuj',
  'pet.tabBuiltIn': 'Wbudowane',
  'pet.tabBuiltInHint': 'Towarzysze dołączeni do Crie3 — wybierz jednego i adoptuj.',
  'pet.builtInEmpty': 'Wbudowane zwierzaki są teraz niedostępne. Odśwież zakładkę Społeczność, gdy daemon wróci.',
  'pet.tabCustom': 'Własny',
  'pet.tabCustomHint': 'Ustaw imię, glif, kolor lub wgraj sprite.',
  'pet.tabCommunity': 'Społeczność',
  'pet.tabCommunityHint': 'Pupile wyklute przez Codex — adoptuj albo wygeneruj nowego z AI.',
  'pet.tabsAria': 'Źródło pupila',
  'pet.adopt': 'Adoptuj',
  'pet.adoptedBadge': 'Adoptowany',
  'pet.adoptCallout': 'Adoptuj pupila',
  'pet.changePet': 'Zmień pupila',
  'pet.wake': 'Obudź',
  'pet.tuck': 'Schowaj',
  'pet.wakeTitle': 'Obudź pupila — pokaż nakładkę.',
  'pet.tuckTitle': 'Schowaj pupila — ukryj nakładkę.',
  'pet.settingsTitle': 'Otwórz ustawienia pupila',
  'pet.useCustom': 'Użyj mojego pupila',
  'pet.customTitle': 'Stwórz własnego',
  'pet.customHint': 'Wybierz imię, symbol i kolor akcentu — nakładka aktualizuje się na żywo.',
  'pet.customGreetingPlaceholder': 'Powitanie od Twojego pupila…',
  'pet.fieldName': 'Imię',
  'pet.fieldGlyph': 'Symbol',
  'pet.fieldGlyphHint': 'Pojedyncze emoji wygląda najlepiej (np. 🐝, 🦄, 🐢).',
  'pet.fieldGreeting': 'Powitanie',
  'pet.fieldAccent': 'Kolor akcentu',
  'pet.fieldAccentCustom': 'Własny kolor',
  'pet.fieldAccentDefault': 'Domyślny kolor akcentu',
  'pet.overlayAria': 'Towarzysz pupil',
  'pet.spriteAria': '{name} — przeciągnij, aby przesunąć, kliknij, aby porozmawiać',
  'pet.spriteTitle': 'Cześć od {name}! Kliknij, aby porozmawiać.',
  'pet.taskSummarySingle': 'Uruchomione jest {count} zadanie Agenta.',
  'pet.taskSummaryMultiple': 'Uruchomionych jest {count} zadań Agenta w {projects} projektach.',
  'pet.taskSummaryRecentSingle': 'Niedawno ukończono {count} zadanie Agenta.',
  'pet.taskSummaryRecentMultiple': 'Niedawno ukończono {count} zadań Agenta.',
  'pet.taskListAria': 'Aktywne zadania Agenta',
  'pet.taskOpenProject': 'Otwórz {project}',
  'pet.taskGroup.running': 'W toku',
  'pet.taskGroup.queued': 'Oczekuje',
  'pet.taskGroup.recent': 'Niedawno ukończone',
  'pet.idleQuote.leonardo.text': 'Nauka nigdy nie wyczerpuje umysłu.',
  'pet.idleQuote.leonardo.author': 'Leonardo da Vinci',
  'pet.idleQuote.michelangelo.text': 'Ujrzałem anioła w marmurze i rzeźbiłem, aż go uwolniłem.',
  'pet.idleQuote.michelangelo.author': 'Michał Anioł',
  'pet.idleQuote.bernini.text': 'Istnieją dwa środki, które mogą pomóc rzeźbiarzowi: światło i cień.',
  'pet.idleQuote.bernini.author': 'Gian Lorenzo Bernini',
  'pet.idleQuote.raphael.text': 'Gdy się maluje, nie myśli się.',
  'pet.idleQuote.raphael.author': 'Rafael',
  'pet.idleQuote.caravaggio.text': 'Wszystkie dzieła, bez względu na to, co i przez kogo namalowane, są niczym więcej niż błahostkami i dziecinnymi drobiazgami, jeśli nie zostały stworzone i namalowane z natury.',
  'pet.idleQuote.caravaggio.author': 'Caravaggio',
  'pet.idleQuote.rodin.text': 'Najważniejsze to wzruszać się, kochać, mieć nadzieję, drżeć, żyć.',
  'pet.idleQuote.rodin.author': 'Auguste Rodin',
  'pet.composerTitle': 'Pupile — obudź, schowaj lub wybierz',
  'pet.composerMenuTitle': 'Pupile',
  'pet.composerMenuHint': 'wskazówka: wpisz /pet, aby przełączyć',
  'pet.composerOpenSettings': 'Zarządzaj zwierzętami',
  'pet.welcomeTeaserTitle': 'Adoptuj pupila',
  'pet.welcomeTeaserBody': 'Mały towarzysz unoszący się nad workspace.',
  'pet.welcomeTeaserCta': 'Wybierz',
  'pet.imageUpload': 'Wgraj sprite',
  'pet.imageReplace': 'Zmień sprite',
  'pet.imageRemove': 'Użyj emoji',
  'pet.imageHintIdle': 'PNG, JPG, WebP, GIF lub SVG. Spritesheet? Wgraj poziomy pasek i ustaw liczbę klatek.',
  'pet.imageHintActive': 'Wyświetlam Twój sprite. Ustaw klatki > 1, aby animować poziomy spritesheet.',
  'pet.fieldFrames': 'Klatki',
  'pet.fieldFramesHint': '1 = statyczny. > 1 = poziomy spritesheet.',
  'pet.fieldFps': 'Szybkość (fps)',
  'pet.fieldFpsHint': 'Jak szybko klatki się zmieniają.',
  'pet.atlasImport': 'Importuj sprite Codex',
  'pet.atlasImportTitle': 'Zaimportuj atlas hatch-pet 8x9 / 192x208 (PNG lub WebP).',
  'pet.atlasPickerTitle': 'Wybierz wiersz animacji',
  'pet.atlasPickerHint': 'Pety Codex mają 9 wierszy animacji. Domyślnie zachowujemy cały atlas, aby pet przełączał wiersze przy hoverze, kierunku przeciągania i dłuższej bezczynności. Możesz też zablokować jeden loop.',
  'pet.atlasCancel': 'Odrzuć atlas',
  'pet.atlasAdopt': 'Zablokuj na tym wierszu',
  'pet.atlasAdoptFull': 'Użyj pełnego atlasu (animowany)',
  'pet.atlasAdoptFullTitle': 'Zachowaj wszystkie wiersze, aby pet reagował na hover, kierunek przeciągania i długą bezczynność.',
  'pet.atlasAdoptRowTitle': 'Wytnij tylko podświetlony wiersz jako pojedynczy zapętlony pasek.',
  'pet.atlasActiveHint': 'Animowany atlas aktywny — pet wybiera wiersz na podstawie Twojej interakcji (hover, przeciąganie, bezczynność).',
  'pet.atlasRow.idle': 'Bezruch',
  'pet.atlasRow.running-right': 'Bieg w prawo',
  'pet.atlasRow.running-left': 'Bieg w lewo',
  'pet.atlasRow.waving': 'Machanie',
  'pet.atlasRow.jumping': 'Skok',
  'pet.atlasRow.failed': 'Porażka',
  'pet.atlasRow.waiting': 'Oczekiwanie',
  'pet.atlasRow.running': 'Bieg',
  'pet.atlasRow.review': 'Przegląd',
  'pet.hatchTitle': 'Wykluj nowego peta z AI',
  'pet.hatchHint': 'Użyj dołączonej skill hatch-pet w czacie, aby wygenerować spritesheet w stylu Codex, a potem zaimportuj go tutaj.',
  'pet.hatchConcept': 'Koncept peta (opcjonalnie)',
  'pet.hatchConceptPlaceholder': 'np.: mały pixel-art shiba w przytulnym sweterku',
  'pet.hatchCopy': 'Kopiuj prompt',
  'pet.hatchCopied': 'Skopiowano!',
  'pet.hatchFoot': 'Gdy skill zapisze peta, wróć tutaj i kliknij „Importuj sprite Codex".',
  'pet.slashPopoverAria': 'Polecenia slash',
  'pet.slashPopoverTitle': 'Polecenia',
  'pet.slashPopoverHint': '↑↓ nawigacja · enter wybierz · esc zamknij',
  'pet.slashPet': 'Przełącz, adoptuj lub otwórz ustawienia peta.',
  'pet.slashPetWake': 'Obudź pływającego peta.',
  'pet.slashPetTuck': 'Schowaj peta na razie.',
  'pet.slashHatch': 'Wygeneruj peta Codex skillem hatch-pet.',
  'pet.slashHatchArg': '<koncept>',
  'pet.slashSearch': 'Szukaj w sieci przez polecenie OD research.',
  'pet.slashSearchArg': '<zapytanie>',
  'pet.codexTitle': 'Niedawno wyklute',
  'pet.codexSubtitle': 'Pety zapakowane przez skill hatch-pet pojawiają się tutaj do adopcji jednym kliknięciem.',
  'pet.codexSubtitleWithDir': 'Skanuję {dir} w poszukiwaniu paczek hatch-pet.',
  'pet.codexEmpty': 'Brak wyklutych petów. Wpisz /hatch w czacie, aby wygenerować.',
  'pet.codexLoading': 'Szukam wyklutych petów…',
  'pet.codexRefresh': 'Odśwież',
  'pet.codexAdopt': 'Adoptuj',
  'pet.codexAdopting': 'Adoptuję…',
  'pet.communitySync': 'Pobierz zwierzaki społeczności',
  'pet.communitySyncing': 'Pobieranie…',
  'pet.communitySyncTitle': 'Zsynchronizuj najnowsze zwierzaki z Codex Pet Share + j20 Hatchery do ~/.codex/pets/.',
  'pet.communitySyncDone': 'Zsynchronizowano {wrote} nowych zwierzaków (łącznie {total}).',
  'pet.communitySyncFailed': 'Błąd synchronizacji: {error}',
  'pet.codexBundled': 'W zestawie',
  'pet.codexBundledTitle': 'Dostarczany z Crie3 — bez pobierania.',
  'settings.notifications': 'Powiadomienia',
  'settings.notificationsHint': 'Dźwięk i powiadomienie pulpitu po zakończeniu zadania',
  'settings.notifyCompletionSound': 'Dźwięk zakończenia',
  'settings.notifyCompletionSoundHint': 'Odtwarzane po zakończeniu tury. Domyślnie wyłączone.',
  'settings.notifySuccessSound': 'Dźwięk sukcesu',
  'settings.notifyFailureSound': 'Dźwięk błędu',
  'settings.notifyDesktop': 'Powiadomienie pulpitu',
  'settings.notifyDesktopHint': 'Wysyłane, gdy okno nie jest aktywne.',
  'settings.notifyDesktopBlocked': 'Zablokowane przez przeglądarkę. Włącz je w ustawieniach witryny.',
  'settings.notifyDesktopUnsupported': 'Powiadomienia pulpitu są niedostępne w tym środowisku.',
  'settings.notifyTest': 'Wyślij test',
  'settings.notifyTestSent': 'Powiadomienie testowe wysłane. Jeśli baner się nie pojawi, sprawdź ustawienia powiadomień przeglądarki i systemu.',
  'settings.notifyTestFailed': 'Wywołanie powiadomienia nie powiodło się. Sprawdź ustawienia powiadomień przeglądarki i systemu.',
  'settings.notifySoundDing': 'Dzyń',
  'settings.notifySoundChime': 'Dzwonek',
  'settings.notifySoundTwoToneUp': 'Dwuton rosnący',
  'settings.notifySoundPluck': 'Szarpnięcie',
  'settings.notifySoundBuzz': 'Brzęczenie',
  'settings.notifySoundTwoToneDown': 'Dwuton malejący',
  'settings.notifySoundThud': 'Łomot',
  'settings.skills': 'Umiejętności',
  'settings.skillsHint': 'Umiejętności funkcyjne, które agent może wywołać w trakcie zadania',
  'settings.skillsNew': 'Nowa umiejętność',
  'settings.skillsEmpty': 'Wybierz umiejętność po lewej lub utwórz nową.',
  'settings.skillsEdit': 'Edytuj',
  'settings.skillsDelete': 'Usuń',
  'settings.skillsDeleteConfirm': 'Potwierdź usunięcie',
  'settings.skillsName': 'Nazwa',
  'settings.skillsTriggers': 'Wyzwalacze (rozdzielone przecinkami lub nowymi liniami)',
  'settings.skillsDescription': 'Opis',
  'settings.skillsBody': 'Treść SKILL.md',
  'settings.skillsCreate': 'Utwórz',
  'settings.skillsSave': 'Zapisz',
  'settings.skillsSaving': 'Zapisywanie…',
  'settings.skillsOverrideCreate': 'Utwórz nadpisanie użytkownika',
  'settings.skillsOverrideSave': 'Zapisz jako nadpisanie użytkownika',
  'settings.skillsBuiltInOverrideWarning': 'Edycja tej wbudowanej umiejętności tworzy nadpisanie użytkownika. Wbudowany wpis zostanie ukryty z listy, dopóki nie usuniesz nadpisania. Kontynuować?',
  'settings.skillsFiles': 'Pliki',
  'settings.skillsNoFiles': 'Brak plików w tym folderze umiejętności.',
  'settings.skillsNameRequired': 'Nazwa umiejętności jest wymagana.',
  'settings.skillsBodyRequired': 'Treść umiejętności jest wymagana.',
  'settings.designSystems': 'Systemy projektowe',
  'settings.designSystemsHint': 'Przeglądaj i przełączaj dostępne systemy projektowe',
  'settings.designSystemsInstalled': 'Zainstalowane',
  'settings.designSystemsAdd': 'Dodaj system projektowy',
  'settings.designSystemsHiddenCount': '{count} ukryte w galerii głównej',
  'settings.designSystemsShowAll': 'Pokaż wszystkie',
  'settings.designSystemsShowHidden': 'Pokaż ukryte',
  'settings.designSystemsSource': 'Źródło',
  'settings.designSystemsSourceLocal': 'Lokalnie',
  'settings.designSystemsSourceGithub': 'GitHub',
  'settings.designSystemsSourceShadcn': 'shadcn',
  'settings.designSystemsShadcnReference': 'Odwołanie do rejestru shadcn',
  'settings.designSystemsImportShadcn': 'Importuj z shadcn',
  'settings.designSystemsStructure': 'Struktura',
  'settings.designSystemsModeHybrid': 'Hybrydowa',
  'settings.designSystemsModeNormalized': 'Znormalizowana',
  'settings.designSystemsModeVerbatim': 'Bez zmian',
  'settings.designSystemsCraft': 'Rzemiosło',
  'settings.designSystemsCraftColor': 'Kolor',
  'settings.designSystemsCraftAccessibility': 'Dostępność',
  'settings.designSystemsGithubUrl': 'URL GitHub',
  'settings.designSystemsProjectPath': 'Ścieżka projektu',
  'settings.designSystemsImportGithub': 'Importuj z GitHub',
  'settings.designSystemsImportProject': 'Importuj z projektu',
  'settings.designSystemsImportedStatus': 'Zaimportowano {title}',
  'settings.designSystemsViewImported': 'Pokaż zaimportowany system projektowy',
  'settings.designSystemsCategory': 'Kategoria',
  'settings.designSystemsAllCategories': 'Wszystkie kategorie',
  'settings.designSystemsShowInHomeGallery': 'Pokaż w galerii głównej',
  'settings.projectLocations': 'Lokalizacje projektów',
  'settings.projectLocationsHint': 'Katalogi główne workspace',
  'settings.projectLocationsDescription': 'Dodaj bazy robocze, które mogą zawierać wiele folderów projektów Crie3. Nowe projekty są zapisywane jako folder w wybranej bazie.',
  'settings.projectLocationsSaveError': 'Nie udało się zapisać lokalizacji projektów. Sprawdź, czy każda ścieżka jest dostępnym folderem.',
  'settings.projectLocationsSaved': 'Lokalizacje projektów zapisane.',
  'settings.projectLocationsScanError': 'Nie udało się przeskanować lokalizacji projektów.',
  'settings.projectLocationsScanComplete': 'Skanowanie zakończone: zaimportowano {imported}, już zarejestrowano {existing}.',
  'settings.projectLocationsNoFolderSelected': 'Nie wybrano folderu.',
  'settings.projectLocationsDuplicate': 'Ta baza robocza jest już dodana.',
  'settings.projectLocationsWorkBaseMeta': 'Baza robocza · projekty są tworzone tutaj jako podfoldery',
  'settings.projectLocationsAddFolder': 'Dodaj folder…',
  'settings.projectLocationsDefaultBadge': 'Lokalizacja domyślna',
  'settings.projectLocationsMakeDefault': 'Ustaw jako domyślną',
  'settings.projectLocationsDefaultSaved': 'Domyślna lokalizacja projektu zaktualizowana.',
  'settings.librarySkills': 'Umiejętności',
  'settings.libraryDesignSystems': 'Systemy projektowe',
  'settings.librarySearch': 'Szukaj...',
  'settings.libraryAll': 'Wszystkie',
  'settings.libraryPreview': 'Podgląd',
  'settings.libraryPreviewClose': 'Zamknij',
  'settings.libraryLoading': 'Ładowanie...',
  'settings.libraryNoResults': 'Brak elementów pasujących do wyszukiwania.',
  'settings.libraryEnabled': 'Włączone',
  'settings.libraryDisabled': 'Wyłączone',
  'settings.connectorsNavHint': 'Połączenia z systemami zewnętrznymi',
  'settings.connectorsHint': 'Zarządzaj ustawieniami konektorów i dostawców narzędzi dla tego urządzenia.',
  'settings.connectorsComposioApiKey': 'Klucz API Composio',
  'settings.connectorsSavedTitle': 'Zapisano w lokalnym daemon',
  'settings.connectorsSavedWithTail': 'Zapisano · ••••{tail}',
  'settings.connectorsSaved': 'Zapisano',
  'settings.connectorsGetApiKey': 'Pobierz klucz API',
  'settings.connectorsReplaceKeyPlaceholder': 'Wklej nowy klucz, aby zastąpić zapisany',
  'settings.connectorsApiKeyPlaceholder': 'Wklej klucz API Composio',
  'settings.connectorsClear': 'Wyczyść',
  'settings.connectorsClearConfirmTitle': 'Wyczyścić zapisany klucz API Composio?',
  'settings.connectorsClearConfirmBody': 'Usunięcie klucza odłącza wszystkie konektory Composio powiązane z tym workspace. Połączone konta, zgody OAuth oraz dostęp do narzędzi zostaną usunięte.',
  'settings.connectorsClearConfirmContinue': 'Kontynuuj',
  'settings.connectorsClearFinalTitle': 'To odłączy wszystkie konektory',
  'settings.connectorsClearFinalBody': 'Tej operacji nie da się cofnąć. Po wklejeniu nowego klucza każdą integrację trzeba podłączyć od nowa.',
  'settings.connectorsClearFinalConfirm': 'Usuń klucz i odłącz',
  'settings.connectorsClearArming': 'Chwilka…',
  'settings.connectorsClearCancel': 'Anuluj',
  'settings.connectorsSaveKey': 'Zapisz klucz',
  'settings.connectorsSaveKeyTitle': 'Wyślij ten klucz do lokalnego demona',
  'settings.connectorsKeySaving': 'Zapisywanie…',
  'settings.connectorsKeySaved': 'Zapisano ✓',
  'settings.connectorsKeyError': 'Nie udało się zapisać klucza. Sprawdź, czy lokalny demon działa, i spróbuj ponownie.',
  'settings.connectorsHelpSaved': 'Twój klucz odblokowuje katalog poniżej i pozostaje w lokalnym daemon. Wklej nowy klucz, aby go zastąpić, albo wyczyść, aby usunąć.',
  'settings.connectorsHelpUnsaved': 'Niezapisane zmiany — kliknij Zapisz klucz, aby zachować te dane w lokalnym demonie i odblokować katalog poniżej.',
  'settings.connectorsHelpEmpty': 'Dodaj klucz, aby odblokować katalog poniżej. Klucze są przechowywane lokalnie w daemon i nigdy nie są wysyłane przez zmienne środowiskowe.',
  'settings.connectorsLoadingSavedKey': 'Sprawdzanie zapisanego klucza w lokalnym daemon…',
  'settings.autosaveSaving': 'Zapisywanie…',
  'settings.autosaveSaved': 'Wszystkie zmiany zapisane',
  'settings.autosaveError': 'Nie udało się zapisać zmian. Lokalny demon może być offline.',
  'settings.libraryToggleLabel': 'Przełącz',
  'settings.memory': 'Pamięć',
  'settings.memoryHint': 'Personal facts auto-extracted from chats',
  'settings.customInstructionsTitle': 'Reguły globalne',
  'settings.customInstructionsHint': 'Stałe instrukcje, których Crie3 powinien przestrzegać w każdym czacie. Zapisuj fakty, preferencje i kontekst projektu jako wspomnienia.',
  'settings.customInstructionsPlaceholder': 'np. „Zawsze używaj TypeScript. Preferuj komponenty funkcyjne. Utrzymuj zwięzłe odpowiedzi.”',
  'settings.memoryDescription': 'Auto-extracted facts about you and your preferences. Saved as Markdown files and folded into every chat.',
  'settings.memoryEnabled': 'Włączone',
  'settings.memoryDisabled': 'Wyłączone',
  'settings.memoryEnableLabel': 'Włącz wstrzykiwanie pamięci',
  'settings.memoryDisabledBanner': 'Pamięć jest obecnie WYŁĄCZONA. Istniejące fakty są zachowane na dysku, ale nie zostaną włączone do nowych czatów, a nowe tury nie wyodrębnią niczego nowego.',
  'settings.memoryNew': 'Nowa pamięć',
  'settings.memoryEdit': 'Edytuj',
  'settings.memoryDelete': 'Usuń',
  'settings.memoryPreview': 'Podgląd',
  'settings.memoryEmpty': 'Brak pamięci.',
  'settings.memoryEmptyHintZh': '记住: 用户偏好深色主题',
  'settings.memoryEmptyHintEn': 'Preferuję tryb ciemny',
  'settings.memoryName': 'Name',
  'settings.memoryDesc': 'One-line description',
  'settings.memoryBody': 'Memory body (Markdown supported)',
  'settings.memoryBodyHint': 'Lead with the rule itself; add Why and How to apply lines.',
  'settings.memoryStartersLabel': 'Potrzebujesz punktu wyjścia? Kliknij, aby wypełnić formularz:',
  'settings.memoryStarterUserName': 'Moja rola',
  'settings.memoryStarterUserDesc': 'Jestem inżynierem frontendu pracującym nad narzędziem projektowym SaaS',
  'settings.memoryStarterUserBody': '- Rola: starszy inżynier frontendu\n- Stos: React, TypeScript, Vite\n- Dziedzina: narzędzia do projektowania / współpracy\n- Strefa czasowa: GMT+8 (Asia/Shanghai)\n\nKiedy stosować: dowolny czat — buduj przykłady wokół frontendu webowego.',
  'settings.memoryStarterFeedbackName': 'Preferencje interfejsu',
  'settings.memoryStarterFeedbackDesc': 'Tryb ciemny, duży tekst podstawowy, niska gęstość informacji',
  'settings.memoryStarterFeedbackBody': '- Motyw: domyślnie ciemny\n- Tekst główny: ≥ 18px\n- Gęstość informacji: preferuj przestrzeń, mniej elementów na ekranie\n\nDlaczego: mniejsze zmęczenie wzroku podczas długich sesji.\nKiedy stosować: zawsze, gdy generujesz interfejs, strony internetowe lub slajdy.',
  'settings.memoryStarterProjectName': 'Bieżący projekt',
  'settings.memoryStarterProjectDesc': 'Crie3 v0.5 — edytor projektów sterowany czatem',
  'settings.memoryStarterProjectBody': '- Cel: wydać edytor sterowany czatem w tym kwartale\n- Priorytety: renderowanie strumieniowe, lokalna multimodalność, tryb offline-first\n- Stos: Next.js 16, demon Express, SQLite\n\nKiedy stosować: w każdej rozmowie dotyczącej tego projektu.',
  'settings.memorySaveHint': 'Nie zapisano automatycznie — kliknij Utwórz / Zapisz, aby zastosować.',
  'settings.memoryIndexSaveHint': 'Zmiany w indeksie nie są zapisywane automatycznie — kliknij Zapisz indeks, aby zastosować.',
  'settings.memoryIndexUnsaved': 'Niezapisane zmiany',
  'settings.memoryFlashCreated': '✓ Utworzono pamięć',
  'settings.memoryFlashSaved': '✓ Zapisano pamięć',
  'settings.memoryFlashDeleted': '✓ Usunięto pamięć',
  'settings.memoryFlashIndexSaved': '✓ Zapisano indeks',
  'settings.memoryFlashPathCopied': '✓ Ścieżka skopiowana',
  'settings.memoryNameLabel': 'Tytuł',
  'settings.memoryTypeLabel': 'Typ',
  'settings.memoryDescLabel': 'Opis',
  'settings.memoryBodyLabel': 'Treść',
  'settings.memoryTypeUser': 'Użytkownik',
  'settings.memoryTypeFeedback': 'Opinia',
  'settings.memoryTypeProject': 'Projekt',
  'settings.memoryTypeReference': 'Odniesienie',
  'settings.memoryTypeProfile': 'Profil',
  'settings.memoryTypeRule': 'Reguła',
  'settings.memoryTabMemories': 'Wspomnienia',
  'settings.memoryTabMemoriesCaption': 'Przeglądaj i zarządzaj zapisaną pamięcią',
  'settings.memoryTabHow': 'Jak to działa',
  'settings.memoryTabHowCaption': 'Dwie pętle i ich elementy sterujące',
  'settings.memoryAddDisclosure': 'Dodaj lub zaimportuj wspomnienia',
  'settings.memoryAddDisclosureHint': 'Profil, wpis ręczny lub połączone aplikacje',
  'settings.memoryProfileTab': 'Profil pracy',
  'settings.memoryProfileTabCaption': 'Kim jesteś i Twoje ustawienia domyślne',
  'settings.memoryProfileTitle': 'Twój profil pracy',
  'settings.memoryProfileHint':
    'Kilka faktów o Tobie i Twoich ustawieniach domyślnych. Pamięć wstrzykuje je przed każdym zadaniem, aby agent wywnioskował, o co Ci chodzi, na podstawie krótkiego polecenia.',
  'settings.memoryProfileName': 'Profil pracy',
  'settings.memoryProfileDescription':
    'Rola, firma, dziedzina, odbiorcy, gust i ustawienia domyślne, które asystent powinien ponownie wykorzystać.',
  'settings.memoryProfileSave': 'Zapisz profil',
  'settings.memoryProfileSaving': 'Zapisywanie…',
  'settings.memoryProfileSaved': 'Zapisano profil',
  'settings.memoryProfileRole': 'Rola',
  'settings.memoryProfileRolePlaceholder': 'np. Founder, designer, PM',
  'settings.memoryProfileCompany': 'Firma / zespół',
  'settings.memoryProfileCompanyPlaceholder': 'np. Acme, zespół growth',
  'settings.memoryProfileDomain': 'Dziedzina',
  'settings.memoryProfileDomainPlaceholder': 'np. B2B SaaS, fintech, devtools',
  'settings.memoryProfileAudience': 'Główni odbiorcy',
  'settings.memoryProfileAudiencePlaceholder': 'np. kadra zarządzająca, inżynierowie, użytkownicy końcowi',
  'settings.memoryProfileAesthetic': 'Estetyka / gust',
  'settings.memoryProfileAestheticPlaceholder':
    'np. czysta i redakcyjna, jasne tła, dużo przestrzeni',
  'settings.memoryProfileDeliverables': 'Domyślne produkty',
  'settings.memoryProfileDeliverablesPlaceholder': 'np. landing pages, prezentacje, one-pagery',
  'settings.memoryProfileLocale': 'Region / język',
  'settings.memoryProfileLocalePlaceholder': 'np. English (US), Simplified Chinese',
  'settings.memoryProfileGoals': 'Bieżące cele',
  'settings.memoryProfileGoalsPlaceholder':
    'np. wydać nową stronę cennika, zwiększyć konwersję w ścieżce wersji próbnej',
  'settings.memoryHooksTitle': 'Haki pamięci',
  'settings.memoryHooksHint':
    'Wybierz, które części pamięci uruchamiają się automatycznie. Główny przełącznik powyżej wyłącza je wszystkie.',
  'settings.memoryHooksProfileLabel': 'Używaj mojego profilu',
  'settings.memoryHooksProfileDesc': 'Wstrzykuj Twój profil pracy do każdego zadania.',
  'settings.memoryHooksRewriteLabel': 'Przepisuj krótkie polecenia',
  'settings.memoryHooksRewriteDesc': 'PRE: rozwiń krótkie polecenie w pełny brief zadania.',
  'settings.memoryHooksVerifyLabel': 'Samodzielnie weryfikuj wynik',
  'settings.memoryHooksVerifyDesc': 'POST: sprawdź wynik względem Twoich reguł, a następnie pokaż kartę wyników.',
  'settings.memoryHooksExtractionLabel': 'Ucz się z czatów',
  'settings.memoryHooksExtractionDesc': 'Wychwytuj przydatne fakty i preferencje z tur czatu.',
  'artifact.odCardTaskBriefChip': 'Zastosowano pamięć · zobacz brief',
  'artifact.odCardScorecardTitle': 'Autokontrola',
  'artifact.odCardScorecardStatusPass': 'Zaliczono',
  'artifact.odCardScorecardStatusPartial': 'Częściowo',
  'artifact.odCardScorecardStatusFail': 'Wymaga poprawy',
  'artifact.odCardRuleKicker': 'Proponowana reguła',
  'artifact.odCardRuleNameLabel': 'Nazwa',
  'artifact.odCardRuleDescriptionLabel': 'Opis',
  'artifact.odCardRuleAssertionLabel': 'Musi być spełnione',
  'artifact.odCardRuleCheckLabel': 'Jak sprawdzić',
  'artifact.odCardRuleRationaleLabel': 'Dlaczego',
  'artifact.odCardRuleKeep': 'Zachowaj',
  'artifact.odCardRuleEdit': 'Edytuj',
  'artifact.odCardRuleDone': 'Gotowe',
  'artifact.odCardRuleDiscard': 'Odrzuć',
  'artifact.odCardRuleSaving': 'Zapisywanie…',
  'artifact.odCardRuleSaved': 'Zapisano „{name}” jako regułę',
  'artifact.odCardRuleError': 'Nie udało się zapisać reguły. Spróbuj ponownie.',
  'artifact.odCardBrandAssistDone': 'Browser assist confirmed',
  'artifact.odCardBrandAssistKicker': 'Browser assist needed: {reason}',
  'artifact.odCardBrandAssistBody': 'Open Browser and clear any human check. Then click More, choose Download Page, wait for the saved snapshot success, and use the left Next Step card to continue extraction.',
  'artifact.odCardBrandAssistError': 'Could not start browser assist. Try again.',
  'artifact.odCardBrandAssistWorking': 'Starting...',
  'artifact.odCardBrandAssistConfirm': 'Open browser assist',
  'settings.memoryIndex': 'MEMORY.md (indeks)',
  'settings.memoryIndexSave': 'Zapisz indeks',
  'settings.memoryIndexReset': 'Resetuj',
  'settings.memoryToastChanged': 'Pamięć zaktualizowana',
  'settings.memoryToastClickHint': 'Zobacz',
  'settings.memoryAll': 'Wszystkie',
  'settings.memoryExtractions': 'Historia wyodrębniania',
  'settings.memoryExtractionsHint': 'Recent LLM-backed extraction attempts. Heuristic regex extraction always runs first; LLM extraction runs in the background after each turn.',
  'settings.memoryExtractionsEmpty': 'Brak wyodrębnień. Następna tura czatu wypełni tę listę.',
  'settings.memoryExtractionsRefresh': 'Odśwież',
  'settings.memoryExtractionsRefreshing': 'Odświeżanie…',
  'settings.memoryExtractionPhaseRunning': 'Uruchamianie…',
  'settings.memoryExtractionPhaseSuccess': 'Sukces',
  'settings.memoryExtractionPhaseSkipped': 'Pominięto',
  'settings.memoryExtractionPhaseFailed': 'Niepowodzenie',
  'settings.memoryExtractionSkipNoProvider': 'Nie skonfigurowano API key do wyodrębniania pamięci przez LLM.',
  'settings.memoryExtractionSkipDisabled': 'Pamięć jest wyłączona.',
  'settings.memoryExtractionSkipEmpty': 'Pusta wiadomość użytkownika — nic do wyodrębnienia.',
  'settings.memoryExtractionSkipNoMatch': 'Żaden wzorzec regex nie pasował do tej tury.',
  'settings.memoryExtractionKindHeuristic': 'regex',
  'settings.memoryExtractionKindLlm': 'LLM',
  'settings.memoryExtractionProviderEnv': 'env',
  'settings.memoryExtractionProviderMediaConfig': 'ustawienia mediów',
  'settings.memoryExtractionProviderOverride': 'ustawienia pamięci',
  'settings.memoryExtractionProposed': 'zaproponowano',
  'settings.memoryExtractionWritten': 'zapisano',
  'settings.memoryExtractionDuration': 'in',
  'settings.memoryExtractionDelete': 'Usuń',
  'settings.memoryVerifyTitle': 'Recent verifications',
  'settings.memoryVerifyStatusPass': 'Approved',
  'settings.memoryVerifyStatusFail': 'Not approved',
  'settings.memoryVerifyStatusMissing': 'Not verified',
  'settings.memoryVerifyRules': '{covered} of {active} rules checked',
  'settings.memoryVerifyUncovered': 'Rules the turn never addressed:',
  'settings.memoryVerifyArtifact': 'In the delivered file:',
  'settings.memoryVerifyRowsFailed': '{failed} of {total} checks failed',
  'settings.memoryExtractionsClear': 'Wyczyść',
  'settings.memoryExtractionsClearTitle': 'Wyczyść całą historię wyodrębniania',
  'settings.memoryExtractionsClearConfirm': 'Wyczyścić całą historię wyodrębniania? Tej operacji nie można cofnąć.',
  'settings.memoryNoProviderBannerTitle': 'Wyodrębnianie pamięci przez LLM nie jest uruchomione',
  'settings.memoryNoProviderBannerBody': 'Nie znaleziono API key dla ekstraktora pamięci. Dodaj klucz OpenAI w sekcji dostawców mediów lub ustaw ANTHROPIC_API_KEY / OPENAI_API_KEY w środowisku, aby włączyć wyodrębnianie sterowane przez LLM. Heurystyczne wyodrębnianie regex jest nadal aktywne.',
  'settings.libraryInstall': 'Zainstaluj',
  'settings.libraryInstallGithub': 'GitHub',
  'settings.libraryInstallLocal': 'Ścieżka lokalna',
  'settings.libraryInstallUrl': 'https://github.com/owner/repo',
  'settings.libraryInstallPath': '/path/to/skill-folder',
  'settings.libraryInstallButton': 'Zainstaluj',
  'settings.libraryUninstall': 'Odinstaluj',
  'settings.libraryBuiltIn': 'Wbudowany',
  'settings.libraryInstalled': 'Zainstalowany',
  'notify.successTitle': 'Zadanie ukończone',
  'notify.failureTitle': 'Zadanie nieudane',
  'notify.successBody': 'Tura zakończona.',
  'notify.failureBody': 'Zadanie zakończyło się błędem.',
  'updater.available': 'Aktualizacja dostępna',
  'updater.availableBody': 'Crie3 {version} jest dostępny. Zostanie pobrany przed otwarciem instalatora.',
  'updater.checking': 'Sprawdzanie aktualizacji',
  'updater.download': 'Pobierz aktualizację',
  'updater.downloading': 'Pobieranie aktualizacji',
  'updater.downloadingPercent': 'Pobieranie aktualizacji {percent}%',
  'updater.done': 'Gotowe',
  'updater.failed': 'Aktualizacja nie powiodła się',
  'updater.installerOpenBody': 'Instalator jest otwarty. Crie3 zamyka się, aby można było dokończyć aktualizację.',
  'updater.installerOpened': 'Instalator otwarty',
  'updater.later': 'Później',
  "updater.allowSilentUpdates": "Zezwalaj na ciche aktualizacje",
  'updater.openFailedFallback': 'Nie można otworzyć instalatora.',
  'updater.installRestart': 'Install and restart',
  'updater.installingRestart': 'Installing and restarting...',
  'updater.openInstaller': 'Zainstaluj aktualizację',
  'updater.opening': 'Otwieranie instalatora...',
  'updater.payloadReadyGeneric': 'A new Crie3 update is ready. Crie3 will close and restart automatically.',
  'updater.payloadReadyVersion': 'Crie3 {version} is ready. Crie3 will close and restart automatically.',
  'updater.quitButton': 'Zamknij Crie3',
  'updater.quitFailedBody': 'Instalator jest otwarty, ale nie można zamknąć Crie3. Zamknij Crie3 przed zastąpieniem aplikacji.',
  'updater.quitFailedTitle': 'Nie można zamknąć',
  'updater.quitting': 'Zamykanie...',
  'updater.ready': 'Aktualizacja gotowa',
  'updater.readyGeneric': 'Nowa wersja jest gotowa. Crie3 zamknie się i otworzy instalator.',
  'updater.readyVersion': 'Crie3 {version} jest gotowy. Crie3 zamknie się i otworzy instalator.',
  'updater.upToDate': 'Masz już najnowszą wersję.',
  'whatsNew.cta': 'Zobacz nowości',
  'whatsNew.dismissAria': 'Zamknij nowości',
  'newsletter.label': 'Newsletter (opcjonalnie)',
  'newsletter.placeholder': 'you@studio.com',
  'newsletter.phoneLabel': 'Telefone / WhatsApp (opcional)',
  'newsletter.phonePlaceholder': '(00) 00000-0000',
  'newsletter.consent': 'Aceito receber novidades e contato do Crie3 por e-mail e WhatsApp.',
  'settings.memoryModelInlineLabel': 'Memory model',
  'settings.memoryModelInlineSameAsChat': 'Same as chat',
  'settings.memoryModelInlineSameAsChatWithModel': 'Same as chat ({model})',
  'settings.memoryModelInlineSameAsChatWithProvider': 'Same as chat ({provider})',
  'settings.memoryModelInlineHintCli': 'Optional. The memory extractor uses an env-var or media-providers API key on this provider; pinning a model here just overrides the auto-pick.',
  'settings.memoryModelInlineHintCliConstrained': 'Optional. Memory will call {provider}; needs an env-var or media-providers API key for that provider, or pick a model below to override.',
  'settings.memoryModelInlineHintByok': 'Optional. Reuses your chat API key on the same provider — picking a different (usually cheaper) model only changes the request body.',
  'settings.memoryModelInlineFlashSaved': 'Saved',
  'settings.memoryModelInlineFlashCleared': 'Cleared',
  'settings.orbit.eyebrow': 'Automatyzacja',
  'settings.orbit.title': 'Orbit',
  'settings.orbit.navHint': 'Dzienne podsumowanie konektorów',
  'settings.orbit.lede': 'Zbieraj aktywność konektorów według harmonogramu i publikuj wynik jako odświeżalny live artifact.',
  'settings.orbit.statusOnTitle': 'Codzienne uruchomienia według harmonogramu są włączone',
  'settings.orbit.statusOffTitle': 'Codzienne uruchomienia według harmonogramu są wyłączone',
  'settings.orbit.statusActive': 'Aktywne',
  'settings.orbit.statusOff': 'Wyłączone',
  'settings.orbit.runTitle': 'Uruchom Orbit i otwórz rozmowę na żywo',
  'settings.orbit.running': 'Uruchamianie…',
  'settings.orbit.runOpen': 'Uruchom teraz',
  'settings.orbit.dailySummaryTitle': 'Podsumowanie dzienne',
  'settings.orbit.dailySummarySub': 'Uruchamia się raz dziennie o zaplanowanej lokalnej godzinie.',
  'settings.orbit.on': 'Włączone',
  'settings.orbit.off': 'Wyłączone',
  'settings.orbit.runTimeTitle': 'Czas uruchomienia',
  'settings.orbit.runTimeSub': 'Domyślnie 08:00. Zapisz, aby zastosować harmonogram daemon.',
  'settings.orbit.runTimeAria': 'Codzienny czas uruchomienia Orbit',
  'settings.orbit.nextRun': 'Następne uruchomienie',
  'settings.orbit.nextRunScheduledAfterSave': 'Zaplanowane po zapisie',
  'settings.orbit.schedule': 'Harmonogram',
  'settings.orbit.pausedManualOnly': 'Wstrzymane — tylko uruchomienia ręczne',
  'settings.orbit.templateTitle': 'Szablon prompt',
  'settings.orbit.templateMissing': 'Szablon {id} nie jest zainstalowany.',
  'settings.orbit.templateMissingOption': '{id} (brak)',
  'settings.orbit.templateMissingInstall': 'Zainstaluj skill Orbit, aby sterować prompt.',
  'settings.orbit.templateMissingPickAnother': 'Wybierz inny szablon z listy.',
  'settings.orbit.templateResetTitle': 'Resetuj do {id}',
  'settings.orbit.templateReset': 'Resetuj',
  'settings.orbit.templateHelp': 'Steruj Orbit za pomocą skill — przykładowy prompt wybranego szablonu jest wstrzykiwany do każdego uruchomienia Orbit, aby podsumowania miały kształt tego szablonu.',
  'settings.orbit.templateAria': 'Szablon prompt Orbit',
  'settings.orbit.templatesLoading': 'Ładowanie szablonów…',
  'settings.orbit.templatesOptgroup': 'Szablony skills Orbit',
  'settings.orbit.lastRun': 'Ostatnie uruchomienie',
  'settings.orbit.triggerManual': 'Ręczne',
  'settings.orbit.triggerScheduled': 'Zaplanowane',
  'settings.orbit.meterAria': '{succeeded} udanych, {skipped} pominiętych, {failed} nieudanych z {checked} sprawdzonych',
  'settings.orbit.countChecked': 'Sprawdzone',
  'settings.orbit.countSucceeded': 'Udane',
  'settings.orbit.countSkipped': 'Pominięte',
  'settings.orbit.countFailed': 'Nieudane',
  'settings.orbit.runError': 'Nie można uruchomić Orbit. Upewnij się, że lokalny daemon działa, a konektory są skonfigurowane.',
  'settings.orbit.gateAriaLabel': 'Do działania Orbit wymagane są łączniki',
  'settings.orbit.gateEyebrow': 'Wymagana konfiguracja',
  'settings.orbit.gateTitle': 'Połącz narzędzie, aby uruchomić Orbit',
  'settings.orbit.gateBody': 'Orbit podsumowuje aktywność Twoich łączników. Nic jeszcze nie zostało podłączone — dodaj co najmniej jedną integrację, aby Orbit miał o czym raportować.',
  'settings.orbit.gateBodyNoKey': 'Orbit podsumowuje aktywność Twoich łączników, a łączniki działają przez Composio. Dodaj klucz API Composio w sekcji Łączniki, aby odblokować katalog i wybrać pierwszą integrację.',
  'settings.orbit.gateAction': 'Otwórz Łączniki',
  'settings.orbit.gateActionNoKey': 'Skonfiguruj Composio',
  'settings.orbit.gateLoading': 'Sprawdzanie łączników…',
  'settings.orbit.controlsLockedBadge': 'Zablokowane',
  'settings.orbit.controlsLockedHint': 'Podłącz narzędzie, aby odblokować harmonogram i szablon Orbit.',
  'settings.orbit.artifactKickerLive': 'żywy artefakt',
  'settings.orbit.artifactKickerLegacy': 'Starsze podsumowanie',
  'settings.orbit.artifactTitle': 'Dzienne podsumowanie aktywności Orbit',
  'settings.orbit.artifactMetaLive': 'Odświeżalny artefakt HTML wygenerowany z aktywności konektorów.',
  'settings.orbit.artifactMetaLegacy': 'Wygenerowano przed włączeniem obsługi live artifact — uruchom Orbit ponownie, aby opublikować jeden.',
  'settings.orbit.copyMarkdownTitle': 'Kopiuj podsumowanie Markdown do schowka',
  'settings.orbit.copied': 'Skopiowano',
  'settings.orbit.copy': 'Kopiuj',
  'settings.orbit.openArtifact': 'Otwórz artefakt',
  'settings.orbit.sourceMarkdown': 'Źródłowy Markdown',
  'settings.memoryModelInlineHintByokNeutral': 'Pamięć używa modelu innego niż czat. Domyślnie korzysta z modelu czatu.',
  'diagnostics.exportTitle': 'Eksportuj diagnostykę',
  'diagnostics.exportButton': 'Eksportuj diagnostykę',
  'diagnostics.exportHint': 'Pakuje ostatnie logi aplikacji i informacje o urządzeniu w archiwum zip do wysłania zespołowi.',
  'diagnostics.exporting': 'Eksportowanie…',
  'diagnostics.exportSuccess': 'Diagnostyka zapisana w {path}',
  'diagnostics.exportFailed': 'Nie udało się wyeksportować diagnostyki: {message}',
  'automations.eyebrow': 'Zaplanowane sesje Agentów',
  'automations.title': 'Automatyzacje',
  'automations.lede': 'Planuj cykliczne rozmowy do pracy nad projektami, podsumowań Orbit i artefaktów na żywo.',
  'automations.summaryAria': 'Podsumowanie automatyzacji',
  'automations.metricActive': 'Aktywne',
  'automations.metricPaused': 'Wstrzymane',
  'automations.metricTemplates': 'Szablony',
  'automations.newAutomation': 'Nowa automatyzacja',
  'automations.yourAutomations': 'Twoje automatyzacje',
  'automations.loading': 'Ładowanie',
  'automations.emptyTitle': 'Brak automatyzacji',
  'automations.emptyBody': 'Utwórz automatyzację z szablonu lub zacznij od pustego harmonogramu.',
  'automations.targetNewEachRun': 'Nowy projekt przy każdym uruchomieniu',
  'automations.targetCreateEachRun': 'Nowy projekt przy każdym uruchomieniu',
  'automations.lastRun': 'Ostatnie uruchomienie {time}',
  'automations.openResult': 'Otwórz wynik',
  'automations.run': 'Uruchom',
  'automations.runNowTitle': 'Uruchom teraz i otwórz rozmowę',
  'automations.history': 'Historia',
  'automations.hideHistory': 'Ukryj historię',
  'automations.edit': 'Edytuj',
  'automations.pause': 'Wstrzymaj',
  'automations.resume': 'Wznów',
  'automations.deleteAria': 'Usuń automatyzację',
  'automations.deleteTitle': 'Usuń tę automatyzację',
  'automations.deleteConfirm': 'Usunąć tę automatyzację? Wcześniejsze uruchomienia i ich projekty zostaną zachowane.',
  'automations.proposalsTitle': 'Propozycje ewolucji',
  'automations.proposalsSub': 'Przejrzyj wyniki automatyzacji, zanim zmienią pamięć, umiejętności lub systemy projektowe.',
  'automations.proposalsPending': '{n} oczekujących',
  'automations.apply': 'Zastosuj',
  'automations.reject': 'Odrzuć',
  'automations.proposalsDismissReason': 'Odrzucono w Automatyzacjach',
  'automations.templatesTitle': 'Szablony',
  'automations.templatesSub': 'Orbit i artefakty na żywo to szablony w ramach tego samego przepływu automatyzacji.',
  'automations.templatesCount': '{filtered} z {total}',
  'automations.templateFiltersAria': 'Filtry szablonów',
  'automations.templatesEmptyTitle': 'Brak szablonów w tej kategorii.',
  'automations.templatesEmptyBody': 'Wypróbuj inny filtr lub zacznij od pustej automatyzacji.',
  'automations.useTemplate': 'Użyj szablonu',
  'automations.runHistoryLoading': 'Ładowanie historii uruchomień...',
  'automations.runHistoryEmpty': 'Brak uruchomień.',
  'automations.runHistoryTitle': 'Historia uruchomień',
  'automations.runHistoryLatest': 'Ostatnie 10',
  'automations.crystallize': 'Skrystalizuj',
  'automations.crystallizing': 'Krystalizowanie',
  'automations.crystallizeTitle': 'Utwórz propozycje umiejętności i pamięci na podstawie tego uruchomienia',
  'automations.crystallizeFailed': 'Crystallize failed: {error}',
  'automations.crystallizePartialSuccess': 'Crystallize created proposals, but Automations could not refresh the proposal list. Review the visible proposals or try refreshing.',
  'automations.crystallizeRefreshFailed': 'Crystallize finished, but Automations could not refresh proposals. Try refreshing before running it again.',
  'automations.crystallizeNoProposals': 'Crystallize finished, but no proposals were returned. Try refreshing or check the run details.',
  'automations.openConversation': 'Otwórz rozmowę',
  'automations.runHistoryAria': 'Historia uruchomień automatyzacji',
  'automations.proposalsAria': 'Propozycje ewolucji automatyzacji',
  'automations.templatesAria': 'Szablony automatyzacji',
  'automations.runInProgress': 'W toku',
  'automations.promptPlaceholder': 'Pobierz wczorajszą aktywność z GitHub i Linear oraz podsumuj zmiany.',
  'automations.scheduleStatusPaused': 'Wstrzymane',
  'automations.nextRunManualOnly': 'Tylko ręcznie',
  'automations.nextRunScheduled': 'Zaplanowane',
  'automations.nextRunAt': 'Następne {time}',
  'automations.statusSucceeded': 'Powodzenie',
  'automations.statusFailed': 'Niepowodzenie',
  'automations.statusRunning': 'W trakcie',
  'automations.statusQueued': 'W kolejce',
  'automations.statusCanceled': 'Anulowano',
  'automations.kindOrbit': 'Orbit',
  'automations.kindLiveArtifact': 'Artefakt na żywo',
  'automations.kindAutomation': 'Automatyzacja',
  'automations.proposalTargetMemory': 'Pamięć',
  'automations.proposalTargetDesignSystem': 'System projektowy',
  'automations.proposalTargetSkill': 'Umiejętność',
  'automations.proposalTargetTemplate': 'Szablon automatyzacji',
  'automations.proposalActionCreate': 'Utwórz',
  'automations.proposalActionUpdate': 'Aktualizuj',
  'automations.proposalActionMerge': 'Scal',
  'automations.proposalActionMove': 'Przenieś',
  'automations.proposalActionDelete': 'Usuń',
  'automations.proposalActionPromote': 'Awansuj',
  'automations.filterAll': 'Wszystkie',
  'automations.filterOrbit': 'Orbit',
  'automations.filterLiveArtifacts': 'Artefakty na żywo',
  'automations.filterMemory': 'Pamięć',
  'automations.filterDesignSystems': 'Systemy projektowe',
  'automations.filterSkills': 'Umiejętności',
  'automations.filterConnectors': 'Konektory',
  'automations.filterCompression': 'Kompresja',
  'automations.filterRelease': 'Wydanie',
  'automations.filterQuality': 'Jakość',
  'automations.tpl.memoryRefresh.title': 'Odśwież pamięć projektu na podstawie ostatniej pracy.',
  'automations.tpl.memoryRefresh.desc': 'Przekształca powtarzające się decyzje, preferencje i opinie w aktualizacje pamięci wielokrotnego użytku.',
  'automations.tpl.designSystemRefresh.title': 'Aktualizuj systemy projektowe na podstawie dostarczonych artefaktów.',
  'automations.tpl.designSystemRefresh.desc': 'Znajduje tokeny, komponenty i reguły wielokrotnego użytku w ostatniej pracy projektowej.',
  'automations.tpl.liveArtifactRegistry.title': 'Audytuj artefakty na żywo i odśwież nieaktualne wersje.',
  'automations.tpl.liveArtifactRegistry.desc': 'Utrzymuje stałe pulpity, raporty i podglądy aktualne, zamiast je duplikować.',
  'automations.tpl.orbitDashboard.title': 'Zbuduj pulpit aktywności konektorów.',
  'automations.tpl.orbitDashboard.desc': 'Agreguje wybrane konektory w pulpit na żywo w stylu Orbit.',
  'automations.tpl.releaseNotes.title': 'Przygotuj informacje o wydaniu na podstawie dostarczonej pracy projektowej.',
  'automations.tpl.releaseNotes.desc': 'Łączy scalone PR, artefakty i zmiany dla użytkowników w informacje o wydaniu.',
  'automations.tpl.qualityRegressionWatch.title': 'Monitoruj regresje w projektowaniu i implementacji.',
  'automations.tpl.qualityRegressionWatch.desc': 'Porównuje ostatnie zmiany z benchmarkami, śladami i zaakceptowanymi odniesieniami.',
  'automations.tpl.orbitDaily.title': 'Dzienne podsumowanie konektorów.',
  'automations.tpl.orbitDaily.desc': 'Odświeża podsumowanie aktywności konektorów według harmonogramu.',
  'automations.tpl.liveStatusBoard.title': 'Utrzymuj aktualny artefakt statusu na żywo.',
  'automations.tpl.liveStatusBoard.desc': 'Aktualizuje jeden stały artefakt zamiast tworzyć nowy raport przy każdym uruchomieniu.',
  'dsManager.areaAria': 'Obszar systemów projektowych',
  'dsManager.tabDesignSystem': 'System projektowy',
  'dsManager.tabTemplate': 'Szablon',
  'dsManager.sourceAria': 'Źródło systemu projektowego',
  'dsManager.templateSourceAria': 'Źródło szablonu',
  'dsManager.yourSystems': 'Twoje systemy',
  'dsManager.officialPresets': 'Oficjalne ustawienia wstępne',
  'dsManager.enterprise': 'Enterprise',
  'dsManager.yourTemplates': 'Twoje szablony',
  'dsManager.yourSystemsAria': 'Twoje systemy projektowe',
  'dsManager.eyebrowDesignSystems': 'Systemy projektowe',
  'dsManager.yourSystemsHeading': 'Twoje systemy',
  'dsManager.filterAria': 'Filtruj systemy projektowe',
  'dsManager.filterAll': 'Wszystkie',
  'dsManager.filterPublished': 'Opublikowane',
  'dsManager.filterDraft': 'Wersja robocza',
  'dsManager.createTitle': 'Utwórz nowy system projektowy',
  'dsManager.createBody': 'Naucz Crie3 swojej marki, produktu, kodu, zasobów i odniesień projektowych.',
  'dsManager.createAction': 'Utwórz',
  'dsManager.emptyMine': 'Brak systemów projektowych. Utwórz jeden na podstawie rzeczywistego kontekstu produktu, przejrzyj wersję roboczą, a następnie opublikuj go do przyszłych projektów.',
  'dsManager.badgeDefault': 'Domyślny',
  'dsManager.rowMetaUpdated': 'Ty · zaktualizowano {date}',
  'dsManager.edit': 'Edytuj',
  'dsManager.openSystem': 'Otwórz',
  'dsManager.editWithAgent': 'Edytuj z Agentem',
  'dsManager.downloadTitle': 'Pobierz system projektowania (.zip + SKILLS.md)',
  'dsManager.downloadAria': 'Pobierz {title} jako .zip',
  'dsManager.downloadFailed': 'Nie udało się pobrać systemu projektowania. Spróbuj ponownie.',
  'dsManager.deleteConfirm': 'Usunąć „{title}”? Spowoduje to usunięcie szkicu systemu projektowania z tego urządzenia.',
  'dsManager.makeDefault': 'Ustaw jako domyślny',
  'dsManager.statusPublished': 'Opublikowany',
  'dsManager.statusDraft': 'Wersja robocza',
  'dsWorkspace.back': 'Back',
  'dsWorkspace.setDefault': 'Default for new chats',
  'dsWorkspace.setDefaultHint': 'Preselect this design system for new chats and new projects.',
  'dsWorkspace.fontsMissingTitle': 'Brand font files missing',
  'dsWorkspace.fontsMissingBody': 'Typography previews are using substitute web fonts until brand font files are added.',
  'dsWorkspace.addFonts': 'Add brand font files',
  'dsWorkspace.stepRead': 'Read current system',
  'dsWorkspace.stepUpdate': 'Update design files',
  'dsWorkspace.stepRefresh': 'Refresh review',
  'dsManager.openSystemAria': 'Otwórz {title}',
  'dsManager.deleteSystemAria': 'Usuń {title}',
  'dsManager.presetsAria': 'Oficjalne ustawienia wstępne systemów projektowych',
  'dsManager.eyebrowLibrary': 'Biblioteka',
  'dsManager.eyebrowTemplates': 'Szablony',
  'dsManager.yourTemplatesAria': 'Twoje szablony',
  'dsManager.emptyTemplates': 'Brak szablonów. Utwórz jeden z dowolnego wygenerowanego projektu przez funkcję Udostępnij, gdy publikowanie szablonów zostanie włączone.',
  'dsManager.templateDescFallback': 'Utworzono z projektu',
  'dsManager.comingSoonBadge': 'Wkrótce',
  'dsManager.enterpriseDsTitle': 'Systemy projektowe Enterprise',
  'dsManager.enterpriseDsBody': 'Współdzielone zespołowe systemy projektowe i zarządzane biblioteki marek już wkrótce.',
  'dsManager.enterpriseTplTitle': 'Szablony Enterprise',
  'dsManager.enterpriseTplBody': 'Szablony zatwierdzone przez zespół i publikowanie w całej organizacji już wkrótce.',
  'settings.instructionsTitle': 'Instrukcje / Reguły',
  'settings.instructionsSubtitle': 'Stałe zachowanie, którego powinien przestrzegać asystent',
  'settings.instructionsNavSub': 'Stałe zachowanie asystenta',
  'settings.customInstructionsDesc': 'Stałe instrukcje, których Crie3 przestrzega w każdej rozmowie. To nie są zapisane wspomnienia; użyj Pamięci do faktów, preferencji i kontekstu projektu.',
  'mcpClient.forwardedToLabel': 'Przekazywane do:',
  'mcpClient.notForwardedToLabel': 'Nie przekazywane do:',
  'mcpClient.forwardedAcpNote': 'Adaptery ACP oznaczone jako stdio otrzymują z tej listy tylko serwery MCP typu stdio; wpisy HTTP i SSE są pomijane podczas uruchamiania.',
  'mcpClient.notForwardedNote': 'Dla tych Agentów skonfiguruj serwery MCP w pliku konfiguracyjnym danego Agenta (np. ~/.codex/config.toml, ~/.gemini/settings.json); poniższe serwery są tam po cichu nieużywane.',

  // Brands library + extraction
  'brand.libraryTitle': 'Zestaw marki',
  'brand.librarySubtitle': 'Teach Crie3 your brand kits — extract one from a website, then apply it in any chat.',
  'brand.newBrand': 'New Brand Kit',
  'brand.searchPlaceholder': 'Search your brand kits…',
  'brand.empty': 'No brand kits yet. Extract one from a website to get started.',
  'brand.colorsCount': '{count} colors',
  'brand.extracting': 'Extracting…',
  'brand.failed': 'Extraction failed',
  'brand.needsInput': 'Needs input',
  'brand.needsInputHint': 'Extraction paused — open the project to finish verification or answer the question.',
  'brand.appliedToChat': 'Using {name}',
  'brand.previewEmpty': 'Select a brand to preview',
  'brand.viewDetails': 'View details',
  'newBrand.title': 'New Brand',
  'newBrand.subtitle': 'Wklej witrynę lub wybierz markę poniżej, a wyodrębnimy jej kolory, czcionki i logo.',
  'newBrand.urlLabel': 'Brand website',
  'newBrand.urlPlaceholder': 'yourcompany.com',
  'newBrand.extract': 'Extract brand',
  'newBrand.cancel': 'Cancel',
  'newBrand.close': 'Close',
  'newBrand.stage1': 'Fetching the site & measuring its design',
  'newBrand.stage2': 'Building a brand preview',
  'newBrand.stage3': 'Deriving & registering the design system',
  'newBrand.measured': '{colors} colors · {fonts} fonts · {logos} logos',
  'newBrand.done': 'Brand ready',
  'brandDetail.identity': 'Identity',
  'brandDetail.designLanguage': 'Design Language',
  'brandDetail.colors': 'Colors',
  'brandDetail.fonts': 'Fonts',
  'brandDetail.tone': 'Tone',
  'brandDetail.aesthetic': 'Aesthetic',
  'brandDetail.tagline': 'Tagline',
  'brandDetail.voice': 'Voice',
  'brandDetail.useInChat': 'Use in new chat',
  'brandDetail.delete': 'Delete brand',
  'brandDetail.back': 'Zestaw marki',
  'brandDetail.refining': 'Refining this brand…',
  'brandDetail.notFound': 'Brand not found.',
  'brandDetail.logo': 'Logo',
  'brandDetail.typography': 'Typography',
  'brandDetail.palette': 'Palette',
  'brandDetail.voiceTone': 'Voice & tone',
  'brandDetail.imageryLayout': 'Imagery & layout',
  'brandDetail.images': 'Images',
  'brandDetail.designSystem': 'Design system',
  'brandDetail.brandAssets': 'Brand assets',
  'brandDetail.openProject': 'Open project',
  'brandDetail.themeLight': 'Light',
  'brandDetail.themeDark': 'Dark',
  'brandDetail.subjects': 'Subjects',
  'brandDetail.treatment': 'Treatment',
  'brandDetail.useLabel': 'Use',
  'brandDetail.avoidLabel': 'Avoid',
  'brandDetail.layoutPosture': 'Layout posture',
  'brandDetail.deleteConfirm': 'Delete "{name}"? This removes the brand and its design system.',
  'brandDetail.viewMore': 'Show all {count}',
  'brandDetail.viewLess': 'Show less',
  'settings.resetOnboarding': 'Reset onboarding',
  'settings.resetOnboardingDesc': 'Replay the first-run setup, including brand extraction.',
  'settings.resetOnboardingButton': 'Reset',
  'onboarding.brandTitle': 'Extract your brand kit',
  'onboarding.brandSubtitle': 'Paste a website and we\'ll turn its brand signals into a reusable brand kit for future work.',
  'onboarding.brandSkip': 'Skip for now',
  'onboarding.brandDone': 'Brand kit extracted',
  'onboarding.buildTitle': 'Stwórz raz, buduj wszędzie',
  'onboarding.buildBody': 'Crie3 zamienia Twoją markę w wielokrotnego użytku system projektowy i utrzymuje spójność oraz zgodność z marką we wszystkim, co tworzysz.',
  'onboarding.buildBenefitMemoryTitle': 'One brand memory',
  'onboarding.buildBenefitMemoryBody': 'Kolory, czcionki, logo i ton wypowiedzi są zapisywane i używane w każdym materiale.',
  'onboarding.buildBenefitAlignedTitle': 'Every output stays aligned',
  'onboarding.buildBenefitAlignedBody': 'Posty, karuzele, relacje i zaproszenia trzymają się tych samych zasad.',
  'onboarding.buildBenefitSourcesTitle': 'Start from what you have',
  'onboarding.buildBenefitSourcesBody': 'Użyj strony, Instagrama, logo, zdjęć lub czcionek, które już masz.',
  'onboarding.buildPreviewLabel': 'Brand system',
  'onboarding.buildStart': 'Utwórz system projektowy',
  'onboarding.interview.title': 'Poznajmy Twój kościół',
  'onboarding.interview.body': 'Odpowiedz na kilka szybkich pytań, a AI uzupełni profil Twojego kościoła do wykorzystania w treściach. Możesz pominąć i zrobić to później w Ustawieniach.',
  'onboarding.interview.placeholder': 'Wpisz swoją odpowiedź…',
  'onboarding.interview.send': 'Wyślij',
  'onboarding.interview.skip': 'Pomiń na razie',
  'onboarding.interview.start': 'Odpowiedz teraz',
  'onboarding.interview.sending': 'Pisze…',
  'onboarding.interview.error': 'Nie można teraz kontynuować wywiadu. Możesz pominąć i uzupełnić później w Ustawienia → Moja marka.',
  'onboarding.interview.errorQuota': 'Twoje konto wykorzystało limit AI na ten miesiąc. Pomiń na razie; profil możesz uzupełnić w Ustawienia → Moja marka.',
  'onboarding.interview.errorBusy': 'AI jest teraz przeciążona. Spróbuj ponownie za chwilę.',
  'onboarding.interview.errorNotConfigured': 'Wywiad z AI nie jest dostępny w tej instalacji. Pomiń na razie; profil możesz uzupełnić ręcznie w Ustawienia → Moja marka.',
  'onboarding.interview.retry': 'Spróbuj ponownie',
  'onboarding.logo.title': 'Prześlij logo kościoła',
  'onboarding.logo.body': 'Zostanie zapisane w profilu kościoła i pojawi się na grafikach tworzonych przez Crie3. Jeśli masz dwie wersje, prześlij wersję na jasne i na ciemne tło. Możesz pominąć i przesłać je później w Ustawienia → Moja marka.',
  'onboarding.interview.titleMinistry': 'Poznajmy Twoją posługę',
  'onboarding.interview.titleWorship': 'Poznajmy Twój zespół',
  'onboarding.interview.titleAgency': 'Poznajmy Twoją agencję',
  'onboarding.interview.bodyProfile': 'Odpowiedz na kilka szybkich pytań, a AI uzupełni Twój profil do wykorzystania w treściach. Możesz pominąć i zrobić to później w Ustawieniach.',
  'onboarding.logo.titleMinistry': 'Prześlij logo posługi',
  'onboarding.logo.titleWorship': 'Prześlij logo zespołu',
  'onboarding.logo.titleAgency': 'Prześlij logo agencji',
  'onboarding.logo.bodyProfile': 'Zostanie zapisane w Twoim profilu i pojawi się na grafikach tworzonych przez Crie3. Jeśli masz dwie wersje, prześlij wersję na jasne i na ciemne tło. Możesz pominąć i przesłać je później w Ustawieniach.',
  'onboarding.interview.done': 'Profil zapisany! Wszystko możesz później dostosować w Ustawienia → Moja marka.',
  'onboarding.interview.continue': 'Dalej',
  'onboarding.buildHome': 'Przejdź do strony głównej',
  'dsCreate.heroEyebrow': "System projektowy",
  'dsCreate.heroTitle': "Design system w kilka minut",
  'dsCreate.heroLede': "Zamień stronę lub DESIGN.md — wraz z kontekstem, który już masz — w kompletny, zgodny z marką design system gotowy do użycia.",
  'dsCreate.heroStepCount': '3 kroki',
  'dsCreate.heroDuration': '~3 min',
  'dsCreate.heroStep1Title': 'Twoja marka',
  'dsCreate.heroStep1Desc': 'Użyj profilu z Moja marka, strony lub Instagrama',
  'dsCreate.heroStep2Title': 'Wyślij materiały',
  'dsCreate.heroStep2Desc': 'Logo, okładki, zdjęcia, czcionki (opcjonalnie)',
  'dsCreate.heroStep3Title': 'Generuj',
  'dsCreate.heroStep3Desc': 'Najpierw szybki szkic, potem AI go dopracuje',
  'dsCreate.heroShowcaseTitle': "Twój design system",
  'dsFonts.missingTitle': "Brakuje plików czcionek marki",
  'dsFonts.missingBody': "Podglądy typografii korzystają z zastępczych czcionek internetowych, dopóki nie dodasz plików czcionek marki.",
  'dsCreate.referenceLabel': 'Copy from existing design system',
  'dsCreate.referenceLoading': 'Loading DESIGN.md...',
  'dsCreate.referenceLoadFailed': 'Could not load that design system.',
  'dsCreate.heroShowGuideAria': 'Pokaż przewodnik po systemie projektowym',
  'dsCreate.heroHideGuideAria': 'Ukryj przewodnik po systemie projektowym',
  'dsCreate.heroShowGuideTitle': 'Pokaż przewodnik',
  'dsCreate.heroHideGuideTitle': 'Ukryj przewodnik',
  'dsCreate.heroGuide': 'Przewodnik',
  'dsCreate.missingSourceError': 'Add a website, DESIGN.md, description, file, Figma source, or notes to create a design system.',
  'dsCreate.continueToGeneration': 'Continue to generation',
  'dsCreate.embeddedTitle': 'Generate from your material',
  'dsCreate.embeddedBody': 'Start with a website or brand reference, then add any source files you already have.',
  'dsCreate.sourceSectionTitle': 'Extract from GitHub, websites, or source material',
  'dsCreate.sourceSectionBody': 'Start with a GitHub repo, website, DESIGN.md, or files that show your style. Crie3 first creates a usable system quickly, then AI can refine it inside the project.',
  'dsCreate.githubWebsiteLabel': 'GitHub or website',
  'dsCreate.add': 'Add',
  'dsCreate.startFromBrand': 'Start from a brand',
  'dsCreate.brandPickerSubtitle': 'Search hundreds of brands — pick one and we\'ll add its site as a style reference.',
  'dsCreate.brandPickerQuickPicks': 'Popular brands — click to add',
  'dsCreate.addedSourceLinks': 'Added source links',
  'dsCreate.openSourceLabel': 'Open {label}',
  'dsCreate.removeSourceLabel': 'Remove {label}',
  'dsCreate.addFiles': 'Add files',
  'dsCreate.describeBrand': 'Describe brand',
  'dsCreate.optional': 'optional',
  'dsCreate.describeBrandHelp': 'Brand voice, intro and product context. Used in the fast pass and AI refinement.',
  'dsCreate.companyPlaceholder': 'e.g. Mission Impastabowl: fast-casual pasta restaurant with kiosk, mobile app and website',
  'dsCreate.pasteDesignMd': 'Paste DESIGN.md',
  'dsCreate.pasteDesignMdHelp': 'Paste a DESIGN.md to create directly from tokens, rationale and component guidance.',
  'dsCreate.reference': 'Reference',
  'dsCreate.designMdViewMode': 'DESIGN.md view mode',
  'dsCreate.advancedToggle': 'Advanced — repo, local code, Figma',
  'dsCreate.githubRepo': 'GitHub repo',
  'dsCreate.localCodeLabel': 'Link local code',
  'dsCreate.localCodeHelper': 'Use a folder or selected files from this computer.',
  'dsCreate.localCodePrompt': 'Drag a folder here or browse',
  'dsCreate.uploadFigLabel': 'Upload .fig',
  'dsCreate.uploadFigHelper': 'Decoded on your machine into real tokens, components & assets — no Figma account.',
  'dsCreate.uploadFigPrompt': 'Drop .fig here or browse',
  'dsCreate.figmaUrl': 'Figma URL',
  'dsCreate.figmaPlaceholder': 'https://figma.com/design/… or /file/…',
  'dsCreate.addedFigmaUrls': 'Added Figma URLs',
  'dsCreate.savedFigmaHelp': 'Saved as a Figma design source. The agent uses it as the canonical reference; export a .fig above for a full offline decode.',
  'dsCreate.notes': 'Notes',
  'dsCreate.notesPlaceholder': 'e.g. We use a warm, earthy color palette with rounded corners. Our brand voice is playful but professional...',
  'dsCreate.back': 'Back',
  'dsCreate.generate': 'Generate',
  'dsCreate.libraryPickerTitle': 'Select from library',
  'dsCreate.libraryPickerConfirm': 'Add to assets',
  'dsCreate.designMdPreviewKicker': 'DESIGN SYSTEM',
  'dsCreate.designMdPreviewTitle': 'DESIGN.md preview',
  'dsCreate.componentKit': 'component kit',
  'dsCreate.defaultTheme': 'default theme',
  'dsCreate.componentKitTitle': '{name} — component kit',
  'dsCreate.designMdGeneratedDescription': 'Generated from pasted DESIGN.md tokens, rationale and component guidance.',
  'dsCreate.previewButtons': 'Buttons',
  'dsCreate.previewButtonsHelp': 'Five types across three sizes.',
  'dsCreate.buttonPrimary': 'Primary',
  'dsCreate.buttonDashed': 'Dashed',
  'dsCreate.buttonText': 'Text',
  'dsCreate.buttonLink': 'Link',
  'dsCreate.sizeSmall': 'Small',
  'dsCreate.sizeMedium': 'Medium',
  'dsCreate.sizeLarge': 'Large',
  'dsCreate.previewTypeScale': 'Type scale',
  'dsCreate.extractedTokens': 'Extracted DESIGN.md tokens',
  'brandPicker.heading': 'Zacznij od marki, którą lubisz',
  'brandPicker.subtext': 'Kliknij dowolną markę, aby wyodrębnić jej zestaw bezpośrednio z jej strony.',
  'brandPicker.quickPicksLabel': 'Popularne marki — kliknij, aby wyodrębnić',
  'brandPicker.searchPlaceholder': 'Szukaj marek…',
  'brandPicker.allCategories': 'Wszystkie',
  'brandPicker.extractAction': 'Wyodrębnij',
  'brandPicker.showMore': 'Pokaż więcej',
  'brandPicker.opening': 'Rozpoczynanie ekstrakcji — otwieranie {brand}…',
  'ds.kitVisualize': 'Wizualizacja',
  'ds.kitEdit': 'Edytuj',
  'ds.kitSource': 'Źródło',
  'ds.saveDesignMd': 'Zapisz DESIGN.md',
  'ds.saving': 'Zapisywanie…',
  'ds.copyDesignMd': 'Kopiuj DESIGN.md',
  'ds.editDesignMd': 'Edytuj DESIGN.md',
  'ds.openDesignMd': 'Otwórz DESIGN.md',
  'ds.copyDesignMdModule': 'Kopiuj sekcję {module}',
  'ds.editDesignMdModule': 'Edytuj sekcję {module}',
  'ds.openDesignMdModule': 'Otwórz sekcję {module}',
  'ds.uploadMd': 'Prześlij MD',
  'ds.uploadFont': 'Dodaj plik fontu',
  'ds.pasteImage': 'Wklej obraz',
  'ds.refresh': 'Odśwież',
  'ds.download': 'Pobierz',
  'ds.importFolder': 'Importuj folder',
  'ds.reset': 'Resetuj',
  'ds.editingDesignMdHint': 'Edycja tego Markdowna aktualizuje wyrenderowane moduły zestawu.',
  'ds.editingModuleHint': 'Edytowany jest tylko moduł {module}.',
  'ds.manualEditModuleHint': 'Edit {module} here. Hover this section to reveal controls.',
  'ds.saveModule': 'Zapisz moduł',
  'ds.uploadLogo': 'Prześlij logo',
  'ds.uploadImage': 'Prześlij obraz',
  'ds.uploading': 'Przesyłanie…',
  'ds.moduleEmptyLogo': 'Nie ma jeszcze logo',
  'ds.moduleEmptyFonts': 'Nie przechwycono fontów.',
  'ds.actionDone': 'Gotowe',
  'ds.actionFailed': 'Coś poszło nie tak. Spróbuj ponownie.',
  'ds.uploadDone': 'Przesłano',
  'ds.uploadFailed': 'Przesyłanie nie powiodło się. Spróbuj ponownie.',
  'ds.deleteLogo': 'Usuń logo',
  'ds.deleteImage': 'Usuń {caption}',
  'ds.deleteProjectConfirm': 'Usunąć „{title}”? Spowoduje to trwałe usunięcie tego systemu projektowania i jego projektu z tego urządzenia.',
  'ds.deleteProjectAction': 'Usuń {title}',
  'ds.editColor': 'Edytuj {name}',
  'ds.colorLabel': 'Kolor',
  'ds.hexLabel': 'Hex',
  'ds.hexValueLabel': 'Wartość Hex',
  'ds.saveColor': 'Zapisz kolor',
  'ds.invalidHexColor': 'Wpisz poprawny kolor Hex, np. #FF6A3D.',
  'ds.colorSaveFailed': 'Nie udało się zapisać tego koloru.',
  'ds.colorResetFailed': 'Nie udało się zresetować tego koloru.',
  'ds.designMdSectionLabel': 'Sekcja {module} w DESIGN.md',
  'ds.kitErrorTitle': 'W tym widoku wystąpił problem.',
  'ds.kitErrorRetry': 'Przeładuj',
  'ds.shortcutsLabel': 'Skróty klawiszowe',
  'ds.shortcutsHint': 'Skróty: E edytuj · C kopiuj · U prześlij · R odśwież · ⌫ usuń logo',
  'ds.moduleEmptyImages': 'Nie ma jeszcze obrazów',
  'ds.noOriginalColor': 'No original color is available for this swatch.',
  'ds.manifestReadFailed': 'Unable to read _ds_manifest.json.',
  'ds.reviewCollapseSection': 'Collapse {title}',
  'ds.reviewExpandSection': 'Expand {title}',
  'ds.reviewNeedsReview': 'Needs review',
  'ds.reviewLooksGood': 'Looks good',
  'ds.reviewActionsLabel': '{title} review',
  'ds.reviewNeedsWorkEllipsis': 'Needs work...',
  'ds.reviewEditFile': 'Edit {file}',
  'ds.reviewFeedbackLabel': 'Tell the agent what to change',
  'ds.reviewFeedbackPlaceholder': 'e.g. tighten spacing in {title}, regenerate this preview...',
  'ds.reviewChangedAfterFeedback': 'This section changed after your feedback. Review it again before publishing.',
  'ds.reviewChangedDuringRun': 'This section changed during the latest run. Review it before publishing.',
  'ds.reviewLastFeedback': 'Last feedback',
  'ds.previewGenerating': 'Generating preview...',
  'ds.creatingProjectTitle': 'Creating your design system...',
  'ds.creatingProjectSubtitle': 'Keep this tab open. You can come back in a few minutes.',
  'ds.generationProgressLabel': 'Design system generation progress {progress}%',
  'ds.publishRepoRequiredTitle': 'Finish importing your GitHub repo before you can publish.',
  'ds.publishDesignSystem': 'Publish design system',
  'ds.unpublishDesignSystem': 'Unpublish design system',
  'ds.published': 'Published',
  'ds.publish': 'Publish',
  'ds.extractionRunningTitle': 'Extracting design system',
  'ds.extractionCompleteTitle': 'Extraction complete',
  'ds.extractionRunningBody': 'Crie3 is updating this system in place.',
  'ds.extractionCompleteBody': 'All extracted modules are shown below; empty sections are intentionally blank.',
  'ds.publishCardPublished': 'Your team\'s new projects can use this design system as context by default.',
  'ds.publishCardDraft': 'Your design system is ready, but your feedback will improve it. Publish it when it is ready to use in future projects.',
  'ds.useSystemTitle': 'Use this system',
  'ds.useSystemBody': 'Start a new design that inherits this system\'s colors, type, and components - kept on-brand automatically.',
  'ds.createNewDesign': 'Create new design',
  'ds.openSourceContext': 'Open source context',
  'ds.manifestNeedsAttention': 'Design manifest needs attention',
  'ds.openManifest': 'Open manifest',
  'ds.workspacePreparing': 'Preparing the design system workspace.',
  'ds.workspaceLoadingLabel': 'Design system workspace is loading',
  'ds.sectionQueued': 'Queued',
  'ds.sectionReviewUpdatedFiles': 'Updated files need review',
  'ds.reviewNeedsWork': 'Needs work',
  'ds.sectionRequiredFileMissing': 'Required file missing: {file}',
  'ds.sectionNoFilesYet': 'No files yet',
  'ds.generationSourceTitle': 'Source context',
  'ds.generationSourceDetail': 'Reading linked source context and repository evidence.',
  'ds.generationGuidanceTitle': 'Brand guidance',
  'ds.generationGuidanceDetail': 'Writing DESIGN.md guidance and voice.',
  'ds.generationTokensTitle': 'Design tokens',
  'ds.generationTokensDetail': 'Extracting colors, type, and spacing tokens.',
  'ds.generationPreviewsTitle': 'Preview cards',
  'ds.generationPreviewsDetail': 'Rendering reviewable preview cards.',
  'ds.generationUiKitTitle': 'UI kit',
  'ds.generationUiKitDetail': 'Creating reusable components and patterns.',
  'ds.generationAssetsTitle': 'Brand assets',
  'ds.generationAssetsDetail': 'Collecting logos, fonts, images, and icons.',
  'ds.phaseQueuedTypography': 'Typography queued',
  'ds.phaseQueuedTokens': 'Tokens queued',
  'ds.phaseQueuedSpacing': 'Spacing queued',
  'ds.phaseQueuedUiKit': 'UI kit queued',
  'ds.phaseQueuedAssets': 'Assets queued',
  'ds.phaseReadingTypography': 'Reading typography',
  'ds.phaseReadingTokens': 'Reading tokens',
  'ds.phaseReadingSpacing': 'Reading spacing',
  'ds.phaseReadingUiKit': 'Reading UI kit',
  'ds.phaseReadingAssets': 'Reading assets',
  'ds.phaseWritingTypography': 'Writing typography',
  'ds.phaseWritingTokens': 'Writing tokens',
  'ds.phaseWritingSpacing': 'Writing spacing',
  'ds.phaseBuildingUiKit': 'Building UI kit',
  'ds.phaseUpdatingAssets': 'Updating assets',
  'ds.phaseNeedsAttention': 'Needs attention',
  'ds.phaseUpdated': 'Updated',
  'ds.sectionActivityFromTodo': '{phase}: {todo}',
  'ds.sectionActivityReadFiles': 'Read {files}',
  'ds.sectionActivityPhaseFiles': '{phase}: {files}',
  'ds.sectionRunningReadingContext': 'Reading context for {title}.',
  'ds.sectionRunningNow': '{phase} now.',
  'ds.reviewLastReviewed': 'Last reviewed {time}',
  'ds.agentFeedbackQueued': 'Agent feedback queued',
  'ds.agentFeedbackSent': 'Agent feedback sent',
  'ds.agentFeedbackSentAt': 'Agent feedback sent {time}',
  'ds.agentFeedbackFailedWithError': 'Agent feedback failed: {error}',
  'ds.agentFeedbackFailed': 'Agent feedback failed',
  'ds.agentFeedbackUnknown': 'Agent feedback status unknown',
  'ds.repoConnectBannerTitle': 'Connect your repo to pull aspects of your design system',
  'ds.repoConnectCardTitle': 'Connect your repo',
  'ds.repoConnectPendingBody': 'Checking your GitHub connection...',
  'ds.repoConnectPendingButton': 'Checking GitHub...',
  'ds.repoConnectedTitle': 'GitHub is connected',
  'ds.repoConnectedBody': 'Re-import this repo to pull its files into your design system.',
  'ds.repoImportButton': 'Import repo',
  'ds.repoConnectBannerBody': 'Connect GitHub so Crie3 can read your repository and pull colors, type, and components into this design system.',
  'ds.repoConnectCardBody': 'Pull colors, type, and components from your repository into this design system.',
  'ds.repoConnectButton': 'Connect GitHub',
  'newproj.startFromLabel': 'Zacznij od',
  'newproj.startBlank': 'Pusty',
  'newproj.startBlankHint': 'Zacznij od zera',
  'workspace.pages': 'Strony',
  'workspace.allProjectFiles': 'Wszystkie pliki projektu',
  'workspace.newBlankPage': 'Nowa pusta strona',
  'workspace.noPagesYet': 'Brak stron',
  'workspace.pageCreateFailed': 'Nie udało się utworzyć strony.',
  'workspace.pageCreatorTitle': 'Utwórz stronę',
  'workspace.pageCreatorSearch': 'Szukaj szablonów',
  'workspace.pageCreatorCategoryAll': 'Wszystkie scenariusze',
  'workspace.pageCreatorEmpty': 'Żaden typ strony nie pasuje do wyszukiwania.',
  'workspace.pageCreatorPreview': 'Podgląd',
  'workspace.pageCreatorUse': 'Użyj',
  'fileViewer.presentInTabDeckHint': 'Notatki prelegenta w wyskakującym oknie',
  'fileViewer.presentEscHint': 'Naciśnij Esc, aby wyjść',
  'fileViewer.presenterPause': 'Pauza',
  'fileViewer.presenterResume': 'Wznów',
  'fileViewer.presenterPrevious': 'Poprzedni',
  'fileViewer.presenterNext': 'Następny',
  'questions.uploadingFiles': 'Przesyłanie plików…',
  'questions.uploadNeedsProject': 'Przesyłanie plików wymaga aktywnego projektu.',
  'questions.uploadPartialFailed': 'Przesłano {uploaded} plik(ów), ale {failed} się nie powiodło.',
  'questions.uploadFailed': 'Nie udało się przesłać {failed} plik(ów).',
  // TikTok consent screen. The Music Usage Confirmation sentence and the
  // processing notice are NOT here on purpose: they come from the server in
  // English because a human auditor reads those exact words, and translating
  // them would change the thing being checked.
  'fileViewer.publishToSocial': 'Publish to social',
  'social.loading': 'Loading your accounts…',
  'settings.socialNetworks': 'Social networks',
  'settings.socialNetworksHint': 'Connected accounts and publishing',
  'social.connectionsTitle': 'Connected accounts',
  'social.clientConnectHint': 'Aby połączyć Instagram klienta, otwórz kartę klienta w sekcji {screen} i użyj „{button}”. Przyciski poniżej łączą profil samego konta.',
  'social.noConnections': 'No account connected yet.',
  'social.disconnect': 'Disconnect',
  'social.connectTo': 'Connect {network}',
  'social.connectFailed': 'Could not start the connection. Publishing may not be configured yet.',
  'social.appCredentialsTitle': 'App credentials',
  'social.appCredentialsHint': 'The keys for this deployment’s own app on each network. Everyone who uses the product publishes through it.',
  'social.publishingOn': 'Publishing is on.',
  'social.publishingOff': 'Publishing is off: {reason}',
  'social.sourceEnv': 'from environment',
  'social.sourceStored': 'saved here',
  'social.sourceUnset': 'not set',
  'social.managedByEnv': 'Set by an environment variable on the host, which takes precedence. Editing here would have no effect.',
  'social.save': 'Save',
  'social.saving': 'Saving…',
  'social.clear': 'Clear',
  'social.publicBaseUrl': 'Public address',
  'social.publicBaseUrlHint': 'The public origin the networks fetch the image from. Without it every post fails at the far end.',
  'social.noAccounts': 'No TikTok account is connected yet.',
  'social.connectTikTok': 'Connect TikTok',
  'social.notConfigured': 'This deployment has no TikTok app credentials, so accounts cannot be connected.',
  'social.account': 'Account',
  'social.postingAs': 'Posting as {name}',
  'social.preview': 'What will be posted',
  'social.titleLabel': 'Title',
  'social.captionLabel': 'Caption',
  'social.privacyLabel': 'Who can see this',
  'social.privacyPlaceholder': 'Choose an audience',
  'social.privacyRequired': 'Choose who can see this post.',
  'social.disableComment': 'Turn off comments',
  'social.commercialContent': 'This post is commercial content',
  'social.yourBrand': 'Your brand',
  'social.yourBrandHint': 'Labels the post as promotional content.',
  'social.brandedContent': 'Branded content',
  'social.brandedContentHint': 'Labels the post as a paid partnership.',
  'social.disclosureRequired': 'Commercial content needs at least one disclosure.',
  'social.brandedNotPrivate': 'A paid partnership cannot be posted as “only me”.',
  'social.musicRequired': 'Accept the Music Usage Confirmation to continue.',
  'social.publish': 'Approve and schedule',
  'social.publishing': 'Sending…',
  'social.queued': 'Approved. It will be posted at the time you chose.',
  'social.cancel': 'Cancel',
  'social.close': 'Close',
  'social.errorGeneric': 'Something went wrong. Try again.',
  'social.noMedia': 'This project has no JPEG or WebP images to post yet.',
  'social.renderTitle': 'Images for Instagram',
  'social.renderHint': 'Instagram only takes JPEG. This turns each card of the piece into its own image, in order, and keeps them in the project.',
  'social.renderAction': 'Prepare images',
  'social.renderBusy': 'Preparing images…',
  'social.renderDone': '{count} images ready in {folder}.',
  'social.renderUnavailable': 'This deployment cannot turn pieces into images.',
  'social.renderTryLater': 'The images could not be prepared right now. Try again in a moment.',
  'social.assembleTitle': 'Video from these slides',
  'social.assembleHint': 'Each slide is fitted whole into a vertical frame, never cropped, and held for three seconds. The clip is silent: a soundtrack is a rights decision, not a default. Nothing is published — the file lands in this project.',
  'social.assembleAction': 'Build the video',
  'social.assembleBusy': 'Building the video...',
  'social.assembleDone': 'Saved as {path} — {width}x{height}, {seconds}s, no audio. Nothing was published.',
  'social.assembleUnavailable': 'This installation has no video encoder, so a clip cannot be built here.',
  // Instagram connect funnel. The account-type question comes before any
  // redirect on purpose: Instagram cannot be reached by a personal account,
  // and Meta does not document what such an attempt returns.
  'social.connectInstagram': 'Connect Instagram',
  'social.askAccountKind': 'What kind of Instagram account is it?',
  'social.askAccountKindWhy': 'Instagram only lets apps post from a professional account. Answering now saves you a failed login.',
  'social.accountKindProfessional': 'Creator or Business',
  'social.accountKindPersonal': 'Personal',
  'social.accountKindUnsure': 'I\'m not sure',
  'social.convertTitle': 'Switch to a Creator account first',
  'social.convertWhy': 'It is free, takes under a minute, and you can switch back any time. Your username, your posts and your followers stay exactly as they are.',
  'social.convertDone': 'Done — connect now',
  'social.convertStep1': 'Open the Instagram app and go to your profile.',
  'social.convertStep2': 'Tap the menu, then Settings and privacy.',
  'social.convertStep3': 'Tap Account type and tools, then Switch to professional account.',
  'social.convertStep4': 'Choose Creator (or Business), pick a category, and finish.',
  'social.convertStep5': 'Come back here and connect again.',
  // Assisted delivery. A different promise from automatic publishing, and
  // the copy says so wherever it appears — selling one plan that silently
  // delivers both behaviours is what produces refunds.
  'social.assistedLabel': 'I will post it myself',
  'social.assistedHint': 'You get the piece and the caption ready at the scheduled time, and post it in two taps. It is not automatic publishing.',
  'social.queuedAssisted': 'Scheduled. At the time you chose you will get the piece and the caption, ready to post.',
  // The list where an assisted piece actually arrives.
  'social.waitingForYou': 'Ready for you to post',
  'social.openApp': 'Open the app',
  'social.iPosted': 'I posted it',
  // Reaching the two paths that had no entry point.
  'social.connectFacebook': 'Connect a Facebook Page',
  'social.assistedOffer': 'No professional account? You can still schedule it.',
  'social.whereWillYouPost': 'Where will you post it?',
  // ISSUE-026 — short placeholder hints, in place of the action prompts.
  'chat.composerHintPiece1': 'Ask for a piece for Sunday service',
  'chat.composerHintPiece2': 'Change the colour, the photo or the verse',
  'chat.composerHintPiece3': 'Ask for a version for stories',
  'chat.composerHintImage1': 'Describe the image you want for the post',
  'chat.composerHintImage2': 'Ask for the same image in another colour',
  'chat.composerHintVideo1': 'Describe the short video for the invitation',
  'chat.composerHintVideo2': 'Ask for a shorter version for stories',
  'chat.composerHintAudio1': 'Say what to announce, and in what voice',
  'chat.composerHintAudio2': 'Ask for a calmer, slower reading',
  'chat.composerHintDesignSystem1': 'Ask to improve the church colours and fonts',
  'chat.composerHintDesignSystem2': 'Ask what is still missing here',
  'chat.composerHintPlan1': 'Ask to turn this plan into the pieces',
  'chat.composerHintPlan2': 'Ask to improve the plan first',
  // ISSUE-014 — the pieces of the "what you sent" line in the transcript.
  'dsCreate.sourceLabelDesignMd': 'pasted DESIGN.md',
  'dsCreate.sourceLabelFile': '1 file',
  'dsCreate.sourceLabelFiles': '{count} files',
  'dsCreate.sourceLabelFolder': '1 folder',
  'dsCreate.sourceLabelFolders': '{count} folders',
  'dsCreate.sourceLabelLink': '1 link',
  'dsCreate.sourceLabelLinks': '{count} links',
  'dsCreate.sourceLabelDescription': 'description',
  'dsCreate.sourceLabelChurchProfile': 'profil z Moja marka',
  'dsCreate.churchProfileTitle': 'To już wypełniono w Moja marka',
  'dsCreate.churchProfileBody': 'The colours, fonts, logos and voice you saved are ready here. Change any of it afterwards — or fill it in from scratch, if this look is a different one.',
  'dsCreate.churchProfileUse': 'Użyj profilu z Moja marka',
  'dsCreate.churchProfileApplied': 'Pochodzi z profilu w Moja marka',
  'dsCreate.churchProfileDrop': 'Do not use the profile',
};
